function bi(n, e) {
    var t = !1,
        i = n.document,
        s = i.documentElement,
        o = i.addEventListener,
        a = o ? "addEventListener" : "attachEvent",
        r = o ? "removeEventListener" : "detachEvent",
        l = o ? "" : "on",
        c = function (u) {
            (u.type === "readystatechange" && i.readyState !== "complete") ||
                ((u.type === "load" ? n : i)[r](l + u.type, c, !1), !t && (t = !0) && e.call(n, u.type || u));
        },
        d = function () {
            try {
                s.doScroll("left");
            } catch {
                setTimeout(d, 50);
                return;
            }
            c("poll");
        };
    if (i.readyState === "complete") e.call(n, "lazy");
    else {
        if (!o && s.doScroll)
            try {
                n.frameElement || d();
            } catch {}
        i[a](l + "DOMContentLoaded", c, !1), i[a](l + "readystatechange", c, !1), n[a](l + "load", c, !1);
    }
}
function Yi() {
    "NodeList" in window &&
        !NodeList.prototype.forEach &&
        (console.info("polyfill for IE11"),
        (NodeList.prototype.forEach = function (n, e) {
            e = e || window;
            for (var t = 0; t < this.length; t++) n.call(e, this[t], t, this);
        }));
}
function Ui() {
    window.addEventListener("scroll", function (n) {
        window.scrollY >= 100 ? document.body.classList.add("scrolled") : document.body.classList.remove("scrolled");
    });
}
function Zi(n, e) {
    for (var t = 0; t < e.length; t++) {
        var i = e[t];
        (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(n, i.key, i);
    }
}
function De(n) {
    return (
        (function (e) {
            if (Array.isArray(e)) return et(e);
        })(n) ||
        (function (e) {
            if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
        })(n) ||
        (function (e, t) {
            if (e) {
                if (typeof e == "string") return et(e, t);
                var i = Object.prototype.toString.call(e).slice(8, -1);
                if ((i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set"))
                    return Array.from(e);
                if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return et(e, t);
            }
        })(n) ||
        (function () {
            throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        })()
    );
}
function et(n, e) {
    (e == null || e > n.length) && (e = n.length);
    for (var t = 0, i = new Array(e); t < e; t++) i[t] = n[t];
    return i;
}
var $t,
    tt,
    he,
    it,
    zt,
    yi =
        (($t = [
            "a[href]",
            "area[href]",
            'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
            "select:not([disabled]):not([aria-hidden])",
            "textarea:not([disabled]):not([aria-hidden])",
            "button:not([disabled]):not([aria-hidden])",
            "iframe",
            "object",
            "embed",
            "[contenteditable]",
            '[tabindex]:not([tabindex^="-"])',
        ]),
        (tt = (function () {
            function n(i) {
                var s = i.targetModal,
                    o = i.triggers,
                    a = o === void 0 ? [] : o,
                    r = i.onShow,
                    l = r === void 0 ? function () {} : r,
                    c = i.onClose,
                    d = c === void 0 ? function () {} : c,
                    u = i.openTrigger,
                    f = u === void 0 ? "data-micromodal-trigger" : u,
                    h = i.closeTrigger,
                    g = h === void 0 ? "data-micromodal-close" : h,
                    p = i.openClass,
                    m = p === void 0 ? "is-open" : p,
                    v = i.disableScroll,
                    b = v !== void 0 && v,
                    S = i.disableFocus,
                    y = S !== void 0 && S,
                    x = i.awaitCloseAnimation,
                    C = x !== void 0 && x,
                    E = i.awaitOpenAnimation,
                    P = E !== void 0 && E,
                    _ = i.debugMode,
                    T = _ !== void 0 && _;
                (function (w, k) {
                    if (!(w instanceof k)) throw new TypeError("Cannot call a class as a function");
                })(this, n),
                    (this.modal = document.getElementById(s)),
                    (this.config = {
                        debugMode: T,
                        disableScroll: b,
                        openTrigger: f,
                        closeTrigger: g,
                        openClass: m,
                        onShow: l,
                        onClose: d,
                        awaitCloseAnimation: C,
                        awaitOpenAnimation: P,
                        disableFocus: y,
                    }),
                    a.length > 0 && this.registerTriggers.apply(this, De(a)),
                    (this.onClick = this.onClick.bind(this)),
                    (this.onKeydown = this.onKeydown.bind(this));
            }
            var e, t;
            return (
                (e = n),
                (t = [
                    {
                        key: "registerTriggers",
                        value: function () {
                            for (var i = this, s = arguments.length, o = new Array(s), a = 0; a < s; a++)
                                o[a] = arguments[a];
                            o.filter(Boolean).forEach(function (r) {
                                r.addEventListener("click", function (l) {
                                    return i.showModal(l);
                                });
                            });
                        },
                    },
                    {
                        key: "showModal",
                        value: function () {
                            var i = this,
                                s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                            if (
                                ((this.activeElement = document.activeElement),
                                this.modal.setAttribute("aria-hidden", "false"),
                                this.modal.classList.add(this.config.openClass),
                                this.scrollBehaviour("disable"),
                                this.addEventListeners(),
                                this.config.awaitOpenAnimation)
                            ) {
                                var o = function a() {
                                    i.modal.removeEventListener("animationend", a, !1), i.setFocusToFirstNode();
                                };
                                this.modal.addEventListener("animationend", o, !1);
                            } else this.setFocusToFirstNode();
                            this.config.onShow(this.modal, this.activeElement, s);
                        },
                    },
                    {
                        key: "closeModal",
                        value: function () {
                            var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null,
                                s = this.modal;
                            if (
                                (this.modal.setAttribute("aria-hidden", "true"),
                                this.removeEventListeners(),
                                this.scrollBehaviour("enable"),
                                this.activeElement && this.activeElement.focus && this.activeElement.focus(),
                                this.config.onClose(this.modal, this.activeElement, i),
                                this.config.awaitCloseAnimation)
                            ) {
                                var o = this.config.openClass;
                                this.modal.addEventListener(
                                    "animationend",
                                    function a() {
                                        s.classList.remove(o), s.removeEventListener("animationend", a, !1);
                                    },
                                    !1
                                );
                            } else s.classList.remove(this.config.openClass);
                        },
                    },
                    {
                        key: "closeModalById",
                        value: function (i) {
                            (this.modal = document.getElementById(i)), this.modal && this.closeModal();
                        },
                    },
                    {
                        key: "scrollBehaviour",
                        value: function (i) {
                            if (this.config.disableScroll) {
                                var s = document.querySelector("body");
                                switch (i) {
                                    case "enable":
                                        Object.assign(s.style, { overflow: "" });
                                        break;
                                    case "disable":
                                        Object.assign(s.style, { overflow: "hidden" });
                                }
                            }
                        },
                    },
                    {
                        key: "addEventListeners",
                        value: function () {
                            this.modal.addEventListener("touchstart", this.onClick),
                                this.modal.addEventListener("click", this.onClick),
                                document.addEventListener("keydown", this.onKeydown);
                        },
                    },
                    {
                        key: "removeEventListeners",
                        value: function () {
                            this.modal.removeEventListener("touchstart", this.onClick),
                                this.modal.removeEventListener("click", this.onClick),
                                document.removeEventListener("keydown", this.onKeydown);
                        },
                    },
                    {
                        key: "onClick",
                        value: function (i) {
                            (i.target.hasAttribute(this.config.closeTrigger) ||
                                i.target.parentNode.hasAttribute(this.config.closeTrigger)) &&
                                (i.preventDefault(), i.stopPropagation(), this.closeModal(i));
                        },
                    },
                    {
                        key: "onKeydown",
                        value: function (i) {
                            i.keyCode === 27 && this.closeModal(i), i.keyCode === 9 && this.retainFocus(i);
                        },
                    },
                    {
                        key: "getFocusableNodes",
                        value: function () {
                            var i = this.modal.querySelectorAll($t);
                            return Array.apply(void 0, De(i));
                        },
                    },
                    {
                        key: "setFocusToFirstNode",
                        value: function () {
                            var i = this;
                            if (!this.config.disableFocus) {
                                var s = this.getFocusableNodes();
                                if (s.length !== 0) {
                                    var o = s.filter(function (a) {
                                        return !a.hasAttribute(i.config.closeTrigger);
                                    });
                                    o.length > 0 && o[0].focus(), o.length === 0 && s[0].focus();
                                }
                            }
                        },
                    },
                    {
                        key: "retainFocus",
                        value: function (i) {
                            var s = this.getFocusableNodes();
                            if (s.length !== 0)
                                if (
                                    ((s = s.filter(function (a) {
                                        return a.offsetParent !== null;
                                    })),
                                    this.modal.contains(document.activeElement))
                                ) {
                                    var o = s.indexOf(document.activeElement);
                                    i.shiftKey && o === 0 && (s[s.length - 1].focus(), i.preventDefault()),
                                        !i.shiftKey &&
                                            s.length > 0 &&
                                            o === s.length - 1 &&
                                            (s[0].focus(), i.preventDefault());
                                } else s[0].focus();
                        },
                    },
                ]) && Zi(e.prototype, t),
                n
            );
        })()),
        (he = null),
        (it = function (n) {
            if (!document.getElementById(n))
                return (
                    console.warn(
                        "MicroModal: ❗Seems like you have missed %c'".concat(n, "'"),
                        "background-color: #f8f9fa;color: #50596c;font-weight: bold;",
                        "ID somewhere in your code. Refer example below to resolve it."
                    ),
                    console.warn(
                        "%cExample:",
                        "background-color: #f8f9fa;color: #50596c;font-weight: bold;",
                        '<div class="modal" id="'.concat(n, '"></div>')
                    ),
                    !1
                );
        }),
        (zt = function (n, e) {
            if (
                ((function (i) {
                    i.length <= 0 &&
                        (console.warn(
                            "MicroModal: ❗Please specify at least one %c'micromodal-trigger'",
                            "background-color: #f8f9fa;color: #50596c;font-weight: bold;",
                            "data attribute."
                        ),
                        console.warn(
                            "%cExample:",
                            "background-color: #f8f9fa;color: #50596c;font-weight: bold;",
                            '<a href="#" data-micromodal-trigger="my-modal"></a>'
                        ));
                })(n),
                !e)
            )
                return !0;
            for (var t in e) it(t);
            return !0;
        }),
        {
            init: function (n) {
                var e = Object.assign({}, { openTrigger: "data-micromodal-trigger" }, n),
                    t = De(document.querySelectorAll("[".concat(e.openTrigger, "]"))),
                    i = (function (a, r) {
                        var l = [];
                        return (
                            a.forEach(function (c) {
                                var d = c.attributes[r].value;
                                l[d] === void 0 && (l[d] = []), l[d].push(c);
                            }),
                            l
                        );
                    })(t, e.openTrigger);
                if (e.debugMode !== !0 || zt(t, i) !== !1)
                    for (var s in i) {
                        var o = i[s];
                        (e.targetModal = s), (e.triggers = De(o)), (he = new tt(e));
                    }
            },
            show: function (n, e) {
                var t = e || {};
                (t.targetModal = n),
                    (t.debugMode === !0 && it(n) === !1) ||
                        (he && he.removeEventListeners(), (he = new tt(t)).showModal());
            },
            close: function (n) {
                n ? he.closeModalById(n) : he.closeModal();
            },
        });
typeof window < "u" && (window.MicroModal = yi);
const Ki = {
    openClass: "is-open",
    onShow: () => {
        document.body.classList.add("modal-open");
    },
    onClose: () => {
        document.body.classList.remove("modal-open");
    },
};
function Ji() {
    yi.init(Ki);
}
function Qi() {
    let n = document.querySelectorAll("[data-klaviyo]");
    n.length &&
        n.forEach(function (s, o) {
            s.addEventListener("click", function () {
                (window._klOnsite = window._klOnsite || []), window._klOnsite.push(["openForm", s.dataset.klaviyo]);
            });
        }),
        sessionStorage.getItem("kk_entry_filled") || i();
    let e = !1;
    window.addEventListener("klaviyoForms", function (s) {
        s.detail.type == "open" &&
            setTimeout(function () {
                if (
                    ((e = document.querySelector('[data-testid="klaviyo-form-' + s.detail.formId + '"]')),
                    (e.id = "newsletter_form"),
                    e)
                ) {
                    let o = e.querySelector("input");
                    o &&
                        o.addEventListener("keyup", function () {
                            e = o.closest("form");
                        });
                }
            }, 1e3),
            s.detail.type == "submit" &&
                (t(),
                typeof dataLayer < "u" &&
                    s.detail.formId &&
                    e &&
                    typeof _sendToLeadLibrary == "function" &&
                    _sendToLeadLibrary(e));
    });
    function t() {
        let s = document.querySelector(".section-hero__tab");
        s && s.classList.add("fade-out"), sessionStorage.setItem("kk_entry_filled", 1);
    }
    function i() {
        let s = document.querySelector(".section-hero__tab");
        s && (s.style.display = "flex");
    }
}
function Dt(n) {
    return n !== null && typeof n == "object" && "constructor" in n && n.constructor === Object;
}
function Lt(n = {}, e = {}) {
    Object.keys(e).forEach((t) => {
        typeof n[t] > "u" ? (n[t] = e[t]) : Dt(e[t]) && Dt(n[t]) && Object.keys(e[t]).length > 0 && Lt(n[t], e[t]);
    });
}
const Si = {
    body: {},
    addEventListener() {},
    removeEventListener() {},
    activeElement: { blur() {}, nodeName: "" },
    querySelector() {
        return null;
    },
    querySelectorAll() {
        return [];
    },
    getElementById() {
        return null;
    },
    createEvent() {
        return { initEvent() {} };
    },
    createElement() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute() {},
            getElementsByTagName() {
                return [];
            },
        };
    },
    createElementNS() {
        return {};
    },
    importNode() {
        return null;
    },
    location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
};
function H() {
    const n = typeof document < "u" ? document : {};
    return Lt(n, Si), n;
}
const en = {
    document: Si,
    navigator: { userAgent: "" },
    location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
    history: { replaceState() {}, pushState() {}, go() {}, back() {} },
    CustomEvent: function () {
        return this;
    },
    addEventListener() {},
    removeEventListener() {},
    getComputedStyle() {
        return {
            getPropertyValue() {
                return "";
            },
        };
    },
    Image() {},
    Date() {},
    screen: {},
    setTimeout() {},
    clearTimeout() {},
    matchMedia() {
        return {};
    },
    requestAnimationFrame(n) {
        return typeof setTimeout > "u" ? (n(), null) : setTimeout(n, 0);
    },
    cancelAnimationFrame(n) {
        typeof setTimeout > "u" || clearTimeout(n);
    },
};
function V() {
    const n = typeof window < "u" ? window : {};
    return Lt(n, en), n;
}
function tn(n) {
    const e = n.__proto__;
    Object.defineProperty(n, "__proto__", {
        get() {
            return e;
        },
        set(t) {
            e.__proto__ = t;
        },
    });
}
class ue extends Array {
    constructor(e) {
        typeof e == "number" ? super(e) : (super(...(e || [])), tn(this));
    }
}
function ze(n = []) {
    const e = [];
    return (
        n.forEach((t) => {
            Array.isArray(t) ? e.push(...ze(t)) : e.push(t);
        }),
        e
    );
}
function wi(n, e) {
    return Array.prototype.filter.call(n, e);
}
function nn(n) {
    const e = [];
    for (let t = 0; t < n.length; t += 1) e.indexOf(n[t]) === -1 && e.push(n[t]);
    return e;
}
function sn(n, e) {
    if (typeof n != "string") return [n];
    const t = [],
        i = e.querySelectorAll(n);
    for (let s = 0; s < i.length; s += 1) t.push(i[s]);
    return t;
}
function L(n, e) {
    const t = V(),
        i = H();
    let s = [];
    if (!e && n instanceof ue) return n;
    if (!n) return new ue(s);
    if (typeof n == "string") {
        const o = n.trim();
        if (o.indexOf("<") >= 0 && o.indexOf(">") >= 0) {
            let a = "div";
            o.indexOf("<li") === 0 && (a = "ul"),
                o.indexOf("<tr") === 0 && (a = "tbody"),
                (o.indexOf("<td") === 0 || o.indexOf("<th") === 0) && (a = "tr"),
                o.indexOf("<tbody") === 0 && (a = "table"),
                o.indexOf("<option") === 0 && (a = "select");
            const r = i.createElement(a);
            r.innerHTML = o;
            for (let l = 0; l < r.childNodes.length; l += 1) s.push(r.childNodes[l]);
        } else s = sn(n.trim(), e || i);
    } else if (n.nodeType || n === t || n === i) s.push(n);
    else if (Array.isArray(n)) {
        if (n instanceof ue) return n;
        s = n;
    }
    return new ue(nn(s));
}
L.fn = ue.prototype;
function on(...n) {
    const e = ze(n.map((t) => t.split(" ")));
    return (
        this.forEach((t) => {
            t.classList.add(...e);
        }),
        this
    );
}
function an(...n) {
    const e = ze(n.map((t) => t.split(" ")));
    return (
        this.forEach((t) => {
            t.classList.remove(...e);
        }),
        this
    );
}
function rn(...n) {
    const e = ze(n.map((t) => t.split(" ")));
    this.forEach((t) => {
        e.forEach((i) => {
            t.classList.toggle(i);
        });
    });
}
function ln(...n) {
    const e = ze(n.map((t) => t.split(" ")));
    return wi(this, (t) => e.filter((i) => t.classList.contains(i)).length > 0).length > 0;
}
function cn(n, e) {
    if (arguments.length === 1 && typeof n == "string") return this[0] ? this[0].getAttribute(n) : void 0;
    for (let t = 0; t < this.length; t += 1)
        if (arguments.length === 2) this[t].setAttribute(n, e);
        else for (const i in n) (this[t][i] = n[i]), this[t].setAttribute(i, n[i]);
    return this;
}
function dn(n) {
    for (let e = 0; e < this.length; e += 1) this[e].removeAttribute(n);
    return this;
}
function un(n) {
    for (let e = 0; e < this.length; e += 1) this[e].style.transform = n;
    return this;
}
function hn(n) {
    for (let e = 0; e < this.length; e += 1) this[e].style.transitionDuration = typeof n != "string" ? `${n}ms` : n;
    return this;
}
function fn(...n) {
    let [e, t, i, s] = n;
    typeof n[1] == "function" && (([e, i, s] = n), (t = void 0)), s || (s = !1);
    function o(c) {
        const d = c.target;
        if (!d) return;
        const u = c.target.dom7EventData || [];
        if ((u.indexOf(c) < 0 && u.unshift(c), L(d).is(t))) i.apply(d, u);
        else {
            const f = L(d).parents();
            for (let h = 0; h < f.length; h += 1) L(f[h]).is(t) && i.apply(f[h], u);
        }
    }
    function a(c) {
        const d = c && c.target ? c.target.dom7EventData || [] : [];
        d.indexOf(c) < 0 && d.unshift(c), i.apply(this, d);
    }
    const r = e.split(" ");
    let l;
    for (let c = 0; c < this.length; c += 1) {
        const d = this[c];
        if (t)
            for (l = 0; l < r.length; l += 1) {
                const u = r[l];
                d.dom7LiveListeners || (d.dom7LiveListeners = {}),
                    d.dom7LiveListeners[u] || (d.dom7LiveListeners[u] = []),
                    d.dom7LiveListeners[u].push({ listener: i, proxyListener: o }),
                    d.addEventListener(u, o, s);
            }
        else
            for (l = 0; l < r.length; l += 1) {
                const u = r[l];
                d.dom7Listeners || (d.dom7Listeners = {}),
                    d.dom7Listeners[u] || (d.dom7Listeners[u] = []),
                    d.dom7Listeners[u].push({ listener: i, proxyListener: a }),
                    d.addEventListener(u, a, s);
            }
    }
    return this;
}
function pn(...n) {
    let [e, t, i, s] = n;
    typeof n[1] == "function" && (([e, i, s] = n), (t = void 0)), s || (s = !1);
    const o = e.split(" ");
    for (let a = 0; a < o.length; a += 1) {
        const r = o[a];
        for (let l = 0; l < this.length; l += 1) {
            const c = this[l];
            let d;
            if (
                (!t && c.dom7Listeners
                    ? (d = c.dom7Listeners[r])
                    : t && c.dom7LiveListeners && (d = c.dom7LiveListeners[r]),
                d && d.length)
            )
                for (let u = d.length - 1; u >= 0; u -= 1) {
                    const f = d[u];
                    (i && f.listener === i) || (i && f.listener && f.listener.dom7proxy && f.listener.dom7proxy === i)
                        ? (c.removeEventListener(r, f.proxyListener, s), d.splice(u, 1))
                        : i || (c.removeEventListener(r, f.proxyListener, s), d.splice(u, 1));
                }
        }
    }
    return this;
}
function mn(...n) {
    const e = V(),
        t = n[0].split(" "),
        i = n[1];
    for (let s = 0; s < t.length; s += 1) {
        const o = t[s];
        for (let a = 0; a < this.length; a += 1) {
            const r = this[a];
            if (e.CustomEvent) {
                const l = new e.CustomEvent(o, { detail: i, bubbles: !0, cancelable: !0 });
                (r.dom7EventData = n.filter((c, d) => d > 0)),
                    r.dispatchEvent(l),
                    (r.dom7EventData = []),
                    delete r.dom7EventData;
            }
        }
    }
    return this;
}
function gn(n) {
    const e = this;
    function t(i) {
        i.target === this && (n.call(this, i), e.off("transitionend", t));
    }
    return n && e.on("transitionend", t), this;
}
function vn(n) {
    if (this.length > 0) {
        if (n) {
            const e = this.styles();
            return (
                this[0].offsetWidth +
                parseFloat(e.getPropertyValue("margin-right")) +
                parseFloat(e.getPropertyValue("margin-left"))
            );
        }
        return this[0].offsetWidth;
    }
    return null;
}
function bn(n) {
    if (this.length > 0) {
        if (n) {
            const e = this.styles();
            return (
                this[0].offsetHeight +
                parseFloat(e.getPropertyValue("margin-top")) +
                parseFloat(e.getPropertyValue("margin-bottom"))
            );
        }
        return this[0].offsetHeight;
    }
    return null;
}
function yn() {
    if (this.length > 0) {
        const n = V(),
            e = H(),
            t = this[0],
            i = t.getBoundingClientRect(),
            s = e.body,
            o = t.clientTop || s.clientTop || 0,
            a = t.clientLeft || s.clientLeft || 0,
            r = t === n ? n.scrollY : t.scrollTop,
            l = t === n ? n.scrollX : t.scrollLeft;
        return { top: i.top + r - o, left: i.left + l - a };
    }
    return null;
}
function Sn() {
    const n = V();
    return this[0] ? n.getComputedStyle(this[0], null) : {};
}
function wn(n, e) {
    const t = V();
    let i;
    if (arguments.length === 1)
        if (typeof n == "string") {
            if (this[0]) return t.getComputedStyle(this[0], null).getPropertyValue(n);
        } else {
            for (i = 0; i < this.length; i += 1) for (const s in n) this[i].style[s] = n[s];
            return this;
        }
    if (arguments.length === 2 && typeof n == "string") {
        for (i = 0; i < this.length; i += 1) this[i].style[n] = e;
        return this;
    }
    return this;
}
function xn(n) {
    return n
        ? (this.forEach((e, t) => {
              n.apply(e, [e, t]);
          }),
          this)
        : this;
}
function En(n) {
    const e = wi(this, n);
    return L(e);
}
function Cn(n) {
    if (typeof n > "u") return this[0] ? this[0].innerHTML : null;
    for (let e = 0; e < this.length; e += 1) this[e].innerHTML = n;
    return this;
}
function Tn(n) {
    if (typeof n > "u") return this[0] ? this[0].textContent.trim() : null;
    for (let e = 0; e < this.length; e += 1) this[e].textContent = n;
    return this;
}
function Mn(n) {
    const e = V(),
        t = H(),
        i = this[0];
    let s, o;
    if (!i || typeof n > "u") return !1;
    if (typeof n == "string") {
        if (i.matches) return i.matches(n);
        if (i.webkitMatchesSelector) return i.webkitMatchesSelector(n);
        if (i.msMatchesSelector) return i.msMatchesSelector(n);
        for (s = L(n), o = 0; o < s.length; o += 1) if (s[o] === i) return !0;
        return !1;
    }
    if (n === t) return i === t;
    if (n === e) return i === e;
    if (n.nodeType || n instanceof ue) {
        for (s = n.nodeType ? [n] : n, o = 0; o < s.length; o += 1) if (s[o] === i) return !0;
        return !1;
    }
    return !1;
}
function Ln() {
    let n = this[0],
        e;
    if (n) {
        for (e = 0; (n = n.previousSibling) !== null; ) n.nodeType === 1 && (e += 1);
        return e;
    }
}
function Pn(n) {
    if (typeof n > "u") return this;
    const e = this.length;
    if (n > e - 1) return L([]);
    if (n < 0) {
        const t = e + n;
        return t < 0 ? L([]) : L([this[t]]);
    }
    return L([this[n]]);
}
function An(...n) {
    let e;
    const t = H();
    for (let i = 0; i < n.length; i += 1) {
        e = n[i];
        for (let s = 0; s < this.length; s += 1)
            if (typeof e == "string") {
                const o = t.createElement("div");
                for (o.innerHTML = e; o.firstChild; ) this[s].appendChild(o.firstChild);
            } else if (e instanceof ue) for (let o = 0; o < e.length; o += 1) this[s].appendChild(e[o]);
            else this[s].appendChild(e);
    }
    return this;
}
function kn(n) {
    const e = H();
    let t, i;
    for (t = 0; t < this.length; t += 1)
        if (typeof n == "string") {
            const s = e.createElement("div");
            for (s.innerHTML = n, i = s.childNodes.length - 1; i >= 0; i -= 1)
                this[t].insertBefore(s.childNodes[i], this[t].childNodes[0]);
        } else if (n instanceof ue) for (i = 0; i < n.length; i += 1) this[t].insertBefore(n[i], this[t].childNodes[0]);
        else this[t].insertBefore(n, this[t].childNodes[0]);
    return this;
}
function On(n) {
    return this.length > 0
        ? n
            ? this[0].nextElementSibling && L(this[0].nextElementSibling).is(n)
                ? L([this[0].nextElementSibling])
                : L([])
            : this[0].nextElementSibling
              ? L([this[0].nextElementSibling])
              : L([])
        : L([]);
}
function In(n) {
    const e = [];
    let t = this[0];
    if (!t) return L([]);
    for (; t.nextElementSibling; ) {
        const i = t.nextElementSibling;
        n ? L(i).is(n) && e.push(i) : e.push(i), (t = i);
    }
    return L(e);
}
function _n(n) {
    if (this.length > 0) {
        const e = this[0];
        return n
            ? e.previousElementSibling && L(e.previousElementSibling).is(n)
                ? L([e.previousElementSibling])
                : L([])
            : e.previousElementSibling
              ? L([e.previousElementSibling])
              : L([]);
    }
    return L([]);
}
function $n(n) {
    const e = [];
    let t = this[0];
    if (!t) return L([]);
    for (; t.previousElementSibling; ) {
        const i = t.previousElementSibling;
        n ? L(i).is(n) && e.push(i) : e.push(i), (t = i);
    }
    return L(e);
}
function zn(n) {
    const e = [];
    for (let t = 0; t < this.length; t += 1)
        this[t].parentNode !== null &&
            (n ? L(this[t].parentNode).is(n) && e.push(this[t].parentNode) : e.push(this[t].parentNode));
    return L(e);
}
function Dn(n) {
    const e = [];
    for (let t = 0; t < this.length; t += 1) {
        let i = this[t].parentNode;
        for (; i; ) n ? L(i).is(n) && e.push(i) : e.push(i), (i = i.parentNode);
    }
    return L(e);
}
function Rn(n) {
    let e = this;
    return typeof n > "u" ? L([]) : (e.is(n) || (e = e.parents(n).eq(0)), e);
}
function qn(n) {
    const e = [];
    for (let t = 0; t < this.length; t += 1) {
        const i = this[t].querySelectorAll(n);
        for (let s = 0; s < i.length; s += 1) e.push(i[s]);
    }
    return L(e);
}
function Fn(n) {
    const e = [];
    for (let t = 0; t < this.length; t += 1) {
        const i = this[t].children;
        for (let s = 0; s < i.length; s += 1) (!n || L(i[s]).is(n)) && e.push(i[s]);
    }
    return L(e);
}
function Nn() {
    for (let n = 0; n < this.length; n += 1) this[n].parentNode && this[n].parentNode.removeChild(this[n]);
    return this;
}
const Rt = {
    addClass: on,
    removeClass: an,
    hasClass: ln,
    toggleClass: rn,
    attr: cn,
    removeAttr: dn,
    transform: un,
    transition: hn,
    on: fn,
    off: pn,
    trigger: mn,
    transitionEnd: gn,
    outerWidth: vn,
    outerHeight: bn,
    styles: Sn,
    offset: yn,
    css: wn,
    each: xn,
    html: Cn,
    text: Tn,
    is: Mn,
    index: Ln,
    eq: Pn,
    append: An,
    prepend: kn,
    next: On,
    nextAll: In,
    prev: _n,
    prevAll: $n,
    parent: zn,
    parents: Dn,
    closest: Rn,
    find: qn,
    children: Fn,
    filter: En,
    remove: Nn,
};
Object.keys(Rt).forEach((n) => {
    Object.defineProperty(L.fn, n, { value: Rt[n], writable: !0 });
});
function jn(n) {
    const e = n;
    Object.keys(e).forEach((t) => {
        try {
            e[t] = null;
        } catch {}
        try {
            delete e[t];
        } catch {}
    });
}
function _e(n, e = 0) {
    return setTimeout(n, e);
}
function $e() {
    return Date.now();
}
function Bn(n) {
    const e = V();
    let t;
    return (
        e.getComputedStyle && (t = e.getComputedStyle(n, null)),
        !t && n.currentStyle && (t = n.currentStyle),
        t || (t = n.style),
        t
    );
}
function Hn(n, e = "x") {
    const t = V();
    let i, s, o;
    const a = Bn(n);
    return (
        t.WebKitCSSMatrix
            ? ((s = a.transform || a.webkitTransform),
              s.split(",").length > 6 &&
                  (s = s
                      .split(", ")
                      .map((r) => r.replace(",", "."))
                      .join(", ")),
              (o = new t.WebKitCSSMatrix(s === "none" ? "" : s)))
            : ((o =
                  a.MozTransform ||
                  a.OTransform ||
                  a.MsTransform ||
                  a.msTransform ||
                  a.transform ||
                  a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")),
              (i = o.toString().split(","))),
        e === "x" &&
            (t.WebKitCSSMatrix ? (s = o.m41) : i.length === 16 ? (s = parseFloat(i[12])) : (s = parseFloat(i[4]))),
        e === "y" &&
            (t.WebKitCSSMatrix ? (s = o.m42) : i.length === 16 ? (s = parseFloat(i[13])) : (s = parseFloat(i[5]))),
        s || 0
    );
}
function ke(n) {
    return (
        typeof n == "object" &&
        n !== null &&
        n.constructor &&
        Object.prototype.toString.call(n).slice(8, -1) === "Object"
    );
}
function Vn(n) {
    return typeof window < "u" && typeof window.HTMLElement < "u"
        ? n instanceof HTMLElement
        : n && (n.nodeType === 1 || n.nodeType === 11);
}
function Z(...n) {
    const e = Object(n[0]),
        t = ["__proto__", "constructor", "prototype"];
    for (let i = 1; i < n.length; i += 1) {
        const s = n[i];
        if (s != null && !Vn(s)) {
            const o = Object.keys(Object(s)).filter((a) => t.indexOf(a) < 0);
            for (let a = 0, r = o.length; a < r; a += 1) {
                const l = o[a],
                    c = Object.getOwnPropertyDescriptor(s, l);
                c !== void 0 &&
                    c.enumerable &&
                    (ke(e[l]) && ke(s[l])
                        ? s[l].__swiper__
                            ? (e[l] = s[l])
                            : Z(e[l], s[l])
                        : !ke(e[l]) && ke(s[l])
                          ? ((e[l] = {}), s[l].__swiper__ ? (e[l] = s[l]) : Z(e[l], s[l]))
                          : (e[l] = s[l]));
            }
        }
    }
    return e;
}
function Re(n, e, t) {
    n.style.setProperty(e, t);
}
function xi({ swiper: n, targetPosition: e, side: t }) {
    const i = V(),
        s = -n.translate;
    let o = null,
        a;
    const r = n.params.speed;
    (n.wrapperEl.style.scrollSnapType = "none"), i.cancelAnimationFrame(n.cssModeFrameID);
    const l = e > s ? "next" : "prev",
        c = (u, f) => (l === "next" && u >= f) || (l === "prev" && u <= f),
        d = () => {
            (a = new Date().getTime()), o === null && (o = a);
            const u = Math.max(Math.min((a - o) / r, 1), 0),
                f = 0.5 - Math.cos(u * Math.PI) / 2;
            let h = s + f * (e - s);
            if ((c(h, e) && (h = e), n.wrapperEl.scrollTo({ [t]: h }), c(h, e))) {
                (n.wrapperEl.style.overflow = "hidden"),
                    (n.wrapperEl.style.scrollSnapType = ""),
                    setTimeout(() => {
                        (n.wrapperEl.style.overflow = ""), n.wrapperEl.scrollTo({ [t]: h });
                    }),
                    i.cancelAnimationFrame(n.cssModeFrameID);
                return;
            }
            n.cssModeFrameID = i.requestAnimationFrame(d);
        };
    d();
}
let nt;
function Gn() {
    const n = V(),
        e = H();
    return {
        smoothScroll: e.documentElement && "scrollBehavior" in e.documentElement.style,
        touch: !!("ontouchstart" in n || (n.DocumentTouch && e instanceof n.DocumentTouch)),
        passiveListener: (function () {
            let i = !1;
            try {
                const s = Object.defineProperty({}, "passive", {
                    get() {
                        i = !0;
                    },
                });
                n.addEventListener("testPassiveListener", null, s);
            } catch {}
            return i;
        })(),
        gestures: (function () {
            return "ongesturestart" in n;
        })(),
    };
}
function Ei() {
    return nt || (nt = Gn()), nt;
}
let st;
function Wn({ userAgent: n } = {}) {
    const e = Ei(),
        t = V(),
        i = t.navigator.platform,
        s = n || t.navigator.userAgent,
        o = { ios: !1, android: !1 },
        a = t.screen.width,
        r = t.screen.height,
        l = s.match(/(Android);?[\s\/]+([\d.]+)?/);
    let c = s.match(/(iPad).*OS\s([\d_]+)/);
    const d = s.match(/(iPod)(.*OS\s([\d_]+))?/),
        u = !c && s.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
        f = i === "Win32";
    let h = i === "MacIntel";
    const g = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810",
    ];
    return (
        !c &&
            h &&
            e.touch &&
            g.indexOf(`${a}x${r}`) >= 0 &&
            ((c = s.match(/(Version)\/([\d.]+)/)), c || (c = [0, 1, "13_0_0"]), (h = !1)),
        l && !f && ((o.os = "android"), (o.android = !0)),
        (c || u || d) && ((o.os = "ios"), (o.ios = !0)),
        o
    );
}
function Xn(n = {}) {
    return st || (st = Wn(n)), st;
}
let ot;
function Yn() {
    const n = V();
    function e() {
        const t = n.navigator.userAgent.toLowerCase();
        return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
    }
    return { isSafari: e(), isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(n.navigator.userAgent) };
}
function Un() {
    return ot || (ot = Yn()), ot;
}
function Zn({ swiper: n, on: e, emit: t }) {
    const i = V();
    let s = null,
        o = null;
    const a = () => {
            !n || n.destroyed || !n.initialized || (t("beforeResize"), t("resize"));
        },
        r = () => {
            !n ||
                n.destroyed ||
                !n.initialized ||
                ((s = new ResizeObserver((d) => {
                    o = i.requestAnimationFrame(() => {
                        const { width: u, height: f } = n;
                        let h = u,
                            g = f;
                        d.forEach(({ contentBoxSize: p, contentRect: m, target: v }) => {
                            (v && v !== n.el) ||
                                ((h = m ? m.width : (p[0] || p).inlineSize),
                                (g = m ? m.height : (p[0] || p).blockSize));
                        }),
                            (h !== u || g !== f) && a();
                    });
                })),
                s.observe(n.el));
        },
        l = () => {
            o && i.cancelAnimationFrame(o), s && s.unobserve && n.el && (s.unobserve(n.el), (s = null));
        },
        c = () => {
            !n || n.destroyed || !n.initialized || t("orientationchange");
        };
    e("init", () => {
        if (n.params.resizeObserver && typeof i.ResizeObserver < "u") {
            r();
            return;
        }
        i.addEventListener("resize", a), i.addEventListener("orientationchange", c);
    }),
        e("destroy", () => {
            l(), i.removeEventListener("resize", a), i.removeEventListener("orientationchange", c);
        });
}
function Kn({ swiper: n, extendParams: e, on: t, emit: i }) {
    const s = [],
        o = V(),
        a = (c, d = {}) => {
            const u = o.MutationObserver || o.WebkitMutationObserver,
                f = new u((h) => {
                    if (h.length === 1) {
                        i("observerUpdate", h[0]);
                        return;
                    }
                    const g = function () {
                        i("observerUpdate", h[0]);
                    };
                    o.requestAnimationFrame ? o.requestAnimationFrame(g) : o.setTimeout(g, 0);
                });
            f.observe(c, {
                attributes: typeof d.attributes > "u" ? !0 : d.attributes,
                childList: typeof d.childList > "u" ? !0 : d.childList,
                characterData: typeof d.characterData > "u" ? !0 : d.characterData,
            }),
                s.push(f);
        },
        r = () => {
            if (n.params.observer) {
                if (n.params.observeParents) {
                    const c = n.$el.parents();
                    for (let d = 0; d < c.length; d += 1) a(c[d]);
                }
                a(n.$el[0], { childList: n.params.observeSlideChildren }), a(n.$wrapperEl[0], { attributes: !1 });
            }
        },
        l = () => {
            s.forEach((c) => {
                c.disconnect();
            }),
                s.splice(0, s.length);
        };
    e({ observer: !1, observeParents: !1, observeSlideChildren: !1 }), t("init", r), t("destroy", l);
}
const Jn = {
    on(n, e, t) {
        const i = this;
        if (!i.eventsListeners || i.destroyed || typeof e != "function") return i;
        const s = t ? "unshift" : "push";
        return (
            n.split(" ").forEach((o) => {
                i.eventsListeners[o] || (i.eventsListeners[o] = []), i.eventsListeners[o][s](e);
            }),
            i
        );
    },
    once(n, e, t) {
        const i = this;
        if (!i.eventsListeners || i.destroyed || typeof e != "function") return i;
        function s(...o) {
            i.off(n, s), s.__emitterProxy && delete s.__emitterProxy, e.apply(i, o);
        }
        return (s.__emitterProxy = e), i.on(n, s, t);
    },
    onAny(n, e) {
        const t = this;
        if (!t.eventsListeners || t.destroyed || typeof n != "function") return t;
        const i = e ? "unshift" : "push";
        return t.eventsAnyListeners.indexOf(n) < 0 && t.eventsAnyListeners[i](n), t;
    },
    offAny(n) {
        const e = this;
        if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
        const t = e.eventsAnyListeners.indexOf(n);
        return t >= 0 && e.eventsAnyListeners.splice(t, 1), e;
    },
    off(n, e) {
        const t = this;
        return (
            !t.eventsListeners ||
                t.destroyed ||
                !t.eventsListeners ||
                n.split(" ").forEach((i) => {
                    typeof e > "u"
                        ? (t.eventsListeners[i] = [])
                        : t.eventsListeners[i] &&
                          t.eventsListeners[i].forEach((s, o) => {
                              (s === e || (s.__emitterProxy && s.__emitterProxy === e)) &&
                                  t.eventsListeners[i].splice(o, 1);
                          });
                }),
            t
        );
    },
    emit(...n) {
        const e = this;
        if (!e.eventsListeners || e.destroyed || !e.eventsListeners) return e;
        let t, i, s;
        return (
            typeof n[0] == "string" || Array.isArray(n[0])
                ? ((t = n[0]), (i = n.slice(1, n.length)), (s = e))
                : ((t = n[0].events), (i = n[0].data), (s = n[0].context || e)),
            i.unshift(s),
            (Array.isArray(t) ? t : t.split(" ")).forEach((a) => {
                e.eventsAnyListeners &&
                    e.eventsAnyListeners.length &&
                    e.eventsAnyListeners.forEach((r) => {
                        r.apply(s, [a, ...i]);
                    }),
                    e.eventsListeners &&
                        e.eventsListeners[a] &&
                        e.eventsListeners[a].forEach((r) => {
                            r.apply(s, i);
                        });
            }),
            e
        );
    },
};
function Qn() {
    const n = this;
    let e, t;
    const i = n.$el;
    typeof n.params.width < "u" && n.params.width !== null ? (e = n.params.width) : (e = i[0].clientWidth),
        typeof n.params.height < "u" && n.params.height !== null ? (t = n.params.height) : (t = i[0].clientHeight),
        !((e === 0 && n.isHorizontal()) || (t === 0 && n.isVertical())) &&
            ((e = e - parseInt(i.css("padding-left") || 0, 10) - parseInt(i.css("padding-right") || 0, 10)),
            (t = t - parseInt(i.css("padding-top") || 0, 10) - parseInt(i.css("padding-bottom") || 0, 10)),
            Number.isNaN(e) && (e = 0),
            Number.isNaN(t) && (t = 0),
            Object.assign(n, { width: e, height: t, size: n.isHorizontal() ? e : t }));
}
function es() {
    const n = this;
    function e(T) {
        return n.isHorizontal()
            ? T
            : {
                  width: "height",
                  "margin-top": "margin-left",
                  "margin-bottom ": "margin-right",
                  "margin-left": "margin-top",
                  "margin-right": "margin-bottom",
                  "padding-left": "padding-top",
                  "padding-right": "padding-bottom",
                  marginRight: "marginBottom",
              }[T];
    }
    function t(T, w) {
        return parseFloat(T.getPropertyValue(e(w)) || 0);
    }
    const i = n.params,
        { $wrapperEl: s, size: o, rtlTranslate: a, wrongRTL: r } = n,
        l = n.virtual && i.virtual.enabled,
        c = l ? n.virtual.slides.length : n.slides.length,
        d = s.children(`.${n.params.slideClass}`),
        u = l ? n.virtual.slides.length : d.length;
    let f = [];
    const h = [],
        g = [];
    let p = i.slidesOffsetBefore;
    typeof p == "function" && (p = i.slidesOffsetBefore.call(n));
    let m = i.slidesOffsetAfter;
    typeof m == "function" && (m = i.slidesOffsetAfter.call(n));
    const v = n.snapGrid.length,
        b = n.slidesGrid.length;
    let S = i.spaceBetween,
        y = -p,
        x = 0,
        C = 0;
    if (typeof o > "u") return;
    typeof S == "string" && S.indexOf("%") >= 0 && (S = (parseFloat(S.replace("%", "")) / 100) * o),
        (n.virtualSize = -S),
        a
            ? d.css({ marginLeft: "", marginBottom: "", marginTop: "" })
            : d.css({ marginRight: "", marginBottom: "", marginTop: "" }),
        i.centeredSlides &&
            i.cssMode &&
            (Re(n.wrapperEl, "--swiper-centered-offset-before", ""),
            Re(n.wrapperEl, "--swiper-centered-offset-after", ""));
    const E = i.grid && i.grid.rows > 1 && n.grid;
    E && n.grid.initSlides(u);
    let P;
    const _ =
        i.slidesPerView === "auto" &&
        i.breakpoints &&
        Object.keys(i.breakpoints).filter((T) => typeof i.breakpoints[T].slidesPerView < "u").length > 0;
    for (let T = 0; T < u; T += 1) {
        P = 0;
        const w = d.eq(T);
        if ((E && n.grid.updateSlide(T, w, u, e), w.css("display") !== "none")) {
            if (i.slidesPerView === "auto") {
                _ && (d[T].style[e("width")] = "");
                const k = getComputedStyle(w[0]),
                    A = w[0].style.transform,
                    O = w[0].style.webkitTransform;
                if ((A && (w[0].style.transform = "none"), O && (w[0].style.webkitTransform = "none"), i.roundLengths))
                    P = n.isHorizontal() ? w.outerWidth(!0) : w.outerHeight(!0);
                else {
                    const $ = t(k, "width"),
                        j = t(k, "padding-left"),
                        G = t(k, "padding-right"),
                        F = t(k, "margin-left"),
                        q = t(k, "margin-right"),
                        ce = k.getPropertyValue("box-sizing");
                    if (ce && ce === "border-box") P = $ + F + q;
                    else {
                        const { clientWidth: te, offsetWidth: Se } = w[0];
                        P = $ + j + G + F + q + (Se - te);
                    }
                }
                A && (w[0].style.transform = A),
                    O && (w[0].style.webkitTransform = O),
                    i.roundLengths && (P = Math.floor(P));
            } else
                (P = (o - (i.slidesPerView - 1) * S) / i.slidesPerView),
                    i.roundLengths && (P = Math.floor(P)),
                    d[T] && (d[T].style[e("width")] = `${P}px`);
            d[T] && (d[T].swiperSlideSize = P),
                g.push(P),
                i.centeredSlides
                    ? ((y = y + P / 2 + x / 2 + S),
                      x === 0 && T !== 0 && (y = y - o / 2 - S),
                      T === 0 && (y = y - o / 2 - S),
                      Math.abs(y) < 1 / 1e3 && (y = 0),
                      i.roundLengths && (y = Math.floor(y)),
                      C % i.slidesPerGroup === 0 && f.push(y),
                      h.push(y))
                    : (i.roundLengths && (y = Math.floor(y)),
                      (C - Math.min(n.params.slidesPerGroupSkip, C)) % n.params.slidesPerGroup === 0 && f.push(y),
                      h.push(y),
                      (y = y + P + S)),
                (n.virtualSize += P + S),
                (x = P),
                (C += 1);
        }
    }
    if (
        ((n.virtualSize = Math.max(n.virtualSize, o) + m),
        a &&
            r &&
            (i.effect === "slide" || i.effect === "coverflow") &&
            s.css({ width: `${n.virtualSize + i.spaceBetween}px` }),
        i.setWrapperSize && s.css({ [e("width")]: `${n.virtualSize + i.spaceBetween}px` }),
        E && n.grid.updateWrapperSize(P, f, e),
        !i.centeredSlides)
    ) {
        const T = [];
        for (let w = 0; w < f.length; w += 1) {
            let k = f[w];
            i.roundLengths && (k = Math.floor(k)), f[w] <= n.virtualSize - o && T.push(k);
        }
        (f = T), Math.floor(n.virtualSize - o) - Math.floor(f[f.length - 1]) > 1 && f.push(n.virtualSize - o);
    }
    if ((f.length === 0 && (f = [0]), i.spaceBetween !== 0)) {
        const T = n.isHorizontal() && a ? "marginLeft" : e("marginRight");
        d.filter((w, k) => (i.cssMode ? k !== d.length - 1 : !0)).css({ [T]: `${S}px` });
    }
    if (i.centeredSlides && i.centeredSlidesBounds) {
        let T = 0;
        g.forEach((k) => {
            T += k + (i.spaceBetween ? i.spaceBetween : 0);
        }),
            (T -= i.spaceBetween);
        const w = T - o;
        f = f.map((k) => (k < 0 ? -p : k > w ? w + m : k));
    }
    if (i.centerInsufficientSlides) {
        let T = 0;
        if (
            (g.forEach((w) => {
                T += w + (i.spaceBetween ? i.spaceBetween : 0);
            }),
            (T -= i.spaceBetween),
            T < o)
        ) {
            const w = (o - T) / 2;
            f.forEach((k, A) => {
                f[A] = k - w;
            }),
                h.forEach((k, A) => {
                    h[A] = k + w;
                });
        }
    }
    if (
        (Object.assign(n, { slides: d, snapGrid: f, slidesGrid: h, slidesSizesGrid: g }),
        i.centeredSlides && i.cssMode && !i.centeredSlidesBounds)
    ) {
        Re(n.wrapperEl, "--swiper-centered-offset-before", `${-f[0]}px`),
            Re(n.wrapperEl, "--swiper-centered-offset-after", `${n.size / 2 - g[g.length - 1] / 2}px`);
        const T = -n.snapGrid[0],
            w = -n.slidesGrid[0];
        (n.snapGrid = n.snapGrid.map((k) => k + T)), (n.slidesGrid = n.slidesGrid.map((k) => k + w));
    }
    if (
        (u !== c && n.emit("slidesLengthChange"),
        f.length !== v && (n.params.watchOverflow && n.checkOverflow(), n.emit("snapGridLengthChange")),
        h.length !== b && n.emit("slidesGridLengthChange"),
        i.watchSlidesProgress && n.updateSlidesOffset(),
        !l && !i.cssMode && (i.effect === "slide" || i.effect === "fade"))
    ) {
        const T = `${i.containerModifierClass}backface-hidden`,
            w = n.$el.hasClass(T);
        u <= i.maxBackfaceHiddenSlides ? w || n.$el.addClass(T) : w && n.$el.removeClass(T);
    }
}
function ts(n) {
    const e = this,
        t = [],
        i = e.virtual && e.params.virtual.enabled;
    let s = 0,
        o;
    typeof n == "number" ? e.setTransition(n) : n === !0 && e.setTransition(e.params.speed);
    const a = (r) =>
        i
            ? e.slides.filter((l) => parseInt(l.getAttribute("data-swiper-slide-index"), 10) === r)[0]
            : e.slides.eq(r)[0];
    if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
        if (e.params.centeredSlides)
            (e.visibleSlides || L([])).each((r) => {
                t.push(r);
            });
        else
            for (o = 0; o < Math.ceil(e.params.slidesPerView); o += 1) {
                const r = e.activeIndex + o;
                if (r > e.slides.length && !i) break;
                t.push(a(r));
            }
    else t.push(a(e.activeIndex));
    for (o = 0; o < t.length; o += 1)
        if (typeof t[o] < "u") {
            const r = t[o].offsetHeight;
            s = r > s ? r : s;
        }
    (s || s === 0) && e.$wrapperEl.css("height", `${s}px`);
}
function is() {
    const n = this,
        e = n.slides;
    for (let t = 0; t < e.length; t += 1) e[t].swiperSlideOffset = n.isHorizontal() ? e[t].offsetLeft : e[t].offsetTop;
}
function ns(n = (this && this.translate) || 0) {
    const e = this,
        t = e.params,
        { slides: i, rtlTranslate: s, snapGrid: o } = e;
    if (i.length === 0) return;
    typeof i[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
    let a = -n;
    s && (a = n), i.removeClass(t.slideVisibleClass), (e.visibleSlidesIndexes = []), (e.visibleSlides = []);
    for (let r = 0; r < i.length; r += 1) {
        const l = i[r];
        let c = l.swiperSlideOffset;
        t.cssMode && t.centeredSlides && (c -= i[0].swiperSlideOffset);
        const d = (a + (t.centeredSlides ? e.minTranslate() : 0) - c) / (l.swiperSlideSize + t.spaceBetween),
            u = (a - o[0] + (t.centeredSlides ? e.minTranslate() : 0) - c) / (l.swiperSlideSize + t.spaceBetween),
            f = -(a - c),
            h = f + e.slidesSizesGrid[r];
        ((f >= 0 && f < e.size - 1) || (h > 1 && h <= e.size) || (f <= 0 && h >= e.size)) &&
            (e.visibleSlides.push(l), e.visibleSlidesIndexes.push(r), i.eq(r).addClass(t.slideVisibleClass)),
            (l.progress = s ? -d : d),
            (l.originalProgress = s ? -u : u);
    }
    e.visibleSlides = L(e.visibleSlides);
}
function ss(n) {
    const e = this;
    if (typeof n > "u") {
        const c = e.rtlTranslate ? -1 : 1;
        n = (e && e.translate && e.translate * c) || 0;
    }
    const t = e.params,
        i = e.maxTranslate() - e.minTranslate();
    let { progress: s, isBeginning: o, isEnd: a } = e;
    const r = o,
        l = a;
    i === 0 ? ((s = 0), (o = !0), (a = !0)) : ((s = (n - e.minTranslate()) / i), (o = s <= 0), (a = s >= 1)),
        Object.assign(e, { progress: s, isBeginning: o, isEnd: a }),
        (t.watchSlidesProgress || (t.centeredSlides && t.autoHeight)) && e.updateSlidesProgress(n),
        o && !r && e.emit("reachBeginning toEdge"),
        a && !l && e.emit("reachEnd toEdge"),
        ((r && !o) || (l && !a)) && e.emit("fromEdge"),
        e.emit("progress", s);
}
function os() {
    const n = this,
        { slides: e, params: t, $wrapperEl: i, activeIndex: s, realIndex: o } = n,
        a = n.virtual && t.virtual.enabled;
    e.removeClass(
        `${t.slideActiveClass} ${t.slideNextClass} ${t.slidePrevClass} ${t.slideDuplicateActiveClass} ${t.slideDuplicateNextClass} ${t.slideDuplicatePrevClass}`
    );
    let r;
    a ? (r = n.$wrapperEl.find(`.${t.slideClass}[data-swiper-slide-index="${s}"]`)) : (r = e.eq(s)),
        r.addClass(t.slideActiveClass),
        t.loop &&
            (r.hasClass(t.slideDuplicateClass)
                ? i
                      .children(`.${t.slideClass}:not(.${t.slideDuplicateClass})[data-swiper-slide-index="${o}"]`)
                      .addClass(t.slideDuplicateActiveClass)
                : i
                      .children(`.${t.slideClass}.${t.slideDuplicateClass}[data-swiper-slide-index="${o}"]`)
                      .addClass(t.slideDuplicateActiveClass));
    let l = r.nextAll(`.${t.slideClass}`).eq(0).addClass(t.slideNextClass);
    t.loop && l.length === 0 && ((l = e.eq(0)), l.addClass(t.slideNextClass));
    let c = r.prevAll(`.${t.slideClass}`).eq(0).addClass(t.slidePrevClass);
    t.loop && c.length === 0 && ((c = e.eq(-1)), c.addClass(t.slidePrevClass)),
        t.loop &&
            (l.hasClass(t.slideDuplicateClass)
                ? i
                      .children(
                          `.${t.slideClass}:not(.${t.slideDuplicateClass})[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`
                      )
                      .addClass(t.slideDuplicateNextClass)
                : i
                      .children(
                          `.${t.slideClass}.${t.slideDuplicateClass}[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`
                      )
                      .addClass(t.slideDuplicateNextClass),
            c.hasClass(t.slideDuplicateClass)
                ? i
                      .children(
                          `.${t.slideClass}:not(.${t.slideDuplicateClass})[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`
                      )
                      .addClass(t.slideDuplicatePrevClass)
                : i
                      .children(
                          `.${t.slideClass}.${t.slideDuplicateClass}[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`
                      )
                      .addClass(t.slideDuplicatePrevClass)),
        n.emitSlidesClasses();
}
function as(n) {
    const e = this,
        t = e.rtlTranslate ? e.translate : -e.translate,
        { slidesGrid: i, snapGrid: s, params: o, activeIndex: a, realIndex: r, snapIndex: l } = e;
    let c = n,
        d;
    if (typeof c > "u") {
        for (let f = 0; f < i.length; f += 1)
            typeof i[f + 1] < "u"
                ? t >= i[f] && t < i[f + 1] - (i[f + 1] - i[f]) / 2
                    ? (c = f)
                    : t >= i[f] && t < i[f + 1] && (c = f + 1)
                : t >= i[f] && (c = f);
        o.normalizeSlideIndex && (c < 0 || typeof c > "u") && (c = 0);
    }
    if (s.indexOf(t) >= 0) d = s.indexOf(t);
    else {
        const f = Math.min(o.slidesPerGroupSkip, c);
        d = f + Math.floor((c - f) / o.slidesPerGroup);
    }
    if ((d >= s.length && (d = s.length - 1), c === a)) {
        d !== l && ((e.snapIndex = d), e.emit("snapIndexChange"));
        return;
    }
    const u = parseInt(e.slides.eq(c).attr("data-swiper-slide-index") || c, 10);
    Object.assign(e, { snapIndex: d, realIndex: u, previousIndex: a, activeIndex: c }),
        e.emit("activeIndexChange"),
        e.emit("snapIndexChange"),
        r !== u && e.emit("realIndexChange"),
        (e.initialized || e.params.runCallbacksOnInit) && e.emit("slideChange");
}
function rs(n) {
    const e = this,
        t = e.params,
        i = L(n).closest(`.${t.slideClass}`)[0];
    let s = !1,
        o;
    if (i) {
        for (let a = 0; a < e.slides.length; a += 1)
            if (e.slides[a] === i) {
                (s = !0), (o = a);
                break;
            }
    }
    if (i && s)
        (e.clickedSlide = i),
            e.virtual && e.params.virtual.enabled
                ? (e.clickedIndex = parseInt(L(i).attr("data-swiper-slide-index"), 10))
                : (e.clickedIndex = o);
    else {
        (e.clickedSlide = void 0), (e.clickedIndex = void 0);
        return;
    }
    t.slideToClickedSlide && e.clickedIndex !== void 0 && e.clickedIndex !== e.activeIndex && e.slideToClickedSlide();
}
const ls = {
    updateSize: Qn,
    updateSlides: es,
    updateAutoHeight: ts,
    updateSlidesOffset: is,
    updateSlidesProgress: ns,
    updateProgress: ss,
    updateSlidesClasses: os,
    updateActiveIndex: as,
    updateClickedSlide: rs,
};
function cs(n = this.isHorizontal() ? "x" : "y") {
    const e = this,
        { params: t, rtlTranslate: i, translate: s, $wrapperEl: o } = e;
    if (t.virtualTranslate) return i ? -s : s;
    if (t.cssMode) return s;
    let a = Hn(o[0], n);
    return i && (a = -a), a || 0;
}
function ds(n, e) {
    const t = this,
        { rtlTranslate: i, params: s, $wrapperEl: o, wrapperEl: a, progress: r } = t;
    let l = 0,
        c = 0;
    const d = 0;
    t.isHorizontal() ? (l = i ? -n : n) : (c = n),
        s.roundLengths && ((l = Math.floor(l)), (c = Math.floor(c))),
        s.cssMode
            ? (a[t.isHorizontal() ? "scrollLeft" : "scrollTop"] = t.isHorizontal() ? -l : -c)
            : s.virtualTranslate || o.transform(`translate3d(${l}px, ${c}px, ${d}px)`),
        (t.previousTranslate = t.translate),
        (t.translate = t.isHorizontal() ? l : c);
    let u;
    const f = t.maxTranslate() - t.minTranslate();
    f === 0 ? (u = 0) : (u = (n - t.minTranslate()) / f),
        u !== r && t.updateProgress(n),
        t.emit("setTranslate", t.translate, e);
}
function us() {
    return -this.snapGrid[0];
}
function hs() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function fs(n = 0, e = this.params.speed, t = !0, i = !0, s) {
    const o = this,
        { params: a, wrapperEl: r } = o;
    if (o.animating && a.preventInteractionOnTransition) return !1;
    const l = o.minTranslate(),
        c = o.maxTranslate();
    let d;
    if ((i && n > l ? (d = l) : i && n < c ? (d = c) : (d = n), o.updateProgress(d), a.cssMode)) {
        const u = o.isHorizontal();
        if (e === 0) r[u ? "scrollLeft" : "scrollTop"] = -d;
        else {
            if (!o.support.smoothScroll) return xi({ swiper: o, targetPosition: -d, side: u ? "left" : "top" }), !0;
            r.scrollTo({ [u ? "left" : "top"]: -d, behavior: "smooth" });
        }
        return !0;
    }
    return (
        e === 0
            ? (o.setTransition(0),
              o.setTranslate(d),
              t && (o.emit("beforeTransitionStart", e, s), o.emit("transitionEnd")))
            : (o.setTransition(e),
              o.setTranslate(d),
              t && (o.emit("beforeTransitionStart", e, s), o.emit("transitionStart")),
              o.animating ||
                  ((o.animating = !0),
                  o.onTranslateToWrapperTransitionEnd ||
                      (o.onTranslateToWrapperTransitionEnd = function (f) {
                          !o ||
                              o.destroyed ||
                              (f.target === this &&
                                  (o.$wrapperEl[0].removeEventListener(
                                      "transitionend",
                                      o.onTranslateToWrapperTransitionEnd
                                  ),
                                  o.$wrapperEl[0].removeEventListener(
                                      "webkitTransitionEnd",
                                      o.onTranslateToWrapperTransitionEnd
                                  ),
                                  (o.onTranslateToWrapperTransitionEnd = null),
                                  delete o.onTranslateToWrapperTransitionEnd,
                                  t && o.emit("transitionEnd")));
                      }),
                  o.$wrapperEl[0].addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd),
                  o.$wrapperEl[0].addEventListener("webkitTransitionEnd", o.onTranslateToWrapperTransitionEnd))),
        !0
    );
}
const ps = { getTranslate: cs, setTranslate: ds, minTranslate: us, maxTranslate: hs, translateTo: fs };
function ms(n, e) {
    const t = this;
    t.params.cssMode || t.$wrapperEl.transition(n), t.emit("setTransition", n, e);
}
function Ci({ swiper: n, runCallbacks: e, direction: t, step: i }) {
    const { activeIndex: s, previousIndex: o } = n;
    let a = t;
    if ((a || (s > o ? (a = "next") : s < o ? (a = "prev") : (a = "reset")), n.emit(`transition${i}`), e && s !== o)) {
        if (a === "reset") {
            n.emit(`slideResetTransition${i}`);
            return;
        }
        n.emit(`slideChangeTransition${i}`),
            a === "next" ? n.emit(`slideNextTransition${i}`) : n.emit(`slidePrevTransition${i}`);
    }
}
function gs(n = !0, e) {
    const t = this,
        { params: i } = t;
    i.cssMode ||
        (i.autoHeight && t.updateAutoHeight(), Ci({ swiper: t, runCallbacks: n, direction: e, step: "Start" }));
}
function vs(n = !0, e) {
    const t = this,
        { params: i } = t;
    (t.animating = !1),
        !i.cssMode && (t.setTransition(0), Ci({ swiper: t, runCallbacks: n, direction: e, step: "End" }));
}
const bs = { setTransition: ms, transitionStart: gs, transitionEnd: vs };
function ys(n = 0, e = this.params.speed, t = !0, i, s) {
    if (typeof n != "number" && typeof n != "string")
        throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof n}] given.`);
    if (typeof n == "string") {
        const S = parseInt(n, 10);
        if (!isFinite(S))
            throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${n}] given.`);
        n = S;
    }
    const o = this;
    let a = n;
    a < 0 && (a = 0);
    const {
        params: r,
        snapGrid: l,
        slidesGrid: c,
        previousIndex: d,
        activeIndex: u,
        rtlTranslate: f,
        wrapperEl: h,
        enabled: g,
    } = o;
    if ((o.animating && r.preventInteractionOnTransition) || (!g && !i && !s)) return !1;
    const p = Math.min(o.params.slidesPerGroupSkip, a);
    let m = p + Math.floor((a - p) / o.params.slidesPerGroup);
    m >= l.length && (m = l.length - 1);
    const v = -l[m];
    if (r.normalizeSlideIndex)
        for (let S = 0; S < c.length; S += 1) {
            const y = -Math.floor(v * 100),
                x = Math.floor(c[S] * 100),
                C = Math.floor(c[S + 1] * 100);
            typeof c[S + 1] < "u"
                ? y >= x && y < C - (C - x) / 2
                    ? (a = S)
                    : y >= x && y < C && (a = S + 1)
                : y >= x && (a = S);
        }
    if (
        o.initialized &&
        a !== u &&
        ((!o.allowSlideNext && v < o.translate && v < o.minTranslate()) ||
            (!o.allowSlidePrev && v > o.translate && v > o.maxTranslate() && (u || 0) !== a))
    )
        return !1;
    a !== (d || 0) && t && o.emit("beforeSlideChangeStart"), o.updateProgress(v);
    let b;
    if (
        (a > u ? (b = "next") : a < u ? (b = "prev") : (b = "reset"),
        (f && -v === o.translate) || (!f && v === o.translate))
    )
        return (
            o.updateActiveIndex(a),
            r.autoHeight && o.updateAutoHeight(),
            o.updateSlidesClasses(),
            r.effect !== "slide" && o.setTranslate(v),
            b !== "reset" && (o.transitionStart(t, b), o.transitionEnd(t, b)),
            !1
        );
    if (r.cssMode) {
        const S = o.isHorizontal(),
            y = f ? v : -v;
        if (e === 0) {
            const x = o.virtual && o.params.virtual.enabled;
            x && ((o.wrapperEl.style.scrollSnapType = "none"), (o._immediateVirtual = !0)),
                (h[S ? "scrollLeft" : "scrollTop"] = y),
                x &&
                    requestAnimationFrame(() => {
                        (o.wrapperEl.style.scrollSnapType = ""), (o._swiperImmediateVirtual = !1);
                    });
        } else {
            if (!o.support.smoothScroll) return xi({ swiper: o, targetPosition: y, side: S ? "left" : "top" }), !0;
            h.scrollTo({ [S ? "left" : "top"]: y, behavior: "smooth" });
        }
        return !0;
    }
    return (
        o.setTransition(e),
        o.setTranslate(v),
        o.updateActiveIndex(a),
        o.updateSlidesClasses(),
        o.emit("beforeTransitionStart", e, i),
        o.transitionStart(t, b),
        e === 0
            ? o.transitionEnd(t, b)
            : o.animating ||
              ((o.animating = !0),
              o.onSlideToWrapperTransitionEnd ||
                  (o.onSlideToWrapperTransitionEnd = function (y) {
                      !o ||
                          o.destroyed ||
                          (y.target === this &&
                              (o.$wrapperEl[0].removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd),
                              o.$wrapperEl[0].removeEventListener(
                                  "webkitTransitionEnd",
                                  o.onSlideToWrapperTransitionEnd
                              ),
                              (o.onSlideToWrapperTransitionEnd = null),
                              delete o.onSlideToWrapperTransitionEnd,
                              o.transitionEnd(t, b)));
                  }),
              o.$wrapperEl[0].addEventListener("transitionend", o.onSlideToWrapperTransitionEnd),
              o.$wrapperEl[0].addEventListener("webkitTransitionEnd", o.onSlideToWrapperTransitionEnd)),
        !0
    );
}
function Ss(n = 0, e = this.params.speed, t = !0, i) {
    if (typeof n == "string") {
        const a = parseInt(n, 10);
        if (!isFinite(a))
            throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${n}] given.`);
        n = a;
    }
    const s = this;
    let o = n;
    return s.params.loop && (o += s.loopedSlides), s.slideTo(o, e, t, i);
}
function ws(n = this.params.speed, e = !0, t) {
    const i = this,
        { animating: s, enabled: o, params: a } = i;
    if (!o) return i;
    let r = a.slidesPerGroup;
    a.slidesPerView === "auto" &&
        a.slidesPerGroup === 1 &&
        a.slidesPerGroupAuto &&
        (r = Math.max(i.slidesPerViewDynamic("current", !0), 1));
    const l = i.activeIndex < a.slidesPerGroupSkip ? 1 : r;
    if (a.loop) {
        if (s && a.loopPreventsSlide) return !1;
        i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft);
    }
    return a.rewind && i.isEnd ? i.slideTo(0, n, e, t) : i.slideTo(i.activeIndex + l, n, e, t);
}
function xs(n = this.params.speed, e = !0, t) {
    const i = this,
        { params: s, animating: o, snapGrid: a, slidesGrid: r, rtlTranslate: l, enabled: c } = i;
    if (!c) return i;
    if (s.loop) {
        if (o && s.loopPreventsSlide) return !1;
        i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft);
    }
    const d = l ? i.translate : -i.translate;
    function u(m) {
        return m < 0 ? -Math.floor(Math.abs(m)) : Math.floor(m);
    }
    const f = u(d),
        h = a.map((m) => u(m));
    let g = a[h.indexOf(f) - 1];
    if (typeof g > "u" && s.cssMode) {
        let m;
        a.forEach((v, b) => {
            f >= v && (m = b);
        }),
            typeof m < "u" && (g = a[m > 0 ? m - 1 : m]);
    }
    let p = 0;
    if (
        (typeof g < "u" &&
            ((p = r.indexOf(g)),
            p < 0 && (p = i.activeIndex - 1),
            s.slidesPerView === "auto" &&
                s.slidesPerGroup === 1 &&
                s.slidesPerGroupAuto &&
                ((p = p - i.slidesPerViewDynamic("previous", !0) + 1), (p = Math.max(p, 0)))),
        s.rewind && i.isBeginning)
    ) {
        const m =
            i.params.virtual && i.params.virtual.enabled && i.virtual
                ? i.virtual.slides.length - 1
                : i.slides.length - 1;
        return i.slideTo(m, n, e, t);
    }
    return i.slideTo(p, n, e, t);
}
function Es(n = this.params.speed, e = !0, t) {
    const i = this;
    return i.slideTo(i.activeIndex, n, e, t);
}
function Cs(n = this.params.speed, e = !0, t, i = 0.5) {
    const s = this;
    let o = s.activeIndex;
    const a = Math.min(s.params.slidesPerGroupSkip, o),
        r = a + Math.floor((o - a) / s.params.slidesPerGroup),
        l = s.rtlTranslate ? s.translate : -s.translate;
    if (l >= s.snapGrid[r]) {
        const c = s.snapGrid[r],
            d = s.snapGrid[r + 1];
        l - c > (d - c) * i && (o += s.params.slidesPerGroup);
    } else {
        const c = s.snapGrid[r - 1],
            d = s.snapGrid[r];
        l - c <= (d - c) * i && (o -= s.params.slidesPerGroup);
    }
    return (o = Math.max(o, 0)), (o = Math.min(o, s.slidesGrid.length - 1)), s.slideTo(o, n, e, t);
}
function Ts() {
    const n = this,
        { params: e, $wrapperEl: t } = n,
        i = e.slidesPerView === "auto" ? n.slidesPerViewDynamic() : e.slidesPerView;
    let s = n.clickedIndex,
        o;
    if (e.loop) {
        if (n.animating) return;
        (o = parseInt(L(n.clickedSlide).attr("data-swiper-slide-index"), 10)),
            e.centeredSlides
                ? s < n.loopedSlides - i / 2 || s > n.slides.length - n.loopedSlides + i / 2
                    ? (n.loopFix(),
                      (s = t
                          .children(`.${e.slideClass}[data-swiper-slide-index="${o}"]:not(.${e.slideDuplicateClass})`)
                          .eq(0)
                          .index()),
                      _e(() => {
                          n.slideTo(s);
                      }))
                    : n.slideTo(s)
                : s > n.slides.length - i
                  ? (n.loopFix(),
                    (s = t
                        .children(`.${e.slideClass}[data-swiper-slide-index="${o}"]:not(.${e.slideDuplicateClass})`)
                        .eq(0)
                        .index()),
                    _e(() => {
                        n.slideTo(s);
                    }))
                  : n.slideTo(s);
    } else n.slideTo(s);
}
const Ms = {
    slideTo: ys,
    slideToLoop: Ss,
    slideNext: ws,
    slidePrev: xs,
    slideReset: Es,
    slideToClosest: Cs,
    slideToClickedSlide: Ts,
};
function Ls() {
    const n = this,
        e = H(),
        { params: t, $wrapperEl: i } = n,
        s = i.children().length > 0 ? L(i.children()[0].parentNode) : i;
    s.children(`.${t.slideClass}.${t.slideDuplicateClass}`).remove();
    let o = s.children(`.${t.slideClass}`);
    if (t.loopFillGroupWithBlank) {
        const l = t.slidesPerGroup - (o.length % t.slidesPerGroup);
        if (l !== t.slidesPerGroup) {
            for (let c = 0; c < l; c += 1) {
                const d = L(e.createElement("div")).addClass(`${t.slideClass} ${t.slideBlankClass}`);
                s.append(d);
            }
            o = s.children(`.${t.slideClass}`);
        }
    }
    t.slidesPerView === "auto" && !t.loopedSlides && (t.loopedSlides = o.length),
        (n.loopedSlides = Math.ceil(parseFloat(t.loopedSlides || t.slidesPerView, 10))),
        (n.loopedSlides += t.loopAdditionalSlides),
        n.loopedSlides > o.length && n.params.loopedSlidesLimit && (n.loopedSlides = o.length);
    const a = [],
        r = [];
    o.each((l, c) => {
        L(l).attr("data-swiper-slide-index", c);
    });
    for (let l = 0; l < n.loopedSlides; l += 1) {
        const c = l - Math.floor(l / o.length) * o.length;
        r.push(o.eq(c)[0]), a.unshift(o.eq(o.length - c - 1)[0]);
    }
    for (let l = 0; l < r.length; l += 1) s.append(L(r[l].cloneNode(!0)).addClass(t.slideDuplicateClass));
    for (let l = a.length - 1; l >= 0; l -= 1) s.prepend(L(a[l].cloneNode(!0)).addClass(t.slideDuplicateClass));
}
function Ps() {
    const n = this;
    n.emit("beforeLoopFix");
    const {
        activeIndex: e,
        slides: t,
        loopedSlides: i,
        allowSlidePrev: s,
        allowSlideNext: o,
        snapGrid: a,
        rtlTranslate: r,
    } = n;
    let l;
    (n.allowSlidePrev = !0), (n.allowSlideNext = !0);
    const d = -a[e] - n.getTranslate();
    e < i
        ? ((l = t.length - i * 3 + e),
          (l += i),
          n.slideTo(l, 0, !1, !0) && d !== 0 && n.setTranslate((r ? -n.translate : n.translate) - d))
        : e >= t.length - i &&
          ((l = -t.length + e + i),
          (l += i),
          n.slideTo(l, 0, !1, !0) && d !== 0 && n.setTranslate((r ? -n.translate : n.translate) - d)),
        (n.allowSlidePrev = s),
        (n.allowSlideNext = o),
        n.emit("loopFix");
}
function As() {
    const n = this,
        { $wrapperEl: e, params: t, slides: i } = n;
    e.children(`.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`).remove(),
        i.removeAttr("data-swiper-slide-index");
}
const ks = { loopCreate: Ls, loopFix: Ps, loopDestroy: As };
function Os(n) {
    const e = this;
    if (e.support.touch || !e.params.simulateTouch || (e.params.watchOverflow && e.isLocked) || e.params.cssMode)
        return;
    const t = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
    (t.style.cursor = "move"), (t.style.cursor = n ? "grabbing" : "grab");
}
function Is() {
    const n = this;
    n.support.touch ||
        (n.params.watchOverflow && n.isLocked) ||
        n.params.cssMode ||
        (n[n.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "");
}
const _s = { setGrabCursor: Os, unsetGrabCursor: Is };
function $s(n, e = this) {
    function t(i) {
        if (!i || i === H() || i === V()) return null;
        i.assignedSlot && (i = i.assignedSlot);
        const s = i.closest(n);
        return !s && !i.getRootNode ? null : s || t(i.getRootNode().host);
    }
    return t(e);
}
function zs(n) {
    const e = this,
        t = H(),
        i = V(),
        s = e.touchEventsData,
        { params: o, touches: a, enabled: r } = e;
    if (!r || (e.animating && o.preventInteractionOnTransition)) return;
    !e.animating && o.cssMode && o.loop && e.loopFix();
    let l = n;
    l.originalEvent && (l = l.originalEvent);
    let c = L(l.target);
    if (
        (o.touchEventsTarget === "wrapper" && !c.closest(e.wrapperEl).length) ||
        ((s.isTouchEvent = l.type === "touchstart"), !s.isTouchEvent && "which" in l && l.which === 3) ||
        (!s.isTouchEvent && "button" in l && l.button > 0) ||
        (s.isTouched && s.isMoved)
    )
        return;
    const d = !!o.noSwipingClass && o.noSwipingClass !== "",
        u = n.composedPath ? n.composedPath() : n.path;
    d && l.target && l.target.shadowRoot && u && (c = L(u[0]));
    const f = o.noSwipingSelector ? o.noSwipingSelector : `.${o.noSwipingClass}`,
        h = !!(l.target && l.target.shadowRoot);
    if (o.noSwiping && (h ? $s(f, c[0]) : c.closest(f)[0])) {
        e.allowClick = !0;
        return;
    }
    if (o.swipeHandler && !c.closest(o.swipeHandler)[0]) return;
    (a.currentX = l.type === "touchstart" ? l.targetTouches[0].pageX : l.pageX),
        (a.currentY = l.type === "touchstart" ? l.targetTouches[0].pageY : l.pageY);
    const g = a.currentX,
        p = a.currentY,
        m = o.edgeSwipeDetection || o.iOSEdgeSwipeDetection,
        v = o.edgeSwipeThreshold || o.iOSEdgeSwipeThreshold;
    if (m && (g <= v || g >= i.innerWidth - v))
        if (m === "prevent") n.preventDefault();
        else return;
    if (
        (Object.assign(s, {
            isTouched: !0,
            isMoved: !1,
            allowTouchCallbacks: !0,
            isScrolling: void 0,
            startMoving: void 0,
        }),
        (a.startX = g),
        (a.startY = p),
        (s.touchStartTime = $e()),
        (e.allowClick = !0),
        e.updateSize(),
        (e.swipeDirection = void 0),
        o.threshold > 0 && (s.allowThresholdMove = !1),
        l.type !== "touchstart")
    ) {
        let b = !0;
        c.is(s.focusableElements) && ((b = !1), c[0].nodeName === "SELECT" && (s.isTouched = !1)),
            t.activeElement &&
                L(t.activeElement).is(s.focusableElements) &&
                t.activeElement !== c[0] &&
                t.activeElement.blur();
        const S = b && e.allowTouchMove && o.touchStartPreventDefault;
        (o.touchStartForcePreventDefault || S) && !c[0].isContentEditable && l.preventDefault();
    }
    e.params.freeMode &&
        e.params.freeMode.enabled &&
        e.freeMode &&
        e.animating &&
        !o.cssMode &&
        e.freeMode.onTouchStart(),
        e.emit("touchStart", l);
}
function Ds(n) {
    const e = H(),
        t = this,
        i = t.touchEventsData,
        { params: s, touches: o, rtlTranslate: a, enabled: r } = t;
    if (!r) return;
    let l = n;
    if ((l.originalEvent && (l = l.originalEvent), !i.isTouched)) {
        i.startMoving && i.isScrolling && t.emit("touchMoveOpposite", l);
        return;
    }
    if (i.isTouchEvent && l.type !== "touchmove") return;
    const c = l.type === "touchmove" && l.targetTouches && (l.targetTouches[0] || l.changedTouches[0]),
        d = l.type === "touchmove" ? c.pageX : l.pageX,
        u = l.type === "touchmove" ? c.pageY : l.pageY;
    if (l.preventedByNestedSwiper) {
        (o.startX = d), (o.startY = u);
        return;
    }
    if (!t.allowTouchMove) {
        L(l.target).is(i.focusableElements) || (t.allowClick = !1),
            i.isTouched &&
                (Object.assign(o, { startX: d, startY: u, currentX: d, currentY: u }), (i.touchStartTime = $e()));
        return;
    }
    if (i.isTouchEvent && s.touchReleaseOnEdges && !s.loop) {
        if (t.isVertical()) {
            if (
                (u < o.startY && t.translate <= t.maxTranslate()) ||
                (u > o.startY && t.translate >= t.minTranslate())
            ) {
                (i.isTouched = !1), (i.isMoved = !1);
                return;
            }
        } else if (
            (d < o.startX && t.translate <= t.maxTranslate()) ||
            (d > o.startX && t.translate >= t.minTranslate())
        )
            return;
    }
    if (i.isTouchEvent && e.activeElement && l.target === e.activeElement && L(l.target).is(i.focusableElements)) {
        (i.isMoved = !0), (t.allowClick = !1);
        return;
    }
    if ((i.allowTouchCallbacks && t.emit("touchMove", l), l.targetTouches && l.targetTouches.length > 1)) return;
    (o.currentX = d), (o.currentY = u);
    const f = o.currentX - o.startX,
        h = o.currentY - o.startY;
    if (t.params.threshold && Math.sqrt(f ** 2 + h ** 2) < t.params.threshold) return;
    if (typeof i.isScrolling > "u") {
        let v;
        (t.isHorizontal() && o.currentY === o.startY) || (t.isVertical() && o.currentX === o.startX)
            ? (i.isScrolling = !1)
            : f * f + h * h >= 25 &&
              ((v = (Math.atan2(Math.abs(h), Math.abs(f)) * 180) / Math.PI),
              (i.isScrolling = t.isHorizontal() ? v > s.touchAngle : 90 - v > s.touchAngle));
    }
    if (
        (i.isScrolling && t.emit("touchMoveOpposite", l),
        typeof i.startMoving > "u" && (o.currentX !== o.startX || o.currentY !== o.startY) && (i.startMoving = !0),
        i.isScrolling)
    ) {
        i.isTouched = !1;
        return;
    }
    if (!i.startMoving) return;
    (t.allowClick = !1),
        !s.cssMode && l.cancelable && l.preventDefault(),
        s.touchMoveStopPropagation && !s.nested && l.stopPropagation(),
        i.isMoved ||
            (s.loop && !s.cssMode && t.loopFix(),
            (i.startTranslate = t.getTranslate()),
            t.setTransition(0),
            t.animating && t.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
            (i.allowMomentumBounce = !1),
            s.grabCursor && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!0),
            t.emit("sliderFirstMove", l)),
        t.emit("sliderMove", l),
        (i.isMoved = !0);
    let g = t.isHorizontal() ? f : h;
    (o.diff = g),
        (g *= s.touchRatio),
        a && (g = -g),
        (t.swipeDirection = g > 0 ? "prev" : "next"),
        (i.currentTranslate = g + i.startTranslate);
    let p = !0,
        m = s.resistanceRatio;
    if (
        (s.touchReleaseOnEdges && (m = 0),
        g > 0 && i.currentTranslate > t.minTranslate()
            ? ((p = !1),
              s.resistance &&
                  (i.currentTranslate = t.minTranslate() - 1 + (-t.minTranslate() + i.startTranslate + g) ** m))
            : g < 0 &&
              i.currentTranslate < t.maxTranslate() &&
              ((p = !1),
              s.resistance &&
                  (i.currentTranslate = t.maxTranslate() + 1 - (t.maxTranslate() - i.startTranslate - g) ** m)),
        p && (l.preventedByNestedSwiper = !0),
        !t.allowSlideNext &&
            t.swipeDirection === "next" &&
            i.currentTranslate < i.startTranslate &&
            (i.currentTranslate = i.startTranslate),
        !t.allowSlidePrev &&
            t.swipeDirection === "prev" &&
            i.currentTranslate > i.startTranslate &&
            (i.currentTranslate = i.startTranslate),
        !t.allowSlidePrev && !t.allowSlideNext && (i.currentTranslate = i.startTranslate),
        s.threshold > 0)
    )
        if (Math.abs(g) > s.threshold || i.allowThresholdMove) {
            if (!i.allowThresholdMove) {
                (i.allowThresholdMove = !0),
                    (o.startX = o.currentX),
                    (o.startY = o.currentY),
                    (i.currentTranslate = i.startTranslate),
                    (o.diff = t.isHorizontal() ? o.currentX - o.startX : o.currentY - o.startY);
                return;
            }
        } else {
            i.currentTranslate = i.startTranslate;
            return;
        }
    !s.followFinger ||
        s.cssMode ||
        (((s.freeMode && s.freeMode.enabled && t.freeMode) || s.watchSlidesProgress) &&
            (t.updateActiveIndex(), t.updateSlidesClasses()),
        t.params.freeMode && s.freeMode.enabled && t.freeMode && t.freeMode.onTouchMove(),
        t.updateProgress(i.currentTranslate),
        t.setTranslate(i.currentTranslate));
}
function Rs(n) {
    const e = this,
        t = e.touchEventsData,
        { params: i, touches: s, rtlTranslate: o, slidesGrid: a, enabled: r } = e;
    if (!r) return;
    let l = n;
    if (
        (l.originalEvent && (l = l.originalEvent),
        t.allowTouchCallbacks && e.emit("touchEnd", l),
        (t.allowTouchCallbacks = !1),
        !t.isTouched)
    ) {
        t.isMoved && i.grabCursor && e.setGrabCursor(!1), (t.isMoved = !1), (t.startMoving = !1);
        return;
    }
    i.grabCursor &&
        t.isMoved &&
        t.isTouched &&
        (e.allowSlideNext === !0 || e.allowSlidePrev === !0) &&
        e.setGrabCursor(!1);
    const c = $e(),
        d = c - t.touchStartTime;
    if (e.allowClick) {
        const b = l.path || (l.composedPath && l.composedPath());
        e.updateClickedSlide((b && b[0]) || l.target),
            e.emit("tap click", l),
            d < 300 && c - t.lastClickTime < 300 && e.emit("doubleTap doubleClick", l);
    }
    if (
        ((t.lastClickTime = $e()),
        _e(() => {
            e.destroyed || (e.allowClick = !0);
        }),
        !t.isTouched || !t.isMoved || !e.swipeDirection || s.diff === 0 || t.currentTranslate === t.startTranslate)
    ) {
        (t.isTouched = !1), (t.isMoved = !1), (t.startMoving = !1);
        return;
    }
    (t.isTouched = !1), (t.isMoved = !1), (t.startMoving = !1);
    let u;
    if ((i.followFinger ? (u = o ? e.translate : -e.translate) : (u = -t.currentTranslate), i.cssMode)) return;
    if (e.params.freeMode && i.freeMode.enabled) {
        e.freeMode.onTouchEnd({ currentPos: u });
        return;
    }
    let f = 0,
        h = e.slidesSizesGrid[0];
    for (let b = 0; b < a.length; b += b < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup) {
        const S = b < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
        typeof a[b + S] < "u"
            ? u >= a[b] && u < a[b + S] && ((f = b), (h = a[b + S] - a[b]))
            : u >= a[b] && ((f = b), (h = a[a.length - 1] - a[a.length - 2]));
    }
    let g = null,
        p = null;
    i.rewind &&
        (e.isBeginning
            ? (p =
                  e.params.virtual && e.params.virtual.enabled && e.virtual
                      ? e.virtual.slides.length - 1
                      : e.slides.length - 1)
            : e.isEnd && (g = 0));
    const m = (u - a[f]) / h,
        v = f < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
    if (d > i.longSwipesMs) {
        if (!i.longSwipes) {
            e.slideTo(e.activeIndex);
            return;
        }
        e.swipeDirection === "next" &&
            (m >= i.longSwipesRatio ? e.slideTo(i.rewind && e.isEnd ? g : f + v) : e.slideTo(f)),
            e.swipeDirection === "prev" &&
                (m > 1 - i.longSwipesRatio
                    ? e.slideTo(f + v)
                    : p !== null && m < 0 && Math.abs(m) > i.longSwipesRatio
                      ? e.slideTo(p)
                      : e.slideTo(f));
    } else {
        if (!i.shortSwipes) {
            e.slideTo(e.activeIndex);
            return;
        }
        e.navigation && (l.target === e.navigation.nextEl || l.target === e.navigation.prevEl)
            ? l.target === e.navigation.nextEl
                ? e.slideTo(f + v)
                : e.slideTo(f)
            : (e.swipeDirection === "next" && e.slideTo(g !== null ? g : f + v),
              e.swipeDirection === "prev" && e.slideTo(p !== null ? p : f));
    }
}
function qt() {
    const n = this,
        { params: e, el: t } = n;
    if (t && t.offsetWidth === 0) return;
    e.breakpoints && n.setBreakpoint();
    const { allowSlideNext: i, allowSlidePrev: s, snapGrid: o } = n;
    (n.allowSlideNext = !0),
        (n.allowSlidePrev = !0),
        n.updateSize(),
        n.updateSlides(),
        n.updateSlidesClasses(),
        (e.slidesPerView === "auto" || e.slidesPerView > 1) && n.isEnd && !n.isBeginning && !n.params.centeredSlides
            ? n.slideTo(n.slides.length - 1, 0, !1, !0)
            : n.slideTo(n.activeIndex, 0, !1, !0),
        n.autoplay && n.autoplay.running && n.autoplay.paused && n.autoplay.run(),
        (n.allowSlidePrev = s),
        (n.allowSlideNext = i),
        n.params.watchOverflow && o !== n.snapGrid && n.checkOverflow();
}
function qs(n) {
    const e = this;
    e.enabled &&
        (e.allowClick ||
            (e.params.preventClicks && n.preventDefault(),
            e.params.preventClicksPropagation && e.animating && (n.stopPropagation(), n.stopImmediatePropagation())));
}
function Fs() {
    const n = this,
        { wrapperEl: e, rtlTranslate: t, enabled: i } = n;
    if (!i) return;
    (n.previousTranslate = n.translate),
        n.isHorizontal() ? (n.translate = -e.scrollLeft) : (n.translate = -e.scrollTop),
        n.translate === 0 && (n.translate = 0),
        n.updateActiveIndex(),
        n.updateSlidesClasses();
    let s;
    const o = n.maxTranslate() - n.minTranslate();
    o === 0 ? (s = 0) : (s = (n.translate - n.minTranslate()) / o),
        s !== n.progress && n.updateProgress(t ? -n.translate : n.translate),
        n.emit("setTranslate", n.translate, !1);
}
let Ft = !1;
function Ns() {}
const Ti = (n, e) => {
    const t = H(),
        { params: i, touchEvents: s, el: o, wrapperEl: a, device: r, support: l } = n,
        c = !!i.nested,
        d = e === "on" ? "addEventListener" : "removeEventListener",
        u = e;
    if (!l.touch) o[d](s.start, n.onTouchStart, !1), t[d](s.move, n.onTouchMove, c), t[d](s.end, n.onTouchEnd, !1);
    else {
        const f =
            s.start === "touchstart" && l.passiveListener && i.passiveListeners ? { passive: !0, capture: !1 } : !1;
        o[d](s.start, n.onTouchStart, f),
            o[d](s.move, n.onTouchMove, l.passiveListener ? { passive: !1, capture: c } : c),
            o[d](s.end, n.onTouchEnd, f),
            s.cancel && o[d](s.cancel, n.onTouchEnd, f);
    }
    (i.preventClicks || i.preventClicksPropagation) && o[d]("click", n.onClick, !0),
        i.cssMode && a[d]("scroll", n.onScroll),
        i.updateOnWindowResize
            ? n[u](r.ios || r.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", qt, !0)
            : n[u]("observerUpdate", qt, !0);
};
function js() {
    const n = this,
        e = H(),
        { params: t, support: i } = n;
    (n.onTouchStart = zs.bind(n)),
        (n.onTouchMove = Ds.bind(n)),
        (n.onTouchEnd = Rs.bind(n)),
        t.cssMode && (n.onScroll = Fs.bind(n)),
        (n.onClick = qs.bind(n)),
        i.touch && !Ft && (e.addEventListener("touchstart", Ns), (Ft = !0)),
        Ti(n, "on");
}
function Bs() {
    Ti(this, "off");
}
const Hs = { attachEvents: js, detachEvents: Bs },
    Nt = (n, e) => n.grid && e.grid && e.grid.rows > 1;
function Vs() {
    const n = this,
        { activeIndex: e, initialized: t, loopedSlides: i = 0, params: s, $el: o } = n,
        a = s.breakpoints;
    if (!a || (a && Object.keys(a).length === 0)) return;
    const r = n.getBreakpoint(a, n.params.breakpointsBase, n.el);
    if (!r || n.currentBreakpoint === r) return;
    const c = (r in a ? a[r] : void 0) || n.originalParams,
        d = Nt(n, s),
        u = Nt(n, c),
        f = s.enabled;
    d && !u
        ? (o.removeClass(`${s.containerModifierClass}grid ${s.containerModifierClass}grid-column`),
          n.emitContainerClasses())
        : !d &&
          u &&
          (o.addClass(`${s.containerModifierClass}grid`),
          ((c.grid.fill && c.grid.fill === "column") || (!c.grid.fill && s.grid.fill === "column")) &&
              o.addClass(`${s.containerModifierClass}grid-column`),
          n.emitContainerClasses()),
        ["navigation", "pagination", "scrollbar"].forEach((m) => {
            const v = s[m] && s[m].enabled,
                b = c[m] && c[m].enabled;
            v && !b && n[m].disable(), !v && b && n[m].enable();
        });
    const h = c.direction && c.direction !== s.direction,
        g = s.loop && (c.slidesPerView !== s.slidesPerView || h);
    h && t && n.changeDirection(), Z(n.params, c);
    const p = n.params.enabled;
    Object.assign(n, {
        allowTouchMove: n.params.allowTouchMove,
        allowSlideNext: n.params.allowSlideNext,
        allowSlidePrev: n.params.allowSlidePrev,
    }),
        f && !p ? n.disable() : !f && p && n.enable(),
        (n.currentBreakpoint = r),
        n.emit("_beforeBreakpoint", c),
        g && t && (n.loopDestroy(), n.loopCreate(), n.updateSlides(), n.slideTo(e - i + n.loopedSlides, 0, !1)),
        n.emit("breakpoint", c);
}
function Gs(n, e = "window", t) {
    if (!n || (e === "container" && !t)) return;
    let i = !1;
    const s = V(),
        o = e === "window" ? s.innerHeight : t.clientHeight,
        a = Object.keys(n).map((r) => {
            if (typeof r == "string" && r.indexOf("@") === 0) {
                const l = parseFloat(r.substr(1));
                return { value: o * l, point: r };
            }
            return { value: r, point: r };
        });
    a.sort((r, l) => parseInt(r.value, 10) - parseInt(l.value, 10));
    for (let r = 0; r < a.length; r += 1) {
        const { point: l, value: c } = a[r];
        e === "window" ? s.matchMedia(`(min-width: ${c}px)`).matches && (i = l) : c <= t.clientWidth && (i = l);
    }
    return i || "max";
}
const Ws = { setBreakpoint: Vs, getBreakpoint: Gs };
function Xs(n, e) {
    const t = [];
    return (
        n.forEach((i) => {
            typeof i == "object"
                ? Object.keys(i).forEach((s) => {
                      i[s] && t.push(e + s);
                  })
                : typeof i == "string" && t.push(e + i);
        }),
        t
    );
}
function Ys() {
    const n = this,
        { classNames: e, params: t, rtl: i, $el: s, device: o, support: a } = n,
        r = Xs(
            [
                "initialized",
                t.direction,
                { "pointer-events": !a.touch },
                { "free-mode": n.params.freeMode && t.freeMode.enabled },
                { autoheight: t.autoHeight },
                { rtl: i },
                { grid: t.grid && t.grid.rows > 1 },
                { "grid-column": t.grid && t.grid.rows > 1 && t.grid.fill === "column" },
                { android: o.android },
                { ios: o.ios },
                { "css-mode": t.cssMode },
                { centered: t.cssMode && t.centeredSlides },
                { "watch-progress": t.watchSlidesProgress },
            ],
            t.containerModifierClass
        );
    e.push(...r), s.addClass([...e].join(" ")), n.emitContainerClasses();
}
function Us() {
    const n = this,
        { $el: e, classNames: t } = n;
    e.removeClass(t.join(" ")), n.emitContainerClasses();
}
const Zs = { addClasses: Ys, removeClasses: Us };
function Ks(n, e, t, i, s, o) {
    const a = V();
    let r;
    function l() {
        o && o();
    }
    !L(n).parent("picture")[0] && (!n.complete || !s) && e
        ? ((r = new a.Image()),
          (r.onload = l),
          (r.onerror = l),
          i && (r.sizes = i),
          t && (r.srcset = t),
          e && (r.src = e))
        : l();
}
function Js() {
    const n = this;
    n.imagesToLoad = n.$el.find("img");
    function e() {
        typeof n > "u" ||
            n === null ||
            !n ||
            n.destroyed ||
            (n.imagesLoaded !== void 0 && (n.imagesLoaded += 1),
            n.imagesLoaded === n.imagesToLoad.length &&
                (n.params.updateOnImagesReady && n.update(), n.emit("imagesReady")));
    }
    for (let t = 0; t < n.imagesToLoad.length; t += 1) {
        const i = n.imagesToLoad[t];
        n.loadImage(
            i,
            i.currentSrc || i.getAttribute("src"),
            i.srcset || i.getAttribute("srcset"),
            i.sizes || i.getAttribute("sizes"),
            !0,
            e
        );
    }
}
const Qs = { loadImage: Ks, preloadImages: Js };
function eo() {
    const n = this,
        { isLocked: e, params: t } = n,
        { slidesOffsetBefore: i } = t;
    if (i) {
        const s = n.slides.length - 1,
            o = n.slidesGrid[s] + n.slidesSizesGrid[s] + i * 2;
        n.isLocked = n.size > o;
    } else n.isLocked = n.snapGrid.length === 1;
    t.allowSlideNext === !0 && (n.allowSlideNext = !n.isLocked),
        t.allowSlidePrev === !0 && (n.allowSlidePrev = !n.isLocked),
        e && e !== n.isLocked && (n.isEnd = !1),
        e !== n.isLocked && n.emit(n.isLocked ? "lock" : "unlock");
}
const to = { checkOverflow: eo },
    jt = {
        init: !0,
        direction: "horizontal",
        touchEventsTarget: "wrapper",
        initialSlide: 0,
        speed: 300,
        cssMode: !1,
        updateOnWindowResize: !0,
        resizeObserver: !0,
        nested: !1,
        createElements: !1,
        enabled: !0,
        focusableElements: "input, select, option, textarea, button, video, label",
        width: null,
        height: null,
        preventInteractionOnTransition: !1,
        userAgent: null,
        url: null,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: "slide",
        breakpoints: void 0,
        breakpointsBase: "window",
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        slidesPerGroupAuto: !1,
        centeredSlides: !1,
        centeredSlidesBounds: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !0,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: 0.5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 0,
        touchMoveStopPropagation: !1,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: 0.85,
        watchSlidesProgress: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        preloadImages: !0,
        updateOnImagesReady: !0,
        loop: !1,
        loopAdditionalSlides: 0,
        loopedSlides: null,
        loopedSlidesLimit: !0,
        loopFillGroupWithBlank: !1,
        loopPreventsSlide: !0,
        rewind: !1,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: "swiper-no-swiping",
        noSwipingSelector: null,
        passiveListeners: !0,
        maxBackfaceHiddenSlides: 10,
        containerModifierClass: "swiper-",
        slideClass: "swiper-slide",
        slideBlankClass: "swiper-slide-invisible-blank",
        slideActiveClass: "swiper-slide-active",
        slideDuplicateActiveClass: "swiper-slide-duplicate-active",
        slideVisibleClass: "swiper-slide-visible",
        slideDuplicateClass: "swiper-slide-duplicate",
        slideNextClass: "swiper-slide-next",
        slideDuplicateNextClass: "swiper-slide-duplicate-next",
        slidePrevClass: "swiper-slide-prev",
        slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
        wrapperClass: "swiper-wrapper",
        runCallbacksOnInit: !0,
        _emitClasses: !1,
    };
function io(n, e) {
    return function (i = {}) {
        const s = Object.keys(i)[0],
            o = i[s];
        if (typeof o != "object" || o === null) {
            Z(e, i);
            return;
        }
        if (
            (["navigation", "pagination", "scrollbar"].indexOf(s) >= 0 && n[s] === !0 && (n[s] = { auto: !0 }),
            !(s in n && "enabled" in o))
        ) {
            Z(e, i);
            return;
        }
        n[s] === !0 && (n[s] = { enabled: !0 }),
            typeof n[s] == "object" && !("enabled" in n[s]) && (n[s].enabled = !0),
            n[s] || (n[s] = { enabled: !1 }),
            Z(e, i);
    };
}
const at = {
        eventsEmitter: Jn,
        update: ls,
        translate: ps,
        transition: bs,
        slide: Ms,
        loop: ks,
        grabCursor: _s,
        events: Hs,
        breakpoints: Ws,
        checkOverflow: to,
        classes: Zs,
        images: Qs,
    },
    rt = {};
class W {
    constructor(...e) {
        let t, i;
        if (
            (e.length === 1 && e[0].constructor && Object.prototype.toString.call(e[0]).slice(8, -1) === "Object"
                ? (i = e[0])
                : ([t, i] = e),
            i || (i = {}),
            (i = Z({}, i)),
            t && !i.el && (i.el = t),
            i.el && L(i.el).length > 1)
        ) {
            const r = [];
            return (
                L(i.el).each((l) => {
                    const c = Z({}, i, { el: l });
                    r.push(new W(c));
                }),
                r
            );
        }
        const s = this;
        (s.__swiper__ = !0),
            (s.support = Ei()),
            (s.device = Xn({ userAgent: i.userAgent })),
            (s.browser = Un()),
            (s.eventsListeners = {}),
            (s.eventsAnyListeners = []),
            (s.modules = [...s.__modules__]),
            i.modules && Array.isArray(i.modules) && s.modules.push(...i.modules);
        const o = {};
        s.modules.forEach((r) => {
            r({
                swiper: s,
                extendParams: io(i, o),
                on: s.on.bind(s),
                once: s.once.bind(s),
                off: s.off.bind(s),
                emit: s.emit.bind(s),
            });
        });
        const a = Z({}, jt, o);
        return (
            (s.params = Z({}, a, rt, i)),
            (s.originalParams = Z({}, s.params)),
            (s.passedParams = Z({}, i)),
            s.params &&
                s.params.on &&
                Object.keys(s.params.on).forEach((r) => {
                    s.on(r, s.params.on[r]);
                }),
            s.params && s.params.onAny && s.onAny(s.params.onAny),
            (s.$ = L),
            Object.assign(s, {
                enabled: s.params.enabled,
                el: t,
                classNames: [],
                slides: L(),
                slidesGrid: [],
                snapGrid: [],
                slidesSizesGrid: [],
                isHorizontal() {
                    return s.params.direction === "horizontal";
                },
                isVertical() {
                    return s.params.direction === "vertical";
                },
                activeIndex: 0,
                realIndex: 0,
                isBeginning: !0,
                isEnd: !1,
                translate: 0,
                previousTranslate: 0,
                progress: 0,
                velocity: 0,
                animating: !1,
                allowSlideNext: s.params.allowSlideNext,
                allowSlidePrev: s.params.allowSlidePrev,
                touchEvents: (function () {
                    const l = ["touchstart", "touchmove", "touchend", "touchcancel"],
                        c = ["pointerdown", "pointermove", "pointerup"];
                    return (
                        (s.touchEventsTouch = { start: l[0], move: l[1], end: l[2], cancel: l[3] }),
                        (s.touchEventsDesktop = { start: c[0], move: c[1], end: c[2] }),
                        s.support.touch || !s.params.simulateTouch ? s.touchEventsTouch : s.touchEventsDesktop
                    );
                })(),
                touchEventsData: {
                    isTouched: void 0,
                    isMoved: void 0,
                    allowTouchCallbacks: void 0,
                    touchStartTime: void 0,
                    isScrolling: void 0,
                    currentTranslate: void 0,
                    startTranslate: void 0,
                    allowThresholdMove: void 0,
                    focusableElements: s.params.focusableElements,
                    lastClickTime: $e(),
                    clickTimeout: void 0,
                    velocities: [],
                    allowMomentumBounce: void 0,
                    isTouchEvent: void 0,
                    startMoving: void 0,
                },
                allowClick: !0,
                allowTouchMove: s.params.allowTouchMove,
                touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
                imagesToLoad: [],
                imagesLoaded: 0,
            }),
            s.emit("_swiper"),
            s.params.init && s.init(),
            s
        );
    }
    enable() {
        const e = this;
        e.enabled || ((e.enabled = !0), e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
    }
    disable() {
        const e = this;
        e.enabled && ((e.enabled = !1), e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
    }
    setProgress(e, t) {
        const i = this;
        e = Math.min(Math.max(e, 0), 1);
        const s = i.minTranslate(),
            a = (i.maxTranslate() - s) * e + s;
        i.translateTo(a, typeof t > "u" ? 0 : t), i.updateActiveIndex(), i.updateSlidesClasses();
    }
    emitContainerClasses() {
        const e = this;
        if (!e.params._emitClasses || !e.el) return;
        const t = e.el.className
            .split(" ")
            .filter((i) => i.indexOf("swiper") === 0 || i.indexOf(e.params.containerModifierClass) === 0);
        e.emit("_containerClasses", t.join(" "));
    }
    getSlideClasses(e) {
        const t = this;
        return t.destroyed
            ? ""
            : e.className
                  .split(" ")
                  .filter((i) => i.indexOf("swiper-slide") === 0 || i.indexOf(t.params.slideClass) === 0)
                  .join(" ");
    }
    emitSlidesClasses() {
        const e = this;
        if (!e.params._emitClasses || !e.el) return;
        const t = [];
        e.slides.each((i) => {
            const s = e.getSlideClasses(i);
            t.push({ slideEl: i, classNames: s }), e.emit("_slideClass", i, s);
        }),
            e.emit("_slideClasses", t);
    }
    slidesPerViewDynamic(e = "current", t = !1) {
        const i = this,
            { params: s, slides: o, slidesGrid: a, slidesSizesGrid: r, size: l, activeIndex: c } = i;
        let d = 1;
        if (s.centeredSlides) {
            let u = o[c].swiperSlideSize,
                f;
            for (let h = c + 1; h < o.length; h += 1)
                o[h] && !f && ((u += o[h].swiperSlideSize), (d += 1), u > l && (f = !0));
            for (let h = c - 1; h >= 0; h -= 1)
                o[h] && !f && ((u += o[h].swiperSlideSize), (d += 1), u > l && (f = !0));
        } else if (e === "current")
            for (let u = c + 1; u < o.length; u += 1) (t ? a[u] + r[u] - a[c] < l : a[u] - a[c] < l) && (d += 1);
        else for (let u = c - 1; u >= 0; u -= 1) a[c] - a[u] < l && (d += 1);
        return d;
    }
    update() {
        const e = this;
        if (!e || e.destroyed) return;
        const { snapGrid: t, params: i } = e;
        i.breakpoints && e.setBreakpoint(),
            e.updateSize(),
            e.updateSlides(),
            e.updateProgress(),
            e.updateSlidesClasses();
        function s() {
            const a = e.rtlTranslate ? e.translate * -1 : e.translate,
                r = Math.min(Math.max(a, e.maxTranslate()), e.minTranslate());
            e.setTranslate(r), e.updateActiveIndex(), e.updateSlidesClasses();
        }
        let o;
        e.params.freeMode && e.params.freeMode.enabled
            ? (s(), e.params.autoHeight && e.updateAutoHeight())
            : ((e.params.slidesPerView === "auto" || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides
                  ? (o = e.slideTo(e.slides.length - 1, 0, !1, !0))
                  : (o = e.slideTo(e.activeIndex, 0, !1, !0)),
              o || s()),
            i.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
            e.emit("update");
    }
    changeDirection(e, t = !0) {
        const i = this,
            s = i.params.direction;
        return (
            e || (e = s === "horizontal" ? "vertical" : "horizontal"),
            e === s ||
                (e !== "horizontal" && e !== "vertical") ||
                (i.$el
                    .removeClass(`${i.params.containerModifierClass}${s}`)
                    .addClass(`${i.params.containerModifierClass}${e}`),
                i.emitContainerClasses(),
                (i.params.direction = e),
                i.slides.each((o) => {
                    e === "vertical" ? (o.style.width = "") : (o.style.height = "");
                }),
                i.emit("changeDirection"),
                t && i.update()),
            i
        );
    }
    changeLanguageDirection(e) {
        const t = this;
        (t.rtl && e === "rtl") ||
            (!t.rtl && e === "ltr") ||
            ((t.rtl = e === "rtl"),
            (t.rtlTranslate = t.params.direction === "horizontal" && t.rtl),
            t.rtl
                ? (t.$el.addClass(`${t.params.containerModifierClass}rtl`), (t.el.dir = "rtl"))
                : (t.$el.removeClass(`${t.params.containerModifierClass}rtl`), (t.el.dir = "ltr")),
            t.update());
    }
    mount(e) {
        const t = this;
        if (t.mounted) return !0;
        const i = L(e || t.params.el);
        if (((e = i[0]), !e)) return !1;
        e.swiper = t;
        const s = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
        let a = (() => {
            if (e && e.shadowRoot && e.shadowRoot.querySelector) {
                const r = L(e.shadowRoot.querySelector(s()));
                return (r.children = (l) => i.children(l)), r;
            }
            return i.children ? i.children(s()) : L(i).children(s());
        })();
        if (a.length === 0 && t.params.createElements) {
            const l = H().createElement("div");
            (a = L(l)),
                (l.className = t.params.wrapperClass),
                i.append(l),
                i.children(`.${t.params.slideClass}`).each((c) => {
                    a.append(c);
                });
        }
        return (
            Object.assign(t, {
                $el: i,
                el: e,
                $wrapperEl: a,
                wrapperEl: a[0],
                mounted: !0,
                rtl: e.dir.toLowerCase() === "rtl" || i.css("direction") === "rtl",
                rtlTranslate:
                    t.params.direction === "horizontal" &&
                    (e.dir.toLowerCase() === "rtl" || i.css("direction") === "rtl"),
                wrongRTL: a.css("display") === "-webkit-box",
            }),
            !0
        );
    }
    init(e) {
        const t = this;
        return (
            t.initialized ||
                t.mount(e) === !1 ||
                (t.emit("beforeInit"),
                t.params.breakpoints && t.setBreakpoint(),
                t.addClasses(),
                t.params.loop && t.loopCreate(),
                t.updateSize(),
                t.updateSlides(),
                t.params.watchOverflow && t.checkOverflow(),
                t.params.grabCursor && t.enabled && t.setGrabCursor(),
                t.params.preloadImages && t.preloadImages(),
                t.params.loop
                    ? t.slideTo(t.params.initialSlide + t.loopedSlides, 0, t.params.runCallbacksOnInit, !1, !0)
                    : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
                t.attachEvents(),
                (t.initialized = !0),
                t.emit("init"),
                t.emit("afterInit")),
            t
        );
    }
    destroy(e = !0, t = !0) {
        const i = this,
            { params: s, $el: o, $wrapperEl: a, slides: r } = i;
        return (
            typeof i.params > "u" ||
                i.destroyed ||
                (i.emit("beforeDestroy"),
                (i.initialized = !1),
                i.detachEvents(),
                s.loop && i.loopDestroy(),
                t &&
                    (i.removeClasses(),
                    o.removeAttr("style"),
                    a.removeAttr("style"),
                    r &&
                        r.length &&
                        r
                            .removeClass(
                                [s.slideVisibleClass, s.slideActiveClass, s.slideNextClass, s.slidePrevClass].join(" ")
                            )
                            .removeAttr("style")
                            .removeAttr("data-swiper-slide-index")),
                i.emit("destroy"),
                Object.keys(i.eventsListeners).forEach((l) => {
                    i.off(l);
                }),
                e !== !1 && ((i.$el[0].swiper = null), jn(i)),
                (i.destroyed = !0)),
            null
        );
    }
    static extendDefaults(e) {
        Z(rt, e);
    }
    static get extendedDefaults() {
        return rt;
    }
    static get defaults() {
        return jt;
    }
    static installModule(e) {
        W.prototype.__modules__ || (W.prototype.__modules__ = []);
        const t = W.prototype.__modules__;
        typeof e == "function" && t.indexOf(e) < 0 && t.push(e);
    }
    static use(e) {
        return Array.isArray(e) ? (e.forEach((t) => W.installModule(t)), W) : (W.installModule(e), W);
    }
}
Object.keys(at).forEach((n) => {
    Object.keys(at[n]).forEach((e) => {
        W.prototype[e] = at[n][e];
    });
});
W.use([Zn, Kn]);
function Pt(n, e, t, i) {
    const s = H();
    return (
        n.params.createElements &&
            Object.keys(i).forEach((o) => {
                if (!t[o] && t.auto === !0) {
                    let a = n.$el.children(`.${i[o]}`)[0];
                    a || ((a = s.createElement("div")), (a.className = i[o]), n.$el.append(a)), (t[o] = a), (e[o] = a);
                }
            }),
        t
    );
}
function no({ swiper: n, extendParams: e, on: t, emit: i }) {
    e({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: !1,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled",
        },
    }),
        (n.navigation = { nextEl: null, $nextEl: null, prevEl: null, $prevEl: null });
    function s(h) {
        let g;
        return (
            h &&
                ((g = L(h)),
                n.params.uniqueNavElements &&
                    typeof h == "string" &&
                    g.length > 1 &&
                    n.$el.find(h).length === 1 &&
                    (g = n.$el.find(h))),
            g
        );
    }
    function o(h, g) {
        const p = n.params.navigation;
        h &&
            h.length > 0 &&
            (h[g ? "addClass" : "removeClass"](p.disabledClass),
            h[0] && h[0].tagName === "BUTTON" && (h[0].disabled = g),
            n.params.watchOverflow && n.enabled && h[n.isLocked ? "addClass" : "removeClass"](p.lockClass));
    }
    function a() {
        if (n.params.loop) return;
        const { $nextEl: h, $prevEl: g } = n.navigation;
        o(g, n.isBeginning && !n.params.rewind), o(h, n.isEnd && !n.params.rewind);
    }
    function r(h) {
        h.preventDefault(),
            !(n.isBeginning && !n.params.loop && !n.params.rewind) && (n.slidePrev(), i("navigationPrev"));
    }
    function l(h) {
        h.preventDefault(), !(n.isEnd && !n.params.loop && !n.params.rewind) && (n.slideNext(), i("navigationNext"));
    }
    function c() {
        const h = n.params.navigation;
        if (
            ((n.params.navigation = Pt(n, n.originalParams.navigation, n.params.navigation, {
                nextEl: "swiper-button-next",
                prevEl: "swiper-button-prev",
            })),
            !(h.nextEl || h.prevEl))
        )
            return;
        const g = s(h.nextEl),
            p = s(h.prevEl);
        g && g.length > 0 && g.on("click", l),
            p && p.length > 0 && p.on("click", r),
            Object.assign(n.navigation, { $nextEl: g, nextEl: g && g[0], $prevEl: p, prevEl: p && p[0] }),
            n.enabled || (g && g.addClass(h.lockClass), p && p.addClass(h.lockClass));
    }
    function d() {
        const { $nextEl: h, $prevEl: g } = n.navigation;
        h && h.length && (h.off("click", l), h.removeClass(n.params.navigation.disabledClass)),
            g && g.length && (g.off("click", r), g.removeClass(n.params.navigation.disabledClass));
    }
    t("init", () => {
        n.params.navigation.enabled === !1 ? f() : (c(), a());
    }),
        t("toEdge fromEdge lock unlock", () => {
            a();
        }),
        t("destroy", () => {
            d();
        }),
        t("enable disable", () => {
            const { $nextEl: h, $prevEl: g } = n.navigation;
            h && h[n.enabled ? "removeClass" : "addClass"](n.params.navigation.lockClass),
                g && g[n.enabled ? "removeClass" : "addClass"](n.params.navigation.lockClass);
        }),
        t("click", (h, g) => {
            const { $nextEl: p, $prevEl: m } = n.navigation,
                v = g.target;
            if (n.params.navigation.hideOnClick && !L(v).is(m) && !L(v).is(p)) {
                if (
                    n.pagination &&
                    n.params.pagination &&
                    n.params.pagination.clickable &&
                    (n.pagination.el === v || n.pagination.el.contains(v))
                )
                    return;
                let b;
                p
                    ? (b = p.hasClass(n.params.navigation.hiddenClass))
                    : m && (b = m.hasClass(n.params.navigation.hiddenClass)),
                    i(b === !0 ? "navigationShow" : "navigationHide"),
                    p && p.toggleClass(n.params.navigation.hiddenClass),
                    m && m.toggleClass(n.params.navigation.hiddenClass);
            }
        });
    const u = () => {
            n.$el.removeClass(n.params.navigation.navigationDisabledClass), c(), a();
        },
        f = () => {
            n.$el.addClass(n.params.navigation.navigationDisabledClass), d();
        };
    Object.assign(n.navigation, { enable: u, disable: f, update: a, init: c, destroy: d });
}
function we(n = "") {
    return `.${n
        .trim()
        .replace(/([\.:!\/])/g, "\\$1")
        .replace(/ /g, ".")}`;
}
function so({ swiper: n, extendParams: e, on: t, emit: i }) {
    const s = "swiper-pagination";
    e({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: !1,
            hideOnClick: !1,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: !1,
            type: "bullets",
            dynamicBullets: !1,
            dynamicMainBullets: 1,
            formatFractionCurrent: (p) => p,
            formatFractionTotal: (p) => p,
            bulletClass: `${s}-bullet`,
            bulletActiveClass: `${s}-bullet-active`,
            modifierClass: `${s}-`,
            currentClass: `${s}-current`,
            totalClass: `${s}-total`,
            hiddenClass: `${s}-hidden`,
            progressbarFillClass: `${s}-progressbar-fill`,
            progressbarOppositeClass: `${s}-progressbar-opposite`,
            clickableClass: `${s}-clickable`,
            lockClass: `${s}-lock`,
            horizontalClass: `${s}-horizontal`,
            verticalClass: `${s}-vertical`,
            paginationDisabledClass: `${s}-disabled`,
        },
    }),
        (n.pagination = { el: null, $el: null, bullets: [] });
    let o,
        a = 0;
    function r() {
        return !n.params.pagination.el || !n.pagination.el || !n.pagination.$el || n.pagination.$el.length === 0;
    }
    function l(p, m) {
        const { bulletActiveClass: v } = n.params.pagination;
        p[m]().addClass(`${v}-${m}`)[m]().addClass(`${v}-${m}-${m}`);
    }
    function c() {
        const p = n.rtl,
            m = n.params.pagination;
        if (r()) return;
        const v = n.virtual && n.params.virtual.enabled ? n.virtual.slides.length : n.slides.length,
            b = n.pagination.$el;
        let S;
        const y = n.params.loop ? Math.ceil((v - n.loopedSlides * 2) / n.params.slidesPerGroup) : n.snapGrid.length;
        if (
            (n.params.loop
                ? ((S = Math.ceil((n.activeIndex - n.loopedSlides) / n.params.slidesPerGroup)),
                  S > v - 1 - n.loopedSlides * 2 && (S -= v - n.loopedSlides * 2),
                  S > y - 1 && (S -= y),
                  S < 0 && n.params.paginationType !== "bullets" && (S = y + S))
                : typeof n.snapIndex < "u"
                  ? (S = n.snapIndex)
                  : (S = n.activeIndex || 0),
            m.type === "bullets" && n.pagination.bullets && n.pagination.bullets.length > 0)
        ) {
            const x = n.pagination.bullets;
            let C, E, P;
            if (
                (m.dynamicBullets &&
                    ((o = x.eq(0)[n.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                    b.css(n.isHorizontal() ? "width" : "height", `${o * (m.dynamicMainBullets + 4)}px`),
                    m.dynamicMainBullets > 1 &&
                        n.previousIndex !== void 0 &&
                        ((a += S - (n.previousIndex - n.loopedSlides || 0)),
                        a > m.dynamicMainBullets - 1 ? (a = m.dynamicMainBullets - 1) : a < 0 && (a = 0)),
                    (C = Math.max(S - a, 0)),
                    (E = C + (Math.min(x.length, m.dynamicMainBullets) - 1)),
                    (P = (E + C) / 2)),
                x.removeClass(
                    ["", "-next", "-next-next", "-prev", "-prev-prev", "-main"]
                        .map((_) => `${m.bulletActiveClass}${_}`)
                        .join(" ")
                ),
                b.length > 1)
            )
                x.each((_) => {
                    const T = L(_),
                        w = T.index();
                    w === S && T.addClass(m.bulletActiveClass),
                        m.dynamicBullets &&
                            (w >= C && w <= E && T.addClass(`${m.bulletActiveClass}-main`),
                            w === C && l(T, "prev"),
                            w === E && l(T, "next"));
                });
            else {
                const _ = x.eq(S),
                    T = _.index();
                if ((_.addClass(m.bulletActiveClass), m.dynamicBullets)) {
                    const w = x.eq(C),
                        k = x.eq(E);
                    for (let A = C; A <= E; A += 1) x.eq(A).addClass(`${m.bulletActiveClass}-main`);
                    if (n.params.loop)
                        if (T >= x.length) {
                            for (let A = m.dynamicMainBullets; A >= 0; A -= 1)
                                x.eq(x.length - A).addClass(`${m.bulletActiveClass}-main`);
                            x.eq(x.length - m.dynamicMainBullets - 1).addClass(`${m.bulletActiveClass}-prev`);
                        } else l(w, "prev"), l(k, "next");
                    else l(w, "prev"), l(k, "next");
                }
            }
            if (m.dynamicBullets) {
                const _ = Math.min(x.length, m.dynamicMainBullets + 4),
                    T = (o * _ - o) / 2 - P * o,
                    w = p ? "right" : "left";
                x.css(n.isHorizontal() ? w : "top", `${T}px`);
            }
        }
        if (
            (m.type === "fraction" &&
                (b.find(we(m.currentClass)).text(m.formatFractionCurrent(S + 1)),
                b.find(we(m.totalClass)).text(m.formatFractionTotal(y))),
            m.type === "progressbar")
        ) {
            let x;
            m.progressbarOpposite
                ? (x = n.isHorizontal() ? "vertical" : "horizontal")
                : (x = n.isHorizontal() ? "horizontal" : "vertical");
            const C = (S + 1) / y;
            let E = 1,
                P = 1;
            x === "horizontal" ? (E = C) : (P = C),
                b
                    .find(we(m.progressbarFillClass))
                    .transform(`translate3d(0,0,0) scaleX(${E}) scaleY(${P})`)
                    .transition(n.params.speed);
        }
        m.type === "custom" && m.renderCustom
            ? (b.html(m.renderCustom(n, S + 1, y)), i("paginationRender", b[0]))
            : i("paginationUpdate", b[0]),
            n.params.watchOverflow && n.enabled && b[n.isLocked ? "addClass" : "removeClass"](m.lockClass);
    }
    function d() {
        const p = n.params.pagination;
        if (r()) return;
        const m = n.virtual && n.params.virtual.enabled ? n.virtual.slides.length : n.slides.length,
            v = n.pagination.$el;
        let b = "";
        if (p.type === "bullets") {
            let S = n.params.loop ? Math.ceil((m - n.loopedSlides * 2) / n.params.slidesPerGroup) : n.snapGrid.length;
            n.params.freeMode && n.params.freeMode.enabled && !n.params.loop && S > m && (S = m);
            for (let y = 0; y < S; y += 1)
                p.renderBullet
                    ? (b += p.renderBullet.call(n, y, p.bulletClass))
                    : (b += `<${p.bulletElement} class="${p.bulletClass}"></${p.bulletElement}>`);
            v.html(b), (n.pagination.bullets = v.find(we(p.bulletClass)));
        }
        p.type === "fraction" &&
            (p.renderFraction
                ? (b = p.renderFraction.call(n, p.currentClass, p.totalClass))
                : (b = `<span class="${p.currentClass}"></span> / <span class="${p.totalClass}"></span>`),
            v.html(b)),
            p.type === "progressbar" &&
                (p.renderProgressbar
                    ? (b = p.renderProgressbar.call(n, p.progressbarFillClass))
                    : (b = `<span class="${p.progressbarFillClass}"></span>`),
                v.html(b)),
            p.type !== "custom" && i("paginationRender", n.pagination.$el[0]);
    }
    function u() {
        n.params.pagination = Pt(n, n.originalParams.pagination, n.params.pagination, { el: "swiper-pagination" });
        const p = n.params.pagination;
        if (!p.el) return;
        let m = L(p.el);
        m.length !== 0 &&
            (n.params.uniqueNavElements &&
                typeof p.el == "string" &&
                m.length > 1 &&
                ((m = n.$el.find(p.el)), m.length > 1 && (m = m.filter((v) => L(v).parents(".swiper")[0] === n.el))),
            p.type === "bullets" && p.clickable && m.addClass(p.clickableClass),
            m.addClass(p.modifierClass + p.type),
            m.addClass(n.isHorizontal() ? p.horizontalClass : p.verticalClass),
            p.type === "bullets" &&
                p.dynamicBullets &&
                (m.addClass(`${p.modifierClass}${p.type}-dynamic`),
                (a = 0),
                p.dynamicMainBullets < 1 && (p.dynamicMainBullets = 1)),
            p.type === "progressbar" && p.progressbarOpposite && m.addClass(p.progressbarOppositeClass),
            p.clickable &&
                m.on("click", we(p.bulletClass), function (b) {
                    b.preventDefault();
                    let S = L(this).index() * n.params.slidesPerGroup;
                    n.params.loop && (S += n.loopedSlides), n.slideTo(S);
                }),
            Object.assign(n.pagination, { $el: m, el: m[0] }),
            n.enabled || m.addClass(p.lockClass));
    }
    function f() {
        const p = n.params.pagination;
        if (r()) return;
        const m = n.pagination.$el;
        m.removeClass(p.hiddenClass),
            m.removeClass(p.modifierClass + p.type),
            m.removeClass(n.isHorizontal() ? p.horizontalClass : p.verticalClass),
            n.pagination.bullets &&
                n.pagination.bullets.removeClass &&
                n.pagination.bullets.removeClass(p.bulletActiveClass),
            p.clickable && m.off("click", we(p.bulletClass));
    }
    t("init", () => {
        n.params.pagination.enabled === !1 ? g() : (u(), d(), c());
    }),
        t("activeIndexChange", () => {
            (n.params.loop || typeof n.snapIndex > "u") && c();
        }),
        t("snapIndexChange", () => {
            n.params.loop || c();
        }),
        t("slidesLengthChange", () => {
            n.params.loop && (d(), c());
        }),
        t("snapGridLengthChange", () => {
            n.params.loop || (d(), c());
        }),
        t("destroy", () => {
            f();
        }),
        t("enable disable", () => {
            const { $el: p } = n.pagination;
            p && p[n.enabled ? "removeClass" : "addClass"](n.params.pagination.lockClass);
        }),
        t("lock unlock", () => {
            c();
        }),
        t("click", (p, m) => {
            const v = m.target,
                { $el: b } = n.pagination;
            if (
                n.params.pagination.el &&
                n.params.pagination.hideOnClick &&
                b &&
                b.length > 0 &&
                !L(v).hasClass(n.params.pagination.bulletClass)
            ) {
                if (
                    n.navigation &&
                    ((n.navigation.nextEl && v === n.navigation.nextEl) ||
                        (n.navigation.prevEl && v === n.navigation.prevEl))
                )
                    return;
                const S = b.hasClass(n.params.pagination.hiddenClass);
                i(S === !0 ? "paginationShow" : "paginationHide"), b.toggleClass(n.params.pagination.hiddenClass);
            }
        });
    const h = () => {
            n.$el.removeClass(n.params.pagination.paginationDisabledClass),
                n.pagination.$el && n.pagination.$el.removeClass(n.params.pagination.paginationDisabledClass),
                u(),
                d(),
                c();
        },
        g = () => {
            n.$el.addClass(n.params.pagination.paginationDisabledClass),
                n.pagination.$el && n.pagination.$el.addClass(n.params.pagination.paginationDisabledClass),
                f();
        };
    Object.assign(n.pagination, { enable: h, disable: g, render: d, update: c, init: u, destroy: f });
}
function oo({ swiper: n, extendParams: e, on: t, emit: i }) {
    const s = H();
    let o = !1,
        a = null,
        r = null,
        l,
        c,
        d,
        u;
    e({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: !1,
            draggable: !1,
            snapOnRelease: !0,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: "swiper-scrollbar-horizontal",
            verticalClass: "swiper-scrollbar-vertical",
        },
    }),
        (n.scrollbar = { el: null, dragEl: null, $el: null, $dragEl: null });
    function f() {
        if (!n.params.scrollbar.el || !n.scrollbar.el) return;
        const { scrollbar: w, rtlTranslate: k, progress: A } = n,
            { $dragEl: O, $el: $ } = w,
            j = n.params.scrollbar;
        let G = c,
            F = (d - c) * A;
        k
            ? ((F = -F), F > 0 ? ((G = c - F), (F = 0)) : -F + c > d && (G = d + F))
            : F < 0
              ? ((G = c + F), (F = 0))
              : F + c > d && (G = d - F),
            n.isHorizontal()
                ? (O.transform(`translate3d(${F}px, 0, 0)`), (O[0].style.width = `${G}px`))
                : (O.transform(`translate3d(0px, ${F}px, 0)`), (O[0].style.height = `${G}px`)),
            j.hide &&
                (clearTimeout(a),
                ($[0].style.opacity = 1),
                (a = setTimeout(() => {
                    ($[0].style.opacity = 0), $.transition(400);
                }, 1e3)));
    }
    function h(w) {
        !n.params.scrollbar.el || !n.scrollbar.el || n.scrollbar.$dragEl.transition(w);
    }
    function g() {
        if (!n.params.scrollbar.el || !n.scrollbar.el) return;
        const { scrollbar: w } = n,
            { $dragEl: k, $el: A } = w;
        (k[0].style.width = ""),
            (k[0].style.height = ""),
            (d = n.isHorizontal() ? A[0].offsetWidth : A[0].offsetHeight),
            (u =
                n.size / (n.virtualSize + n.params.slidesOffsetBefore - (n.params.centeredSlides ? n.snapGrid[0] : 0))),
            n.params.scrollbar.dragSize === "auto" ? (c = d * u) : (c = parseInt(n.params.scrollbar.dragSize, 10)),
            n.isHorizontal() ? (k[0].style.width = `${c}px`) : (k[0].style.height = `${c}px`),
            u >= 1 ? (A[0].style.display = "none") : (A[0].style.display = ""),
            n.params.scrollbar.hide && (A[0].style.opacity = 0),
            n.params.watchOverflow &&
                n.enabled &&
                w.$el[n.isLocked ? "addClass" : "removeClass"](n.params.scrollbar.lockClass);
    }
    function p(w) {
        return n.isHorizontal()
            ? w.type === "touchstart" || w.type === "touchmove"
                ? w.targetTouches[0].clientX
                : w.clientX
            : w.type === "touchstart" || w.type === "touchmove"
              ? w.targetTouches[0].clientY
              : w.clientY;
    }
    function m(w) {
        const { scrollbar: k, rtlTranslate: A } = n,
            { $el: O } = k;
        let $;
        ($ = (p(w) - O.offset()[n.isHorizontal() ? "left" : "top"] - (l !== null ? l : c / 2)) / (d - c)),
            ($ = Math.max(Math.min($, 1), 0)),
            A && ($ = 1 - $);
        const j = n.minTranslate() + (n.maxTranslate() - n.minTranslate()) * $;
        n.updateProgress(j), n.setTranslate(j), n.updateActiveIndex(), n.updateSlidesClasses();
    }
    function v(w) {
        const k = n.params.scrollbar,
            { scrollbar: A, $wrapperEl: O } = n,
            { $el: $, $dragEl: j } = A;
        (o = !0),
            (l =
                w.target === j[0] || w.target === j
                    ? p(w) - w.target.getBoundingClientRect()[n.isHorizontal() ? "left" : "top"]
                    : null),
            w.preventDefault(),
            w.stopPropagation(),
            O.transition(100),
            j.transition(100),
            m(w),
            clearTimeout(r),
            $.transition(0),
            k.hide && $.css("opacity", 1),
            n.params.cssMode && n.$wrapperEl.css("scroll-snap-type", "none"),
            i("scrollbarDragStart", w);
    }
    function b(w) {
        const { scrollbar: k, $wrapperEl: A } = n,
            { $el: O, $dragEl: $ } = k;
        o &&
            (w.preventDefault ? w.preventDefault() : (w.returnValue = !1),
            m(w),
            A.transition(0),
            O.transition(0),
            $.transition(0),
            i("scrollbarDragMove", w));
    }
    function S(w) {
        const k = n.params.scrollbar,
            { scrollbar: A, $wrapperEl: O } = n,
            { $el: $ } = A;
        o &&
            ((o = !1),
            n.params.cssMode && (n.$wrapperEl.css("scroll-snap-type", ""), O.transition("")),
            k.hide &&
                (clearTimeout(r),
                (r = _e(() => {
                    $.css("opacity", 0), $.transition(400);
                }, 1e3))),
            i("scrollbarDragEnd", w),
            k.snapOnRelease && n.slideToClosest());
    }
    function y(w) {
        const { scrollbar: k, touchEventsTouch: A, touchEventsDesktop: O, params: $, support: j } = n,
            G = k.$el;
        if (!G) return;
        const F = G[0],
            q = j.passiveListener && $.passiveListeners ? { passive: !1, capture: !1 } : !1,
            ce = j.passiveListener && $.passiveListeners ? { passive: !0, capture: !1 } : !1;
        if (!F) return;
        const te = w === "on" ? "addEventListener" : "removeEventListener";
        j.touch
            ? (F[te](A.start, v, q), F[te](A.move, b, q), F[te](A.end, S, ce))
            : (F[te](O.start, v, q), s[te](O.move, b, q), s[te](O.end, S, ce));
    }
    function x() {
        !n.params.scrollbar.el || !n.scrollbar.el || y("on");
    }
    function C() {
        !n.params.scrollbar.el || !n.scrollbar.el || y("off");
    }
    function E() {
        const { scrollbar: w, $el: k } = n;
        n.params.scrollbar = Pt(n, n.originalParams.scrollbar, n.params.scrollbar, { el: "swiper-scrollbar" });
        const A = n.params.scrollbar;
        if (!A.el) return;
        let O = L(A.el);
        n.params.uniqueNavElements &&
            typeof A.el == "string" &&
            O.length > 1 &&
            k.find(A.el).length === 1 &&
            (O = k.find(A.el)),
            O.addClass(n.isHorizontal() ? A.horizontalClass : A.verticalClass);
        let $ = O.find(`.${n.params.scrollbar.dragClass}`);
        $.length === 0 && (($ = L(`<div class="${n.params.scrollbar.dragClass}"></div>`)), O.append($)),
            Object.assign(w, { $el: O, el: O[0], $dragEl: $, dragEl: $[0] }),
            A.draggable && x(),
            O && O[n.enabled ? "removeClass" : "addClass"](n.params.scrollbar.lockClass);
    }
    function P() {
        const w = n.params.scrollbar,
            k = n.scrollbar.$el;
        k && k.removeClass(n.isHorizontal() ? w.horizontalClass : w.verticalClass), C();
    }
    t("init", () => {
        n.params.scrollbar.enabled === !1 ? T() : (E(), g(), f());
    }),
        t("update resize observerUpdate lock unlock", () => {
            g();
        }),
        t("setTranslate", () => {
            f();
        }),
        t("setTransition", (w, k) => {
            h(k);
        }),
        t("enable disable", () => {
            const { $el: w } = n.scrollbar;
            w && w[n.enabled ? "removeClass" : "addClass"](n.params.scrollbar.lockClass);
        }),
        t("destroy", () => {
            P();
        });
    const _ = () => {
            n.$el.removeClass(n.params.scrollbar.scrollbarDisabledClass),
                n.scrollbar.$el && n.scrollbar.$el.removeClass(n.params.scrollbar.scrollbarDisabledClass),
                E(),
                g(),
                f();
        },
        T = () => {
            n.$el.addClass(n.params.scrollbar.scrollbarDisabledClass),
                n.scrollbar.$el && n.scrollbar.$el.addClass(n.params.scrollbar.scrollbarDisabledClass),
                P();
        };
    Object.assign(n.scrollbar, { enable: _, disable: T, updateSize: g, setTranslate: f, init: E, destroy: P });
}
function ao({ swiper: n, extendParams: e, on: t, emit: i }) {
    let s;
    (n.autoplay = { running: !1, paused: !1 }),
        e({
            autoplay: {
                enabled: !1,
                delay: 3e3,
                waitForTransition: !0,
                disableOnInteraction: !0,
                stopOnLastSlide: !1,
                reverseDirection: !1,
                pauseOnMouseEnter: !1,
            },
        });
    function o() {
        if (!n.size) {
            (n.autoplay.running = !1), (n.autoplay.paused = !1);
            return;
        }
        const p = n.slides.eq(n.activeIndex);
        let m = n.params.autoplay.delay;
        p.attr("data-swiper-autoplay") && (m = p.attr("data-swiper-autoplay") || n.params.autoplay.delay),
            clearTimeout(s),
            (s = _e(() => {
                let v;
                n.params.autoplay.reverseDirection
                    ? n.params.loop
                        ? (n.loopFix(), (v = n.slidePrev(n.params.speed, !0, !0)), i("autoplay"))
                        : n.isBeginning
                          ? n.params.autoplay.stopOnLastSlide
                              ? r()
                              : ((v = n.slideTo(n.slides.length - 1, n.params.speed, !0, !0)), i("autoplay"))
                          : ((v = n.slidePrev(n.params.speed, !0, !0)), i("autoplay"))
                    : n.params.loop
                      ? (n.loopFix(), (v = n.slideNext(n.params.speed, !0, !0)), i("autoplay"))
                      : n.isEnd
                        ? n.params.autoplay.stopOnLastSlide
                            ? r()
                            : ((v = n.slideTo(0, n.params.speed, !0, !0)), i("autoplay"))
                        : ((v = n.slideNext(n.params.speed, !0, !0)), i("autoplay")),
                    ((n.params.cssMode && n.autoplay.running) || v === !1) && o();
            }, m));
    }
    function a() {
        return typeof s < "u" || n.autoplay.running ? !1 : ((n.autoplay.running = !0), i("autoplayStart"), o(), !0);
    }
    function r() {
        return !n.autoplay.running || typeof s > "u"
            ? !1
            : (s && (clearTimeout(s), (s = void 0)), (n.autoplay.running = !1), i("autoplayStop"), !0);
    }
    function l(p) {
        n.autoplay.running &&
            (n.autoplay.paused ||
                (s && clearTimeout(s),
                (n.autoplay.paused = !0),
                p === 0 || !n.params.autoplay.waitForTransition
                    ? ((n.autoplay.paused = !1), o())
                    : ["transitionend", "webkitTransitionEnd"].forEach((m) => {
                          n.$wrapperEl[0].addEventListener(m, d);
                      })));
    }
    function c() {
        const p = H();
        p.visibilityState === "hidden" && n.autoplay.running && l(),
            p.visibilityState === "visible" && n.autoplay.paused && (o(), (n.autoplay.paused = !1));
    }
    function d(p) {
        !n ||
            n.destroyed ||
            !n.$wrapperEl ||
            (p.target === n.$wrapperEl[0] &&
                (["transitionend", "webkitTransitionEnd"].forEach((m) => {
                    n.$wrapperEl[0].removeEventListener(m, d);
                }),
                (n.autoplay.paused = !1),
                n.autoplay.running ? o() : r()));
    }
    function u() {
        n.params.autoplay.disableOnInteraction ? r() : (i("autoplayPause"), l()),
            ["transitionend", "webkitTransitionEnd"].forEach((p) => {
                n.$wrapperEl[0].removeEventListener(p, d);
            });
    }
    function f() {
        n.params.autoplay.disableOnInteraction || ((n.autoplay.paused = !1), i("autoplayResume"), o());
    }
    function h() {
        n.params.autoplay.pauseOnMouseEnter && (n.$el.on("mouseenter", u), n.$el.on("mouseleave", f));
    }
    function g() {
        n.$el.off("mouseenter", u), n.$el.off("mouseleave", f);
    }
    t("init", () => {
        n.params.autoplay.enabled && (a(), H().addEventListener("visibilitychange", c), h());
    }),
        t("beforeTransitionStart", (p, m, v) => {
            n.autoplay.running && (v || !n.params.autoplay.disableOnInteraction ? n.autoplay.pause(m) : r());
        }),
        t("sliderFirstMove", () => {
            n.autoplay.running && (n.params.autoplay.disableOnInteraction ? r() : l());
        }),
        t("touchEnd", () => {
            n.params.cssMode && n.autoplay.paused && !n.params.autoplay.disableOnInteraction && o();
        }),
        t("destroy", () => {
            g(), n.autoplay.running && r(), H().removeEventListener("visibilitychange", c);
        }),
        Object.assign(n.autoplay, { pause: l, run: o, start: a, stop: r });
}
function ro({ swiper: n, extendParams: e, on: t }) {
    e({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: !0,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs",
        },
    });
    let i = !1,
        s = !1;
    n.thumbs = { swiper: null };
    function o() {
        const l = n.thumbs.swiper;
        if (!l || l.destroyed) return;
        const c = l.clickedIndex,
            d = l.clickedSlide;
        if ((d && L(d).hasClass(n.params.thumbs.slideThumbActiveClass)) || typeof c > "u" || c === null) return;
        let u;
        if (
            (l.params.loop ? (u = parseInt(L(l.clickedSlide).attr("data-swiper-slide-index"), 10)) : (u = c),
            n.params.loop)
        ) {
            let f = n.activeIndex;
            n.slides.eq(f).hasClass(n.params.slideDuplicateClass) &&
                (n.loopFix(), (n._clientLeft = n.$wrapperEl[0].clientLeft), (f = n.activeIndex));
            const h = n.slides.eq(f).prevAll(`[data-swiper-slide-index="${u}"]`).eq(0).index(),
                g = n.slides.eq(f).nextAll(`[data-swiper-slide-index="${u}"]`).eq(0).index();
            typeof h > "u" ? (u = g) : typeof g > "u" ? (u = h) : g - f < f - h ? (u = g) : (u = h);
        }
        n.slideTo(u);
    }
    function a() {
        const { thumbs: l } = n.params;
        if (i) return !1;
        i = !0;
        const c = n.constructor;
        if (l.swiper instanceof c)
            (n.thumbs.swiper = l.swiper),
                Object.assign(n.thumbs.swiper.originalParams, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                Object.assign(n.thumbs.swiper.params, { watchSlidesProgress: !0, slideToClickedSlide: !1 });
        else if (ke(l.swiper)) {
            const d = Object.assign({}, l.swiper);
            Object.assign(d, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                (n.thumbs.swiper = new c(d)),
                (s = !0);
        }
        return n.thumbs.swiper.$el.addClass(n.params.thumbs.thumbsContainerClass), n.thumbs.swiper.on("tap", o), !0;
    }
    function r(l) {
        const c = n.thumbs.swiper;
        if (!c || c.destroyed) return;
        const d = c.params.slidesPerView === "auto" ? c.slidesPerViewDynamic() : c.params.slidesPerView;
        let u = 1;
        const f = n.params.thumbs.slideThumbActiveClass;
        if (
            (n.params.slidesPerView > 1 && !n.params.centeredSlides && (u = n.params.slidesPerView),
            n.params.thumbs.multipleActiveThumbs || (u = 1),
            (u = Math.floor(u)),
            c.slides.removeClass(f),
            c.params.loop || (c.params.virtual && c.params.virtual.enabled))
        )
            for (let p = 0; p < u; p += 1)
                c.$wrapperEl.children(`[data-swiper-slide-index="${n.realIndex + p}"]`).addClass(f);
        else for (let p = 0; p < u; p += 1) c.slides.eq(n.realIndex + p).addClass(f);
        const h = n.params.thumbs.autoScrollOffset,
            g = h && !c.params.loop;
        if (n.realIndex !== c.realIndex || g) {
            let p = c.activeIndex,
                m,
                v;
            if (c.params.loop) {
                c.slides.eq(p).hasClass(c.params.slideDuplicateClass) &&
                    (c.loopFix(), (c._clientLeft = c.$wrapperEl[0].clientLeft), (p = c.activeIndex));
                const b = c.slides.eq(p).prevAll(`[data-swiper-slide-index="${n.realIndex}"]`).eq(0).index(),
                    S = c.slides.eq(p).nextAll(`[data-swiper-slide-index="${n.realIndex}"]`).eq(0).index();
                typeof b > "u"
                    ? (m = S)
                    : typeof S > "u"
                      ? (m = b)
                      : S - p === p - b
                        ? (m = c.params.slidesPerGroup > 1 ? S : p)
                        : S - p < p - b
                          ? (m = S)
                          : (m = b),
                    (v = n.activeIndex > n.previousIndex ? "next" : "prev");
            } else (m = n.realIndex), (v = m > n.previousIndex ? "next" : "prev");
            g && (m += v === "next" ? h : -1 * h),
                c.visibleSlidesIndexes &&
                    c.visibleSlidesIndexes.indexOf(m) < 0 &&
                    (c.params.centeredSlides
                        ? m > p
                            ? (m = m - Math.floor(d / 2) + 1)
                            : (m = m + Math.floor(d / 2) - 1)
                        : m > p && c.params.slidesPerGroup,
                    c.slideTo(m, l ? 0 : void 0));
        }
    }
    t("beforeInit", () => {
        const { thumbs: l } = n.params;
        !l || !l.swiper || (a(), r(!0));
    }),
        t("slideChange update resize observerUpdate", () => {
            r();
        }),
        t("setTransition", (l, c) => {
            const d = n.thumbs.swiper;
            !d || d.destroyed || d.setTransition(c);
        }),
        t("beforeDestroy", () => {
            const l = n.thumbs.swiper;
            !l || l.destroyed || (s && l.destroy());
        }),
        Object.assign(n.thumbs, { init: a, update: r });
}
function lo({ swiper: n, extendParams: e }) {
    e({ grid: { rows: 1, fill: "column" } });
    let t, i, s;
    const o = (l) => {
            const { slidesPerView: c } = n.params,
                { rows: d, fill: u } = n.params.grid;
            (i = t / d),
                (s = Math.floor(l / d)),
                Math.floor(l / d) === l / d ? (t = l) : (t = Math.ceil(l / d) * d),
                c !== "auto" && u === "row" && (t = Math.max(t, c * d));
        },
        a = (l, c, d, u) => {
            const { slidesPerGroup: f, spaceBetween: h } = n.params,
                { rows: g, fill: p } = n.params.grid;
            let m, v, b;
            if (p === "row" && f > 1) {
                const S = Math.floor(l / (f * g)),
                    y = l - g * f * S,
                    x = S === 0 ? f : Math.min(Math.ceil((d - S * g * f) / g), f);
                (b = Math.floor(y / x)),
                    (v = y - b * x + S * f),
                    (m = v + (b * t) / g),
                    c.css({ "-webkit-order": m, order: m });
            } else
                p === "column"
                    ? ((v = Math.floor(l / g)),
                      (b = l - v * g),
                      (v > s || (v === s && b === g - 1)) && ((b += 1), b >= g && ((b = 0), (v += 1))))
                    : ((b = Math.floor(l / i)), (v = l - b * i));
            c.css(u("margin-top"), b !== 0 ? h && `${h}px` : "");
        },
        r = (l, c, d) => {
            const { spaceBetween: u, centeredSlides: f, roundLengths: h } = n.params,
                { rows: g } = n.params.grid;
            if (
                ((n.virtualSize = (l + u) * t),
                (n.virtualSize = Math.ceil(n.virtualSize / g) - u),
                n.$wrapperEl.css({ [d("width")]: `${n.virtualSize + u}px` }),
                f)
            ) {
                c.splice(0, c.length);
                const p = [];
                for (let m = 0; m < c.length; m += 1) {
                    let v = c[m];
                    h && (v = Math.floor(v)), c[m] < n.virtualSize + c[0] && p.push(v);
                }
                c.push(...p);
            }
        };
    n.grid = { initSlides: o, updateSlide: a, updateWrapperSize: r };
}
W.use([no, so, ao, ro, lo, oo]);
function co() {
    (window.sliders = []), (window.mobileSliders = []);
}
function uo() {
    var n = document.querySelectorAll(".swiper-container:not(.control):not(.mobile)");
    n.forEach(function (e, t) {
        initSlider(e, t, "section, aside");
    });
}
function Mi() {
    const n = window.innerWidth || document.documentElement.clientWidth;
    var e = document.querySelectorAll(".swiper-container.mobile");
    e.forEach(function (t, i) {
        window.mobileSliders[t.getAttribute("id")] &&
            (window.mobileSliders[t.getAttribute("id")].destroy(!0, !0),
            (window.mobileSliders[t.getAttribute("id")] = null)),
            n <= 768 && initSlider(t, i, "section, aside");
    });
}
window.initSlider = function (n, e, t) {
    if (n) {
        var i = n.closest(t),
            s = i.querySelector(".control"),
            o = i.querySelector(".swiper-pagination"),
            a = i.querySelector(".swiper-scrollbar"),
            r = {
                speed: 600,
                loop: !0,
                slideToClickedSlide: !1,
                centeredSlides: !0,
                spaceBetween: 20,
                autoplay: { delay: 5e3, disableOnInteraction: !0 },
                navigation: { nextEl: i.querySelector(".swiper-next"), prevEl: i.querySelector(".swiper-prev") },
                scrollbar: { el: ".swiper-scrollbar", hide: !1 },
                pagination: { el: o || "", clickable: !0 },
                thumbs: {},
                breakpoints: { 992: { slidesPerView: 3 }, 1500: { slidesPerView: 4 } },
            };
        n.id == "product-slider" && ((r.autoplay = !1), (r.loop = !1)),
            n.classList.contains("phone-videos") &&
                ((r.spaceBetween = 0),
                (r.centeredSlides = !0),
                (r.slidesPerView = 3),
                (r.breakpoints = { 1500: { slidesPerView: 5 } })),
            n.hasAttribute("data-slidestoshow") &&
                ((r.breakpoints = { 992: {}, 1199: {} }),
                (r.breakpoints[1199].slidesPerView = parseInt(n.getAttribute("data-slidestoshow")))),
            s &&
                new W(s, {
                    spaceBetween: 8,
                    centeredSlides: !1,
                    slideToClickedSlide: !0,
                    watchSlidesVisibility: !0,
                    watchSlidesProgress: !0,
                    controller: {},
                    autoplay: !1,
                    slidesPerView: 3,
                    slidesPerGroup: 1,
                    breakpoints: { 1200: { spaceBetween: 12, slidesPerView: 5, slidesPerGroup: 1 } },
                }),
            n.classList.contains("collections-carousel-swiper") &&
                ((r.slidesPerView = 1),
                (r.spaceBetween = 10),
                (r.loop = !1),
                (r.centeredSlides = !1),
                (r.breakpoints = {
                    568: { spaceBetween: 12, slidesPerView: 2 },
                    992: {
                        slidesPerView: parseInt(n.getAttribute("data-slidesperview")) || 3,
                        spaceBetween: parseInt(n.getAttribute("data-spacebetween")) || 12,
                    },
                })),
            n.classList.contains("compare-products") &&
                ((r.slidesPerView = 1),
                (r.spaceBetween = 10),
                (r.centeredSlides = !0),
                (r.autoplay = !1),
                (r.freeMode = !0),
                (r.freeModeMomentum = !1),
                (r.grabCursor = !0)),
            n.classList.contains("testimonial") &&
                ((r.scrollbar = a),
                (r.centeredSlides = !1),
                (r.loop = !1),
                (r.breakpoints = {
                    768: { slidesPerView: 2.125, spaceBetween: 12 },
                    992: { spaceBetween: 16, slidesPerView: 2.5 },
                    1220: { slidesPerView: 3 },
                })),
            n.classList.contains("marquee-bar-swiper") &&
                (r = {
                    speed: 5e3,
                    loop: !0,
                    slidesPerView: 6,
                    centeredSlides: !1,
                    spaceBetween: 10,
                    freeMode: !0,
                    freeModeMomentum: !1,
                    grabCursor: !0,
                    autoplay: { delay: 1, disableOnInteraction: !1 },
                    breakpoints: { 500: { slidesPerView: 4 }, 768: { slidesPerView: 5 }, 1300: { slidesPerView: 6 } },
                }),
            n.classList.contains("upsell-slider") && ((r.loop = !1), n.setAttribute("id", "upsell-slider-" + e)),
            n.getAttribute("id") && n.classList.contains("mobile")
                ? (window.mobileSliders[n.getAttribute("id")] = new W(n, r))
                : n.getAttribute("id")
                  ? (window.sliders[n.getAttribute("id")] = new W(n, r))
                  : new W(n, r);
    }
};
function ho() {
    class n extends HTMLElement {
        constructor() {
            super(),
                (this.elements = {
                    input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
                    button: this.querySelector("button"),
                    panel: this.querySelector("ul"),
                }),
                this.elements.button.addEventListener("click", this.openSelector.bind(this)),
                this.elements.button.addEventListener("focusout", this.closeSelector.bind(this)),
                this.addEventListener("keyup", this.onContainerKeyUp.bind(this)),
                this.querySelectorAll("a").forEach((t) => t.addEventListener("click", this.onItemClick.bind(this)));
        }
        hidePanel() {
            this.elements.button.setAttribute("aria-expanded", "false"), this.elements.panel.setAttribute("hidden", !0);
        }
        onContainerKeyUp(t) {
            t.code.toUpperCase() === "ESCAPE" && (this.hidePanel(), this.elements.button.focus());
        }
        onItemClick(t) {
            t.preventDefault();
            const i = this.querySelector("form");
            (this.elements.input.value = t.currentTarget.dataset.value), i && i.submit();
        }
        openSelector() {
            this.elements.button.focus(),
                this.elements.panel.toggleAttribute("hidden"),
                this.elements.button.setAttribute(
                    "aria-expanded",
                    (this.elements.button.getAttribute("aria-expanded") === "false").toString()
                );
        }
        closeSelector(t) {
            const i = t.relatedTarget && t.relatedTarget.nodeName === "BUTTON";
            (t.relatedTarget === null || i) && this.hidePanel();
        }
    }
    customElements.define("localization-form", n);
}
function fo() {
    const n = (r) => {
            r.style.height = `${r.scrollHeight}px`;
        },
        e = (r) => {
            r.style.height = "0px";
        };
    let t = document.querySelectorAll(".accordion-item dt");
    t &&
        t.forEach(function (r) {
            r.addEventListener("click", function () {
                let l = r.parentNode,
                    c = l.querySelector("dd");
                if (l.classList.contains("active")) l.classList.remove("active"), e(c);
                else {
                    let d = l.parentNode.querySelector(".accordion-item.active");
                    if (d) {
                        let u = d.querySelector("dd");
                        e(u), d.classList.remove("active");
                    }
                    l.classList.add("active"), n(c);
                }
            });
        });
    let i = document.querySelectorAll(".tabs__nav__item a[data-toggle='tab']");
    i &&
        i.forEach(function (r) {
            r.addEventListener("click", function () {
                let l = this.getAttribute("href");
                setTimeout(() => {
                    let c = document.querySelector(l);
                    if (c && c.classList.contains("active")) {
                        let d = c.querySelector(".accordion-item.active");
                        if (d) {
                            let u = d.querySelector("dd");
                            n(u);
                        }
                    }
                }, 300);
            });
        });
    const s = document.querySelectorAll("dl.accordion");
    s &&
        s.forEach(function (r) {
            let l = r.querySelector(".accordion-item");
            l && l.querySelector("dd");
        });
    var o = document.querySelector(".mobile-tab-selector"),
        a = document.querySelector(".tabs__content");
    o &&
        o.addEventListener("change", function () {
            var r = this.value,
                l = a.querySelector("#" + r);
            a.querySelectorAll(".tabs__content__pane").forEach(function (c) {
                c.classList.remove("active");
            }),
                l && l.classList.add("active");
        });
}
function po() {
    let n = document.querySelector(".section-tabs");
    if (!n) return;
    let e = n.querySelectorAll(".tabs__nav__item a"),
        t = n.querySelectorAll(".tabs__content__pane"),
        i = !1;
    e.forEach(function (s, o) {
        s.classList.contains("active") && (i = !0),
            s.addEventListener("click", function (a) {
                a.preventDefault(),
                    e.forEach(function (r) {
                        r.parentNode.classList.remove("active");
                    }),
                    t.forEach(function (r) {
                        r.classList.remove("active");
                    }),
                    s.parentNode.classList.add("active"),
                    n.querySelector(s.getAttribute("href")).classList.add("active");
            });
    }),
        !i && e[0] && e[0].click();
}
function mo() {
    let n = document.querySelectorAll(".view-animation"),
        e = !!window.MSInputMethodContext && !!document.documentMode;
    n.forEach(function (t, i) {
        e
            ? t.classList.add("animated")
            : new IntersectionObserver(
                  function (s) {
                      s[0].isIntersecting === !0 && s[0].target.classList.add("animated");
                  },
                  { threshold: [0.5] }
              ).observe(t);
    });
}
const M = (n, e = 1e4) => ((n = parseFloat(n + "") || 0), Math.round((n + Number.EPSILON) * e) / e),
    Ct = function (n) {
        if (!(n && n instanceof Element && n.offsetParent)) return !1;
        const e = n.scrollHeight > n.clientHeight,
            t = window.getComputedStyle(n).overflowY,
            i = t.indexOf("hidden") !== -1,
            s = t.indexOf("visible") !== -1;
        return e && !i && !s;
    },
    Ze = function (n, e = void 0) {
        return !(!n || n === document.body || (e && n === e)) && (Ct(n) ? n : Ze(n.parentElement, e));
    },
    se = function (n) {
        var e = new DOMParser().parseFromString(n, "text/html").body;
        if (e.childElementCount > 1) {
            for (var t = document.createElement("div"); e.firstChild; ) t.appendChild(e.firstChild);
            return t;
        }
        return e.firstChild;
    },
    At = (n) => `${n || ""}`.split(" ").filter((e) => !!e),
    oe = (n, e, t) => {
        n &&
            At(e).forEach((i) => {
                n.classList.toggle(i, t || !1);
            });
    };
class xe {
    constructor(e) {
        Object.defineProperty(this, "pageX", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
            Object.defineProperty(this, "pageY", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
            Object.defineProperty(this, "clientX", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
            Object.defineProperty(this, "clientY", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
            Object.defineProperty(this, "id", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
            Object.defineProperty(this, "time", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
            Object.defineProperty(this, "nativePointer", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0,
            }),
            (this.nativePointer = e),
            (this.pageX = e.pageX),
            (this.pageY = e.pageY),
            (this.clientX = e.clientX),
            (this.clientY = e.clientY),
            (this.id = self.Touch && e instanceof Touch ? e.identifier : -1),
            (this.time = Date.now());
    }
}
const Ee = { passive: !1 };
class go {
    constructor(e, { start: t = () => !0, move: i = () => {}, end: s = () => {} }) {
        Object.defineProperty(this, "element", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
            Object.defineProperty(this, "startCallback", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0,
            }),
            Object.defineProperty(this, "moveCallback", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0,
            }),
            Object.defineProperty(this, "endCallback", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0,
            }),
            Object.defineProperty(this, "currentPointers", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: [],
            }),
            Object.defineProperty(this, "startPointers", { enumerable: !0, configurable: !0, writable: !0, value: [] }),
            (this.element = e),
            (this.startCallback = t),
            (this.moveCallback = i),
            (this.endCallback = s);
        for (const o of ["onPointerStart", "onTouchStart", "onMove", "onTouchEnd", "onPointerEnd", "onWindowBlur"])
            this[o] = this[o].bind(this);
        this.element.addEventListener("mousedown", this.onPointerStart, Ee),
            this.element.addEventListener("touchstart", this.onTouchStart, Ee),
            this.element.addEventListener("touchmove", this.onMove, Ee),
            this.element.addEventListener("touchend", this.onTouchEnd),
            this.element.addEventListener("touchcancel", this.onTouchEnd);
    }
    onPointerStart(e) {
        if (!e.buttons || e.button !== 0) return;
        const t = new xe(e);
        this.currentPointers.some((i) => i.id === t.id) ||
            (this.triggerPointerStart(t, e) &&
                (window.addEventListener("mousemove", this.onMove),
                window.addEventListener("mouseup", this.onPointerEnd),
                window.addEventListener("blur", this.onWindowBlur)));
    }
    onTouchStart(e) {
        for (const t of Array.from(e.changedTouches || [])) this.triggerPointerStart(new xe(t), e);
        window.addEventListener("blur", this.onWindowBlur);
    }
    onMove(e) {
        const t = this.currentPointers.slice(),
            i = "changedTouches" in e ? Array.from(e.changedTouches || []).map((o) => new xe(o)) : [new xe(e)],
            s = [];
        for (const o of i) {
            const a = this.currentPointers.findIndex((r) => r.id === o.id);
            a < 0 || (s.push(o), (this.currentPointers[a] = o));
        }
        s.length && this.moveCallback(e, this.currentPointers.slice(), t);
    }
    onPointerEnd(e) {
        (e.buttons > 0 && e.button !== 0) ||
            (this.triggerPointerEnd(e, new xe(e)),
            window.removeEventListener("mousemove", this.onMove),
            window.removeEventListener("mouseup", this.onPointerEnd),
            window.removeEventListener("blur", this.onWindowBlur));
    }
    onTouchEnd(e) {
        for (const t of Array.from(e.changedTouches || [])) this.triggerPointerEnd(e, new xe(t));
    }
    triggerPointerStart(e, t) {
        return (
            !!this.startCallback(t, e, this.currentPointers.slice()) &&
            (this.currentPointers.push(e), this.startPointers.push(e), !0)
        );
    }
    triggerPointerEnd(e, t) {
        const i = this.currentPointers.findIndex((s) => s.id === t.id);
        i < 0 ||
            (this.currentPointers.splice(i, 1),
            this.startPointers.splice(i, 1),
            this.endCallback(e, t, this.currentPointers.slice()));
    }
    onWindowBlur() {
        this.clear();
    }
    clear() {
        for (; this.currentPointers.length; ) {
            const e = this.currentPointers[this.currentPointers.length - 1];
            this.currentPointers.splice(this.currentPointers.length - 1, 1),
                this.startPointers.splice(this.currentPointers.length - 1, 1),
                this.endCallback(
                    new Event("touchend", { bubbles: !0, cancelable: !0, clientX: e.clientX, clientY: e.clientY }),
                    e,
                    this.currentPointers.slice()
                );
        }
    }
    stop() {
        this.element.removeEventListener("mousedown", this.onPointerStart, Ee),
            this.element.removeEventListener("touchstart", this.onTouchStart, Ee),
            this.element.removeEventListener("touchmove", this.onMove, Ee),
            this.element.removeEventListener("touchend", this.onTouchEnd),
            this.element.removeEventListener("touchcancel", this.onTouchEnd),
            window.removeEventListener("mousemove", this.onMove),
            window.removeEventListener("mouseup", this.onPointerEnd),
            window.removeEventListener("blur", this.onWindowBlur);
    }
}
function Bt(n, e) {
    return e ? Math.sqrt(Math.pow(e.clientX - n.clientX, 2) + Math.pow(e.clientY - n.clientY, 2)) : 0;
}
function Ht(n, e) {
    return e ? { clientX: (n.clientX + e.clientX) / 2, clientY: (n.clientY + e.clientY) / 2 } : n;
}
const Tt = (n) =>
        typeof n == "object" &&
        n !== null &&
        n.constructor === Object &&
        Object.prototype.toString.call(n) === "[object Object]",
    U = (n, ...e) => {
        const t = e.length;
        for (let i = 0; i < t; i++) {
            const s = e[i] || {};
            Object.entries(s).forEach(([o, a]) => {
                const r = Array.isArray(a) ? [] : {};
                n[o] || Object.assign(n, { [o]: r }),
                    Tt(a)
                        ? Object.assign(n[o], U(r, a))
                        : Array.isArray(a)
                          ? Object.assign(n, { [o]: [...a] })
                          : Object.assign(n, { [o]: a });
            });
        }
        return n;
    },
    lt = function (n, e) {
        return n.split(".").reduce((t, i) => (typeof t == "object" ? t[i] : void 0), e);
    };
class Ke {
    constructor(e = {}) {
        Object.defineProperty(this, "options", { enumerable: !0, configurable: !0, writable: !0, value: e }),
            Object.defineProperty(this, "events", { enumerable: !0, configurable: !0, writable: !0, value: new Map() }),
            this.setOptions(e);
        for (const t of Object.getOwnPropertyNames(Object.getPrototypeOf(this)))
            t.startsWith("on") && typeof this[t] == "function" && (this[t] = this[t].bind(this));
    }
    setOptions(e) {
        this.options = e ? U({}, this.constructor.defaults, e) : {};
        for (const [t, i] of Object.entries(this.option("on") || {})) this.on(t, i);
    }
    option(e, ...t) {
        let i = lt(e, this.options);
        return i && typeof i == "function" && (i = i.call(this, this, ...t)), i;
    }
    optionFor(e, t, i, ...s) {
        let o = lt(t, e);
        var a;
        typeof (a = o) != "string" || isNaN(a) || isNaN(parseFloat(a)) || (o = parseFloat(o)),
            o === "true" && (o = !0),
            o === "false" && (o = !1),
            o && typeof o == "function" && (o = o.call(this, this, e, ...s));
        let r = lt(t, this.options);
        return (
            r && typeof r == "function" ? (o = r.call(this, this, e, ...s, o)) : o === void 0 && (o = r),
            o === void 0 ? i : o
        );
    }
    cn(e) {
        const t = this.options.classes;
        return (t && t[e]) || "";
    }
    localize(e, t = []) {
        e = String(e).replace(/\{\{(\w+).?(\w+)?\}\}/g, (i, s, o) => {
            let a = "";
            return (
                o
                    ? (a = this.option(`${s[0] + s.toLowerCase().substring(1)}.l10n.${o}`))
                    : s && (a = this.option(`l10n.${s}`)),
                a || (a = i),
                a
            );
        });
        for (let i = 0; i < t.length; i++) e = e.split(t[i][0]).join(t[i][1]);
        return (e = e.replace(/\{\{(.*?)\}\}/g, (i, s) => s));
    }
    on(e, t) {
        let i = [];
        typeof e == "string" ? (i = e.split(" ")) : Array.isArray(e) && (i = e),
            this.events || (this.events = new Map()),
            i.forEach((s) => {
                let o = this.events.get(s);
                o || (this.events.set(s, []), (o = [])), o.includes(t) || o.push(t), this.events.set(s, o);
            });
    }
    off(e, t) {
        let i = [];
        typeof e == "string" ? (i = e.split(" ")) : Array.isArray(e) && (i = e),
            i.forEach((s) => {
                const o = this.events.get(s);
                if (Array.isArray(o)) {
                    const a = o.indexOf(t);
                    a > -1 && o.splice(a, 1);
                }
            });
    }
    emit(e, ...t) {
        [...(this.events.get(e) || [])].forEach((i) => i(this, ...t)), e !== "*" && this.emit("*", e, ...t);
    }
}
Object.defineProperty(Ke, "version", { enumerable: !0, configurable: !0, writable: !0, value: "5.0.36" }),
    Object.defineProperty(Ke, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: {} });
class kt extends Ke {
    constructor(e = {}) {
        super(e), Object.defineProperty(this, "plugins", { enumerable: !0, configurable: !0, writable: !0, value: {} });
    }
    attachPlugins(e = {}) {
        const t = new Map();
        for (const [i, s] of Object.entries(e)) {
            const o = this.option(i),
                a = this.plugins[i];
            a || o === !1 ? a && o === !1 && (a.detach(), delete this.plugins[i]) : t.set(i, new s(this, o || {}));
        }
        for (const [i, s] of t) (this.plugins[i] = s), s.attach();
    }
    detachPlugins(e) {
        e = e || Object.keys(this.plugins);
        for (const t of e) {
            const i = this.plugins[t];
            i && i.detach(), delete this.plugins[t];
        }
        return this.emit("detachPlugins"), this;
    }
}
var R;
(function (n) {
    (n[(n.Init = 0)] = "Init"),
        (n[(n.Error = 1)] = "Error"),
        (n[(n.Ready = 2)] = "Ready"),
        (n[(n.Panning = 3)] = "Panning"),
        (n[(n.Mousemove = 4)] = "Mousemove"),
        (n[(n.Destroy = 5)] = "Destroy");
})(R || (R = {}));
const ae = ["a", "b", "c", "d", "e", "f"],
    Li = {
        PANUP: "Move up",
        PANDOWN: "Move down",
        PANLEFT: "Move left",
        PANRIGHT: "Move right",
        ZOOMIN: "Zoom in",
        ZOOMOUT: "Zoom out",
        TOGGLEZOOM: "Toggle zoom level",
        TOGGLE1TO1: "Toggle zoom level",
        ITERATEZOOM: "Toggle zoom level",
        ROTATECCW: "Rotate counterclockwise",
        ROTATECW: "Rotate clockwise",
        FLIPX: "Flip horizontally",
        FLIPY: "Flip vertically",
        FITX: "Fit horizontally",
        FITY: "Fit vertically",
        RESET: "Reset",
        TOGGLEFS: "Toggle fullscreen",
    },
    vo = {
        content: null,
        width: "auto",
        height: "auto",
        panMode: "drag",
        touch: !0,
        dragMinThreshold: 3,
        lockAxis: !1,
        mouseMoveFactor: 1,
        mouseMoveFriction: 0.12,
        zoom: !0,
        pinchToZoom: !0,
        panOnlyZoomed: "auto",
        minScale: 1,
        maxScale: 2,
        friction: 0.25,
        dragFriction: 0.35,
        decelFriction: 0.05,
        click: "toggleZoom",
        dblClick: !1,
        wheel: "zoom",
        wheelLimit: 7,
        spinner: !0,
        bounds: "auto",
        infinite: !1,
        rubberband: !0,
        bounce: !0,
        maxVelocity: 75,
        transformParent: !1,
        classes: {
            content: "f-panzoom__content",
            isLoading: "is-loading",
            canZoomIn: "can-zoom_in",
            canZoomOut: "can-zoom_out",
            isDraggable: "is-draggable",
            isDragging: "is-dragging",
            inFullscreen: "in-fullscreen",
            htmlHasFullscreen: "with-panzoom-in-fullscreen",
        },
        l10n: Li,
    },
    Vt = '<circle cx="25" cy="25" r="20"></circle>',
    Ot = '<div class="f-spinner"><svg viewBox="0 0 50 50">' + Vt + Vt + "</svg></div>",
    Y = (n) => n && n !== null && n instanceof Element && "nodeType" in n,
    D = (n, e) => {
        n &&
            At(e).forEach((t) => {
                n.classList.remove(t);
            });
    },
    I = (n, e) => {
        n &&
            At(e).forEach((t) => {
                n.classList.add(t);
            });
    },
    qe = { a: 1, b: 0, c: 0, d: 1, e: 0, f: 0 },
    bo = 1e5,
    Fe = 1e4,
    K = "mousemove",
    Gt = "drag",
    Wt = "content",
    J = "auto";
let ct = null,
    dt = null;
class ye extends kt {
    get fits() {
        return (
            this.contentRect.width - this.contentRect.fitWidth < 1 &&
            this.contentRect.height - this.contentRect.fitHeight < 1
        );
    }
    get isTouchDevice() {
        return dt === null && (dt = window.matchMedia("(hover: none)").matches), dt;
    }
    get isMobile() {
        return ct === null && (ct = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)), ct;
    }
    get panMode() {
        return this.options.panMode !== K || this.isTouchDevice ? Gt : K;
    }
    get panOnlyZoomed() {
        const e = this.options.panOnlyZoomed;
        return e === J ? this.isTouchDevice : e;
    }
    get isInfinite() {
        return this.option("infinite");
    }
    get angle() {
        return (180 * Math.atan2(this.current.b, this.current.a)) / Math.PI || 0;
    }
    get targetAngle() {
        return (180 * Math.atan2(this.target.b, this.target.a)) / Math.PI || 0;
    }
    get scale() {
        const { a: e, b: t } = this.current;
        return Math.sqrt(e * e + t * t) || 1;
    }
    get targetScale() {
        const { a: e, b: t } = this.target;
        return Math.sqrt(e * e + t * t) || 1;
    }
    get minScale() {
        return this.option("minScale") || 1;
    }
    get fullScale() {
        const { contentRect: e } = this;
        return e.fullWidth / e.fitWidth || 1;
    }
    get maxScale() {
        return this.fullScale * (this.option("maxScale") || 1) || 1;
    }
    get coverScale() {
        const { containerRect: e, contentRect: t } = this,
            i = Math.max(e.height / t.fitHeight, e.width / t.fitWidth) || 1;
        return Math.min(this.fullScale, i);
    }
    get isScaling() {
        return Math.abs(this.targetScale - this.scale) > 1e-5 && !this.isResting;
    }
    get isContentLoading() {
        const e = this.content;
        return !!(e && e instanceof HTMLImageElement) && !e.complete;
    }
    get isResting() {
        if (this.isBouncingX || this.isBouncingY) return !1;
        for (const e of ae) {
            const t = e == "e" || e === "f" ? 1e-4 : 1e-5;
            if (Math.abs(this.target[e] - this.current[e]) > t) return !1;
        }
        return !(!this.ignoreBounds && !this.checkBounds().inBounds);
    }
    constructor(e, t = {}, i = {}) {
        var s;
        if (
            (super(t),
            Object.defineProperty(this, "pointerTracker", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: null,
            }),
            Object.defineProperty(this, "resizeObserver", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: null,
            }),
            Object.defineProperty(this, "updateTimer", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "clickTimer", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "rAF", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "isTicking", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
            Object.defineProperty(this, "ignoreBounds", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
            Object.defineProperty(this, "isBouncingX", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
            Object.defineProperty(this, "isBouncingY", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
            Object.defineProperty(this, "clicks", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
            Object.defineProperty(this, "trackingPoints", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: [],
            }),
            Object.defineProperty(this, "pwt", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
            Object.defineProperty(this, "cwd", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
            Object.defineProperty(this, "pmme", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
            Object.defineProperty(this, "friction", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
            Object.defineProperty(this, "state", { enumerable: !0, configurable: !0, writable: !0, value: R.Init }),
            Object.defineProperty(this, "isDragging", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
            Object.defineProperty(this, "container", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
            Object.defineProperty(this, "content", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
            Object.defineProperty(this, "spinner", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "containerRect", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: { width: 0, height: 0, innerWidth: 0, innerHeight: 0 },
            }),
            Object.defineProperty(this, "contentRect", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    fullWidth: 0,
                    fullHeight: 0,
                    fitWidth: 0,
                    fitHeight: 0,
                    width: 0,
                    height: 0,
                },
            }),
            Object.defineProperty(this, "dragStart", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: { x: 0, y: 0, top: 0, left: 0, time: 0 },
            }),
            Object.defineProperty(this, "dragOffset", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: { x: 0, y: 0, time: 0 },
            }),
            Object.defineProperty(this, "current", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: Object.assign({}, qe),
            }),
            Object.defineProperty(this, "target", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: Object.assign({}, qe),
            }),
            Object.defineProperty(this, "velocity", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 0 },
            }),
            Object.defineProperty(this, "lockedAxis", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
            !e)
        )
            throw new Error("Container Element Not Found");
        (this.container = e),
            this.initContent(),
            this.attachPlugins(Object.assign(Object.assign({}, ye.Plugins), i)),
            this.emit("attachPlugins"),
            this.emit("init");
        const o = this.content;
        if (
            (o.addEventListener("load", this.onLoad), o.addEventListener("error", this.onError), this.isContentLoading)
        ) {
            if (this.option("spinner")) {
                e.classList.add(this.cn("isLoading"));
                const a = se(Ot);
                !e.contains(o) || o.parentElement instanceof HTMLPictureElement
                    ? (this.spinner = e.appendChild(a))
                    : (this.spinner =
                          ((s = o.parentElement) === null || s === void 0 ? void 0 : s.insertBefore(a, o)) || null);
            }
            this.emit("beforeLoad");
        } else
            queueMicrotask(() => {
                this.enable();
            });
    }
    initContent() {
        const { container: e } = this,
            t = this.cn(Wt);
        let i = this.option(Wt) || e.querySelector(`.${t}`);
        if (
            (i || ((i = e.querySelector("img,picture") || e.firstElementChild), i && I(i, t)),
            i instanceof HTMLPictureElement && (i = i.querySelector("img")),
            !i)
        )
            throw new Error("No content found");
        this.content = i;
    }
    onLoad() {
        const { spinner: e, container: t, state: i } = this;
        e && (e.remove(), (this.spinner = null)),
            this.option("spinner") && t.classList.remove(this.cn("isLoading")),
            this.emit("afterLoad"),
            i === R.Init ? this.enable() : this.updateMetrics();
    }
    onError() {
        this.state !== R.Destroy &&
            (this.spinner && (this.spinner.remove(), (this.spinner = null)),
            this.stop(),
            this.detachEvents(),
            (this.state = R.Error),
            this.emit("error"));
    }
    getNextScale(e) {
        const { fullScale: t, targetScale: i, coverScale: s, maxScale: o, minScale: a } = this;
        let r = a;
        switch (e) {
            case "toggleMax":
                r = i - a < 0.5 * (o - a) ? o : a;
                break;
            case "toggleCover":
                r = i - a < 0.5 * (s - a) ? s : a;
                break;
            case "toggleZoom":
                r = i - a < 0.5 * (t - a) ? t : a;
                break;
            case "iterateZoom":
                let l = [1, t, o].sort((d, u) => d - u),
                    c = l.findIndex((d) => d > i + 1e-5);
                r = l[c] || 1;
        }
        return r;
    }
    attachObserver() {
        var e;
        const t = () => {
            const { container: i, containerRect: s } = this;
            return (
                Math.abs(s.width - i.getBoundingClientRect().width) > 0.1 ||
                Math.abs(s.height - i.getBoundingClientRect().height) > 0.1
            );
        };
        this.resizeObserver ||
            window.ResizeObserver === void 0 ||
            (this.resizeObserver = new ResizeObserver(() => {
                this.updateTimer ||
                    (t()
                        ? (this.onResize(),
                          this.isMobile &&
                              (this.updateTimer = setTimeout(() => {
                                  t() && this.onResize(), (this.updateTimer = null);
                              }, 500)))
                        : this.updateTimer && (clearTimeout(this.updateTimer), (this.updateTimer = null)));
            })),
            (e = this.resizeObserver) === null || e === void 0 || e.observe(this.container);
    }
    detachObserver() {
        var e;
        (e = this.resizeObserver) === null || e === void 0 || e.disconnect();
    }
    attachEvents() {
        const { container: e } = this;
        e.addEventListener("click", this.onClick, { passive: !1, capture: !1 }),
            e.addEventListener("wheel", this.onWheel, { passive: !1 }),
            (this.pointerTracker = new go(e, {
                start: this.onPointerDown,
                move: this.onPointerMove,
                end: this.onPointerUp,
            })),
            document.addEventListener(K, this.onMouseMove);
    }
    detachEvents() {
        var e;
        const { container: t } = this;
        t.removeEventListener("click", this.onClick, { passive: !1, capture: !1 }),
            t.removeEventListener("wheel", this.onWheel, { passive: !1 }),
            (e = this.pointerTracker) === null || e === void 0 || e.stop(),
            (this.pointerTracker = null),
            document.removeEventListener(K, this.onMouseMove),
            document.removeEventListener("keydown", this.onKeydown, !0),
            this.clickTimer && (clearTimeout(this.clickTimer), (this.clickTimer = null)),
            this.updateTimer && (clearTimeout(this.updateTimer), (this.updateTimer = null));
    }
    animate() {
        this.setTargetForce();
        const e = this.friction,
            t = this.option("maxVelocity");
        for (const i of ae)
            e
                ? ((this.velocity[i] *= 1 - e),
                  t && !this.isScaling && (this.velocity[i] = Math.max(Math.min(this.velocity[i], t), -1 * t)),
                  (this.current[i] += this.velocity[i]))
                : (this.current[i] = this.target[i]);
        this.setTransform(),
            this.setEdgeForce(),
            !this.isResting || this.isDragging
                ? (this.rAF = requestAnimationFrame(() => this.animate()))
                : this.stop("current");
    }
    setTargetForce() {
        for (const e of ae)
            (e === "e" && this.isBouncingX) ||
                (e === "f" && this.isBouncingY) ||
                (this.velocity[e] = (1 / (1 - this.friction) - 1) * (this.target[e] - this.current[e]));
    }
    checkBounds(e = 0, t = 0) {
        const { current: i } = this,
            s = i.e + e,
            o = i.f + t,
            a = this.getBounds(),
            { x: r, y: l } = a,
            c = r.min,
            d = r.max,
            u = l.min,
            f = l.max;
        let h = 0,
            g = 0;
        return (
            c !== 1 / 0 && s < c ? (h = c - s) : d !== 1 / 0 && s > d && (h = d - s),
            u !== 1 / 0 && o < u ? (g = u - o) : f !== 1 / 0 && o > f && (g = f - o),
            Math.abs(h) < 1e-4 && (h = 0),
            Math.abs(g) < 1e-4 && (g = 0),
            Object.assign(Object.assign({}, a), { xDiff: h, yDiff: g, inBounds: !h && !g })
        );
    }
    clampTargetBounds() {
        const { target: e } = this,
            { x: t, y: i } = this.getBounds();
        t.min !== 1 / 0 && (e.e = Math.max(e.e, t.min)),
            t.max !== 1 / 0 && (e.e = Math.min(e.e, t.max)),
            i.min !== 1 / 0 && (e.f = Math.max(e.f, i.min)),
            i.max !== 1 / 0 && (e.f = Math.min(e.f, i.max));
    }
    calculateContentDim(e = this.current) {
        const { content: t, contentRect: i } = this,
            { fitWidth: s, fitHeight: o, fullWidth: a, fullHeight: r } = i;
        let l = a,
            c = r;
        if (this.option("zoom") || this.angle !== 0) {
            const d =
                    !(t instanceof HTMLImageElement) &&
                    (window.getComputedStyle(t).maxWidth === "none" || window.getComputedStyle(t).maxHeight === "none"),
                u = d ? a : s,
                f = d ? r : o,
                h = this.getMatrix(e),
                g = new DOMPoint(0, 0).matrixTransform(h),
                p = new DOMPoint(0 + u, 0).matrixTransform(h),
                m = new DOMPoint(0 + u, 0 + f).matrixTransform(h),
                v = new DOMPoint(0, 0 + f).matrixTransform(h),
                b = Math.abs(m.x - g.x),
                S = Math.abs(m.y - g.y),
                y = Math.abs(v.x - p.x),
                x = Math.abs(v.y - p.y);
            (l = Math.max(b, y)), (c = Math.max(S, x));
        }
        return { contentWidth: l, contentHeight: c };
    }
    setEdgeForce() {
        if (this.ignoreBounds || this.isDragging || this.panMode === K || this.targetScale < this.scale)
            return (this.isBouncingX = !1), void (this.isBouncingY = !1);
        const { target: e } = this,
            { x: t, y: i, xDiff: s, yDiff: o } = this.checkBounds(),
            a = this.option("maxVelocity");
        let r = this.velocity.e,
            l = this.velocity.f;
        s !== 0
            ? ((this.isBouncingX = !0),
              s * r <= 0
                  ? (r += 0.14 * s)
                  : ((r = 0.14 * s),
                    t.min !== 1 / 0 && (this.target.e = Math.max(e.e, t.min)),
                    t.max !== 1 / 0 && (this.target.e = Math.min(e.e, t.max))),
              a && (r = Math.max(Math.min(r, a), -1 * a)))
            : (this.isBouncingX = !1),
            o !== 0
                ? ((this.isBouncingY = !0),
                  o * l <= 0
                      ? (l += 0.14 * o)
                      : ((l = 0.14 * o),
                        i.min !== 1 / 0 && (this.target.f = Math.max(e.f, i.min)),
                        i.max !== 1 / 0 && (this.target.f = Math.min(e.f, i.max))),
                  a && (l = Math.max(Math.min(l, a), -1 * a)))
                : (this.isBouncingY = !1),
            this.isBouncingX && (this.velocity.e = r),
            this.isBouncingY && (this.velocity.f = l);
    }
    enable() {
        const { content: e } = this,
            t = new DOMMatrixReadOnly(window.getComputedStyle(e).transform);
        for (const i of ae) this.current[i] = this.target[i] = t[i];
        this.updateMetrics(), this.attachObserver(), this.attachEvents(), (this.state = R.Ready), this.emit("ready");
    }
    onClick(e) {
        var t;
        e.type === "click" && e.detail === 0 && ((this.dragOffset.x = 0), (this.dragOffset.y = 0)),
            this.isDragging &&
                ((t = this.pointerTracker) === null || t === void 0 || t.clear(),
                (this.trackingPoints = []),
                this.startDecelAnim());
        const i = e.target;
        if (!i || e.defaultPrevented) return;
        if (i.hasAttribute("disabled")) return e.preventDefault(), void e.stopPropagation();
        if (
            (() => {
                const h = window.getSelection();
                return h && h.type === "Range";
            })() &&
            !i.closest("button")
        )
            return;
        const s = i.closest("[data-panzoom-action]"),
            o = i.closest("[data-panzoom-change]"),
            a = s || o,
            r = a && Y(a) ? a.dataset : null;
        if (r) {
            const h = r.panzoomChange,
                g = r.panzoomAction;
            if (((h || g) && e.preventDefault(), h)) {
                let p = {};
                try {
                    p = JSON.parse(h);
                } catch {
                    console && console.warn("The given data was not valid JSON");
                }
                return void this.applyChange(p);
            }
            if (g) return void (this[g] && this[g]());
        }
        if (Math.abs(this.dragOffset.x) > 3 || Math.abs(this.dragOffset.y) > 3)
            return e.preventDefault(), void e.stopPropagation();
        if (i.closest("[data-fancybox]")) return;
        const l = this.content.getBoundingClientRect(),
            c = this.dragStart;
        if (c.time && !this.canZoomOut() && (Math.abs(l.x - c.x) > 2 || Math.abs(l.y - c.y) > 2)) return;
        this.dragStart.time = 0;
        const d = (h) => {
                this.option("zoom", e) &&
                    h &&
                    typeof h == "string" &&
                    /(iterateZoom)|(toggle(Zoom|Full|Cover|Max)|(zoomTo(Fit|Cover|Max)))/.test(h) &&
                    typeof this[h] == "function" &&
                    (e.preventDefault(), this[h]({ event: e }));
            },
            u = this.option("click", e),
            f = this.option("dblClick", e);
        f
            ? (this.clicks++,
              this.clicks == 1 &&
                  (this.clickTimer = setTimeout(() => {
                      this.clicks === 1
                          ? (this.emit("click", e), !e.defaultPrevented && u && d(u))
                          : (this.emit("dblClick", e), e.defaultPrevented || d(f)),
                          (this.clicks = 0),
                          (this.clickTimer = null);
                  }, 350)))
            : (this.emit("click", e), !e.defaultPrevented && u && d(u));
    }
    addTrackingPoint(e) {
        const t = this.trackingPoints.filter((i) => i.time > Date.now() - 100);
        t.push(e), (this.trackingPoints = t);
    }
    onPointerDown(e, t, i) {
        var s;
        if (this.option("touch", e) === !1) return !1;
        (this.pwt = 0), (this.dragOffset = { x: 0, y: 0, time: 0 }), (this.trackingPoints = []);
        const o = this.content.getBoundingClientRect();
        if (((this.dragStart = { x: o.x, y: o.y, top: o.top, left: o.left, time: Date.now() }), this.clickTimer))
            return !1;
        if (this.panMode === K && this.targetScale > 1) return e.preventDefault(), e.stopPropagation(), !1;
        const a = e.composedPath()[0];
        if (!i.length) {
            if (
                ["TEXTAREA", "OPTION", "INPUT", "SELECT", "VIDEO", "IFRAME"].includes(a.nodeName) ||
                a.closest(
                    "[contenteditable],[data-selectable],[data-draggable],[data-clickable],[data-panzoom-change],[data-panzoom-action]"
                )
            )
                return !1;
            (s = window.getSelection()) === null || s === void 0 || s.removeAllRanges();
        }
        if (e.type === "mousedown") ["A", "BUTTON"].includes(a.nodeName) || e.preventDefault();
        else if (Math.abs(this.velocity.a) > 0.3) return !1;
        return (
            (this.target.e = this.current.e),
            (this.target.f = this.current.f),
            this.stop(),
            this.isDragging || ((this.isDragging = !0), this.addTrackingPoint(t), this.emit("touchStart", e)),
            !0
        );
    }
    onPointerMove(e, t, i) {
        if (
            this.option("touch", e) === !1 ||
            !this.isDragging ||
            (t.length < 2 && this.panOnlyZoomed && M(this.targetScale) <= M(this.minScale)) ||
            (this.emit("touchMove", e), e.defaultPrevented)
        )
            return;
        this.addTrackingPoint(t[0]);
        const { content: s } = this,
            o = Ht(i[0], i[1]),
            a = Ht(t[0], t[1]);
        let r = 0,
            l = 0;
        if (t.length > 1) {
            const S = s.getBoundingClientRect();
            (r = o.clientX - S.left - 0.5 * S.width), (l = o.clientY - S.top - 0.5 * S.height);
        }
        const c = Bt(i[0], i[1]),
            d = Bt(t[0], t[1]);
        let u = c ? d / c : 1,
            f = a.clientX - o.clientX,
            h = a.clientY - o.clientY;
        (this.dragOffset.x += f), (this.dragOffset.y += h), (this.dragOffset.time = Date.now() - this.dragStart.time);
        let g = M(this.targetScale) === M(this.minScale) && this.option("lockAxis");
        if (g && !this.lockedAxis)
            if (g === "xy" || g === "y" || e.type === "touchmove") {
                if (Math.abs(this.dragOffset.x) < 6 && Math.abs(this.dragOffset.y) < 6) return void e.preventDefault();
                const S = Math.abs((180 * Math.atan2(this.dragOffset.y, this.dragOffset.x)) / Math.PI);
                (this.lockedAxis = S > 45 && S < 135 ? "y" : "x"),
                    (this.dragOffset.x = 0),
                    (this.dragOffset.y = 0),
                    (f = 0),
                    (h = 0);
            } else this.lockedAxis = g;
        if (
            (Ze(e.target, this.content) && ((g = "x"), (this.dragOffset.y = 0)),
            g && g !== "xy" && this.lockedAxis !== g && M(this.targetScale) === M(this.minScale))
        )
            return;
        e.cancelable && e.preventDefault(), this.container.classList.add(this.cn("isDragging"));
        const p = this.checkBounds(f, h);
        this.option("rubberband")
            ? (this.isInfinite !== "x" &&
                  ((p.xDiff > 0 && f < 0) || (p.xDiff < 0 && f > 0)) &&
                  (f *= Math.max(0, 0.5 - Math.abs((0.75 / this.contentRect.fitWidth) * p.xDiff))),
              this.isInfinite !== "y" &&
                  ((p.yDiff > 0 && h < 0) || (p.yDiff < 0 && h > 0)) &&
                  (h *= Math.max(0, 0.5 - Math.abs((0.75 / this.contentRect.fitHeight) * p.yDiff))))
            : (p.xDiff && (f = 0), p.yDiff && (h = 0));
        const m = this.targetScale,
            v = this.minScale,
            b = this.maxScale;
        m < 0.5 * v && (u = Math.max(u, v)),
            m > 1.5 * b && (u = Math.min(u, b)),
            this.lockedAxis === "y" && M(m) === M(v) && (f = 0),
            this.lockedAxis === "x" && M(m) === M(v) && (h = 0),
            this.applyChange({
                originX: r,
                originY: l,
                panX: f,
                panY: h,
                scale: u,
                friction: this.option("dragFriction"),
                ignoreBounds: !0,
            });
    }
    onPointerUp(e, t, i) {
        if (i.length) return (this.dragOffset.x = 0), (this.dragOffset.y = 0), void (this.trackingPoints = []);
        this.container.classList.remove(this.cn("isDragging")),
            this.isDragging &&
                (this.addTrackingPoint(t),
                this.panOnlyZoomed &&
                    this.contentRect.width - this.contentRect.fitWidth < 1 &&
                    this.contentRect.height - this.contentRect.fitHeight < 1 &&
                    (this.trackingPoints = []),
                Ze(e.target, this.content) && this.lockedAxis === "y" && (this.trackingPoints = []),
                this.emit("touchEnd", e),
                (this.isDragging = !1),
                (this.lockedAxis = !1),
                this.state !== R.Destroy && (e.defaultPrevented || this.startDecelAnim()));
    }
    startDecelAnim() {
        var e;
        const t = this.isScaling;
        this.rAF && (cancelAnimationFrame(this.rAF), (this.rAF = null)),
            (this.isBouncingX = !1),
            (this.isBouncingY = !1);
        for (const S of ae) this.velocity[S] = 0;
        (this.target.e = this.current.e),
            (this.target.f = this.current.f),
            D(this.container, "is-scaling"),
            D(this.container, "is-animating"),
            (this.isTicking = !1);
        const { trackingPoints: i } = this,
            s = i[0],
            o = i[i.length - 1];
        let a = 0,
            r = 0,
            l = 0;
        o && s && ((a = o.clientX - s.clientX), (r = o.clientY - s.clientY), (l = o.time - s.time));
        const c = ((e = window.visualViewport) === null || e === void 0 ? void 0 : e.scale) || 1;
        c !== 1 && ((a *= c), (r *= c));
        let d = 0,
            u = 0,
            f = 0,
            h = 0,
            g = this.option("decelFriction");
        const p = this.targetScale;
        if (l > 0) {
            (f = Math.abs(a) > 3 ? a / (l / 30) : 0), (h = Math.abs(r) > 3 ? r / (l / 30) : 0);
            const S = this.option("maxVelocity");
            S && ((f = Math.max(Math.min(f, S), -1 * S)), (h = Math.max(Math.min(h, S), -1 * S)));
        }
        f && (d = f / (1 / (1 - g) - 1)),
            h && (u = h / (1 / (1 - g) - 1)),
            (this.option("lockAxis") === "y" ||
                (this.option("lockAxis") === "xy" && this.lockedAxis === "y" && M(p) === this.minScale)) &&
                (d = f = 0),
            (this.option("lockAxis") === "x" ||
                (this.option("lockAxis") === "xy" && this.lockedAxis === "x" && M(p) === this.minScale)) &&
                (u = h = 0);
        const m = this.dragOffset.x,
            v = this.dragOffset.y,
            b = this.option("dragMinThreshold") || 0;
        Math.abs(m) < b && Math.abs(v) < b && ((d = u = 0), (f = h = 0)),
            ((this.option("zoom") && (p < this.minScale - 1e-5 || p > this.maxScale + 1e-5)) || (t && !d && !u)) &&
                (g = 0.35),
            this.applyChange({ panX: d, panY: u, friction: g }),
            this.emit("decel", f, h, m, v);
    }
    onWheel(e) {
        var t = [-e.deltaX || 0, -e.deltaY || 0, -e.detail || 0].reduce(function (o, a) {
            return Math.abs(a) > Math.abs(o) ? a : o;
        });
        const i = Math.max(-1, Math.min(1, t));
        if ((this.emit("wheel", e, i), this.panMode === K || e.defaultPrevented)) return;
        const s = this.option("wheel");
        s === "pan"
            ? (e.preventDefault(),
              (this.panOnlyZoomed && !this.canZoomOut()) ||
                  this.applyChange({ panX: 2 * -e.deltaX, panY: 2 * -e.deltaY, bounce: !1 }))
            : s === "zoom" && this.option("zoom") !== !1 && this.zoomWithWheel(e);
    }
    onMouseMove(e) {
        this.panWithMouse(e);
    }
    onKeydown(e) {
        e.key === "Escape" && this.toggleFS();
    }
    onResize() {
        this.updateMetrics(), this.checkBounds().inBounds || this.requestTick();
    }
    setTransform() {
        this.emit("beforeTransform");
        const { current: e, target: t, content: i, contentRect: s } = this,
            o = Object.assign({}, qe);
        for (const m of ae) {
            const v = m == "e" || m === "f" ? Fe : bo;
            (o[m] = M(e[m], v)), Math.abs(t[m] - e[m]) < (m == "e" || m === "f" ? 0.51 : 0.001) && (e[m] = t[m]);
        }
        let { a, b: r, c: l, d: c, e: d, f: u } = o,
            f = `matrix(${a}, ${r}, ${l}, ${c}, ${d}, ${u})`,
            h = i.parentElement instanceof HTMLPictureElement ? i.parentElement : i;
        if ((this.option("transformParent") && (h = h.parentElement || h), h.style.transform === f)) return;
        h.style.transform = f;
        const { contentWidth: g, contentHeight: p } = this.calculateContentDim();
        (s.width = g), (s.height = p), this.emit("afterTransform");
    }
    updateMetrics(e = !1) {
        var t;
        if (!this || this.state === R.Destroy || this.isContentLoading) return;
        const i = Math.max(1, ((t = window.visualViewport) === null || t === void 0 ? void 0 : t.scale) || 1),
            { container: s, content: o } = this,
            a = o instanceof HTMLImageElement,
            r = s.getBoundingClientRect(),
            l = getComputedStyle(this.container);
        let c = r.width * i,
            d = r.height * i;
        const u = parseFloat(l.paddingTop) + parseFloat(l.paddingBottom),
            f = c - (parseFloat(l.paddingLeft) + parseFloat(l.paddingRight)),
            h = d - u;
        this.containerRect = { width: c, height: d, innerWidth: f, innerHeight: h };
        const g =
                parseFloat(o.dataset.width || "") ||
                ((A) => {
                    let O = 0;
                    return (
                        (O =
                            A instanceof HTMLImageElement
                                ? A.naturalWidth
                                : A instanceof SVGElement
                                  ? A.width.baseVal.value
                                  : Math.max(A.offsetWidth, A.scrollWidth)),
                        O || 0
                    );
                })(o),
            p =
                parseFloat(o.dataset.height || "") ||
                ((A) => {
                    let O = 0;
                    return (
                        (O =
                            A instanceof HTMLImageElement
                                ? A.naturalHeight
                                : A instanceof SVGElement
                                  ? A.height.baseVal.value
                                  : Math.max(A.offsetHeight, A.scrollHeight)),
                        O || 0
                    );
                })(o);
        let m = this.option("width", g) || J,
            v = this.option("height", p) || J;
        const b = m === J,
            S = v === J;
        typeof m != "number" && (m = g),
            typeof v != "number" && (v = p),
            b && (m = g * (v / p)),
            S && (v = p / (g / m));
        let y = o.parentElement instanceof HTMLPictureElement ? o.parentElement : o;
        this.option("transformParent") && (y = y.parentElement || y);
        const x = y.getAttribute("style") || "";
        y.style.setProperty("transform", "none", "important"),
            a && ((y.style.width = ""), (y.style.height = "")),
            y.offsetHeight;
        const C = o.getBoundingClientRect();
        let E = C.width * i,
            P = C.height * i,
            _ = E,
            T = P;
        (E = Math.min(E, m)),
            (P = Math.min(P, v)),
            a
                ? ({ width: E, height: P } = ((A, O, $, j) => {
                      const G = $ / A,
                          F = j / O,
                          q = Math.min(G, F);
                      return { width: (A *= q), height: (O *= q) };
                  })(m, v, E, P))
                : ((E = Math.min(E, m)), (P = Math.min(P, v)));
        let w = 0.5 * (T - P),
            k = 0.5 * (_ - E);
        (this.contentRect = Object.assign(Object.assign({}, this.contentRect), {
            top: C.top - r.top + w,
            bottom: r.bottom - C.bottom + w,
            left: C.left - r.left + k,
            right: r.right - C.right + k,
            fitWidth: E,
            fitHeight: P,
            width: E,
            height: P,
            fullWidth: m,
            fullHeight: v,
        })),
            (y.style.cssText = x),
            a && ((y.style.width = `${E}px`), (y.style.height = `${P}px`)),
            this.setTransform(),
            e !== !0 && this.emit("refresh"),
            this.ignoreBounds ||
                (M(this.targetScale) < M(this.minScale)
                    ? this.zoomTo(this.minScale, { friction: 0 })
                    : this.targetScale > this.maxScale
                      ? this.zoomTo(this.maxScale, { friction: 0 })
                      : this.state === R.Init || this.checkBounds().inBounds || this.requestTick()),
            this.updateControls();
    }
    calculateBounds() {
        const { contentWidth: e, contentHeight: t } = this.calculateContentDim(this.target),
            { targetScale: i, lockedAxis: s } = this,
            { fitWidth: o, fitHeight: a } = this.contentRect;
        let r = 0,
            l = 0,
            c = 0,
            d = 0;
        const u = this.option("infinite");
        if (u === !0 || (s && u === s)) (r = -1 / 0), (c = 1 / 0), (l = -1 / 0), (d = 1 / 0);
        else {
            let { containerRect: f, contentRect: h } = this,
                g = M(o * i, Fe),
                p = M(a * i, Fe),
                { innerWidth: m, innerHeight: v } = f;
            if ((f.width === g && (m = f.width), f.width === p && (v = f.height), e > m)) {
                (c = 0.5 * (e - m)), (r = -1 * c);
                let b = 0.5 * (h.right - h.left);
                (r += b), (c += b);
            }
            if ((o > m && e < m && ((r -= 0.5 * (o - m)), (c -= 0.5 * (o - m))), t > v)) {
                (d = 0.5 * (t - v)), (l = -1 * d);
                let b = 0.5 * (h.bottom - h.top);
                (l += b), (d += b);
            }
            a > v && t < v && ((r -= 0.5 * (a - v)), (c -= 0.5 * (a - v)));
        }
        return { x: { min: r, max: c }, y: { min: l, max: d } };
    }
    getBounds() {
        const e = this.option("bounds");
        return e !== J ? e : this.calculateBounds();
    }
    updateControls() {
        const e = this,
            t = e.container,
            { panMode: i, contentRect: s, targetScale: o, minScale: a } = e;
        let r = a,
            l = e.option("click") || !1;
        l && (r = e.getNextScale(l));
        let c = e.canZoomIn(),
            d = e.canZoomOut(),
            u = i === Gt && !!this.option("touch"),
            f = d && u;
        if (
            (u &&
                (M(o) < M(a) && !this.panOnlyZoomed && (f = !0),
                (M(s.width, 1) > M(s.fitWidth, 1) || M(s.height, 1) > M(s.fitHeight, 1)) && (f = !0)),
            M(s.width * o, 1) < M(s.fitWidth, 1) && (f = !1),
            i === K && (f = !1),
            oe(t, this.cn("isDraggable"), f),
            !this.option("zoom"))
        )
            return;
        let h = c && M(r) > M(o),
            g = !h && !f && d && M(r) < M(o);
        oe(t, this.cn("canZoomIn"), h), oe(t, this.cn("canZoomOut"), g);
        for (const p of t.querySelectorAll("[data-panzoom-action]")) {
            let m = !1,
                v = !1;
            switch (p.dataset.panzoomAction) {
                case "zoomIn":
                    c ? (m = !0) : (v = !0);
                    break;
                case "zoomOut":
                    d ? (m = !0) : (v = !0);
                    break;
                case "toggleZoom":
                case "iterateZoom":
                    c || d ? (m = !0) : (v = !0);
                    const b = p.querySelector("g");
                    b && (b.style.display = c ? "" : "none");
            }
            m
                ? (p.removeAttribute("disabled"), p.removeAttribute("tabindex"))
                : v && (p.setAttribute("disabled", ""), p.setAttribute("tabindex", "-1"));
        }
    }
    panTo({
        x: e = this.target.e,
        y: t = this.target.f,
        scale: i = this.targetScale,
        friction: s = this.option("friction"),
        angle: o = 0,
        originX: a = 0,
        originY: r = 0,
        flipX: l = !1,
        flipY: c = !1,
        ignoreBounds: d = !1,
    }) {
        this.state !== R.Destroy &&
            this.applyChange({
                panX: e - this.target.e,
                panY: t - this.target.f,
                scale: i / this.targetScale,
                angle: o,
                originX: a,
                originY: r,
                friction: s,
                flipX: l,
                flipY: c,
                ignoreBounds: d,
            });
    }
    applyChange({
        panX: e = 0,
        panY: t = 0,
        scale: i = 1,
        angle: s = 0,
        originX: o = -this.current.e,
        originY: a = -this.current.f,
        friction: r = this.option("friction"),
        flipX: l = !1,
        flipY: c = !1,
        ignoreBounds: d = !1,
        bounce: u = this.option("bounce"),
    }) {
        const f = this.state;
        if (f === R.Destroy) return;
        this.rAF && (cancelAnimationFrame(this.rAF), (this.rAF = null)),
            (this.friction = r || 0),
            (this.ignoreBounds = d);
        const { current: h } = this,
            g = h.e,
            p = h.f,
            m = this.getMatrix(this.target);
        let v = new DOMMatrix().translate(g, p).translate(o, a).translate(e, t);
        if (this.option("zoom")) {
            if (!d) {
                const b = this.targetScale,
                    S = this.minScale,
                    y = this.maxScale;
                b * i < S && (i = S / b), b * i > y && (i = y / b);
            }
            v = v.scale(i);
        }
        (v = v.translate(-o, -a).translate(-g, -p).multiply(m)),
            s && (v = v.rotate(s)),
            l && (v = v.scale(-1, 1)),
            c && (v = v.scale(1, -1));
        for (const b of ae)
            b !== "e" && b !== "f" && (v[b] > this.minScale + 1e-5 || v[b] < this.minScale - 1e-5)
                ? (this.target[b] = v[b])
                : (this.target[b] = M(v[b], Fe));
        (this.targetScale < this.scale || Math.abs(i - 1) > 0.1 || this.panMode === K || u === !1) &&
            !d &&
            this.clampTargetBounds(),
            f === R.Init ? this.animate() : this.isResting || ((this.state = R.Panning), this.requestTick());
    }
    stop(e = !1) {
        if (this.state === R.Init || this.state === R.Destroy) return;
        const t = this.isTicking;
        this.rAF && (cancelAnimationFrame(this.rAF), (this.rAF = null)),
            (this.isBouncingX = !1),
            (this.isBouncingY = !1);
        for (const i of ae)
            (this.velocity[i] = 0),
                e === "current"
                    ? (this.current[i] = this.target[i])
                    : e === "target" && (this.target[i] = this.current[i]);
        this.setTransform(),
            D(this.container, "is-scaling"),
            D(this.container, "is-animating"),
            (this.isTicking = !1),
            (this.state = R.Ready),
            t && (this.emit("endAnimation"), this.updateControls());
    }
    requestTick() {
        this.isTicking ||
            (this.emit("startAnimation"),
            this.updateControls(),
            I(this.container, "is-animating"),
            this.isScaling && I(this.container, "is-scaling")),
            (this.isTicking = !0),
            this.rAF || (this.rAF = requestAnimationFrame(() => this.animate()));
    }
    panWithMouse(e, t = this.option("mouseMoveFriction")) {
        if (((this.pmme = e), this.panMode !== K || !e || M(this.targetScale) <= M(this.minScale))) return;
        this.emit("mouseMove", e);
        const { container: i, containerRect: s, contentRect: o } = this,
            a = s.width,
            r = s.height,
            l = i.getBoundingClientRect(),
            c = (e.clientX || 0) - l.left,
            d = (e.clientY || 0) - l.top;
        let { contentWidth: u, contentHeight: f } = this.calculateContentDim(this.target);
        const h = this.option("mouseMoveFactor");
        h > 1 && (u !== a && (u *= h), f !== r && (f *= h));
        let g = 0.5 * (u - a) - (((c / a) * 100) / 100) * (u - a);
        g += 0.5 * (o.right - o.left);
        let p = 0.5 * (f - r) - (((d / r) * 100) / 100) * (f - r);
        (p += 0.5 * (o.bottom - o.top)),
            this.applyChange({ panX: g - this.target.e, panY: p - this.target.f, friction: t });
    }
    zoomWithWheel(e) {
        if (this.state === R.Destroy || this.state === R.Init) return;
        const t = Date.now();
        if (t - this.pwt < 45) return void e.preventDefault();
        this.pwt = t;
        var i = [-e.deltaX || 0, -e.deltaY || 0, -e.detail || 0].reduce(function (c, d) {
            return Math.abs(d) > Math.abs(c) ? d : c;
        });
        const s = Math.max(-1, Math.min(1, i)),
            { targetScale: o, maxScale: a, minScale: r } = this;
        let l = (o * (100 + 45 * s)) / 100;
        M(l) < M(r) && M(o) <= M(r)
            ? ((this.cwd += Math.abs(s)), (l = r))
            : M(l) > M(a) && M(o) >= M(a)
              ? ((this.cwd += Math.abs(s)), (l = a))
              : ((this.cwd = 0), (l = Math.max(Math.min(l, a), r))),
            this.cwd > this.option("wheelLimit") || (e.preventDefault(), M(l) !== M(o) && this.zoomTo(l, { event: e }));
    }
    canZoomIn() {
        return (
            this.option("zoom") &&
            (M(this.contentRect.width, 1) < M(this.contentRect.fitWidth, 1) || M(this.targetScale) < M(this.maxScale))
        );
    }
    canZoomOut() {
        return this.option("zoom") && M(this.targetScale) > M(this.minScale);
    }
    zoomIn(e = 1.25, t) {
        this.zoomTo(this.targetScale * e, t);
    }
    zoomOut(e = 0.8, t) {
        this.zoomTo(this.targetScale * e, t);
    }
    zoomToFit(e) {
        this.zoomTo("fit", e);
    }
    zoomToCover(e) {
        this.zoomTo("cover", e);
    }
    zoomToFull(e) {
        this.zoomTo("full", e);
    }
    zoomToMax(e) {
        this.zoomTo("max", e);
    }
    toggleZoom(e) {
        this.zoomTo(this.getNextScale("toggleZoom"), e);
    }
    toggleMax(e) {
        this.zoomTo(this.getNextScale("toggleMax"), e);
    }
    toggleCover(e) {
        this.zoomTo(this.getNextScale("toggleCover"), e);
    }
    iterateZoom(e) {
        this.zoomTo("next", e);
    }
    zoomTo(e = 1, { friction: t = J, originX: i = J, originY: s = J, event: o } = {}) {
        if (this.isContentLoading || this.state === R.Destroy) return;
        const { targetScale: a, fullScale: r, maxScale: l, coverScale: c } = this;
        if ((this.stop(), this.panMode === K && (o = this.pmme || o), o || i === J || s === J)) {
            const u = this.content.getBoundingClientRect(),
                f = this.container.getBoundingClientRect(),
                h = o ? o.clientX : f.left + 0.5 * f.width,
                g = o ? o.clientY : f.top + 0.5 * f.height;
            (i = h - u.left - 0.5 * u.width), (s = g - u.top - 0.5 * u.height);
        }
        let d = 1;
        typeof e == "number"
            ? (d = e)
            : e === "full"
              ? (d = r)
              : e === "cover"
                ? (d = c)
                : e === "max"
                  ? (d = l)
                  : e === "fit"
                    ? (d = 1)
                    : e === "next" && (d = this.getNextScale("iterateZoom")),
            (d = d / a || 1),
            (t = t === J ? (d > 1 ? 0.15 : 0.25) : t),
            this.applyChange({ scale: d, originX: i, originY: s, friction: t }),
            o && this.panMode === K && this.panWithMouse(o, t);
    }
    rotateCCW() {
        this.applyChange({ angle: -90 });
    }
    rotateCW() {
        this.applyChange({ angle: 90 });
    }
    flipX() {
        this.applyChange({ flipX: !0 });
    }
    flipY() {
        this.applyChange({ flipY: !0 });
    }
    fitX() {
        this.stop("target");
        const { containerRect: e, contentRect: t, target: i } = this;
        this.applyChange({
            panX: 0.5 * e.width - (t.left + 0.5 * t.fitWidth) - i.e,
            panY: 0.5 * e.height - (t.top + 0.5 * t.fitHeight) - i.f,
            scale: e.width / t.fitWidth / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0,
        });
    }
    fitY() {
        this.stop("target");
        const { containerRect: e, contentRect: t, target: i } = this;
        this.applyChange({
            panX: 0.5 * e.width - (t.left + 0.5 * t.fitWidth) - i.e,
            panY: 0.5 * e.innerHeight - (t.top + 0.5 * t.fitHeight) - i.f,
            scale: e.height / t.fitHeight / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0,
        });
    }
    toggleFS() {
        const { container: e } = this,
            t = this.cn("inFullscreen"),
            i = this.cn("htmlHasFullscreen");
        e.classList.toggle(t);
        const s = e.classList.contains(t);
        s
            ? (document.documentElement.classList.add(i), document.addEventListener("keydown", this.onKeydown, !0))
            : (document.documentElement.classList.remove(i),
              document.removeEventListener("keydown", this.onKeydown, !0)),
            this.updateMetrics(),
            this.emit(s ? "enterFS" : "exitFS");
    }
    getMatrix(e = this.current) {
        const { a: t, b: i, c: s, d: o, e: a, f: r } = e;
        return new DOMMatrix([t, i, s, o, a, r]);
    }
    reset(e) {
        if (this.state !== R.Init && this.state !== R.Destroy) {
            this.stop("current");
            for (const t of ae) this.target[t] = qe[t];
            (this.target.a = this.minScale),
                (this.target.d = this.minScale),
                this.clampTargetBounds(),
                this.isResting ||
                    ((this.friction = e === void 0 ? this.option("friction") : e),
                    (this.state = R.Panning),
                    this.requestTick());
        }
    }
    destroy() {
        this.stop(), (this.state = R.Destroy), this.detachEvents(), this.detachObserver();
        const { container: e, content: t } = this,
            i = this.option("classes") || {};
        for (const s of Object.values(i)) e.classList.remove(s + "");
        t && (t.removeEventListener("load", this.onLoad), t.removeEventListener("error", this.onError)),
            this.detachPlugins();
    }
}
Object.defineProperty(ye, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: vo }),
    Object.defineProperty(ye, "Plugins", { enumerable: !0, configurable: !0, writable: !0, value: {} });
const Xt = function (n, e) {
        let t = !0;
        return (...i) => {
            t &&
                ((t = !1),
                n(...i),
                setTimeout(() => {
                    t = !0;
                }, e));
        };
    },
    Yt = (n, e) => {
        let t = [];
        return (
            n.childNodes.forEach((i) => {
                i.nodeType !== Node.ELEMENT_NODE || (e && !i.matches(e)) || t.push(i);
            }),
            t
        );
    },
    yo = {
        viewport: null,
        track: null,
        enabled: !0,
        slides: [],
        axis: "x",
        transition: "fade",
        preload: 1,
        slidesPerPage: "auto",
        initialPage: 0,
        friction: 0.12,
        Panzoom: { decelFriction: 0.12 },
        center: !0,
        infinite: !0,
        fill: !0,
        dragFree: !1,
        adaptiveHeight: !1,
        direction: "ltr",
        classes: {
            container: "f-carousel",
            viewport: "f-carousel__viewport",
            track: "f-carousel__track",
            slide: "f-carousel__slide",
            isLTR: "is-ltr",
            isRTL: "is-rtl",
            isHorizontal: "is-horizontal",
            isVertical: "is-vertical",
            inTransition: "in-transition",
            isSelected: "is-selected",
        },
        l10n: { NEXT: "Next slide", PREV: "Previous slide", GOTO: "Go to slide #%d" },
    };
var N;
(function (n) {
    (n[(n.Init = 0)] = "Init"), (n[(n.Ready = 1)] = "Ready"), (n[(n.Destroy = 2)] = "Destroy");
})(N || (N = {}));
const ut = (n) => {
        if (typeof n == "string" || n instanceof HTMLElement) n = { html: n };
        else {
            const e = n.thumb;
            e !== void 0 &&
                (typeof e == "string" && (n.thumbSrc = e),
                e instanceof HTMLImageElement && ((n.thumbEl = e), (n.thumbElSrc = e.src), (n.thumbSrc = e.src)),
                delete n.thumb);
        }
        return Object.assign(
            {
                html: "",
                el: null,
                isDom: !1,
                class: "",
                customClass: "",
                index: -1,
                dim: 0,
                gap: 0,
                pos: 0,
                transition: !1,
            },
            n
        );
    },
    So = (n = {}) => Object.assign({ index: -1, slides: [], dim: 0, pos: -1 }, n);
class ie extends Ke {
    constructor(e, t) {
        super(t), Object.defineProperty(this, "instance", { enumerable: !0, configurable: !0, writable: !0, value: e });
    }
    attach() {}
    detach() {}
}
const wo = {
    classes: {
        list: "f-carousel__dots",
        isDynamic: "is-dynamic",
        hasDots: "has-dots",
        dot: "f-carousel__dot",
        isBeforePrev: "is-before-prev",
        isPrev: "is-prev",
        isCurrent: "is-current",
        isNext: "is-next",
        isAfterNext: "is-after-next",
    },
    dotTpl: '<button type="button" data-carousel-page="%i" aria-label="{{GOTO}}"><span class="f-carousel__dot" aria-hidden="true"></span></button>',
    dynamicFrom: 11,
    maxCount: 1 / 0,
    minCount: 2,
};
class Pi extends ie {
    constructor() {
        super(...arguments),
            Object.defineProperty(this, "isDynamic", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
            Object.defineProperty(this, "list", { enumerable: !0, configurable: !0, writable: !0, value: null });
    }
    onRefresh() {
        this.refresh();
    }
    build() {
        let e = this.list;
        if (!e) {
            (e = document.createElement("ul")), I(e, this.cn("list")), e.setAttribute("role", "tablist");
            const t = this.instance.container;
            t.appendChild(e), I(t, this.cn("hasDots")), (this.list = e);
        }
        return e;
    }
    refresh() {
        var e;
        const t = this.instance.pages.length,
            i = Math.min(2, this.option("minCount")),
            s = Math.max(2e3, this.option("maxCount")),
            o = this.option("dynamicFrom");
        if (t < i || t > s) return void this.cleanup();
        const a = typeof o == "number" && t > 5 && t >= o,
            r = !this.list || this.isDynamic !== a || this.list.children.length !== t;
        r && this.cleanup();
        const l = this.build();
        if ((oe(l, this.cn("isDynamic"), !!a), r)) for (let u = 0; u < t; u++) l.append(this.createItem(u));
        let c,
            d = 0;
        for (const u of [...l.children]) {
            const f = d === this.instance.page;
            f && (c = u),
                oe(u, this.cn("isCurrent"), f),
                (e = u.children[0]) === null || e === void 0 || e.setAttribute("aria-selected", f ? "true" : "false");
            for (const h of ["isBeforePrev", "isPrev", "isNext", "isAfterNext"]) D(u, this.cn(h));
            d++;
        }
        if (((c = c || l.firstChild), a && c)) {
            const u = c.previousElementSibling,
                f = u && u.previousElementSibling;
            I(u, this.cn("isPrev")), I(f, this.cn("isBeforePrev"));
            const h = c.nextElementSibling,
                g = h && h.nextElementSibling;
            I(h, this.cn("isNext")), I(g, this.cn("isAfterNext"));
        }
        this.isDynamic = a;
    }
    createItem(e = 0) {
        var t;
        const i = document.createElement("li");
        i.setAttribute("role", "presentation");
        const s = se(this.instance.localize(this.option("dotTpl"), [["%d", e + 1]]).replace(/\%i/g, e + ""));
        return i.appendChild(s), (t = i.children[0]) === null || t === void 0 || t.setAttribute("role", "tab"), i;
    }
    cleanup() {
        this.list && (this.list.remove(), (this.list = null)),
            (this.isDynamic = !1),
            D(this.instance.container, this.cn("hasDots"));
    }
    attach() {
        this.instance.on(["refresh", "change"], this.onRefresh);
    }
    detach() {
        this.instance.off(["refresh", "change"], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty(Pi, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: wo });
const Ne = "disabled",
    je = "next",
    Ut = "prev";
class Ai extends ie {
    constructor() {
        super(...arguments),
            Object.defineProperty(this, "container", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "prev", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "next", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "isDom", { enumerable: !0, configurable: !0, writable: !0, value: !1 });
    }
    onRefresh() {
        const e = this.instance,
            t = e.pages.length,
            i = e.page;
        if (t < 2) return void this.cleanup();
        this.build();
        let s = this.prev,
            o = this.next;
        s &&
            o &&
            (s.removeAttribute(Ne),
            o.removeAttribute(Ne),
            e.isInfinite || (i <= 0 && s.setAttribute(Ne, ""), i >= t - 1 && o.setAttribute(Ne, "")));
    }
    addBtn(e) {
        var t;
        const i = this.instance,
            s = document.createElement("button");
        s.setAttribute("tabindex", "0"),
            s.setAttribute("title", i.localize(`{{${e.toUpperCase()}}}`)),
            I(s, this.cn("button") + " " + this.cn(e === je ? "isNext" : "isPrev"));
        const o = i.isRTL ? (e === je ? Ut : je) : e;
        var a;
        return (
            (s.innerHTML = i.localize(this.option(`${o}Tpl`))),
            (s.dataset[
                `carousel${((a = e), a ? (a.match("^[a-z]") ? a.charAt(0).toUpperCase() + a.substring(1) : a) : "")}`
            ] = "true"),
            (t = this.container) === null || t === void 0 || t.appendChild(s),
            s
        );
    }
    build() {
        const e = this.instance.container,
            t = this.cn("container");
        let { container: i, prev: s, next: o } = this;
        i || ((i = e.querySelector("." + t)), (this.isDom = !!i)),
            i || ((i = document.createElement("div")), I(i, t), e.appendChild(i)),
            (this.container = i),
            o || (o = i.querySelector("[data-carousel-next]")),
            o || (o = this.addBtn(je)),
            (this.next = o),
            s || (s = i.querySelector("[data-carousel-prev]")),
            s || (s = this.addBtn(Ut)),
            (this.prev = s);
    }
    cleanup() {
        this.isDom ||
            (this.prev && this.prev.remove(),
            this.next && this.next.remove(),
            this.container && this.container.remove()),
            (this.prev = null),
            (this.next = null),
            (this.container = null),
            (this.isDom = !1);
    }
    attach() {
        this.instance.on(["refresh", "change"], this.onRefresh);
    }
    detach() {
        this.instance.off(["refresh", "change"], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty(Ai, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        classes: { container: "f-carousel__nav", button: "f-button", isNext: "is-next", isPrev: "is-prev" },
        nextTpl:
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
        prevTpl:
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>',
    },
});
class ki extends ie {
    constructor() {
        super(...arguments),
            Object.defineProperty(this, "selectedIndex", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: null,
            }),
            Object.defineProperty(this, "target", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "nav", { enumerable: !0, configurable: !0, writable: !0, value: null });
    }
    addAsTargetFor(e) {
        (this.target = this.instance), (this.nav = e), this.attachEvents();
    }
    addAsNavFor(e) {
        (this.nav = this.instance), (this.target = e), this.attachEvents();
    }
    attachEvents() {
        const { nav: e, target: t } = this;
        e &&
            t &&
            ((e.options.initialSlide = t.options.initialPage),
            e.state === N.Ready ? this.onNavReady(e) : e.on("ready", this.onNavReady),
            t.state === N.Ready ? this.onTargetReady(t) : t.on("ready", this.onTargetReady));
    }
    onNavReady(e) {
        e.on("createSlide", this.onNavCreateSlide),
            e.on("Panzoom.click", this.onNavClick),
            e.on("Panzoom.touchEnd", this.onNavTouch),
            this.onTargetChange();
    }
    onTargetReady(e) {
        e.on("change", this.onTargetChange), e.on("Panzoom.refresh", this.onTargetChange), this.onTargetChange();
    }
    onNavClick(e, t, i) {
        this.onNavTouch(e, e.panzoom, i);
    }
    onNavTouch(e, t, i) {
        var s, o;
        if (Math.abs(t.dragOffset.x) > 3 || Math.abs(t.dragOffset.y) > 3) return;
        const a = i.target,
            { nav: r, target: l } = this;
        if (!r || !l || !a) return;
        const c = a.closest("[data-index]");
        if ((i.stopPropagation(), i.preventDefault(), !c)) return;
        const d = parseInt(c.dataset.index || "", 10) || 0,
            u = l.getPageForSlide(d),
            f = r.getPageForSlide(d);
        r.slideTo(f),
            l.slideTo(u, {
                friction:
                    ((o = (s = this.nav) === null || s === void 0 ? void 0 : s.plugins) === null || o === void 0
                        ? void 0
                        : o.Sync.option("friction")) || 0,
            }),
            this.markSelectedSlide(d);
    }
    onNavCreateSlide(e, t) {
        t.index === this.selectedIndex && this.markSelectedSlide(t.index);
    }
    onTargetChange() {
        var e, t;
        const { target: i, nav: s } = this;
        if (!i || !s || s.state !== N.Ready || i.state !== N.Ready) return;
        const o =
                (t = (e = i.pages[i.page]) === null || e === void 0 ? void 0 : e.slides[0]) === null || t === void 0
                    ? void 0
                    : t.index,
            a = s.getPageForSlide(o);
        this.markSelectedSlide(o), s.slideTo(a, s.prevPage === null && i.prevPage === null ? { friction: 0 } : void 0);
    }
    markSelectedSlide(e) {
        const t = this.nav;
        t &&
            t.state === N.Ready &&
            ((this.selectedIndex = e),
            [...t.slides].map((i) => {
                i.el && i.el.classList[i.index === e ? "add" : "remove"]("is-nav-selected");
            }));
    }
    attach() {
        const e = this;
        let t = e.options.target,
            i = e.options.nav;
        t ? e.addAsNavFor(t) : i && e.addAsTargetFor(i);
    }
    detach() {
        const e = this,
            t = e.nav,
            i = e.target;
        t &&
            (t.off("ready", e.onNavReady),
            t.off("createSlide", e.onNavCreateSlide),
            t.off("Panzoom.click", e.onNavClick),
            t.off("Panzoom.touchEnd", e.onNavTouch)),
            (e.nav = null),
            i &&
                (i.off("ready", e.onTargetReady),
                i.off("refresh", e.onTargetChange),
                i.off("change", e.onTargetChange)),
            (e.target = null);
    }
}
Object.defineProperty(ki, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: { friction: 0.35 } });
const xo = { Navigation: Ai, Dots: Pi, Sync: ki },
    Be = "animationend",
    Zt = "isSelected",
    He = "slide";
class be extends kt {
    get axis() {
        return this.isHorizontal ? "e" : "f";
    }
    get isEnabled() {
        return this.state === N.Ready;
    }
    get isInfinite() {
        let e = !1;
        const { contentDim: t, viewportDim: i, pages: s, slides: o } = this,
            a = o[0];
        return s.length >= 2 && a && t + a.dim >= i && (e = this.option("infinite")), e;
    }
    get isRTL() {
        return this.option("direction") === "rtl";
    }
    get isHorizontal() {
        return this.option("axis") === "x";
    }
    constructor(e, t = {}, i = {}) {
        if (
            (super(),
            Object.defineProperty(this, "bp", { enumerable: !0, configurable: !0, writable: !0, value: "" }),
            Object.defineProperty(this, "lp", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
            Object.defineProperty(this, "userOptions", { enumerable: !0, configurable: !0, writable: !0, value: {} }),
            Object.defineProperty(this, "userPlugins", { enumerable: !0, configurable: !0, writable: !0, value: {} }),
            Object.defineProperty(this, "state", { enumerable: !0, configurable: !0, writable: !0, value: N.Init }),
            Object.defineProperty(this, "page", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
            Object.defineProperty(this, "prevPage", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "container", { enumerable: !0, configurable: !0, writable: !0, value: void 0 }),
            Object.defineProperty(this, "viewport", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "track", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "slides", { enumerable: !0, configurable: !0, writable: !0, value: [] }),
            Object.defineProperty(this, "pages", { enumerable: !0, configurable: !0, writable: !0, value: [] }),
            Object.defineProperty(this, "panzoom", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "inTransition", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: new Set(),
            }),
            Object.defineProperty(this, "contentDim", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
            Object.defineProperty(this, "viewportDim", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
            typeof e == "string" && (e = document.querySelector(e)),
            !e || !Y(e))
        )
            throw new Error("No Element found");
        (this.container = e),
            (this.slideNext = Xt(this.slideNext.bind(this), 150)),
            (this.slidePrev = Xt(this.slidePrev.bind(this), 150)),
            (this.userOptions = t),
            (this.userPlugins = i),
            queueMicrotask(() => {
                this.processOptions();
            });
    }
    processOptions() {
        var e, t;
        const i = U({}, be.defaults, this.userOptions);
        let s = "";
        const o = i.breakpoints;
        if (o && Tt(o))
            for (const [a, r] of Object.entries(o)) window.matchMedia(a).matches && Tt(r) && ((s += a), U(i, r));
        (s === this.bp && this.state !== N.Init) ||
            ((this.bp = s),
            this.state === N.Ready &&
                (i.initialSlide =
                    ((t = (e = this.pages[this.page]) === null || e === void 0 ? void 0 : e.slides[0]) === null ||
                    t === void 0
                        ? void 0
                        : t.index) || 0),
            this.state !== N.Init && this.destroy(),
            super.setOptions(i),
            this.option("enabled") === !1
                ? this.attachEvents()
                : setTimeout(() => {
                      this.init();
                  }, 0));
    }
    init() {
        (this.state = N.Init),
            this.emit("init"),
            this.attachPlugins(Object.assign(Object.assign({}, be.Plugins), this.userPlugins)),
            this.emit("attachPlugins"),
            this.initLayout(),
            this.initSlides(),
            this.updateMetrics(),
            this.setInitialPosition(),
            this.initPanzoom(),
            this.attachEvents(),
            (this.state = N.Ready),
            this.emit("ready");
    }
    initLayout() {
        const { container: e } = this,
            t = this.option("classes");
        I(e, this.cn("container")),
            oe(e, t.isLTR, !this.isRTL),
            oe(e, t.isRTL, this.isRTL),
            oe(e, t.isVertical, !this.isHorizontal),
            oe(e, t.isHorizontal, this.isHorizontal);
        let i = this.option("viewport") || e.querySelector(`.${t.viewport}`);
        i || ((i = document.createElement("div")), I(i, t.viewport), i.append(...Yt(e, `.${t.slide}`)), e.prepend(i)),
            i.addEventListener("scroll", this.onScroll);
        let s = this.option("track") || e.querySelector(`.${t.track}`);
        s || ((s = document.createElement("div")), I(s, t.track), s.append(...Array.from(i.childNodes))),
            s.setAttribute("aria-live", "polite"),
            i.contains(s) || i.prepend(s),
            (this.viewport = i),
            (this.track = s),
            this.emit("initLayout");
    }
    initSlides() {
        const { track: e } = this;
        if (!e) return;
        const t = [...this.slides],
            i = [];
        [...Yt(e, `.${this.cn(He)}`)].forEach((s) => {
            if (Y(s)) {
                const o = ut({ el: s, isDom: !0, index: this.slides.length });
                i.push(o);
            }
        });
        for (let s of [...(this.option("slides", []) || []), ...t]) i.push(ut(s));
        this.slides = i;
        for (let s = 0; s < this.slides.length; s++) this.slides[s].index = s;
        for (const s of i) this.emit("beforeInitSlide", s, s.index), this.emit("initSlide", s, s.index);
        this.emit("initSlides");
    }
    setInitialPage() {
        const e = this.option("initialSlide");
        this.page =
            typeof e == "number" ? this.getPageForSlide(e) : parseInt(this.option("initialPage", 0) + "", 10) || 0;
    }
    setInitialPosition() {
        const { track: e, pages: t, isHorizontal: i } = this;
        if (!e || !t.length) return;
        let s = this.page;
        t[s] || (this.page = s = 0);
        const o = (t[s].pos || 0) * (this.isRTL && i ? 1 : -1),
            a = i ? `${o}px` : "0",
            r = i ? "0" : `${o}px`;
        (e.style.transform = `translate3d(${a}, ${r}, 0) scale(1)`),
            this.option("adaptiveHeight") && this.setViewportHeight();
    }
    initPanzoom() {
        this.panzoom && (this.panzoom.destroy(), (this.panzoom = null));
        const e = this.option("Panzoom") || {};
        (this.panzoom = new ye(
            this.viewport,
            U(
                {},
                {
                    content: this.track,
                    zoom: !1,
                    panOnlyZoomed: !1,
                    lockAxis: this.isHorizontal ? "x" : "y",
                    infinite: this.isInfinite,
                    click: !1,
                    dblClick: !1,
                    touch: (t) => !(this.pages.length < 2 && !t.options.infinite),
                    bounds: () => this.getBounds(),
                    maxVelocity: (t) =>
                        Math.abs(t.target[this.axis] - t.current[this.axis]) < 2 * this.viewportDim ? 100 : 0,
                },
                e
            )
        )),
            this.panzoom.on("*", (t, i, ...s) => {
                this.emit(`Panzoom.${i}`, t, ...s);
            }),
            this.panzoom.on("decel", this.onDecel),
            this.panzoom.on("refresh", this.onRefresh),
            this.panzoom.on("beforeTransform", this.onBeforeTransform),
            this.panzoom.on("endAnimation", this.onEndAnimation);
    }
    attachEvents() {
        const e = this.container;
        e &&
            (e.addEventListener("click", this.onClick, { passive: !1, capture: !1 }),
            e.addEventListener("slideTo", this.onSlideTo)),
            window.addEventListener("resize", this.onResize);
    }
    createPages() {
        let e = [];
        const { contentDim: t, viewportDim: i } = this;
        let s = this.option("slidesPerPage");
        s = (s === "auto" || t <= i) && this.option("fill") !== !1 ? 1 / 0 : parseFloat(s + "");
        let o = 0,
            a = 0,
            r = 0;
        for (const l of this.slides)
            (!e.length || a + l.dim - i > 0.05 || r >= s) && (e.push(So()), (o = e.length - 1), (a = 0), (r = 0)),
                e[o].slides.push(l),
                (a += l.dim + l.gap),
                r++;
        return e;
    }
    processPages() {
        const e = this.pages,
            { contentDim: t, viewportDim: i, isInfinite: s } = this,
            o = this.option("center"),
            a = this.option("fill"),
            r = a && o && t > i && !s;
        if (
            (e.forEach((d, u) => {
                var f;
                (d.index = u),
                    (d.pos = ((f = d.slides[0]) === null || f === void 0 ? void 0 : f.pos) || 0),
                    (d.dim = 0);
                for (const [h, g] of d.slides.entries()) (d.dim += g.dim), h < d.slides.length - 1 && (d.dim += g.gap);
                r && d.pos + 0.5 * d.dim < 0.5 * i
                    ? (d.pos = 0)
                    : r && d.pos + 0.5 * d.dim >= t - 0.5 * i
                      ? (d.pos = t - i)
                      : o && (d.pos += -0.5 * (i - d.dim));
            }),
            e.forEach((d) => {
                a && !s && t > i && ((d.pos = Math.max(d.pos, 0)), (d.pos = Math.min(d.pos, t - i))),
                    (d.pos = M(d.pos, 1e3)),
                    (d.dim = M(d.dim, 1e3)),
                    Math.abs(d.pos) <= 0.1 && (d.pos = 0);
            }),
            s)
        )
            return e;
        const l = [];
        let c;
        return (
            e.forEach((d) => {
                const u = Object.assign({}, d);
                c && u.pos === c.pos
                    ? ((c.dim += u.dim), (c.slides = [...c.slides, ...u.slides]))
                    : ((u.index = l.length), (c = u), l.push(u));
            }),
            l
        );
    }
    getPageFromIndex(e = 0) {
        const t = this.pages.length;
        let i;
        return (
            (e = parseInt((e || 0).toString()) || 0),
            (i = this.isInfinite ? ((e % t) + t) % t : Math.max(Math.min(e, t - 1), 0)),
            i
        );
    }
    getSlideMetrics(e) {
        var t, i;
        const s = this.isHorizontal ? "width" : "height";
        let o = 0,
            a = 0,
            r = e.el;
        const l = !(!r || r.parentNode);
        if (
            (r
                ? (o = parseFloat(r.dataset[s] || "") || 0)
                : ((r = document.createElement("div")),
                  (r.style.visibility = "hidden"),
                  (this.track || document.body).prepend(r)),
            I(r, this.cn(He) + " " + e.class + " " + e.customClass),
            o)
        )
            (r.style[s] = `${o}px`), (r.style[s === "width" ? "height" : "width"] = "");
        else {
            l && (this.track || document.body).prepend(r),
                (o =
                    r.getBoundingClientRect()[s] *
                    Math.max(1, ((t = window.visualViewport) === null || t === void 0 ? void 0 : t.scale) || 1));
            let d = r[this.isHorizontal ? "offsetWidth" : "offsetHeight"];
            d - 1 > o && (o = d);
        }
        const c = getComputedStyle(r);
        return (
            c.boxSizing === "content-box" &&
                (this.isHorizontal
                    ? ((o += parseFloat(c.paddingLeft) || 0), (o += parseFloat(c.paddingRight) || 0))
                    : ((o += parseFloat(c.paddingTop) || 0), (o += parseFloat(c.paddingBottom) || 0))),
            (a = parseFloat(c[this.isHorizontal ? "marginRight" : "marginBottom"]) || 0),
            l ? (i = r.parentElement) === null || i === void 0 || i.removeChild(r) : e.el || r.remove(),
            { dim: M(o, 1e3), gap: M(a, 1e3) }
        );
    }
    getBounds() {
        const { isInfinite: e, isRTL: t, isHorizontal: i, pages: s } = this;
        let o = { min: 0, max: 0 };
        if (e) o = { min: -1 / 0, max: 1 / 0 };
        else if (s.length) {
            const a = s[0].pos,
                r = s[s.length - 1].pos;
            o = t && i ? { min: a, max: r } : { min: -1 * r, max: -1 * a };
        }
        return { x: i ? o : { min: 0, max: 0 }, y: i ? { min: 0, max: 0 } : o };
    }
    repositionSlides() {
        let e,
            {
                isHorizontal: t,
                isRTL: i,
                isInfinite: s,
                viewport: o,
                viewportDim: a,
                contentDim: r,
                page: l,
                pages: c,
                slides: d,
                panzoom: u,
            } = this,
            f = 0,
            h = 0,
            g = 0,
            p = 0;
        u ? (p = -1 * u.current[this.axis]) : c[l] && (p = c[l].pos || 0),
            (e = t ? (i ? "right" : "left") : "top"),
            i && t && (p *= -1);
        for (const S of d) {
            const y = S.el;
            y
                ? (e === "top" ? ((y.style.right = ""), (y.style.left = "")) : (y.style.top = ""),
                  S.index !== f ? (y.style[e] = h === 0 ? "" : `${M(h, 1e3)}px`) : (y.style[e] = ""),
                  (g += S.dim + S.gap),
                  f++)
                : (h += S.dim + S.gap);
        }
        if (s && g && o) {
            let S = getComputedStyle(o),
                y = "padding",
                x = t ? "Right" : "Bottom",
                C = parseFloat(S[y + (t ? "Left" : "Top")]);
            (p -= C), (a += C), (a += parseFloat(S[y + x]));
            for (const E of d)
                E.el &&
                    (M(E.pos) < M(a) &&
                        M(E.pos + E.dim + E.gap) < M(p) &&
                        M(p) > M(r - a) &&
                        (E.el.style[e] = `${M(h + g, 1e3)}px`),
                    M(E.pos + E.gap) >= M(r - a) &&
                        M(E.pos) > M(p + a) &&
                        M(p) < M(a) &&
                        (E.el.style[e] = `-${M(g, 1e3)}px`));
        }
        let m,
            v,
            b = [...this.inTransition];
        if ((b.length > 1 && ((m = c[b[0]]), (v = c[b[1]])), m && v)) {
            let S = 0;
            for (const y of d)
                y.el
                    ? this.inTransition.has(y.index) &&
                      m.slides.indexOf(y) < 0 &&
                      (y.el.style[e] = `${M(S + (m.pos - v.pos), 1e3)}px`)
                    : (S += y.dim + y.gap);
        }
    }
    createSlideEl(e) {
        const { track: t, slides: i } = this;
        if (!t || !e || (e.el && e.el.parentNode)) return;
        const s = e.el || document.createElement("div");
        I(s, this.cn(He)), I(s, e.class), I(s, e.customClass);
        const o = e.html;
        o && (o instanceof HTMLElement ? s.appendChild(o) : (s.innerHTML = e.html + ""));
        const a = [];
        i.forEach((d, u) => {
            d.el && a.push(u);
        });
        const r = e.index;
        let l = null;
        a.length && (l = i[a.reduce((d, u) => (Math.abs(u - r) < Math.abs(d - r) ? u : d))]);
        const c = l && l.el && l.el.parentNode ? (l.index < e.index ? l.el.nextSibling : l.el) : null;
        t.insertBefore(s, t.contains(c) ? c : null), (e.el = s), this.emit("createSlide", e);
    }
    removeSlideEl(e, t = !1) {
        const i = e == null ? void 0 : e.el;
        if (!i || !i.parentNode) return;
        const s = this.cn(Zt);
        if ((i.classList.contains(s) && (D(i, s), this.emit("unselectSlide", e)), e.isDom && !t))
            return i.removeAttribute("aria-hidden"), i.removeAttribute("data-index"), void (i.style.left = "");
        this.emit("removeSlide", e);
        const o = new CustomEvent(Be);
        i.dispatchEvent(o), e.el && (e.el.remove(), (e.el = null));
    }
    transitionTo(e = 0, t = this.option("transition")) {
        var i, s, o, a;
        if (!t) return !1;
        const r = this.page,
            { pages: l, panzoom: c } = this;
        e = parseInt((e || 0).toString()) || 0;
        const d = this.getPageFromIndex(e);
        if (
            !c ||
            !l[d] ||
            l.length < 2 ||
            Math.abs(
                (((s = (i = l[r]) === null || i === void 0 ? void 0 : i.slides[0]) === null || s === void 0
                    ? void 0
                    : s.dim) || 0) - this.viewportDim
            ) > 1
        )
            return !1;
        let u = e > r ? 1 : -1;
        this.isInfinite && (r === 0 && e === l.length - 1 && (u = -1), r === l.length - 1 && e === 0 && (u = 1));
        const f = l[d].pos * (this.isRTL ? 1 : -1);
        if (r === d && Math.abs(f - c.target[this.axis]) < 1) return !1;
        this.clearTransitions();
        const h = c.isResting;
        I(this.container, this.cn("inTransition"));
        const g = ((o = l[r]) === null || o === void 0 ? void 0 : o.slides[0]) || null,
            p = ((a = l[d]) === null || a === void 0 ? void 0 : a.slides[0]) || null;
        this.inTransition.add(p.index), this.createSlideEl(p);
        let m = g.el,
            v = p.el;
        h || t === He || ((t = "fadeFast"), (m = null));
        const b = this.isRTL ? "next" : "prev",
            S = this.isRTL ? "prev" : "next";
        return (
            m &&
                (this.inTransition.add(g.index),
                (g.transition = t),
                m.addEventListener(Be, this.onAnimationEnd),
                m.classList.add(`f-${t}Out`, `to-${u > 0 ? S : b}`)),
            v &&
                ((p.transition = t),
                v.addEventListener(Be, this.onAnimationEnd),
                v.classList.add(`f-${t}In`, `from-${u > 0 ? b : S}`)),
            (c.current[this.axis] = f),
            (c.target[this.axis] = f),
            c.requestTick(),
            this.onChange(d),
            !0
        );
    }
    manageSlideVisiblity() {
        const e = new Set(),
            t = new Set(),
            i = this.getVisibleSlides(parseFloat(this.option("preload", 0) + "") || 0);
        for (const s of this.slides) i.has(s) ? e.add(s) : t.add(s);
        for (const s of this.inTransition) e.add(this.slides[s]);
        for (const s of e) this.createSlideEl(s), this.lazyLoadSlide(s);
        for (const s of t) e.has(s) || this.removeSlideEl(s);
        this.markSelectedSlides(), this.repositionSlides();
    }
    markSelectedSlides() {
        if (!this.pages[this.page] || !this.pages[this.page].slides) return;
        const e = "aria-hidden";
        let t = this.cn(Zt);
        if (t)
            for (const i of this.slides) {
                const s = i.el;
                s &&
                    ((s.dataset.index = `${i.index}`),
                    s.classList.contains("f-thumbs__slide")
                        ? this.getVisibleSlides(0).has(i)
                            ? s.removeAttribute(e)
                            : s.setAttribute(e, "true")
                        : this.pages[this.page].slides.includes(i)
                          ? (s.classList.contains(t) || (I(s, t), this.emit("selectSlide", i)), s.removeAttribute(e))
                          : (s.classList.contains(t) && (D(s, t), this.emit("unselectSlide", i)),
                            s.setAttribute(e, "true")));
            }
    }
    flipInfiniteTrack() {
        const { axis: e, isHorizontal: t, isInfinite: i, isRTL: s, viewportDim: o, contentDim: a } = this,
            r = this.panzoom;
        if (!r || !i) return;
        let l = r.current[e],
            c = r.target[e] - l,
            d = 0,
            u = 0.5 * o;
        s && t
            ? (l < -u && ((d = -1), (l += a)), l > a - u && ((d = 1), (l -= a)))
            : (l > u && ((d = 1), (l -= a)), l < -a + u && ((d = -1), (l += a))),
            d && ((r.current[e] = l), (r.target[e] = l + c));
    }
    lazyLoadImg(e, t) {
        const i = this,
            s = "f-fadeIn",
            o = "is-preloading";
        let a = !1,
            r = null;
        const l = () => {
            a ||
                ((a = !0),
                r && (r.remove(), (r = null)),
                D(t, o),
                t.complete &&
                    (I(t, s),
                    setTimeout(() => {
                        D(t, s);
                    }, 350)),
                this.option("adaptiveHeight") &&
                    e.el &&
                    this.pages[this.page].slides.indexOf(e) > -1 &&
                    (i.updateMetrics(), i.setViewportHeight()),
                this.emit("load", e));
        };
        I(t, o),
            (t.src = t.dataset.lazySrcset || t.dataset.lazySrc || ""),
            delete t.dataset.lazySrc,
            delete t.dataset.lazySrcset,
            t.addEventListener("error", () => {
                l();
            }),
            t.addEventListener("load", () => {
                l();
            }),
            setTimeout(() => {
                const c = t.parentNode;
                c && e.el && (t.complete ? l() : a || ((r = se(Ot)), c.insertBefore(r, t)));
            }, 300);
    }
    lazyLoadSlide(e) {
        const t = e && e.el;
        if (!t) return;
        const i = new Set();
        let s = Array.from(t.querySelectorAll("[data-lazy-src],[data-lazy-srcset]"));
        t.dataset.lazySrc && s.push(t),
            s.map((o) => {
                o instanceof HTMLImageElement
                    ? i.add(o)
                    : o instanceof HTMLElement &&
                      o.dataset.lazySrc &&
                      ((o.style.backgroundImage = `url('${o.dataset.lazySrc}')`), delete o.dataset.lazySrc);
            });
        for (const o of i) this.lazyLoadImg(e, o);
    }
    onAnimationEnd(e) {
        var t;
        const i = e.target,
            s = i ? parseInt(i.dataset.index || "", 10) || 0 : -1,
            o = this.slides[s],
            a = e.animationName;
        if (!i || !o || !a) return;
        const r = !!this.inTransition.has(s) && o.transition;
        r && a.substring(0, r.length + 2) === `f-${r}` && this.inTransition.delete(s),
            this.inTransition.size || this.clearTransitions(),
            s === this.page && !((t = this.panzoom) === null || t === void 0) && t.isResting && this.emit("settle");
    }
    onDecel(e, t = 0, i = 0, s = 0, o = 0) {
        if (this.option("dragFree")) return void this.setPageFromPosition();
        const { isRTL: a, isHorizontal: r, axis: l, pages: c } = this,
            d = c.length,
            u = Math.abs(Math.atan2(i, t) / (Math.PI / 180));
        let f = 0;
        if (((f = u > 45 && u < 135 ? (r ? 0 : i) : r ? t : 0), !d)) return;
        let h = this.page,
            g = a && r ? 1 : -1;
        const p = e.current[l] * g;
        let { pageIndex: m } = this.getPageFromPosition(p);
        Math.abs(f) > 5
            ? (c[h].dim < document.documentElement["client" + (this.isHorizontal ? "Width" : "Height")] - 1 && (h = m),
              (h = a && r ? (f < 0 ? h - 1 : h + 1) : f < 0 ? h + 1 : h - 1))
            : (h = s === 0 && o === 0 ? h : m),
            this.slideTo(h, { transition: !1, friction: e.option("decelFriction") });
    }
    onClick(e) {
        const t = e.target,
            i = t && Y(t) ? t.dataset : null;
        let s, o;
        i &&
            (i.carouselPage !== void 0
                ? ((o = "slideTo"), (s = i.carouselPage))
                : i.carouselNext !== void 0
                  ? (o = "slideNext")
                  : i.carouselPrev !== void 0 && (o = "slidePrev")),
            o
                ? (e.preventDefault(), e.stopPropagation(), t && !t.hasAttribute("disabled") && this[o](s))
                : this.emit("click", e);
    }
    onSlideTo(e) {
        const t = e.detail || 0;
        this.slideTo(this.getPageForSlide(t), { friction: 0 });
    }
    onChange(e, t = 0) {
        const i = this.page;
        (this.prevPage = i),
            (this.page = e),
            this.option("adaptiveHeight") && this.setViewportHeight(),
            e !== i && (this.markSelectedSlides(), this.emit("change", e, i, t));
    }
    onRefresh() {
        let e = this.contentDim,
            t = this.viewportDim;
        this.updateMetrics(),
            (this.contentDim === e && this.viewportDim === t) ||
                this.slideTo(this.page, { friction: 0, transition: !1 });
    }
    onScroll() {
        var e;
        (e = this.viewport) === null || e === void 0 || e.scroll(0, 0);
    }
    onResize() {
        this.option("breakpoints") && this.processOptions();
    }
    onBeforeTransform(e) {
        this.lp !== e.current[this.axis] && (this.flipInfiniteTrack(), this.manageSlideVisiblity()),
            (this.lp = e.current.e);
    }
    onEndAnimation() {
        this.inTransition.size || this.emit("settle");
    }
    reInit(e = null, t = null) {
        this.destroy(),
            (this.state = N.Init),
            (this.prevPage = null),
            (this.userOptions = e || this.userOptions),
            (this.userPlugins = t || this.userPlugins),
            this.processOptions();
    }
    slideTo(e = 0, { friction: t = this.option("friction"), transition: i = this.option("transition") } = {}) {
        if (this.state === N.Destroy) return;
        e = parseInt((e || 0).toString()) || 0;
        const s = this.getPageFromIndex(e),
            { axis: o, isHorizontal: a, isRTL: r, pages: l, panzoom: c } = this,
            d = l.length,
            u = r && a ? 1 : -1;
        if (!c || !d) return;
        if (this.page !== s) {
            const h = new Event("beforeChange", { bubbles: !0, cancelable: !0 });
            if ((this.emit("beforeChange", h, e), h.defaultPrevented)) return;
        }
        if (this.transitionTo(e, i)) return;
        let f = l[s].pos;
        if (this.isInfinite) {
            const h = this.contentDim,
                g = c.target[o] * u;
            d === 2
                ? (f += h * Math.floor(parseFloat(e + "") / 2))
                : (f = [f, f - h, f + h].reduce(function (p, m) {
                      return Math.abs(m - g) < Math.abs(p - g) ? m : p;
                  }));
        }
        (f *= u),
            Math.abs(c.target[o] - f) < 1 || (c.panTo({ x: a ? f : 0, y: a ? 0 : f, friction: t }), this.onChange(s));
    }
    slideToClosest(e) {
        if (this.panzoom) {
            const { pageIndex: t } = this.getPageFromPosition();
            this.slideTo(t, e);
        }
    }
    slideNext() {
        this.slideTo(this.page + 1);
    }
    slidePrev() {
        this.slideTo(this.page - 1);
    }
    clearTransitions() {
        this.inTransition.clear(), D(this.container, this.cn("inTransition"));
        const e = ["to-prev", "to-next", "from-prev", "from-next"];
        for (const t of this.slides) {
            const i = t.el;
            if (i) {
                i.removeEventListener(Be, this.onAnimationEnd), i.classList.remove(...e);
                const s = t.transition;
                s && i.classList.remove(`f-${s}Out`, `f-${s}In`);
            }
        }
        this.manageSlideVisiblity();
    }
    addSlide(e, t) {
        var i, s, o, a;
        const r = this.panzoom,
            l = ((i = this.pages[this.page]) === null || i === void 0 ? void 0 : i.pos) || 0,
            c = ((s = this.pages[this.page]) === null || s === void 0 ? void 0 : s.dim) || 0,
            d = this.contentDim < this.viewportDim;
        let u = Array.isArray(t) ? t : [t];
        const f = [];
        for (const h of u) f.push(ut(h));
        this.slides.splice(e, 0, ...f);
        for (let h = 0; h < this.slides.length; h++) this.slides[h].index = h;
        for (const h of f) this.emit("beforeInitSlide", h, h.index);
        if ((this.page >= e && (this.page += f.length), this.updateMetrics(), r)) {
            const h = ((o = this.pages[this.page]) === null || o === void 0 ? void 0 : o.pos) || 0,
                g = ((a = this.pages[this.page]) === null || a === void 0 ? void 0 : a.dim) || 0,
                p = this.pages.length || 1,
                m = this.isRTL ? c - g : g - c,
                v = this.isRTL ? l - h : h - l;
            d && p === 1
                ? (e <= this.page && ((r.current[this.axis] -= m), (r.target[this.axis] -= m)),
                  r.panTo({ [this.isHorizontal ? "x" : "y"]: -1 * h }))
                : v && e <= this.page && ((r.target[this.axis] -= v), (r.current[this.axis] -= v), r.requestTick());
        }
        for (const h of f) this.emit("initSlide", h, h.index);
    }
    prependSlide(e) {
        this.addSlide(0, e);
    }
    appendSlide(e) {
        this.addSlide(this.slides.length, e);
    }
    removeSlide(e) {
        const t = this.slides.length;
        e = ((e % t) + t) % t;
        const i = this.slides[e];
        if (i) {
            this.removeSlideEl(i, !0), this.slides.splice(e, 1);
            for (let s = 0; s < this.slides.length; s++) this.slides[s].index = s;
            this.updateMetrics(),
                this.slideTo(this.page, { friction: 0, transition: !1 }),
                this.emit("destroySlide", i);
        }
    }
    updateMetrics() {
        const { panzoom: e, viewport: t, track: i, slides: s, isHorizontal: o, isInfinite: a } = this;
        if (!i) return;
        const r = o ? "width" : "height",
            l = o ? "offsetWidth" : "offsetHeight";
        if (t) {
            let u = Math.max(t[l], M(t.getBoundingClientRect()[r], 1e3)),
                f = getComputedStyle(t),
                h = "padding",
                g = o ? "Right" : "Bottom";
            (u -= parseFloat(f[h + (o ? "Left" : "Top")]) + parseFloat(f[h + g])), (this.viewportDim = u);
        }
        let c,
            d = 0;
        for (const [u, f] of s.entries()) {
            let h = 0,
                g = 0;
            !f.el && c ? ((h = c.dim), (g = c.gap)) : (({ dim: h, gap: g } = this.getSlideMetrics(f)), (c = f)),
                (h = M(h, 1e3)),
                (g = M(g, 1e3)),
                (f.dim = h),
                (f.gap = g),
                (f.pos = d),
                (d += h),
                (a || u < s.length - 1) && (d += g);
        }
        (d = M(d, 1e3)),
            (this.contentDim = d),
            e && ((e.contentRect[r] = d), (e.contentRect[o ? "fullWidth" : "fullHeight"] = d)),
            (this.pages = this.createPages()),
            (this.pages = this.processPages()),
            this.state === N.Init && this.setInitialPage(),
            (this.page = Math.max(0, Math.min(this.page, this.pages.length - 1))),
            this.manageSlideVisiblity(),
            this.emit("refresh");
    }
    getProgress(e, t = !1, i = !1) {
        e === void 0 && (e = this.page);
        const s = this,
            o = s.panzoom,
            a = s.contentDim,
            r = s.pages[e] || 0;
        if (!r || !o) return e > this.page ? -1 : 1;
        let l = -1 * o.current.e,
            c = M((l - r.pos) / (1 * r.dim), 1e3),
            d = c,
            u = c;
        this.isInfinite &&
            i !== !0 &&
            ((d = M((l - r.pos + a) / (1 * r.dim), 1e3)), (u = M((l - r.pos - a) / (1 * r.dim), 1e3)));
        let f = [c, d, u].reduce(function (h, g) {
            return Math.abs(g) < Math.abs(h) ? g : h;
        });
        return t ? f : f > 1 ? 1 : f < -1 ? -1 : f;
    }
    setViewportHeight() {
        const { page: e, pages: t, viewport: i, isHorizontal: s } = this;
        if (!i || !t[e]) return;
        let o = 0;
        s &&
            this.track &&
            ((this.track.style.height = "auto"),
            t[e].slides.forEach((a) => {
                a.el && (o = Math.max(o, a.el.offsetHeight));
            })),
            (i.style.height = o ? `${o}px` : "");
    }
    getPageForSlide(e) {
        for (const t of this.pages) for (const i of t.slides) if (i.index === e) return t.index;
        return -1;
    }
    getVisibleSlides(e = 0) {
        var t;
        const i = new Set();
        let { panzoom: s, contentDim: o, viewportDim: a, pages: r, page: l } = this;
        if (a) {
            o = o + ((t = this.slides[this.slides.length - 1]) === null || t === void 0 ? void 0 : t.gap) || 0;
            let c = 0;
            (c =
                s && s.state !== R.Init && s.state !== R.Destroy ? -1 * s.current[this.axis] : (r[l] && r[l].pos) || 0),
                this.isInfinite && (c -= Math.floor(c / o) * o),
                this.isRTL && this.isHorizontal && (c *= -1);
            const d = c - a * e,
                u = c + a * (e + 1),
                f = this.isInfinite ? [-1, 0, 1] : [0];
            for (const h of this.slides)
                for (const g of f) {
                    const p = h.pos + g * o,
                        m = p + h.dim + h.gap;
                    p < u && m > d && i.add(h);
                }
        }
        return i;
    }
    getPageFromPosition(e) {
        const { viewportDim: t, contentDim: i, slides: s, pages: o, panzoom: a } = this,
            r = o.length,
            l = s.length,
            c = s[0],
            d = s[l - 1],
            u = this.option("center");
        let f = 0,
            h = 0,
            g = 0,
            p = e === void 0 ? -1 * ((a == null ? void 0 : a.target[this.axis]) || 0) : e;
        u && (p += 0.5 * t),
            this.isInfinite
                ? (p < c.pos - 0.5 * d.gap && ((p -= i), (g = -1)),
                  p > d.pos + d.dim + 0.5 * d.gap && ((p -= i), (g = 1)))
                : (p = Math.max(c.pos || 0, Math.min(p, d.pos)));
        let m = d,
            v = s.find((b) => {
                const S = b.pos - 0.5 * m.gap,
                    y = b.pos + b.dim + 0.5 * b.gap;
                return (m = b), p >= S && p < y;
            });
        return v || (v = d), (h = this.getPageForSlide(v.index)), (f = h + g * r), { page: f, pageIndex: h };
    }
    setPageFromPosition() {
        const { pageIndex: e } = this.getPageFromPosition();
        this.onChange(e);
    }
    destroy() {
        if ([N.Destroy].includes(this.state)) return;
        this.state = N.Destroy;
        const { container: e, viewport: t, track: i, slides: s, panzoom: o } = this,
            a = this.option("classes");
        e.removeEventListener("click", this.onClick, { passive: !1, capture: !1 }),
            e.removeEventListener("slideTo", this.onSlideTo),
            window.removeEventListener("resize", this.onResize),
            o && (o.destroy(), (this.panzoom = null)),
            s &&
                s.forEach((l) => {
                    this.removeSlideEl(l);
                }),
            this.detachPlugins(),
            t &&
                (t.removeEventListener("scroll", this.onScroll),
                t.offsetParent && i && i.offsetParent && t.replaceWith(...i.childNodes));
        for (const [l, c] of Object.entries(a)) l !== "container" && c && e.classList.remove(c);
        (this.track = null), (this.viewport = null), (this.page = 0), (this.slides = []);
        const r = this.events.get("ready");
        (this.events = new Map()), r && this.events.set("ready", r);
    }
}
Object.defineProperty(be, "Panzoom", { enumerable: !0, configurable: !0, writable: !0, value: ye }),
    Object.defineProperty(be, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: yo }),
    Object.defineProperty(be, "Plugins", { enumerable: !0, configurable: !0, writable: !0, value: xo });
const Oi = function (n) {
        if (!Y(n)) return 0;
        const e = window.scrollY,
            t = window.innerHeight,
            i = e + t,
            s = n.getBoundingClientRect(),
            o = s.y + e,
            a = s.height,
            r = o + a;
        if (e > r || i < o) return 0;
        if ((e < o && i > r) || (o < e && r > i)) return 100;
        let l = a;
        o < e && (l -= e - o), r > i && (l -= r - i);
        const c = (l / t) * 100;
        return Math.round(c);
    },
    Ie = !(typeof window > "u" || !window.document || !window.document.createElement);
let ht;
const ft = [
        "a[href]",
        "area[href]",
        'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
        "select:not([disabled]):not([aria-hidden])",
        "textarea:not([disabled]):not([aria-hidden])",
        "button:not([disabled]):not([aria-hidden]):not(.fancybox-focus-guard)",
        "iframe",
        "object",
        "embed",
        "video",
        "audio",
        "[contenteditable]",
        '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])',
    ].join(","),
    Kt = (n) => {
        if (n && Ie) {
            ht === void 0 &&
                document.createElement("div").focus({
                    get preventScroll() {
                        return (ht = !0), !1;
                    },
                });
            try {
                if (ht) n.focus({ preventScroll: !0 });
                else {
                    const e = window.scrollY || document.body.scrollTop,
                        t = window.scrollX || document.body.scrollLeft;
                    n.focus(), document.body.scrollTo({ top: e, left: t, behavior: "auto" });
                }
            } catch {}
        }
    },
    Ii = () => {
        const n = document;
        let e,
            t = "",
            i = "",
            s = "";
        return (
            n.fullscreenEnabled
                ? ((t = "requestFullscreen"), (i = "exitFullscreen"), (s = "fullscreenElement"))
                : n.webkitFullscreenEnabled &&
                  ((t = "webkitRequestFullscreen"), (i = "webkitExitFullscreen"), (s = "webkitFullscreenElement")),
            t &&
                (e = {
                    request: function (o = n.documentElement) {
                        return t === "webkitRequestFullscreen" ? o[t](Element.ALLOW_KEYBOARD_INPUT) : o[t]();
                    },
                    exit: function () {
                        return n[s] && n[i]();
                    },
                    isFullscreen: function () {
                        return n[s];
                    },
                }),
            e
        );
    },
    Mt = {
        animated: !0,
        autoFocus: !0,
        backdropClick: "close",
        Carousel: {
            classes: {
                container: "fancybox__carousel",
                viewport: "fancybox__viewport",
                track: "fancybox__track",
                slide: "fancybox__slide",
            },
        },
        closeButton: "auto",
        closeExisting: !1,
        commonCaption: !1,
        compact: () => window.matchMedia("(max-width: 578px), (max-height: 578px)").matches,
        contentClick: "toggleZoom",
        contentDblClick: !1,
        defaultType: "image",
        defaultDisplay: "flex",
        dragToClose: !0,
        Fullscreen: { autoStart: !1 },
        groupAll: !1,
        groupAttr: "data-fancybox",
        hideClass: "f-fadeOut",
        hideScrollbar: !0,
        idle: 3500,
        keyboard: {
            Escape: "close",
            Delete: "close",
            Backspace: "close",
            PageUp: "next",
            PageDown: "prev",
            ArrowUp: "prev",
            ArrowDown: "next",
            ArrowRight: "next",
            ArrowLeft: "prev",
        },
        l10n: Object.assign(Object.assign({}, Li), {
            CLOSE: "Close",
            NEXT: "Next",
            PREV: "Previous",
            MODAL: "You can close this modal content with the ESC key",
            ERROR: "Something Went Wrong, Please Try Again Later",
            IMAGE_ERROR: "Image Not Found",
            ELEMENT_NOT_FOUND: "HTML Element Not Found",
            AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
            AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
            IFRAME_ERROR: "Error Loading Page",
            TOGGLE_ZOOM: "Toggle zoom level",
            TOGGLE_THUMBS: "Toggle thumbnails",
            TOGGLE_SLIDESHOW: "Toggle slideshow",
            TOGGLE_FULLSCREEN: "Toggle full-screen mode",
            DOWNLOAD: "Download",
        }),
        parentEl: null,
        placeFocusBack: !0,
        showClass: "f-zoomInUp",
        startIndex: 0,
        tpl: {
            closeButton:
                '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg></button>',
            main: `<div class="fancybox__container" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">
    <div class="fancybox__backdrop"></div>
    <div class="fancybox__carousel"></div>
    <div class="fancybox__footer"></div>
  </div>`,
        },
        trapFocus: !0,
        wheel: "zoom",
    };
var B, X;
(function (n) {
    (n[(n.Init = 0)] = "Init"),
        (n[(n.Ready = 1)] = "Ready"),
        (n[(n.Closing = 2)] = "Closing"),
        (n[(n.CustomClosing = 3)] = "CustomClosing"),
        (n[(n.Destroy = 4)] = "Destroy");
})(B || (B = {})),
    (function (n) {
        (n[(n.Loading = 0)] = "Loading"),
            (n[(n.Opening = 1)] = "Opening"),
            (n[(n.Ready = 2)] = "Ready"),
            (n[(n.Closing = 3)] = "Closing");
    })(X || (X = {}));
let Jt = "",
    Oe = !1,
    Ve = !1,
    ge = null;
const _i = () => {
        let n = "",
            e = "";
        const t = z.getInstance();
        if (t) {
            const i = t.carousel,
                s = t.getSlide();
            if (i && s) {
                let o = s.slug || void 0,
                    a = s.triggerEl || void 0;
                (e = o || t.option("slug") || ""),
                    !e && a && a.dataset && (e = a.dataset.fancybox || ""),
                    e && e !== "true" && (n = "#" + e + (!o && i.slides.length > 1 ? "-" + (s.index + 1) : ""));
            }
        }
        return { hash: n, slug: e, index: 1 };
    },
    Je = () => {
        const n = new URL(document.URL).hash,
            e = n.slice(1).split("-"),
            t = e[e.length - 1],
            i = (t && /^\+?\d+$/.test(t) && parseInt(e.pop() || "1", 10)) || 1;
        return { hash: n, slug: e.join("-"), index: i };
    },
    $i = () => {
        const { slug: n, index: e } = Je();
        if (!n) return;
        let t = document.querySelector(`[data-slug="${n}"]`);
        if ((t && t.dispatchEvent(new CustomEvent("click", { bubbles: !0, cancelable: !0 })), z.getInstance())) return;
        const i = document.querySelectorAll(`[data-fancybox="${n}"]`);
        i.length && ((t = i[e - 1]), t && t.dispatchEvent(new CustomEvent("click", { bubbles: !0, cancelable: !0 })));
    },
    zi = () => {
        if (z.defaults.Hash === !1) return;
        const n = z.getInstance();
        if ((n == null ? void 0 : n.options.Hash) === !1) return;
        const { slug: e, index: t } = Je(),
            { slug: i } = _i();
        n && (e === i ? n.jumpTo(t - 1) : ((Oe = !0), n.close())), $i();
    },
    Di = () => {
        ge && clearTimeout(ge),
            queueMicrotask(() => {
                zi();
            });
    },
    Qt = () => {
        window.addEventListener("hashchange", Di, !1),
            setTimeout(() => {
                zi();
            }, 500);
    };
Ie &&
    (/complete|interactive|loaded/.test(document.readyState)
        ? Qt()
        : document.addEventListener("DOMContentLoaded", Qt));
const Ge = "is-zooming-in";
class Ri extends ie {
    onCreateSlide(e, t, i) {
        const s = this.instance.optionFor(i, "src") || "";
        i.el && i.type === "image" && typeof s == "string" && this.setImage(i, s);
    }
    onRemoveSlide(e, t, i) {
        i.panzoom && i.panzoom.destroy(), (i.panzoom = void 0), (i.imageEl = void 0);
    }
    onChange(e, t, i, s) {
        D(this.instance.container, Ge);
        for (const o of t.slides) {
            const a = o.panzoom;
            a && o.index !== i && a.reset(0.35);
        }
    }
    onClose() {
        var e;
        const t = this.instance,
            i = t.container,
            s = t.getSlide();
        if (!i || !i.parentElement || !s) return;
        const { el: o, contentEl: a, panzoom: r, thumbElSrc: l } = s;
        if (!o || !l || !a || !r || r.isContentLoading || r.state === R.Init || r.state === R.Destroy) return;
        r.updateMetrics();
        let c = this.getZoomInfo(s);
        if (!c) return;
        (this.instance.state = B.CustomClosing),
            i.classList.remove(Ge),
            i.classList.add("is-zooming-out"),
            (a.style.backgroundImage = `url('${l}')`);
        const d = i.getBoundingClientRect();
        (((e = window.visualViewport) === null || e === void 0 ? void 0 : e.scale) || 1) === 1 &&
            Object.assign(i.style, {
                position: "absolute",
                top: `${i.offsetTop + window.scrollY}px`,
                left: `${i.offsetLeft + window.scrollX}px`,
                bottom: "auto",
                right: "auto",
                width: `${d.width}px`,
                height: `${d.height}px`,
                overflow: "hidden",
            });
        const { x: u, y: f, scale: h, opacity: g } = c;
        if (g) {
            const p = ((m, v, b, S) => {
                const y = v - m,
                    x = S - b;
                return (C) => b + (((C - m) / y) * x || 0);
            })(r.scale, h, 1, 0);
            r.on("afterTransform", () => {
                a.style.opacity = p(r.scale) + "";
            });
        }
        r.on("endAnimation", () => {
            t.destroy();
        }),
            (r.target.a = h),
            (r.target.b = 0),
            (r.target.c = 0),
            (r.target.d = h),
            r.panTo({ x: u, y: f, scale: h, friction: g ? 0.2 : 0.33, ignoreBounds: !0 }),
            r.isResting && t.destroy();
    }
    setImage(e, t) {
        const i = this.instance;
        (e.src = t),
            this.process(e, t).then(
                (s) => {
                    const { contentEl: o, imageEl: a, thumbElSrc: r, el: l } = e;
                    if (i.isClosing() || !o || !a) return;
                    o.offsetHeight;
                    const c = !!i.isOpeningSlide(e) && this.getZoomInfo(e);
                    if (this.option("protected") && l) {
                        l.addEventListener("contextmenu", (f) => {
                            f.preventDefault();
                        });
                        const u = document.createElement("div");
                        I(u, "fancybox-protected"), o.appendChild(u);
                    }
                    if (r && c) {
                        const u = s.contentRect,
                            f = Math.max(u.fullWidth, u.fullHeight);
                        let h = null;
                        !c.opacity &&
                            f > 1200 &&
                            ((h = document.createElement("img")),
                            I(h, "fancybox-ghost"),
                            (h.src = r),
                            o.appendChild(h));
                        const g = () => {
                            h &&
                                (I(h, "f-fadeFastOut"),
                                setTimeout(() => {
                                    h && (h.remove(), (h = null));
                                }, 200));
                        };
                        ((d = r),
                        new Promise((p, m) => {
                            const v = new Image();
                            (v.onload = p), (v.onerror = m), (v.src = d);
                        })).then(
                            () => {
                                i.hideLoading(e),
                                    (e.state = X.Opening),
                                    this.instance.emit("reveal", e),
                                    this.zoomIn(e).then(
                                        () => {
                                            g(), this.instance.done(e);
                                        },
                                        () => {}
                                    ),
                                    h &&
                                        setTimeout(
                                            () => {
                                                g();
                                            },
                                            f > 2500 ? 800 : 200
                                        );
                            },
                            () => {
                                i.hideLoading(e), i.revealContent(e);
                            }
                        );
                    } else {
                        const u = this.optionFor(e, "initialSize"),
                            f = this.optionFor(e, "zoom"),
                            h = { event: i.prevMouseMoveEvent || i.options.event, friction: f ? 0.12 : 0 };
                        let g = i.optionFor(e, "showClass") || void 0,
                            p = !0;
                        i.isOpeningSlide(e) &&
                            (u === "full"
                                ? s.zoomToFull(h)
                                : u === "cover"
                                  ? s.zoomToCover(h)
                                  : u === "max"
                                    ? s.zoomToMax(h)
                                    : (p = !1),
                            s.stop("current")),
                            p && g && (g = s.isDragging ? "f-fadeIn" : ""),
                            i.hideLoading(e),
                            i.revealContent(e, g);
                    }
                    var d;
                },
                () => {
                    i.setError(e, "{{IMAGE_ERROR}}");
                }
            );
    }
    process(e, t) {
        return new Promise((i, s) => {
            var o;
            const a = this.instance,
                r = e.el;
            a.clearContent(e), a.showLoading(e);
            let l = this.optionFor(e, "content");
            if ((typeof l == "string" && (l = se(l)), !l || !Y(l))) {
                if (((l = document.createElement("img")), l instanceof HTMLImageElement)) {
                    let c = "",
                        d = e.caption;
                    (c =
                        typeof d == "string" && d
                            ? d.replace(/<[^>]+>/gi, "").substring(0, 1e3)
                            : `Image ${e.index + 1} of ${((o = a.carousel) === null || o === void 0 ? void 0 : o.pages.length) || 1}`),
                        (l.src = t || ""),
                        (l.alt = c),
                        (l.draggable = !1),
                        e.srcset && l.setAttribute("srcset", e.srcset),
                        this.instance.isOpeningSlide(e) && (l.fetchPriority = "high");
                }
                e.sizes && l.setAttribute("sizes", e.sizes);
            }
            I(l, "fancybox-image"),
                (e.imageEl = l),
                a.setContent(e, l, !1),
                (e.panzoom = new ye(
                    r,
                    U({ transformParent: !0 }, this.option("Panzoom") || {}, {
                        content: l,
                        width: (c, d) => a.optionFor(e, "width", "auto", d) || "auto",
                        height: (c, d) => a.optionFor(e, "height", "auto", d) || "auto",
                        wheel: () => {
                            const c = a.option("wheel");
                            return (c === "zoom" || c == "pan") && c;
                        },
                        click: (c, d) => {
                            var u, f;
                            if (
                                a.isCompact ||
                                a.isClosing() ||
                                e.index !== ((u = a.getSlide()) === null || u === void 0 ? void 0 : u.index)
                            )
                                return !1;
                            if (d) {
                                const g = d.composedPath()[0];
                                if (
                                    ["A", "BUTTON", "TEXTAREA", "OPTION", "INPUT", "SELECT", "VIDEO"].includes(
                                        g.nodeName
                                    )
                                )
                                    return !1;
                            }
                            let h =
                                !d ||
                                (d.target &&
                                    ((f = e.contentEl) === null || f === void 0 ? void 0 : f.contains(d.target)));
                            return a.option(h ? "contentClick" : "backdropClick") || !1;
                        },
                        dblClick: () => (a.isCompact ? "toggleZoom" : a.option("contentDblClick") || !1),
                        spinner: !1,
                        panOnlyZoomed: !0,
                        wheelLimit: 1 / 0,
                        on: {
                            ready: (c) => {
                                i(c);
                            },
                            error: () => {
                                s();
                            },
                            destroy: () => {
                                s();
                            },
                        },
                    })
                ));
        });
    }
    zoomIn(e) {
        return new Promise((t, i) => {
            const s = this.instance,
                o = s.container,
                { panzoom: a, contentEl: r, el: l } = e;
            a && a.updateMetrics();
            const c = this.getZoomInfo(e);
            if (!(c && l && r && a && o)) return void i();
            const { x: d, y: u, scale: f, opacity: h } = c,
                g = () => {
                    e.state !== X.Closing &&
                        (h && (r.style.opacity = Math.max(Math.min(1, 1 - (1 - a.scale) / (1 - f)), 0) + ""),
                        a.scale >= 1 && a.scale > a.targetScale - 0.1 && t(a));
                },
                p = (b) => {
                    ((b.scale < 0.99 || b.scale > 1.01) && !b.isDragging) ||
                        (D(o, Ge),
                        (r.style.opacity = ""),
                        b.off("endAnimation", p),
                        b.off("touchStart", p),
                        b.off("afterTransform", g),
                        t(b));
                };
            a.on("endAnimation", p),
                a.on("touchStart", p),
                a.on("afterTransform", g),
                a.on(["error", "destroy"], () => {
                    i();
                }),
                a.panTo({ x: d, y: u, scale: f, friction: 0, ignoreBounds: !0 }),
                a.stop("current");
            const m = { event: a.panMode === "mousemove" ? s.prevMouseMoveEvent || s.options.event : void 0 },
                v = this.optionFor(e, "initialSize");
            I(o, Ge),
                s.hideLoading(e),
                v === "full"
                    ? a.zoomToFull(m)
                    : v === "cover"
                      ? a.zoomToCover(m)
                      : v === "max"
                        ? a.zoomToMax(m)
                        : a.reset(0.172);
        });
    }
    getZoomInfo(e) {
        const { el: t, imageEl: i, thumbEl: s, panzoom: o } = e,
            a = this.instance,
            r = a.container;
        if (
            !t ||
            !i ||
            !s ||
            !o ||
            Oi(s) < 3 ||
            !this.optionFor(e, "zoom") ||
            !r ||
            a.state === B.Destroy ||
            getComputedStyle(r).getPropertyValue("--f-images-zoom") === "0"
        )
            return !1;
        const l = window.visualViewport || null;
        if ((l ? l.scale : 1) !== 1) return !1;
        let { top: c, left: d, width: u, height: f } = s.getBoundingClientRect(),
            { top: h, left: g, fitWidth: p, fitHeight: m } = o.contentRect;
        if (!(u && f && p && m)) return !1;
        const v = o.container.getBoundingClientRect();
        (g += v.left), (h += v.top);
        const b = -1 * (g + 0.5 * p - (d + 0.5 * u)),
            S = -1 * (h + 0.5 * m - (c + 0.5 * f)),
            y = u / p;
        let x = this.option("zoomOpacity") || !1;
        return x === "auto" && (x = Math.abs(u / f - p / m) > 0.1), { x: b, y: S, scale: y, opacity: x };
    }
    attach() {
        const e = this,
            t = e.instance;
        t.on("Carousel.change", e.onChange),
            t.on("Carousel.createSlide", e.onCreateSlide),
            t.on("Carousel.removeSlide", e.onRemoveSlide),
            t.on("close", e.onClose);
    }
    detach() {
        const e = this,
            t = e.instance;
        t.off("Carousel.change", e.onChange),
            t.off("Carousel.createSlide", e.onCreateSlide),
            t.off("Carousel.removeSlide", e.onRemoveSlide),
            t.off("close", e.onClose);
    }
}
Object.defineProperty(Ri, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: { initialSize: "fit", Panzoom: { maxScale: 1 }, protected: !1, zoom: !0, zoomOpacity: "auto" },
}),
    typeof SuppressedError == "function" && SuppressedError;
const pt = "html",
    ei = "image",
    mt = "map",
    re = "youtube",
    fe = "vimeo",
    Pe = "html5video",
    ti = (n, e = {}) => {
        const t = new URL(n),
            i = new URLSearchParams(t.search),
            s = new URLSearchParams();
        for (const [r, l] of [...i, ...Object.entries(e)]) {
            let c = l + "";
            if (r === "t") {
                let d = c.match(/((\d*)m)?(\d*)s?/);
                d && s.set("start", 60 * parseInt(d[2] || "0") + parseInt(d[3] || "0") + "");
            } else s.set(r, c);
        }
        let o = s + "",
            a = n.match(/#t=((.*)?\d+s)/);
        return a && (o += `#t=${a[1]}`), o;
    },
    Eo = {
        ajax: null,
        autoSize: !0,
        iframeAttr: { allow: "autoplay; fullscreen", scrolling: "auto" },
        preload: !0,
        videoAutoplay: !0,
        videoRatio: 16 / 9,
        videoTpl: `<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">
  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn't support embedded videos.</video>`,
        videoFormat: "",
        vimeo: { byline: 1, color: "00adef", controls: 1, dnt: 1, muted: 0 },
        youtube: { controls: 1, enablejsapi: 1, nocookie: 1, rel: 0, fs: 1 },
    },
    Co = ["image", "html", "ajax", "inline", "clone", "iframe", "map", "pdf", "html5video", "youtube", "vimeo"];
class qi extends ie {
    onBeforeInitSlide(e, t, i) {
        this.processType(i);
    }
    onCreateSlide(e, t, i) {
        this.setContent(i);
    }
    onClearContent(e, t) {
        t.xhr && (t.xhr.abort(), (t.xhr = null));
        const i = t.iframeEl;
        i && ((i.onload = i.onerror = null), (i.src = "//about:blank"), (t.iframeEl = null));
        const s = t.contentEl,
            o = t.placeholderEl;
        if (t.type === "inline" && s && o)
            s.classList.remove("fancybox__content"),
                getComputedStyle(s).getPropertyValue("display") !== "none" && (s.style.display = "none"),
                setTimeout(() => {
                    o && (s && o.parentNode && o.parentNode.insertBefore(s, o), o.remove());
                }, 0),
                (t.contentEl = void 0),
                (t.placeholderEl = void 0);
        else for (; t.el && t.el.firstChild; ) t.el.removeChild(t.el.firstChild);
    }
    onSelectSlide(e, t, i) {
        i.state === X.Ready && this.playVideo();
    }
    onUnselectSlide(e, t, i) {
        var s, o;
        if (i.type === Pe) {
            try {
                (o = (s = i.el) === null || s === void 0 ? void 0 : s.querySelector("video")) === null ||
                    o === void 0 ||
                    o.pause();
            } catch {}
            return;
        }
        let a;
        i.type === fe
            ? (a = { method: "pause", value: "true" })
            : i.type === re && (a = { event: "command", func: "pauseVideo" }),
            a && i.iframeEl && i.iframeEl.contentWindow && i.iframeEl.contentWindow.postMessage(JSON.stringify(a), "*"),
            i.poller && clearTimeout(i.poller);
    }
    onDone(e, t) {
        e.isCurrentSlide(t) && !e.isClosing() && this.playVideo();
    }
    onRefresh(e, t) {
        t.slides.forEach((i) => {
            i.el && (this.resizeIframe(i), this.setAspectRatio(i));
        });
    }
    onMessage(e) {
        try {
            let t = JSON.parse(e.data);
            if (e.origin === "https://player.vimeo.com") {
                if (t.event === "ready")
                    for (let i of Array.from(document.getElementsByClassName("fancybox__iframe")))
                        i instanceof HTMLIFrameElement && i.contentWindow === e.source && (i.dataset.ready = "true");
            } else if (e.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && t.event === "onReady") {
                const i = document.getElementById(t.id);
                i && (i.dataset.ready = "true");
            }
        } catch {}
    }
    loadAjaxContent(e) {
        const t = this.instance.optionFor(e, "src") || "";
        this.instance.showLoading(e);
        const i = this.instance,
            s = new XMLHttpRequest();
        i.showLoading(e),
            (s.onreadystatechange = function () {
                s.readyState === XMLHttpRequest.DONE &&
                    i.state === B.Ready &&
                    (i.hideLoading(e),
                    s.status === 200
                        ? i.setContent(e, s.responseText)
                        : i.setError(e, s.status === 404 ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}"));
            });
        const o = e.ajax || null;
        s.open(o ? "POST" : "GET", t + ""),
            s.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"),
            s.setRequestHeader("X-Requested-With", "XMLHttpRequest"),
            s.send(o),
            (e.xhr = s);
    }
    setInlineContent(e) {
        let t = null;
        if (Y(e.src)) t = e.src;
        else if (typeof e.src == "string") {
            const i = e.src.split("#", 2).pop();
            t = i ? document.getElementById(i) : null;
        }
        if (t) {
            if (e.type === "clone" || t.closest(".fancybox__slide")) {
                t = t.cloneNode(!0);
                const i = t.dataset.animationName;
                i && (t.classList.remove(i), delete t.dataset.animationName);
                let s = t.getAttribute("id");
                (s = s ? `${s}--clone` : `clone-${this.instance.id}-${e.index}`), t.setAttribute("id", s);
            } else if (t.parentNode) {
                const i = document.createElement("div");
                i.classList.add("fancybox-placeholder"), t.parentNode.insertBefore(i, t), (e.placeholderEl = i);
            }
            this.instance.setContent(e, t);
        } else this.instance.setError(e, "{{ELEMENT_NOT_FOUND}}");
    }
    setIframeContent(e) {
        const { src: t, el: i } = e;
        if (!t || typeof t != "string" || !i) return;
        i.classList.add("is-loading");
        const s = this.instance,
            o = document.createElement("iframe");
        (o.className = "fancybox__iframe"), o.setAttribute("id", `fancybox__iframe_${s.id}_${e.index}`);
        for (const [r, l] of Object.entries(this.optionFor(e, "iframeAttr") || {})) o.setAttribute(r, l);
        (o.onerror = () => {
            s.setError(e, "{{IFRAME_ERROR}}");
        }),
            (e.iframeEl = o);
        const a = this.optionFor(e, "preload");
        if (e.type !== "iframe" || a === !1)
            return (
                o.setAttribute("src", e.src + ""), s.setContent(e, o, !1), this.resizeIframe(e), void s.revealContent(e)
            );
        s.showLoading(e),
            (o.onload = () => {
                if (!o.src.length) return;
                const r = o.dataset.ready !== "true";
                (o.dataset.ready = "true"), this.resizeIframe(e), r ? s.revealContent(e) : s.hideLoading(e);
            }),
            o.setAttribute("src", t),
            s.setContent(e, o, !1);
    }
    resizeIframe(e) {
        const { type: t, iframeEl: i } = e;
        if (t === re || t === fe) return;
        const s = i == null ? void 0 : i.parentElement;
        if (!i || !s) return;
        let o = e.autoSize;
        o === void 0 && (o = this.optionFor(e, "autoSize"));
        let a = e.width || 0,
            r = e.height || 0;
        a && r && (o = !1);
        const l = s && s.style;
        if (e.preload !== !1 && o !== !1 && l)
            try {
                const c = window.getComputedStyle(s),
                    d = parseFloat(c.paddingLeft) + parseFloat(c.paddingRight),
                    u = parseFloat(c.paddingTop) + parseFloat(c.paddingBottom),
                    f = i.contentWindow;
                if (f) {
                    const h = f.document,
                        g = h.getElementsByTagName(pt)[0],
                        p = h.body;
                    (l.width = ""),
                        (p.style.overflow = "hidden"),
                        (a = a || g.scrollWidth + d),
                        (l.width = `${a}px`),
                        (p.style.overflow = ""),
                        (l.flex = "0 0 auto"),
                        (l.height = `${p.scrollHeight}px`),
                        (r = g.scrollHeight + u);
                }
            } catch {}
        if (a || r) {
            const c = { flex: "0 1 auto", width: "", height: "" };
            a && a !== "auto" && (c.width = `${a}px`), r && r !== "auto" && (c.height = `${r}px`), Object.assign(l, c);
        }
    }
    playVideo() {
        const e = this.instance.getSlide();
        if (!e) return;
        const { el: t } = e;
        if (!t || !t.offsetParent || !this.optionFor(e, "videoAutoplay")) return;
        if (e.type === Pe)
            try {
                const s = t.querySelector("video");
                if (s) {
                    const o = s.play();
                    o !== void 0 &&
                        o
                            .then(() => {})
                            .catch((a) => {
                                (s.muted = !0), s.play();
                            });
                }
            } catch {}
        if (e.type !== re && e.type !== fe) return;
        const i = () => {
            if (e.iframeEl && e.iframeEl.contentWindow) {
                let s;
                if (e.iframeEl.dataset.ready === "true")
                    return (
                        (s =
                            e.type === re
                                ? { event: "command", func: "playVideo" }
                                : { method: "play", value: "true" }),
                        s && e.iframeEl.contentWindow.postMessage(JSON.stringify(s), "*"),
                        void (e.poller = void 0)
                    );
                e.type === re &&
                    ((s = { event: "listening", id: e.iframeEl.getAttribute("id") }),
                    e.iframeEl.contentWindow.postMessage(JSON.stringify(s), "*"));
            }
            e.poller = setTimeout(i, 250);
        };
        i();
    }
    processType(e) {
        if (e.html) return (e.type = pt), (e.src = e.html), void (e.html = "");
        const t = this.instance.optionFor(e, "src", "");
        if (!t || typeof t != "string") return;
        let i = e.type,
            s = null;
        if (
            (s = t.match(
                /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i
            ))
        ) {
            const o = this.optionFor(e, re),
                { nocookie: a } = o,
                r = (function (u, f) {
                    var h = {};
                    for (var g in u) Object.prototype.hasOwnProperty.call(u, g) && f.indexOf(g) < 0 && (h[g] = u[g]);
                    if (u != null && typeof Object.getOwnPropertySymbols == "function") {
                        var p = 0;
                        for (g = Object.getOwnPropertySymbols(u); p < g.length; p++)
                            f.indexOf(g[p]) < 0 &&
                                Object.prototype.propertyIsEnumerable.call(u, g[p]) &&
                                (h[g[p]] = u[g[p]]);
                    }
                    return h;
                })(o, ["nocookie"]),
                l = `www.youtube${a ? "-nocookie" : ""}.com`,
                c = ti(t, r),
                d = encodeURIComponent(s[2]);
            (e.videoId = d),
                (e.src = `https://${l}/embed/${d}?${c}`),
                (e.thumbSrc = e.thumbSrc || `https://i.ytimg.com/vi/${d}/mqdefault.jpg`),
                (i = re);
        } else if ((s = t.match(/^.+vimeo.com\/(?:\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/))) {
            const o = ti(t, this.optionFor(e, fe)),
                a = encodeURIComponent(s[1]),
                r = s[4] || "";
            (e.videoId = a),
                (e.src = `https://player.vimeo.com/video/${a}?${r ? `h=${r}${o ? "&" : ""}` : ""}${o}`),
                (i = fe);
        }
        if (!i && e.triggerEl) {
            const o = e.triggerEl.dataset.type;
            Co.includes(o) && (i = o);
        }
        i ||
            (typeof t == "string" &&
                (t.charAt(0) === "#"
                    ? (i = "inline")
                    : (s = t.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i))
                      ? ((i = Pe), (e.videoFormat = e.videoFormat || "video/" + (s[1] === "ogv" ? "ogg" : s[1])))
                      : t.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i)
                        ? (i = ei)
                        : t.match(/\.(pdf)((\?|#).*)?$/i) && (i = "pdf"))),
            (s = t.match(
                /(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i
            ))
                ? ((e.src = `https://maps.google.${s[1]}/?ll=${(s[2] ? s[2] + "&z=" + Math.floor(parseFloat(s[3])) + (s[4] ? s[4].replace(/^\//, "&") : "") : s[4] + "").replace(/\?/, "&")}&output=${s[4] && s[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`),
                  (i = mt))
                : (s = t.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) &&
                  ((e.src = `https://maps.google.${s[1]}/maps?q=${s[2].replace("query=", "q=").replace("api=1", "")}&output=embed`),
                  (i = mt)),
            (i = i || this.instance.option("defaultType")),
            (e.type = i),
            i === ei && (e.thumbSrc = e.thumbSrc || e.src);
    }
    setContent(e) {
        const t = this.instance.optionFor(e, "src") || "";
        if (e && e.type && t) {
            switch (e.type) {
                case pt:
                    this.instance.setContent(e, t);
                    break;
                case Pe:
                    const i = this.option("videoTpl");
                    i &&
                        this.instance.setContent(
                            e,
                            i
                                .replace(/\{\{src\}\}/gi, t + "")
                                .replace(/\{\{format\}\}/gi, this.optionFor(e, "videoFormat") || "")
                                .replace(/\{\{poster\}\}/gi, e.poster || e.thumbSrc || "")
                        );
                    break;
                case "inline":
                case "clone":
                    this.setInlineContent(e);
                    break;
                case "ajax":
                    this.loadAjaxContent(e);
                    break;
                case "pdf":
                case mt:
                case re:
                case fe:
                    e.preload = !1;
                case "iframe":
                    this.setIframeContent(e);
            }
            this.setAspectRatio(e);
        }
    }
    setAspectRatio(e) {
        const t = e.contentEl;
        if (!(e.el && t && e.type && [re, fe, Pe].includes(e.type))) return;
        let i,
            s = e.width || "auto",
            o = e.height || "auto";
        if (s === "auto" || o === "auto") {
            i = this.optionFor(e, "videoRatio");
            const c = (i + "").match(/(\d+)\s*\/\s?(\d+)/);
            i = c && c.length > 2 ? parseFloat(c[1]) / parseFloat(c[2]) : parseFloat(i + "");
        } else s && o && (i = s / o);
        if (!i) return;
        (t.style.aspectRatio = ""), (t.style.width = ""), (t.style.height = ""), t.offsetHeight;
        const a = t.getBoundingClientRect(),
            r = a.width || 1,
            l = a.height || 1;
        (t.style.aspectRatio = i + ""),
            i < r / l
                ? ((o = o === "auto" ? l : Math.min(l, o)), (t.style.width = "auto"), (t.style.height = `${o}px`))
                : ((s = s === "auto" ? r : Math.min(r, s)), (t.style.width = `${s}px`), (t.style.height = "auto"));
    }
    attach() {
        const e = this,
            t = e.instance;
        t.on("Carousel.beforeInitSlide", e.onBeforeInitSlide),
            t.on("Carousel.createSlide", e.onCreateSlide),
            t.on("Carousel.selectSlide", e.onSelectSlide),
            t.on("Carousel.unselectSlide", e.onUnselectSlide),
            t.on("Carousel.Panzoom.refresh", e.onRefresh),
            t.on("done", e.onDone),
            t.on("clearContent", e.onClearContent),
            window.addEventListener("message", e.onMessage);
    }
    detach() {
        const e = this,
            t = e.instance;
        t.off("Carousel.beforeInitSlide", e.onBeforeInitSlide),
            t.off("Carousel.createSlide", e.onCreateSlide),
            t.off("Carousel.selectSlide", e.onSelectSlide),
            t.off("Carousel.unselectSlide", e.onUnselectSlide),
            t.off("Carousel.Panzoom.refresh", e.onRefresh),
            t.off("done", e.onDone),
            t.off("clearContent", e.onClearContent),
            window.removeEventListener("message", e.onMessage);
    }
}
Object.defineProperty(qi, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: Eo });
const We = "play",
    Xe = "pause",
    Ae = "ready";
class Fi extends ie {
    constructor() {
        super(...arguments),
            Object.defineProperty(this, "state", { enumerable: !0, configurable: !0, writable: !0, value: Ae }),
            Object.defineProperty(this, "inHover", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
            Object.defineProperty(this, "timer", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "progressBar", { enumerable: !0, configurable: !0, writable: !0, value: null });
    }
    get isActive() {
        return this.state !== Ae;
    }
    onReady(e) {
        this.option("autoStart") && (e.isInfinite || e.page < e.pages.length - 1) && this.start();
    }
    onChange() {
        this.removeProgressBar(), this.pause();
    }
    onSettle() {
        this.resume();
    }
    onVisibilityChange() {
        document.visibilityState === "visible" ? this.resume() : this.pause();
    }
    onMouseEnter() {
        (this.inHover = !0), this.pause();
    }
    onMouseLeave() {
        var e;
        (this.inHover = !1), !((e = this.instance.panzoom) === null || e === void 0) && e.isResting && this.resume();
    }
    onTimerEnd() {
        const e = this.instance;
        this.state === "play" && (e.isInfinite || e.page !== e.pages.length - 1 ? e.slideNext() : e.slideTo(0));
    }
    removeProgressBar() {
        this.progressBar && (this.progressBar.remove(), (this.progressBar = null));
    }
    createProgressBar() {
        var e;
        if (!this.option("showProgress")) return null;
        this.removeProgressBar();
        const t = this.instance,
            i = ((e = t.pages[t.page]) === null || e === void 0 ? void 0 : e.slides) || [];
        let s = this.option("progressParentEl");
        if ((s || (s = (i.length === 1 ? i[0].el : null) || t.viewport), !s)) return null;
        const o = document.createElement("div");
        return I(o, "f-progress"), s.prepend(o), (this.progressBar = o), o.offsetHeight, o;
    }
    set() {
        const e = this,
            t = e.instance;
        if (t.pages.length < 2 || e.timer) return;
        const i = e.option("timeout");
        (e.state = We), I(t.container, "has-autoplay");
        let s = e.createProgressBar();
        s && ((s.style.transitionDuration = `${i}ms`), (s.style.transform = "scaleX(1)")),
            (e.timer = setTimeout(() => {
                (e.timer = null), e.inHover || e.onTimerEnd();
            }, i)),
            e.emit("set");
    }
    clear() {
        const e = this;
        e.timer && (clearTimeout(e.timer), (e.timer = null)), e.removeProgressBar();
    }
    start() {
        const e = this;
        if ((e.set(), e.state !== Ae)) {
            if (e.option("pauseOnHover")) {
                const t = e.instance.container;
                t.addEventListener("mouseenter", e.onMouseEnter, !1),
                    t.addEventListener("mouseleave", e.onMouseLeave, !1);
            }
            document.addEventListener("visibilitychange", e.onVisibilityChange, !1), e.emit("start");
        }
    }
    stop() {
        const e = this,
            t = e.state,
            i = e.instance.container;
        e.clear(),
            (e.state = Ae),
            i.removeEventListener("mouseenter", e.onMouseEnter, !1),
            i.removeEventListener("mouseleave", e.onMouseLeave, !1),
            document.removeEventListener("visibilitychange", e.onVisibilityChange, !1),
            D(i, "has-autoplay"),
            t !== Ae && e.emit("stop");
    }
    pause() {
        const e = this;
        e.state === We && ((e.state = Xe), e.clear(), e.emit(Xe));
    }
    resume() {
        const e = this,
            t = e.instance;
        if (t.isInfinite || t.page !== t.pages.length - 1)
            if (e.state !== We) {
                if (e.state === Xe && !e.inHover) {
                    const i = new Event("resume", { bubbles: !0, cancelable: !0 });
                    e.emit("resume", i), i.defaultPrevented || e.set();
                }
            } else e.set();
        else e.stop();
    }
    toggle() {
        this.state === We || this.state === Xe ? this.stop() : this.start();
    }
    attach() {
        const e = this,
            t = e.instance;
        t.on("ready", e.onReady),
            t.on("Panzoom.startAnimation", e.onChange),
            t.on("Panzoom.endAnimation", e.onSettle),
            t.on("Panzoom.touchMove", e.onChange);
    }
    detach() {
        const e = this,
            t = e.instance;
        t.off("ready", e.onReady),
            t.off("Panzoom.startAnimation", e.onChange),
            t.off("Panzoom.endAnimation", e.onSettle),
            t.off("Panzoom.touchMove", e.onChange),
            e.stop();
    }
}
Object.defineProperty(Fi, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: { autoStart: !0, pauseOnHover: !0, progressParentEl: null, showProgress: !0, timeout: 3e3 },
});
class Ni extends ie {
    constructor() {
        super(...arguments),
            Object.defineProperty(this, "ref", { enumerable: !0, configurable: !0, writable: !0, value: null });
    }
    onPrepare(e) {
        const t = e.carousel;
        if (!t) return;
        const i = e.container;
        i &&
            ((t.options.Autoplay = U({ autoStart: !1 }, this.option("Autoplay") || {}, {
                pauseOnHover: !1,
                timeout: this.option("timeout"),
                progressParentEl: () => this.option("progressParentEl") || null,
                on: {
                    start: () => {
                        e.emit("startSlideshow");
                    },
                    set: (s) => {
                        var o;
                        i.classList.add("has-slideshow"),
                            ((o = e.getSlide()) === null || o === void 0 ? void 0 : o.state) !== X.Ready && s.pause();
                    },
                    stop: () => {
                        i.classList.remove("has-slideshow"), e.isCompact || e.endIdle(), e.emit("endSlideshow");
                    },
                    resume: (s, o) => {
                        var a, r, l;
                        !o ||
                            !o.cancelable ||
                            (((a = e.getSlide()) === null || a === void 0 ? void 0 : a.state) === X.Ready &&
                                !(
                                    (l = (r = e.carousel) === null || r === void 0 ? void 0 : r.panzoom) === null ||
                                    l === void 0
                                ) &&
                                l.isResting) ||
                            o.preventDefault();
                    },
                },
            })),
            t.attachPlugins({ Autoplay: Fi }),
            (this.ref = t.plugins.Autoplay));
    }
    onReady(e) {
        const t = e.carousel,
            i = this.ref;
        i && t && this.option("playOnStart") && (t.isInfinite || t.page < t.pages.length - 1) && i.start();
    }
    onDone(e, t) {
        const i = this.ref,
            s = e.carousel;
        if (!i || !s) return;
        const o = t.panzoom;
        o &&
            o.on("startAnimation", () => {
                e.isCurrentSlide(t) && i.stop();
            }),
            e.isCurrentSlide(t) && i.resume();
    }
    onKeydown(e, t) {
        var i;
        const s = this.ref;
        s &&
            t === this.option("key") &&
            ((i = document.activeElement) === null || i === void 0 ? void 0 : i.nodeName) !== "BUTTON" &&
            s.toggle();
    }
    attach() {
        const e = this,
            t = e.instance;
        t.on("Carousel.init", e.onPrepare),
            t.on("Carousel.ready", e.onReady),
            t.on("done", e.onDone),
            t.on("keydown", e.onKeydown);
    }
    detach() {
        const e = this,
            t = e.instance;
        t.off("Carousel.init", e.onPrepare),
            t.off("Carousel.ready", e.onReady),
            t.off("done", e.onDone),
            t.off("keydown", e.onKeydown);
    }
}
Object.defineProperty(Ni, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        key: " ",
        playOnStart: !1,
        progressParentEl: (n) => {
            var e;
            return (
                ((e = n.instance.container) === null || e === void 0
                    ? void 0
                    : e.querySelector(".fancybox__toolbar [data-fancybox-toggle-slideshow]")) || n.instance.container
            );
        },
        timeout: 3e3,
    },
});
const ji = {
    classes: {
        container: "f-thumbs f-carousel__thumbs",
        viewport: "f-thumbs__viewport",
        track: "f-thumbs__track",
        slide: "f-thumbs__slide",
        isResting: "is-resting",
        isSelected: "is-selected",
        isLoading: "is-loading",
        hasThumbs: "has-thumbs",
    },
    minCount: 2,
    parentEl: null,
    thumbTpl:
        '<button class="f-thumbs__slide__button" tabindex="0" type="button" aria-label="{{GOTO}}" data-carousel-index="%i"><img class="f-thumbs__slide__img" data-lazy-src="{{%s}}" alt="" /></button>',
    type: "modern",
};
var le;
(function (n) {
    (n[(n.Init = 0)] = "Init"), (n[(n.Ready = 1)] = "Ready"), (n[(n.Hidden = 2)] = "Hidden");
})(le || (le = {}));
const ii = "isResting",
    Ye = "thumbWidth",
    Ce = "thumbHeight",
    ne = "thumbClipWidth";
let Bi = class extends ie {
    constructor() {
        super(...arguments),
            Object.defineProperty(this, "type", { enumerable: !0, configurable: !0, writable: !0, value: "modern" }),
            Object.defineProperty(this, "container", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "track", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "carousel", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "thumbWidth", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
            Object.defineProperty(this, "thumbClipWidth", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
            Object.defineProperty(this, "thumbHeight", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
            Object.defineProperty(this, "thumbGap", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
            Object.defineProperty(this, "thumbExtraGap", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
            Object.defineProperty(this, "state", { enumerable: !0, configurable: !0, writable: !0, value: le.Init });
    }
    get isModern() {
        return this.type === "modern";
    }
    onInitSlide(n, e) {
        const t = e.el ? e.el.dataset : void 0;
        t &&
            ((e.thumbSrc = t.thumbSrc || e.thumbSrc || ""),
            (e[ne] = parseFloat(t[ne] || "") || e[ne] || 0),
            (e[Ce] = parseFloat(t.thumbHeight || "") || e[Ce] || 0)),
            this.addSlide(e);
    }
    onInitSlides() {
        this.build();
    }
    onChange() {
        var n;
        if (!this.isModern) return;
        const e = this.container,
            t = this.instance,
            i = t.panzoom,
            s = this.carousel,
            o = s ? s.panzoom : null,
            a = t.page;
        if (i && s && o) {
            if (i.isDragging) {
                D(e, this.cn(ii));
                let r = ((n = s.pages[a]) === null || n === void 0 ? void 0 : n.pos) || 0;
                r += t.getProgress(a) * (this[ne] + this.thumbGap);
                let l = o.getBounds();
                -1 * r > l.x.min && -1 * r < l.x.max && o.panTo({ x: -1 * r, friction: 0.12 });
            } else oe(e, this.cn(ii), i.isResting);
            this.shiftModern();
        }
    }
    onRefresh() {
        this.updateProps();
        for (const n of this.instance.slides || []) this.resizeModernSlide(n);
        this.shiftModern();
    }
    isDisabled() {
        const n = this.option("minCount") || 0;
        if (n) {
            const t = this.instance;
            let i = 0;
            for (const s of t.slides || []) s.thumbSrc && i++;
            if (i < n) return !0;
        }
        const e = this.option("type");
        return ["modern", "classic"].indexOf(e) < 0;
    }
    getThumb(n) {
        const e = this.option("thumbTpl") || "";
        return {
            html: this.instance.localize(e, [
                ["%i", n.index],
                ["%d", n.index + 1],
                ["%s", n.thumbSrc || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"],
            ]),
        };
    }
    addSlide(n) {
        const e = this.carousel;
        e && e.addSlide(n.index, this.getThumb(n));
    }
    getSlides() {
        const n = [];
        for (const e of this.instance.slides || []) n.push(this.getThumb(e));
        return n;
    }
    resizeModernSlide(n) {
        this.isModern && (n[Ye] = n[ne] && n[Ce] ? Math.round(this[Ce] * (n[ne] / n[Ce])) : this[Ye]);
    }
    updateProps() {
        const n = this.container;
        if (!n) return;
        const e = (t) => parseFloat(getComputedStyle(n).getPropertyValue("--f-thumb-" + t)) || 0;
        (this.thumbGap = e("gap")),
            (this.thumbExtraGap = e("extra-gap")),
            (this[Ye] = e("width") || 40),
            (this[ne] = e("clip-width") || 40),
            (this[Ce] = e("height") || 40);
    }
    build() {
        const n = this;
        if (n.state !== le.Init) return;
        if (n.isDisabled()) return void n.emit("disabled");
        const e = n.instance,
            t = e.container,
            i = n.getSlides(),
            s = n.option("type");
        n.type = s;
        const o = n.option("parentEl"),
            a = n.cn("container"),
            r = n.cn("track");
        let l = o == null ? void 0 : o.querySelector("." + a);
        l || ((l = document.createElement("div")), I(l, a), o ? o.appendChild(l) : t.after(l)),
            I(l, `is-${s}`),
            I(t, n.cn("hasThumbs")),
            (n.container = l),
            n.updateProps();
        let c = l.querySelector("." + r);
        c || ((c = document.createElement("div")), I(c, n.cn("track")), l.appendChild(c)), (n.track = c);
        const d = U(
                {},
                {
                    track: c,
                    infinite: !1,
                    center: !0,
                    fill: s === "classic",
                    dragFree: !0,
                    slidesPerPage: 1,
                    transition: !1,
                    preload: 0.25,
                    friction: 0.12,
                    Panzoom: { maxVelocity: 0 },
                    Dots: !1,
                    Navigation: !1,
                    classes: {
                        container: "f-thumbs",
                        viewport: "f-thumbs__viewport",
                        track: "f-thumbs__track",
                        slide: "f-thumbs__slide",
                    },
                },
                n.option("Carousel") || {},
                { Sync: { target: e }, slides: i }
            ),
            u = new e.constructor(l, d);
        u.on("createSlide", (f, h) => {
            n.setProps(h.index), n.emit("createSlide", h, h.el);
        }),
            u.on("ready", () => {
                n.shiftModern(), n.emit("ready");
            }),
            u.on("refresh", () => {
                n.shiftModern();
            }),
            u.on("Panzoom.click", (f, h, g) => {
                n.onClick(g);
            }),
            (n.carousel = u),
            (n.state = le.Ready);
    }
    onClick(n) {
        n.preventDefault(), n.stopPropagation();
        const e = this.instance,
            { pages: t, page: i } = e,
            s = (p) => {
                if (p) {
                    const m = p.closest("[data-carousel-index]");
                    if (m) return [parseInt(m.dataset.carouselIndex || "", 10) || 0, m];
                }
                return [-1, void 0];
            },
            o = (p, m) => {
                const v = document.elementFromPoint(p, m);
                return v ? s(v) : [-1, void 0];
            };
        let [a, r] = s(n.target);
        if (a > -1) return;
        const l = this[ne],
            c = n.clientX,
            d = n.clientY;
        let [u, f] = o(c - l, d),
            [h, g] = o(c + l, d);
        f && g
            ? ((a =
                  Math.abs(c - f.getBoundingClientRect().right) < Math.abs(c - g.getBoundingClientRect().left) ? u : h),
              a === i && (a = a === u ? h : u))
            : f
              ? (a = u)
              : g && (a = h),
            a > -1 && t[a] && e.slideTo(a);
    }
    getShift(n) {
        var e;
        const t = this,
            { instance: i } = t,
            s = t.carousel;
        if (!i || !s) return 0;
        const o = t[Ye],
            a = t[ne],
            r = t.thumbGap,
            l = t.thumbExtraGap;
        if (!(!((e = s.slides[n]) === null || e === void 0) && e.el)) return 0;
        const c = 0.5 * (o - a),
            d = i.pages.length - 1;
        let u = i.getProgress(0),
            f = i.getProgress(d),
            h = i.getProgress(n, !1, !0),
            g = 0,
            p = c + l + r;
        const m = u < 0 && u > -1,
            v = f > 0 && f < 1;
        return (
            n === 0
                ? ((g = p * Math.abs(u)), v && u === 1 && (g -= p * Math.abs(f)))
                : n === d
                  ? ((g = p * Math.abs(f) * -1), m && f === -1 && (g += p * Math.abs(u)))
                  : m || v
                    ? ((g = -1 * p), (g += p * Math.abs(u)), (g += p * (1 - Math.abs(f))))
                    : (g = p * h),
            g
        );
    }
    setProps(n) {
        var e;
        const t = this;
        if (!t.isModern) return;
        const { instance: i } = t,
            s = t.carousel;
        if (i && s) {
            const o = (e = s.slides[n]) === null || e === void 0 ? void 0 : e.el;
            if (o && o.childNodes.length) {
                let a = M(1 - Math.abs(i.getProgress(n))),
                    r = M(t.getShift(n));
                o.style.setProperty("--progress", a ? a + "" : ""), o.style.setProperty("--shift", r + "");
            }
        }
    }
    shiftModern() {
        const n = this;
        if (!n.isModern) return;
        const { instance: e, track: t } = n,
            i = e.panzoom,
            s = n.carousel;
        if (!(e && t && i && s) || i.state === R.Init || i.state === R.Destroy) return;
        for (const a of e.slides) n.setProps(a.index);
        let o = (n[ne] + n.thumbGap) * (s.slides.length || 0);
        t.style.setProperty("--width", o + "");
    }
    cleanup() {
        const n = this;
        n.carousel && n.carousel.destroy(),
            (n.carousel = null),
            n.container && n.container.remove(),
            (n.container = null),
            n.track && n.track.remove(),
            (n.track = null),
            (n.state = le.Init),
            D(n.instance.container, n.cn("hasThumbs"));
    }
    attach() {
        const n = this,
            e = n.instance;
        e.on("initSlide", n.onInitSlide),
            e.state === N.Init ? e.on("initSlides", n.onInitSlides) : n.onInitSlides(),
            e.on(["change", "Panzoom.afterTransform"], n.onChange),
            e.on("Panzoom.refresh", n.onRefresh);
    }
    detach() {
        const n = this,
            e = n.instance;
        e.off("initSlide", n.onInitSlide),
            e.off("initSlides", n.onInitSlides),
            e.off(["change", "Panzoom.afterTransform"], n.onChange),
            e.off("Panzoom.refresh", n.onRefresh),
            n.cleanup();
    }
};
Object.defineProperty(Bi, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: ji });
const To = Object.assign(Object.assign({}, ji), { key: "t", showOnStart: !0, parentEl: null }),
    ni = "is-masked",
    si = "aria-hidden";
class Hi extends ie {
    constructor() {
        super(...arguments),
            Object.defineProperty(this, "ref", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "hidden", { enumerable: !0, configurable: !0, writable: !0, value: !1 });
    }
    get isEnabled() {
        const e = this.ref;
        return e && !e.isDisabled();
    }
    get isHidden() {
        return this.hidden;
    }
    onClick(e, t) {
        t.stopPropagation();
    }
    onCreateSlide(e, t) {
        var i, s, o;
        const a =
                ((o =
                    (s = (i = this.instance) === null || i === void 0 ? void 0 : i.carousel) === null || s === void 0
                        ? void 0
                        : s.slides[t.index]) === null || o === void 0
                    ? void 0
                    : o.type) || "",
            r = t.el;
        if (r && a) {
            let l = `for-${a}`;
            ["video", "youtube", "vimeo", "html5video"].includes(a) && (l += " for-video"), I(r, l);
        }
    }
    onInit() {
        var e;
        const t = this,
            i = t.instance,
            s = i.carousel;
        if (t.ref || !s) return;
        const o = t.option("parentEl") || i.footer || i.container;
        if (!o) return;
        const a = U({}, t.options, {
            parentEl: o,
            classes: { container: "f-thumbs fancybox__thumbs" },
            Carousel: { Sync: { friction: i.option("Carousel.friction") || 0 } },
            on: {
                ready: (r) => {
                    const l = r.container;
                    l &&
                        this.hidden &&
                        (t.refresh(),
                        (l.style.transition = "none"),
                        t.hide(),
                        l.offsetHeight,
                        queueMicrotask(() => {
                            (l.style.transition = ""), t.show();
                        }));
                },
            },
        });
        (a.Carousel = a.Carousel || {}),
            (a.Carousel.on = U(((e = t.options.Carousel) === null || e === void 0 ? void 0 : e.on) || {}, {
                click: this.onClick,
                createSlide: this.onCreateSlide,
            })),
            (s.options.Thumbs = a),
            s.attachPlugins({ Thumbs: Bi }),
            (t.ref = s.plugins.Thumbs),
            t.option("showOnStart") || ((t.ref.state = le.Hidden), (t.hidden = !0));
    }
    onResize() {
        var e;
        const t = (e = this.ref) === null || e === void 0 ? void 0 : e.container;
        t && (t.style.maxHeight = "");
    }
    onKeydown(e, t) {
        const i = this.option("key");
        i && i === t && this.toggle();
    }
    toggle() {
        const e = this.ref;
        if (e && !e.isDisabled())
            return e.state === le.Hidden
                ? ((e.state = le.Init), void e.build())
                : void (this.hidden ? this.show() : this.hide());
    }
    show() {
        const e = this.ref;
        if (!e || e.isDisabled()) return;
        const t = e.container;
        t && (this.refresh(), t.offsetHeight, t.removeAttribute(si), t.classList.remove(ni), (this.hidden = !1));
    }
    hide() {
        const e = this.ref,
            t = e && e.container;
        t && (this.refresh(), t.offsetHeight, t.classList.add(ni), t.setAttribute(si, "true")), (this.hidden = !0);
    }
    refresh() {
        const e = this.ref;
        if (!e || !e.state) return;
        const t = e.container,
            i = (t == null ? void 0 : t.firstChild) || null;
        t && i && i.childNodes.length && (t.style.maxHeight = `${i.getBoundingClientRect().height}px`);
    }
    attach() {
        const e = this,
            t = e.instance;
        t.state === B.Init ? t.on("Carousel.init", e.onInit) : e.onInit(),
            t.on("resize", e.onResize),
            t.on("keydown", e.onKeydown);
    }
    detach() {
        var e;
        const t = this,
            i = t.instance;
        i.off("Carousel.init", t.onInit),
            i.off("resize", t.onResize),
            i.off("keydown", t.onKeydown),
            (e = i.carousel) === null || e === void 0 || e.detachPlugins(["Thumbs"]),
            (t.ref = null);
    }
}
Object.defineProperty(Hi, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: To });
const gt = {
    panLeft: { icon: '<svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg>', change: { panX: -100 } },
    panRight: { icon: '<svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg>', change: { panX: 100 } },
    panUp: { icon: '<svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg>', change: { panY: -100 } },
    panDown: { icon: '<svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg>', change: { panY: 100 } },
    zoomIn: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg>',
        action: "zoomIn",
    },
    zoomOut: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "zoomOut",
    },
    toggle1to1: {
        icon: '<svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg>',
        action: "toggleZoom",
    },
    toggleZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "toggleZoom",
    },
    iterateZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "iterateZoom",
    },
    rotateCCW: {
        icon: '<svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg>',
        action: "rotateCCW",
    },
    rotateCW: {
        icon: '<svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg>',
        action: "rotateCW",
    },
    flipX: {
        icon: '<svg style="stroke-width: 1.3"><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg>',
        action: "flipX",
    },
    flipY: {
        icon: '<svg style="stroke-width: 1.3"><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg>',
        action: "flipY",
    },
    fitX: {
        icon: '<svg><path d="M4 12V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6M10 18H3M21 18h-7M6 15l-3 3 3 3M18 15l3 3-3 3"/></svg>',
        action: "fitX",
    },
    fitY: {
        icon: '<svg><path d="M12 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6M18 14v7M18 3v7M15 18l3 3 3-3M15 6l3-3 3 3"/></svg>',
        action: "fitY",
    },
    reset: {
        icon: '<svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg>',
        action: "reset",
    },
    toggleFS: {
        icon: '<svg><g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g></svg>',
        action: "toggleFS",
    },
};
var ve;
(function (n) {
    (n[(n.Init = 0)] = "Init"), (n[(n.Ready = 1)] = "Ready"), (n[(n.Disabled = 2)] = "Disabled");
})(ve || (ve = {}));
const Mo = {
        absolute: "auto",
        display: {
            left: ["infobar"],
            middle: [],
            right: ["iterateZoom", "slideshow", "fullscreen", "thumbs", "close"],
        },
        enabled: "auto",
        items: {
            infobar: {
                tpl: '<div class="fancybox__infobar" tabindex="-1"><span data-fancybox-current-index></span>/<span data-fancybox-count></span></div>',
            },
            download: {
                tpl: '<a class="f-button" title="{{DOWNLOAD}}" data-fancybox-download href="javasript:;"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></a>',
            },
            prev: {
                tpl: '<button class="f-button" title="{{PREV}}" data-fancybox-prev><svg><path d="m15 6-6 6 6 6"/></svg></button>',
            },
            next: {
                tpl: '<button class="f-button" title="{{NEXT}}" data-fancybox-next><svg><path d="m9 6 6 6-6 6"/></svg></button>',
            },
            slideshow: {
                tpl: '<button class="f-button" title="{{TOGGLE_SLIDESHOW}}" data-fancybox-toggle-slideshow><svg><g><path d="M8 4v16l13 -8z"></path></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>',
            },
            fullscreen: {
                tpl: '<button class="f-button" title="{{TOGGLE_FULLSCREEN}}" data-fancybox-toggle-fullscreen><svg><g><path d="M4 8V6a2 2 0 0 1 2-2h2M4 16v2a2 2 0 0 0 2 2h2M16 4h2a2 2 0 0 1 2 2v2M16 20h2a2 2 0 0 0 2-2v-2"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>',
            },
            thumbs: {
                tpl: '<button class="f-button" title="{{TOGGLE_THUMBS}}" data-fancybox-toggle-thumbs><svg><circle cx="5.5" cy="5.5" r="1"/><circle cx="12" cy="5.5" r="1"/><circle cx="18.5" cy="5.5" r="1"/><circle cx="5.5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="18.5" cy="12" r="1"/><circle cx="5.5" cy="18.5" r="1"/><circle cx="12" cy="18.5" r="1"/><circle cx="18.5" cy="18.5" r="1"/></svg></button>',
            },
            close: {
                tpl: '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="m19.5 4.5-15 15M4.5 4.5l15 15"/></svg></button>',
            },
        },
        parentEl: null,
    },
    Lo = { tabindex: "-1", width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
    oi = "has-toolbar",
    vt = "fancybox__toolbar";
class Vi extends ie {
    constructor() {
        super(...arguments),
            Object.defineProperty(this, "state", { enumerable: !0, configurable: !0, writable: !0, value: ve.Init }),
            Object.defineProperty(this, "container", { enumerable: !0, configurable: !0, writable: !0, value: null });
    }
    onReady(e) {
        var t;
        if (!e.carousel) return;
        let i = this.option("display"),
            s = this.option("absolute"),
            o = this.option("enabled");
        if (o === "auto") {
            const c = this.instance.carousel;
            let d = 0;
            if (c) for (const u of c.slides) (u.panzoom || u.type === "image") && d++;
            d || (o = !1);
        }
        o || (i = void 0);
        let a = 0;
        const r = { left: [], middle: [], right: [] };
        if (i)
            for (const c of ["left", "middle", "right"])
                for (const d of i[c]) {
                    const u = this.createEl(d);
                    u && ((t = r[c]) === null || t === void 0 || t.push(u), a++);
                }
        let l = null;
        if ((a && (l = this.createContainer()), l)) {
            for (const [c, d] of Object.entries(r)) {
                const u = document.createElement("div");
                I(u, vt + "__column is-" + c);
                for (const f of d) u.appendChild(f);
                s !== "auto" || c !== "middle" || d.length || (s = !0), l.appendChild(u);
            }
            s === !0 && I(l, "is-absolute"), (this.state = ve.Ready), this.onRefresh();
        } else this.state = ve.Disabled;
    }
    onClick(e) {
        var t, i;
        const s = this.instance,
            o = s.getSlide(),
            a = o == null ? void 0 : o.panzoom,
            r = e.target,
            l = r && Y(r) ? r.dataset : null;
        if (!l) return;
        if (l.fancyboxToggleThumbs !== void 0)
            return (
                e.preventDefault(),
                e.stopPropagation(),
                void ((t = s.plugins.Thumbs) === null || t === void 0 || t.toggle())
            );
        if (l.fancyboxToggleFullscreen !== void 0)
            return e.preventDefault(), e.stopPropagation(), void this.instance.toggleFullscreen();
        if (l.fancyboxToggleSlideshow !== void 0) {
            e.preventDefault(), e.stopPropagation();
            const u = (i = s.carousel) === null || i === void 0 ? void 0 : i.plugins.Autoplay;
            let f = u.isActive;
            return a && a.panMode === "mousemove" && !f && a.reset(), void (f ? u.stop() : u.start());
        }
        const c = l.panzoomAction,
            d = l.panzoomChange;
        if (((d || c) && (e.preventDefault(), e.stopPropagation()), d)) {
            let u = {};
            try {
                u = JSON.parse(d);
            } catch {}
            a && a.applyChange(u);
        } else c && a && a[c] && a[c]();
    }
    onChange() {
        this.onRefresh();
    }
    onRefresh() {
        if (this.instance.isClosing()) return;
        const e = this.container;
        if (!e) return;
        const t = this.instance.getSlide();
        if (!t || t.state !== X.Ready) return;
        const i = t && !t.error && t.panzoom;
        for (const a of e.querySelectorAll("[data-panzoom-action]"))
            i
                ? (a.removeAttribute("disabled"), a.removeAttribute("tabindex"))
                : (a.setAttribute("disabled", ""), a.setAttribute("tabindex", "-1"));
        let s = i && i.canZoomIn(),
            o = i && i.canZoomOut();
        for (const a of e.querySelectorAll('[data-panzoom-action="zoomIn"]'))
            s
                ? (a.removeAttribute("disabled"), a.removeAttribute("tabindex"))
                : (a.setAttribute("disabled", ""), a.setAttribute("tabindex", "-1"));
        for (const a of e.querySelectorAll('[data-panzoom-action="zoomOut"]'))
            o
                ? (a.removeAttribute("disabled"), a.removeAttribute("tabindex"))
                : (a.setAttribute("disabled", ""), a.setAttribute("tabindex", "-1"));
        for (const a of e.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')) {
            o || s
                ? (a.removeAttribute("disabled"), a.removeAttribute("tabindex"))
                : (a.setAttribute("disabled", ""), a.setAttribute("tabindex", "-1"));
            const r = a.querySelector("g");
            r && (r.style.display = s ? "" : "none");
        }
    }
    onDone(e, t) {
        var i;
        (i = t.panzoom) === null ||
            i === void 0 ||
            i.on("afterTransform", () => {
                this.instance.isCurrentSlide(t) && this.onRefresh();
            }),
            this.instance.isCurrentSlide(t) && this.onRefresh();
    }
    createContainer() {
        const e = this.instance.container;
        if (!e) return null;
        const t = this.option("parentEl") || e;
        let i = t.querySelector("." + vt);
        return (
            i || ((i = document.createElement("div")), I(i, vt), t.prepend(i)),
            i.addEventListener("click", this.onClick, { passive: !1, capture: !0 }),
            e && I(e, oi),
            (this.container = i),
            i
        );
    }
    createEl(e) {
        const t = this.instance,
            i = t.carousel;
        if (!i || e === "toggleFS" || (e === "fullscreen" && !Ii())) return null;
        let s = null;
        const o = i.slides.length || 0;
        let a = 0,
            r = 0;
        for (const c of i.slides)
            (c.panzoom || c.type === "image") && a++, (c.type === "image" || c.downloadSrc) && r++;
        if (o < 2 && ["infobar", "prev", "next"].includes(e)) return s;
        if ((gt[e] !== void 0 && !a) || (e === "download" && !r)) return null;
        if (e === "thumbs") {
            const c = t.plugins.Thumbs;
            if (!c || !c.isEnabled) return null;
        }
        if (e === "slideshow" && (!i.plugins.Autoplay || o < 2)) return null;
        if (gt[e] !== void 0) {
            const c = gt[e];
            (s = document.createElement("button")),
                s.setAttribute("title", this.instance.localize(`{{${e.toUpperCase()}}}`)),
                I(s, "f-button"),
                c.action && (s.dataset.panzoomAction = c.action),
                c.change && (s.dataset.panzoomChange = JSON.stringify(c.change)),
                s.appendChild(se(this.instance.localize(c.icon)));
        } else {
            const c = (this.option("items") || [])[e];
            c &&
                ((s = se(this.instance.localize(c.tpl))),
                typeof c.click == "function" &&
                    s.addEventListener("click", (d) => {
                        d.preventDefault(),
                            d.stopPropagation(),
                            typeof c.click == "function" && c.click.call(this, this, d);
                    }));
        }
        const l = s == null ? void 0 : s.querySelector("svg");
        if (l) for (const [c, d] of Object.entries(Lo)) l.getAttribute(c) || l.setAttribute(c, String(d));
        return s;
    }
    removeContainer() {
        const e = this.container;
        e && e.remove(), (this.container = null), (this.state = ve.Disabled);
        const t = this.instance.container;
        t && D(t, oi);
    }
    attach() {
        const e = this,
            t = e.instance;
        t.on("Carousel.initSlides", e.onReady),
            t.on("done", e.onDone),
            t.on(["reveal", "Carousel.change"], e.onChange),
            e.onReady(e.instance);
    }
    detach() {
        const e = this,
            t = e.instance;
        t.off("Carousel.initSlides", e.onReady),
            t.off("done", e.onDone),
            t.off(["reveal", "Carousel.change"], e.onChange),
            e.removeContainer();
    }
}
Object.defineProperty(Vi, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: Mo });
const Po = {
        Hash: class extends ie {
            onReady() {
                Oe = !1;
            }
            onChange(n) {
                ge && clearTimeout(ge);
                const { hash: e } = _i(),
                    { hash: t } = Je(),
                    i = n.isOpeningSlide(n.getSlide());
                i && (Jt = t === e ? "" : t),
                    e &&
                        e !== t &&
                        (ge = setTimeout(() => {
                            try {
                                if (n.state === B.Ready) {
                                    let s = "replaceState";
                                    i && !Ve && ((s = "pushState"), (Ve = !0)),
                                        window.history[s](
                                            {},
                                            document.title,
                                            window.location.pathname + window.location.search + e
                                        );
                                }
                            } catch {}
                        }, 300));
            }
            onClose(n) {
                if ((ge && clearTimeout(ge), !Oe && Ve)) return (Ve = !1), (Oe = !1), void window.history.back();
                if (!Oe)
                    try {
                        window.history.replaceState(
                            {},
                            document.title,
                            window.location.pathname + window.location.search + (Jt || "")
                        );
                    } catch {}
            }
            attach() {
                const n = this.instance;
                n.on("ready", this.onReady),
                    n.on(["Carousel.ready", "Carousel.change"], this.onChange),
                    n.on("close", this.onClose);
            }
            detach() {
                const n = this.instance;
                n.off("ready", this.onReady),
                    n.off(["Carousel.ready", "Carousel.change"], this.onChange),
                    n.off("close", this.onClose);
            }
            static parseURL() {
                return Je();
            }
            static startFromUrl() {
                $i();
            }
            static destroy() {
                window.removeEventListener("hashchange", Di, !1);
            }
        },
        Html: qi,
        Images: Ri,
        Slideshow: Ni,
        Thumbs: Hi,
        Toolbar: Vi,
    },
    ai = "with-fancybox",
    bt = "hide-scrollbar",
    ri = "--fancybox-scrollbar-compensate",
    li = "--fancybox-body-margin",
    yt = "aria-hidden",
    St = "is-using-tab",
    wt = "is-animated",
    ci = "is-compact",
    di = "is-loading",
    xt = "is-opening",
    Ue = "has-caption",
    Te = "disabled",
    pe = "tabindex",
    ui = "download",
    Et = "href",
    Me = "src",
    de = (n) => typeof n == "string",
    hi = function () {
        var n = window.getSelection();
        return !!n && n.type === "Range";
    };
let Q,
    ee = null,
    me = null,
    fi = 0,
    pi = 0,
    mi = 0,
    gi = 0;
const Le = new Map();
let Ao = 0;
class z extends kt {
    get isIdle() {
        return this.idle;
    }
    get isCompact() {
        return this.option("compact");
    }
    constructor(e = [], t = {}, i = {}) {
        super(t),
            Object.defineProperty(this, "userSlides", { enumerable: !0, configurable: !0, writable: !0, value: [] }),
            Object.defineProperty(this, "userPlugins", { enumerable: !0, configurable: !0, writable: !0, value: {} }),
            Object.defineProperty(this, "idle", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
            Object.defineProperty(this, "idleTimer", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "clickTimer", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "pwt", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
            Object.defineProperty(this, "ignoreFocusChange", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: !1,
            }),
            Object.defineProperty(this, "startedFs", { enumerable: !0, configurable: !0, writable: !0, value: !1 }),
            Object.defineProperty(this, "state", { enumerable: !0, configurable: !0, writable: !0, value: B.Init }),
            Object.defineProperty(this, "id", { enumerable: !0, configurable: !0, writable: !0, value: 0 }),
            Object.defineProperty(this, "container", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "footer", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "carousel", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "lastFocus", { enumerable: !0, configurable: !0, writable: !0, value: null }),
            Object.defineProperty(this, "prevMouseMoveEvent", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0,
            }),
            Q || (Q = Ii()),
            (this.id = t.id || ++Ao),
            Le.set(this.id, this),
            (this.userSlides = e),
            (this.userPlugins = i),
            queueMicrotask(() => {
                this.init();
            });
    }
    init() {
        if (this.state === B.Destroy) return;
        (this.state = B.Init),
            this.attachPlugins(Object.assign(Object.assign({}, z.Plugins), this.userPlugins)),
            this.emit("init"),
            this.emit("attachPlugins"),
            this.option("hideScrollbar") === !0 &&
                (() => {
                    if (!Ie) return;
                    const t = document,
                        i = t.body,
                        s = t.documentElement;
                    if (i.classList.contains(bt)) return;
                    let o = window.innerWidth - s.getBoundingClientRect().width;
                    const a = parseFloat(window.getComputedStyle(i).marginRight);
                    o < 0 && (o = 0),
                        s.style.setProperty(ri, `${o}px`),
                        a && i.style.setProperty(li, `${a}px`),
                        i.classList.add(bt);
                })(),
            this.initLayout(),
            this.scale();
        const e = () => {
            this.initCarousel(this.userSlides),
                (this.state = B.Ready),
                this.attachEvents(),
                this.emit("ready"),
                setTimeout(() => {
                    this.container && this.container.setAttribute(yt, "false");
                }, 16);
        };
        this.option("Fullscreen.autoStart") && Q && !Q.isFullscreen()
            ? Q.request()
                  .then(() => {
                      (this.startedFs = !0), e();
                  })
                  .catch(() => e())
            : e();
    }
    initLayout() {
        var e, t;
        const i = this.option("parentEl") || document.body,
            s = se(this.localize(this.option("tpl.main") || ""));
        if (s) {
            if (
                (s.setAttribute("id", `fancybox-${this.id}`),
                s.setAttribute("aria-label", this.localize("{{MODAL}}")),
                s.classList.toggle(ci, this.isCompact),
                I(s, this.option("mainClass") || ""),
                I(s, xt),
                (this.container = s),
                (this.footer = s.querySelector(".fancybox__footer")),
                i.appendChild(s),
                I(document.documentElement, ai),
                (ee && me) ||
                    ((ee = document.createElement("span")),
                    I(ee, "fancybox-focus-guard"),
                    ee.setAttribute(pe, "0"),
                    ee.setAttribute(yt, "true"),
                    ee.setAttribute("aria-label", "Focus guard"),
                    (me = ee.cloneNode()),
                    (e = s.parentElement) === null || e === void 0 || e.insertBefore(ee, s),
                    (t = s.parentElement) === null || t === void 0 || t.append(me)),
                s.addEventListener("mousedown", (o) => {
                    (fi = o.pageX), (pi = o.pageY), D(s, St);
                }),
                this.option("closeExisting"))
            )
                for (const o of Le.values()) o.id !== this.id && o.close();
            else
                this.option("animated") &&
                    (I(s, wt),
                    setTimeout(() => {
                        this.isClosing() || D(s, wt);
                    }, 350));
            this.emit("initLayout");
        }
    }
    initCarousel(e) {
        const t = this.container;
        if (!t) return;
        const i = t.querySelector(".fancybox__carousel");
        if (!i) return;
        const s = (this.carousel = new be(
            i,
            U(
                {},
                {
                    slides: e,
                    transition: "fade",
                    Panzoom: {
                        lockAxis: this.option("dragToClose") ? "xy" : "x",
                        infinite: !!this.option("dragToClose") && "y",
                    },
                    Dots: !1,
                    Navigation: {
                        classes: {
                            container: "fancybox__nav",
                            button: "f-button",
                            isNext: "is-next",
                            isPrev: "is-prev",
                        },
                    },
                    initialPage: this.option("startIndex"),
                    l10n: this.option("l10n"),
                },
                this.option("Carousel") || {}
            )
        ));
        s.on("*", (o, a, ...r) => {
            this.emit(`Carousel.${a}`, o, ...r);
        }),
            s.on(["ready", "change"], () => {
                this.manageCaption();
            }),
            this.on("Carousel.removeSlide", (o, a, r) => {
                this.clearContent(r), (r.state = void 0);
            }),
            s.on("Panzoom.touchStart", () => {
                var o, a;
                this.isCompact || this.endIdle(),
                    !((o = document.activeElement) === null || o === void 0) &&
                        o.closest(".f-thumbs") &&
                        ((a = this.container) === null || a === void 0 || a.focus());
            }),
            s.on("settle", () => {
                this.idleTimer || this.isCompact || !this.option("idle") || this.setIdle(),
                    this.option("autoFocus") && !this.isClosing && this.checkFocus();
            }),
            this.option("dragToClose") &&
                (s.on("Panzoom.afterTransform", (o, a) => {
                    const r = this.getSlide();
                    if (r && Ct(r.el)) return;
                    const l = this.container;
                    if (l) {
                        const c = Math.abs(a.current.f),
                            d = c < 1 ? "" : Math.max(0.5, Math.min(1, 1 - (c / a.contentRect.fitHeight) * 1.5));
                        l.style.setProperty("--fancybox-ts", d ? "0s" : ""),
                            l.style.setProperty("--fancybox-opacity", d + "");
                    }
                }),
                s.on("Panzoom.touchEnd", (o, a, r) => {
                    var l;
                    const c = this.getSlide();
                    if (
                        (c && Ct(c.el)) ||
                        (a.isMobile &&
                            document.activeElement &&
                            ["TEXTAREA", "INPUT"].indexOf(
                                (l = document.activeElement) === null || l === void 0 ? void 0 : l.nodeName
                            ) !== -1)
                    )
                        return;
                    const d = Math.abs(a.dragOffset.y);
                    a.lockedAxis === "y" &&
                        (d >= 200 || (d >= 50 && a.dragOffset.time < 300)) &&
                        (r && r.cancelable && r.preventDefault(),
                        this.close(r, "f-throwOut" + (a.current.f < 0 ? "Up" : "Down")));
                })),
            s.on("change", (o) => {
                var a;
                let r = (a = this.getSlide()) === null || a === void 0 ? void 0 : a.triggerEl;
                if (r) {
                    const l = new CustomEvent("slideTo", { bubbles: !0, cancelable: !0, detail: o.page });
                    r.dispatchEvent(l);
                }
            }),
            s.on(["refresh", "change"], (o) => {
                const a = this.container;
                if (!a) return;
                for (const c of a.querySelectorAll("[data-fancybox-current-index]")) c.innerHTML = o.page + 1;
                for (const c of a.querySelectorAll("[data-fancybox-count]")) c.innerHTML = o.pages.length;
                if (!o.isInfinite) {
                    for (const c of a.querySelectorAll("[data-fancybox-next]"))
                        o.page < o.pages.length - 1
                            ? (c.removeAttribute(Te), c.removeAttribute(pe))
                            : (c.setAttribute(Te, ""), c.setAttribute(pe, "-1"));
                    for (const c of a.querySelectorAll("[data-fancybox-prev]"))
                        o.page > 0
                            ? (c.removeAttribute(Te), c.removeAttribute(pe))
                            : (c.setAttribute(Te, ""), c.setAttribute(pe, "-1"));
                }
                const r = this.getSlide();
                if (!r) return;
                let l = r.downloadSrc || "";
                l || r.type !== "image" || r.error || !de(r[Me]) || (l = r[Me]);
                for (const c of a.querySelectorAll("[data-fancybox-download]")) {
                    const d = r.downloadFilename;
                    l
                        ? (c.removeAttribute(Te),
                          c.removeAttribute(pe),
                          c.setAttribute(Et, l),
                          c.setAttribute(ui, d || l),
                          c.setAttribute("target", "_blank"))
                        : (c.setAttribute(Te, ""),
                          c.setAttribute(pe, "-1"),
                          c.removeAttribute(Et),
                          c.removeAttribute(ui));
                }
            }),
            this.emit("initCarousel");
    }
    attachEvents() {
        const e = this,
            t = e.container;
        if (!t) return;
        t.addEventListener("click", e.onClick, { passive: !1, capture: !1 }),
            t.addEventListener("wheel", e.onWheel, { passive: !1, capture: !1 }),
            document.addEventListener("keydown", e.onKeydown, { passive: !1, capture: !0 }),
            document.addEventListener("visibilitychange", e.onVisibilityChange, !1),
            document.addEventListener("mousemove", e.onMousemove),
            e.option("trapFocus") && document.addEventListener("focus", e.onFocus, !0),
            window.addEventListener("resize", e.onResize);
        const i = window.visualViewport;
        i && (i.addEventListener("scroll", e.onResize), i.addEventListener("resize", e.onResize));
    }
    detachEvents() {
        const e = this,
            t = e.container;
        if (!t) return;
        document.removeEventListener("keydown", e.onKeydown, { passive: !1, capture: !0 }),
            t.removeEventListener("wheel", e.onWheel, { passive: !1, capture: !1 }),
            t.removeEventListener("click", e.onClick, { passive: !1, capture: !1 }),
            document.removeEventListener("mousemove", e.onMousemove),
            window.removeEventListener("resize", e.onResize);
        const i = window.visualViewport;
        i && (i.removeEventListener("resize", e.onResize), i.removeEventListener("scroll", e.onResize)),
            document.removeEventListener("visibilitychange", e.onVisibilityChange, !1),
            document.removeEventListener("focus", e.onFocus, !0);
    }
    scale() {
        const e = this.container;
        if (!e) return;
        const t = window.visualViewport,
            i = Math.max(1, (t == null ? void 0 : t.scale) || 1);
        let s = "",
            o = "",
            a = "";
        if (t && i > 1) {
            let r = `${t.offsetLeft}px`,
                l = `${t.offsetTop}px`;
            (s = t.width * i + "px"), (o = t.height * i + "px"), (a = `translate3d(${r}, ${l}, 0) scale(${1 / i})`);
        }
        (e.style.transform = a), (e.style.width = s), (e.style.height = o);
    }
    onClick(e) {
        var t;
        const { container: i, isCompact: s } = this;
        if (!i || this.isClosing()) return;
        !s && this.option("idle") && this.resetIdle();
        const o = e.composedPath()[0];
        if (o.closest(".fancybox-spinner") || o.closest("[data-fancybox-close]"))
            return e.preventDefault(), void this.close(e);
        if (o.closest("[data-fancybox-prev]")) return e.preventDefault(), void this.prev();
        if (o.closest("[data-fancybox-next]")) return e.preventDefault(), void this.next();
        if ((e.type === "click" && e.detail === 0) || Math.abs(e.pageX - fi) > 30 || Math.abs(e.pageY - pi) > 30)
            return;
        const a = document.activeElement;
        if (hi() && a && i.contains(a)) return;
        if (s && ((t = this.getSlide()) === null || t === void 0 ? void 0 : t.type) === "image")
            return void (this.clickTimer
                ? (clearTimeout(this.clickTimer), (this.clickTimer = null))
                : (this.clickTimer = setTimeout(() => {
                      this.toggleIdle(), (this.clickTimer = null);
                  }, 350)));
        if ((this.emit("click", e), e.defaultPrevented)) return;
        let r = !1;
        if (o.closest(".fancybox__content")) {
            if (a) {
                if (a.closest("[contenteditable]")) return;
                o.matches(ft) || a.blur();
            }
            if (hi()) return;
            r = this.option("contentClick");
        } else o.closest(".fancybox__carousel") && !o.matches(ft) && (r = this.option("backdropClick"));
        r === "close"
            ? (e.preventDefault(), this.close(e))
            : r === "next"
              ? (e.preventDefault(), this.next())
              : r === "prev" && (e.preventDefault(), this.prev());
    }
    onWheel(e) {
        const t = e.target;
        let i = this.option("wheel", e);
        t.closest(".fancybox__thumbs") && (i = "slide");
        const s = i === "slide",
            o = [-e.deltaX || 0, -e.deltaY || 0, -e.detail || 0].reduce(function (l, c) {
                return Math.abs(c) > Math.abs(l) ? c : l;
            }),
            a = Math.max(-1, Math.min(1, o)),
            r = Date.now();
        this.pwt && r - this.pwt < 300
            ? s && e.preventDefault()
            : ((this.pwt = r),
              this.emit("wheel", e, a),
              e.defaultPrevented ||
                  (i === "close"
                      ? (e.preventDefault(), this.close(e))
                      : i === "slide" && (Ze(t) || (e.preventDefault(), this[a > 0 ? "prev" : "next"]()))));
    }
    onScroll() {
        window.scrollTo(mi, gi);
    }
    onKeydown(e) {
        if (!this.isTopmost()) return;
        this.isCompact || !this.option("idle") || this.isClosing() || this.resetIdle();
        const t = e.key,
            i = this.option("keyboard");
        if (!i) return;
        const s = e.composedPath()[0],
            o = document.activeElement && document.activeElement.classList,
            a = (o && o.contains("f-button")) || s.dataset.carouselPage || s.dataset.carouselIndex;
        if (
            (t !== "Escape" &&
                !a &&
                Y(s) &&
                (s.isContentEditable ||
                    ["TEXTAREA", "OPTION", "INPUT", "SELECT", "VIDEO"].indexOf(s.nodeName) !== -1)) ||
            (e.key === "Tab" ? I(this.container, St) : D(this.container, St), e.ctrlKey || e.altKey || e.shiftKey)
        )
            return;
        this.emit("keydown", t, e);
        const r = i[t];
        r && typeof this[r] == "function" && (e.preventDefault(), this[r]());
    }
    onResize() {
        const e = this.container;
        if (!e) return;
        const t = this.isCompact;
        e.classList.toggle(ci, t),
            this.manageCaption(this.getSlide()),
            this.isCompact ? this.clearIdle() : this.endIdle(),
            this.scale(),
            this.emit("resize");
    }
    onFocus(e) {
        this.isTopmost() && this.checkFocus(e);
    }
    onMousemove(e) {
        (this.prevMouseMoveEvent = e), !this.isCompact && this.option("idle") && this.resetIdle();
    }
    onVisibilityChange() {
        document.visibilityState === "visible" ? this.checkFocus() : this.endIdle();
    }
    manageCloseBtn(e) {
        const t = this.optionFor(e, "closeButton") || !1;
        if (t === "auto") {
            const s = this.plugins.Toolbar;
            if (s && s.state === ve.Ready) return;
        }
        if (!t || !e.contentEl || e.closeBtnEl) return;
        const i = this.option("tpl.closeButton");
        if (i) {
            const s = se(this.localize(i));
            (e.closeBtnEl = e.contentEl.appendChild(s)), e.el && I(e.el, "has-close-btn");
        }
    }
    manageCaption(e = void 0) {
        var t, i;
        const s = "fancybox__caption",
            o = this.container;
        if (!o) return;
        D(o, Ue);
        const a = this.isCompact || this.option("commonCaption"),
            r = !a;
        if (
            (this.caption && this.stop(this.caption),
            r && this.caption && (this.caption.remove(), (this.caption = null)),
            a && !this.caption)
        )
            for (const u of ((t = this.carousel) === null || t === void 0 ? void 0 : t.slides) || [])
                u.captionEl &&
                    (u.captionEl.remove(),
                    (u.captionEl = void 0),
                    D(u.el, Ue),
                    (i = u.el) === null || i === void 0 || i.removeAttribute("aria-labelledby"));
        if ((e || (e = this.getSlide()), !e || (a && !this.isCurrentSlide(e)))) return;
        const l = e.el;
        let c = this.optionFor(e, "caption", "");
        if (!c)
            return void (
                a &&
                this.caption &&
                this.animate(this.caption, "f-fadeOut", () => {
                    this.caption && (this.caption.innerHTML = "");
                })
            );
        let d = null;
        if (r) {
            if (((d = e.captionEl || null), l && !d)) {
                const u = s + `_${this.id}_${e.index}`;
                (d = document.createElement("div")),
                    I(d, s),
                    d.setAttribute("id", u),
                    (e.captionEl = l.appendChild(d)),
                    I(l, Ue),
                    l.setAttribute("aria-labelledby", u);
            }
        } else
            (d = this.caption),
                d || (d = o.querySelector("." + s)),
                !d &&
                    ((d = document.createElement("div")),
                    (d.dataset.fancyboxCaption = ""),
                    I(d, s),
                    (this.footer || o).prepend(d)),
                I(o, Ue),
                (this.caption = d);
        d &&
            ((d.innerHTML = ""),
            de(c) || typeof c == "number" ? (d.innerHTML = c + "") : c instanceof HTMLElement && d.appendChild(c));
    }
    checkFocus(e) {
        this.focus(e);
    }
    focus(e) {
        var t;
        if (this.ignoreFocusChange) return;
        const i = document.activeElement || null,
            s = (e == null ? void 0 : e.target) || null,
            o = this.container,
            a = (t = this.carousel) === null || t === void 0 ? void 0 : t.viewport;
        if (!o || !a || (!e && i && o.contains(i))) return;
        const r = this.getSlide(),
            l = r && r.state === X.Ready ? r.el : null;
        if (!l || l.contains(i) || o === i) return;
        e && e.cancelable && e.preventDefault(), (this.ignoreFocusChange = !0);
        const c = Array.from(o.querySelectorAll(ft));
        let d = [],
            u = null;
        for (let h of c) {
            const g = !h.offsetParent || !!h.closest('[aria-hidden="true"]'),
                p = l && l.contains(h),
                m = !a.contains(h);
            if (h === o || ((p || m) && !g)) {
                d.push(h);
                const v = h.dataset.origTabindex;
                v !== void 0 && v && (h.tabIndex = parseFloat(v)),
                    h.removeAttribute("data-orig-tabindex"),
                    (!h.hasAttribute("autoFocus") && u) || (u = h);
            } else {
                const v = h.dataset.origTabindex === void 0 ? h.getAttribute("tabindex") || "" : h.dataset.origTabindex;
                v && (h.dataset.origTabindex = v), (h.tabIndex = -1);
            }
        }
        let f = null;
        e
            ? (!s || d.indexOf(s) < 0) &&
              ((f = u || o),
              d.length && (i === me ? (f = d[0]) : (this.lastFocus !== o && i !== ee) || (f = d[d.length - 1])))
            : (f = r && r.type === "image" ? o : u || o),
            f && Kt(f),
            (this.lastFocus = document.activeElement),
            (this.ignoreFocusChange = !1);
    }
    next() {
        const e = this.carousel;
        e && e.pages.length > 1 && e.slideNext();
    }
    prev() {
        const e = this.carousel;
        e && e.pages.length > 1 && e.slidePrev();
    }
    jumpTo(...e) {
        this.carousel && this.carousel.slideTo(...e);
    }
    isTopmost() {
        var e;
        return ((e = z.getInstance()) === null || e === void 0 ? void 0 : e.id) == this.id;
    }
    animate(e = null, t = "", i) {
        if (!e || !t) return void (i && i());
        this.stop(e);
        const s = (o) => {
            o.target === e &&
                e.dataset.animationName &&
                (e.removeEventListener("animationend", s), delete e.dataset.animationName, i && i(), D(e, t));
        };
        (e.dataset.animationName = t), e.addEventListener("animationend", s), I(e, t);
    }
    stop(e) {
        e && e.dispatchEvent(new CustomEvent("animationend", { bubbles: !1, cancelable: !0, currentTarget: e }));
    }
    setContent(e, t = "", i = !0) {
        if (this.isClosing()) return;
        const s = e.el;
        if (!s) return;
        let o = null;
        if (
            (Y(t) ? (o = t) : ((o = se(t + "")), Y(o) || ((o = document.createElement("div")), (o.innerHTML = t + ""))),
            ["img", "picture", "iframe", "video", "audio"].includes(o.nodeName.toLowerCase()))
        ) {
            const a = document.createElement("div");
            a.appendChild(o), (o = a);
        }
        Y(o) && e.filter && !e.error && (o = o.querySelector(e.filter)),
            o && Y(o)
                ? (I(o, "fancybox__content"),
                  e.id && o.setAttribute("id", e.id),
                  s.classList.add(`has-${e.error ? "error" : e.type || "unknown"}`),
                  s.prepend(o),
                  o.style.display === "none" && (o.style.display = ""),
                  getComputedStyle(o).getPropertyValue("display") === "none" &&
                      (o.style.display = e.display || this.option("defaultDisplay") || "flex"),
                  (e.contentEl = o),
                  i && this.revealContent(e),
                  this.manageCloseBtn(e),
                  this.manageCaption(e))
                : this.setError(e, "{{ELEMENT_NOT_FOUND}}");
    }
    revealContent(e, t) {
        const i = e.el,
            s = e.contentEl;
        i &&
            s &&
            (this.emit("reveal", e),
            this.hideLoading(e),
            (e.state = X.Opening),
            (t = this.isOpeningSlide(e) ? (t === void 0 ? this.optionFor(e, "showClass") : t) : "f-fadeIn")
                ? this.animate(s, t, () => {
                      this.done(e);
                  })
                : this.done(e));
    }
    done(e) {
        this.isClosing() ||
            ((e.state = X.Ready),
            this.emit("done", e),
            I(e.el, "is-done"),
            this.isCurrentSlide(e) &&
                this.option("autoFocus") &&
                queueMicrotask(() => {
                    var t;
                    (t = e.panzoom) === null || t === void 0 || t.updateControls(),
                        this.option("autoFocus") && this.focus();
                }),
            this.isOpeningSlide(e) &&
                (D(this.container, xt), !this.isCompact && this.option("idle") && this.setIdle()));
    }
    isCurrentSlide(e) {
        const t = this.getSlide();
        return !(!e || !t) && t.index === e.index;
    }
    isOpeningSlide(e) {
        var t, i;
        return (
            ((t = this.carousel) === null || t === void 0 ? void 0 : t.prevPage) === null &&
            e &&
            e.index === ((i = this.getSlide()) === null || i === void 0 ? void 0 : i.index)
        );
    }
    showLoading(e) {
        e.state = X.Loading;
        const t = e.el;
        t &&
            (I(t, di),
            this.emit("loading", e),
            e.spinnerEl ||
                setTimeout(() => {
                    if (!this.isClosing() && !e.spinnerEl && e.state === X.Loading) {
                        let i = se(Ot);
                        I(i, "fancybox-spinner"), (e.spinnerEl = i), t.prepend(i), this.animate(i, "f-fadeIn");
                    }
                }, 250));
    }
    hideLoading(e) {
        const t = e.el;
        if (!t) return;
        const i = e.spinnerEl;
        this.isClosing()
            ? i == null || i.remove()
            : (D(t, di),
              i &&
                  this.animate(i, "f-fadeOut", () => {
                      i.remove();
                  }),
              e.state === X.Loading && (this.emit("loaded", e), (e.state = X.Ready)));
    }
    setError(e, t) {
        if (this.isClosing()) return;
        const i = new Event("error", { bubbles: !0, cancelable: !0 });
        if ((this.emit("error", i, e), i.defaultPrevented)) return;
        (e.error = t), this.hideLoading(e), this.clearContent(e);
        const s = document.createElement("div");
        s.classList.add("fancybox-error"),
            (s.innerHTML = this.localize(t || "<p>{{ERROR}}</p>")),
            this.setContent(e, s);
    }
    clearContent(e) {
        if (e.state === void 0) return;
        this.emit("clearContent", e), e.contentEl && (e.contentEl.remove(), (e.contentEl = void 0));
        const t = e.el;
        t && (D(t, "has-error"), D(t, "has-unknown"), D(t, `has-${e.type || "unknown"}`)),
            e.closeBtnEl && e.closeBtnEl.remove(),
            (e.closeBtnEl = void 0),
            e.captionEl && e.captionEl.remove(),
            (e.captionEl = void 0),
            e.spinnerEl && e.spinnerEl.remove(),
            (e.spinnerEl = void 0);
    }
    getSlide() {
        var e;
        const t = this.carousel;
        return (
            ((e = t == null ? void 0 : t.pages[t == null ? void 0 : t.page]) === null || e === void 0
                ? void 0
                : e.slides[0]) || void 0
        );
    }
    close(e, t) {
        if (this.isClosing()) return;
        const i = new Event("shouldClose", { bubbles: !0, cancelable: !0 });
        if ((this.emit("shouldClose", i, e), i.defaultPrevented)) return;
        e && e.cancelable && (e.preventDefault(), e.stopPropagation());
        const s = () => {
            this.proceedClose(e, t);
        };
        this.startedFs && Q && Q.isFullscreen() ? Promise.resolve(Q.exit()).then(() => s()) : s();
    }
    clearIdle() {
        this.idleTimer && clearTimeout(this.idleTimer), (this.idleTimer = null);
    }
    setIdle(e = !1) {
        const t = () => {
            this.clearIdle(), (this.idle = !0), I(this.container, "is-idle"), this.emit("setIdle");
        };
        if ((this.clearIdle(), !this.isClosing()))
            if (e) t();
            else {
                const i = this.option("idle");
                i && (this.idleTimer = setTimeout(t, i));
            }
    }
    endIdle() {
        this.clearIdle(),
            this.idle && !this.isClosing() && ((this.idle = !1), D(this.container, "is-idle"), this.emit("endIdle"));
    }
    resetIdle() {
        this.endIdle(), this.setIdle();
    }
    toggleIdle() {
        this.idle ? this.endIdle() : this.setIdle(!0);
    }
    toggleFullscreen() {
        Q &&
            (Q.isFullscreen()
                ? Q.exit()
                : Q.request().then(() => {
                      this.startedFs = !0;
                  }));
    }
    isClosing() {
        return [B.Closing, B.CustomClosing, B.Destroy].includes(this.state);
    }
    proceedClose(e, t) {
        var i, s;
        (this.state = B.Closing), this.clearIdle(), this.detachEvents();
        const o = this.container,
            a = this.carousel,
            r = this.getSlide(),
            l = r && this.option("placeFocusBack") ? r.triggerEl || this.option("triggerEl") : null;
        if (
            (l && (Oi(l) ? Kt(l) : l.focus()),
            o &&
                (D(o, xt),
                I(o, "is-closing"),
                o.setAttribute(yt, "true"),
                this.option("animated") && I(o, wt),
                (o.style.pointerEvents = "none")),
            a)
        ) {
            a.clearTransitions(),
                (i = a.panzoom) === null || i === void 0 || i.destroy(),
                (s = a.plugins.Navigation) === null || s === void 0 || s.detach();
            for (const c of a.slides) {
                (c.state = X.Closing), this.hideLoading(c);
                const d = c.contentEl;
                d && this.stop(d);
                const u = c == null ? void 0 : c.panzoom;
                u && (u.stop(), u.detachEvents(), u.detachObserver()),
                    this.isCurrentSlide(c) || a.emit("removeSlide", c);
            }
        }
        (mi = window.scrollX),
            (gi = window.scrollY),
            window.addEventListener("scroll", this.onScroll),
            this.emit("close", e),
            this.state !== B.CustomClosing
                ? (t === void 0 && r && (t = this.optionFor(r, "hideClass")),
                  t && r
                      ? (this.animate(r.contentEl, t, () => {
                            a && a.emit("removeSlide", r);
                        }),
                        setTimeout(() => {
                            this.destroy();
                        }, 500))
                      : this.destroy())
                : setTimeout(() => {
                      this.destroy();
                  }, 500);
    }
    destroy() {
        var e;
        if (this.state === B.Destroy) return;
        window.removeEventListener("scroll", this.onScroll),
            (this.state = B.Destroy),
            (e = this.carousel) === null || e === void 0 || e.destroy();
        const t = this.container;
        t && t.remove(), Le.delete(this.id);
        const i = z.getInstance();
        i
            ? i.focus()
            : (ee && (ee.remove(), (ee = null)),
              me && (me.remove(), (me = null)),
              D(document.documentElement, ai),
              (() => {
                  if (!Ie) return;
                  const s = document,
                      o = s.body;
                  o.classList.remove(bt), o.style.setProperty(li, ""), s.documentElement.style.setProperty(ri, "");
              })(),
              this.emit("destroy"));
    }
    static bind(e, t, i) {
        if (!Ie) return;
        let s,
            o = "",
            a = {};
        if (
            (e === void 0
                ? (s = document.body)
                : de(e)
                  ? ((s = document.body), (o = e), typeof t == "object" && (a = t || {}))
                  : ((s = e), de(t) && (o = t), typeof i == "object" && (a = i || {})),
            !s || !Y(s))
        )
            return;
        o = o || "[data-fancybox]";
        const r = z.openers.get(s) || new Map();
        r.set(o, a), z.openers.set(s, r), r.size === 1 && s.addEventListener("click", z.fromEvent);
    }
    static unbind(e, t) {
        let i,
            s = "";
        if ((de(e) ? ((i = document.body), (s = e)) : ((i = e), de(t) && (s = t)), !i)) return;
        const o = z.openers.get(i);
        o && s && o.delete(s), (s && o) || (z.openers.delete(i), i.removeEventListener("click", z.fromEvent));
    }
    static destroy() {
        let e;
        for (; (e = z.getInstance()); ) e.destroy();
        for (const t of z.openers.keys()) t.removeEventListener("click", z.fromEvent);
        z.openers = new Map();
    }
    static fromEvent(e) {
        if (e.defaultPrevented || (e.button && e.button !== 0) || e.ctrlKey || e.metaKey || e.shiftKey) return;
        let t = e.composedPath()[0];
        const i = t.closest("[data-fancybox-trigger]");
        if (i) {
            const g = i.dataset.fancyboxTrigger || "",
                p = document.querySelectorAll(`[data-fancybox="${g}"]`),
                m = parseInt(i.dataset.fancyboxIndex || "", 10) || 0;
            t = p[m] || t;
        }
        if (!(t && t instanceof Element)) return;
        let s, o, a, r;
        if (
            ([...z.openers].reverse().find(
                ([g, p]) =>
                    !(
                        !g.contains(t) ||
                        ![...p].reverse().find(([m, v]) => {
                            let b = t.closest(m);
                            return !!b && ((s = g), (o = m), (a = b), (r = v), !0);
                        })
                    )
            ),
            !s || !o || !a)
        )
            return;
        (r = r || {}), e.preventDefault(), (t = a);
        let l = [],
            c = U({}, Mt, r);
        (c.event = e), (c.triggerEl = t), (c.delegate = i);
        const d = c.groupAll,
            u = c.groupAttr,
            f = u && t ? t.getAttribute(`${u}`) : "";
        if (
            ((!t || f || d) && (l = [].slice.call(s.querySelectorAll(o))),
            t && !d && (l = f ? l.filter((g) => g.getAttribute(`${u}`) === f) : [t]),
            !l.length)
        )
            return;
        const h = z.getInstance();
        return h && h.options.triggerEl && l.indexOf(h.options.triggerEl) > -1
            ? void 0
            : (t && (c.startIndex = l.indexOf(t)), z.fromNodes(l, c));
    }
    static fromSelector(e, t, i) {
        let s = null,
            o = "",
            a = {};
        if (
            (de(e)
                ? ((s = document.body), (o = e), typeof t == "object" && (a = t || {}))
                : e instanceof HTMLElement && de(t) && ((s = e), (o = t), typeof i == "object" && (a = i || {})),
            !s || !o)
        )
            return !1;
        const r = z.openers.get(s);
        return !!r && ((a = U({}, r.get(o) || {}, a)), !!a && z.fromNodes(Array.from(s.querySelectorAll(o)), a));
    }
    static fromNodes(e, t) {
        t = U({}, Mt, t || {});
        const i = [];
        for (const s of e) {
            const o = s.dataset || {},
                a = o[Me] || s.getAttribute(Et) || s.getAttribute("currentSrc") || s.getAttribute(Me) || void 0;
            let r;
            const l = t.delegate;
            let c;
            l &&
                i.length === t.startIndex &&
                (r = l instanceof HTMLImageElement ? l : l.querySelector("img:not([aria-hidden])")),
                r || (r = s instanceof HTMLImageElement ? s : s.querySelector("img:not([aria-hidden])")),
                r &&
                    ((c = r.currentSrc || r[Me] || void 0),
                    !c && r.dataset && (c = r.dataset.lazySrc || r.dataset[Me] || void 0));
            const d = { src: a, triggerEl: s, thumbEl: r, thumbElSrc: c, thumbSrc: c };
            for (const u in o) {
                let f = o[u] + "";
                (f = f !== "false" && (f === "true" || f)), (d[u] = f);
            }
            i.push(d);
        }
        return new z(i, t);
    }
    static getInstance(e) {
        return e
            ? Le.get(e)
            : Array.from(Le.values())
                  .reverse()
                  .find((t) => !t.isClosing() && t) || null;
    }
    static getSlide() {
        var e;
        return ((e = z.getInstance()) === null || e === void 0 ? void 0 : e.getSlide()) || null;
    }
    static show(e = [], t = {}) {
        return new z(e, t);
    }
    static next() {
        const e = z.getInstance();
        e && e.next();
    }
    static prev() {
        const e = z.getInstance();
        e && e.prev();
    }
    static close(e = !0, ...t) {
        if (e) for (const i of Le.values()) i.close(...t);
        else {
            const i = z.getInstance();
            i && i.close(...t);
        }
    }
}
Object.defineProperty(z, "version", { enumerable: !0, configurable: !0, writable: !0, value: "5.0.36" }),
    Object.defineProperty(z, "defaults", { enumerable: !0, configurable: !0, writable: !0, value: Mt }),
    Object.defineProperty(z, "Plugins", { enumerable: !0, configurable: !0, writable: !0, value: Po }),
    Object.defineProperty(z, "openers", { enumerable: !0, configurable: !0, writable: !0, value: new Map() });
function ko() {
    z.bind("[data-fancybox]", {});
}
function Oo() {
    document.querySelectorAll(".filters__dropdown .sort-by").forEach(function (e, t) {
        e.addEventListener("click", function () {
            e.classList.toggle("open");
        });
    });
}
function Io() {
    document.addEventListener("click", async function (n) {
        if (n.target.classList.contains("js-qty-update")) {
            n.target.classList.contains("cart-qty") || n.target.classList.contains("ajax-cart")
                ? ((productAvailabliltyNotice = n.target
                      .closest(".cart-item")
                      .querySelector(".js-availability-notice ")),
                  (productAvailablilty = productAvailabliltyNotice.querySelector(
                      ".js-availability-notice .js-availablilty"
                  )))
                : ((productAvailabliltyNotice = n.target
                      .closest('form[action="/cart/add"]')
                      .querySelector(".js-availability-notice ")),
                  (productAvailablilty = productAvailabliltyNotice.querySelector(
                      ".js-availability-notice .js-availablilty"
                  )));
            var e = n.target.closest(".qty-container").querySelector("input"),
                t = parseInt(e.value);
            let i = "increment";
            if (
                (n.target.classList.contains("increase")
                    ? (t++, (i = "increment"))
                    : n.target.classList.contains("decrease") && t >= 1 && (t--, (i = "decrement")),
                (e.value = t),
                t > parseInt(productAvailablilty.textContent)
                    ? productAvailabliltyNotice.classList.remove("disabled")
                    : productAvailabliltyNotice.classList.add("disabled"),
                n.target.classList.contains("ajax-cart"))
            ) {
                if (window.enable_minmax_buys) {
                    let s = e.closest("[data-id]").dataset.id,
                        o = e.closest("[data-handle]").dataset.handle,
                        a = _createFormDataFromObject({
                            id: s,
                            handle: o,
                            quantity: i == "increment" ? 1 : -1,
                            direction: i,
                        }),
                        r = await _canUpdateCart(a);
                    r.amended && (e.value = r.amended);
                }
                if ((_ajaxUpdateCart(n.target), t == 0)) {
                    let s = n.target.closest(".cart-item");
                    s && s.remove();
                }
            }
        }
    });
}
function _o() {
    let n = document.querySelector('[name="pagenumber"]');
    if (!n) return;
    n.addEventListener("keyup", function (t) {
        if (t.key === "Enter" || t.keyCode === 13)
            if (isNaN(n.value)) {
                n.value = 1;
                return;
            } else {
                if (parseInt(n.value) < n.min) {
                    n.value = 1;
                    return;
                }
                if (parseInt(n.value) > n.max) {
                    n.value = n.max;
                    return;
                }
                window.location.href = e(window.location.href, "page", n.value);
            }
    });
    function e(t, i, s) {
        var o = new RegExp("([?&])" + i + "=.*?(&|$)", "i"),
            a = t.indexOf("?") !== -1 ? "&" : "?";
        return t.match(o) ? t.replace(o, "$1" + i + "=" + s + "$2") : t + a + i + "=" + s;
    }
}
function $o() {
    (window._populateSlideOutCart = async function (e, t) {
        let i = document.querySelector("#cart-template").innerHTML,
            s = document.querySelector("#cart-slideout-contents"),
            o = document.querySelector("#cart-slideout-subtotal");
        const a = e.items.map(async function (l, c) {
                let d = i;
                (d = d.replaceAll("#URL#", l.url)),
                    (d = d.replaceAll("#HANDLE#", l.handle)),
                    (d = d.replaceAll("#TITLE#", l.product_title)),
                    (d = d.replaceAll("#FINALPRICE#", Shopify.formatMoney(l.final_line_price))),
                    (d = d.replaceAll("#ID#", l.id)),
                    (d = d.replaceAll("#QTY#", l.quantity)),
                    (d = d.replaceAll("#INDEX#", c + 1)),
                    (d = d.replaceAll("#IMG#", l.image));
                let f = (await _ajaxGetVariantStock(l.handle)).variantStock;
                f &&
                    f[l.id] &&
                    ((d = d.replaceAll("#STOCK#", f[l.id].inventory)),
                    f[l.id].inventory_policy == "continue" ||
                    f[l.id].inventory_management == "null" ||
                    f[l.id].inventory_management == ""
                        ? (d = d.replaceAll("#INVALID#", "invalid"))
                        : (d = d.replaceAll("#INVALID#", "")),
                    f[l.id].inventory <= 10
                        ? (d = d.replaceAll("#DISABLED#", ""))
                        : l.quantity < f[l.id].inventory
                          ? (d = d.replaceAll("#DISABLED#", "disabled"))
                          : (d = d.replaceAll("#DISABLED#", ""))),
                    l.final_line_price < l.original_total_price
                        ? (d = d.replaceAll("#ORIGINAL#", "<s>" + Shopify.formatMoney(l.original_line_price) + "</s>"))
                        : (d = d.replaceAll("#ORIGINAL#", ""));
                let h = "";
                if (
                    (l.selling_plan_allocation
                        ? (d = d.replaceAll(
                              "#SUBSCRIPTION#",
                              '<span class="subscription-option">' +
                                  l.selling_plan_allocation.selling_plan.name +
                                  "</span>"
                          ))
                        : (d = d.replaceAll("#SUBSCRIPTION#", "")),
                    l.total_discount
                        ? (d = d.replaceAll(
                              "#SAVED#",
                              '<span class="item-discount">Bonus Discount -' +
                                  Shopify.formatMoney(l.total_discount) +
                                  " Off!</span>"
                          ))
                        : (d = d.replaceAll("#SAVED#", "")),
                    l.product_has_only_default_variant ||
                        l.options_with_values.forEach((g) => {
                            (h += '<span class="variant-title">'),
                                (h += "<b>" + g.name + ":</b> " + g.value),
                                (h += "</span>");
                        }),
                    (d = d.replace("#OPTIONS#", h)),
                    enable_minmax_buys)
                ) {
                    let g = await _ajaxGetMetafields(l.handle);
                    g &&
                        g.min_buy &&
                        g.max_buy &&
                        ((d = d.replaceAll("#MIN#", g.min_buy)), (d = d.replaceAll("#MAX#", g.max_buy)));
                } else (d = d.replaceAll("#MIN#", 1)), (d = d.replaceAll("#MAX#", 999999));
                return (
                    document.querySelector('.cart-upsell__product[data-id="' + l.id + '"]') && _removeUpsellItem(l.id),
                    n(e),
                    d
                );
            }),
            r = await Promise.all(a);
        (s.innerHTML = r.join("")),
            (o.textContent = Shopify.formatMoney(e.total_price)),
            t && document.body.classList.add("cart-open");
    }),
        (window._ajaxUpdateCart = function (e, t = !1) {
            let i = e.closest("form"),
                s = new FormData(i),
                o = new URLSearchParams(s).toString(),
                a = window.Shopify.routes.root + "cart/update.js?" + o;
            fetch(a, { method: "POST" })
                .then((r) => (r.ok ? r.json() : Promise.reject("Error: Network response was not ok.")))
                .then((r) => {
                    // let l = document.querySelector("#cart-slideout-subtotal");
                    // if (r.total_price && l) {
                    //     if (
                    //         ((l.textContent = Shopify.formatMoney(r.total_price)),
                    //         r.total_price < r.original_total_price)
                    //     ) {
                    //         let d = document.querySelector("#cart-slideout-original");
                    //         d && (d.textContent = Shopify.formatMoney(r.original_total_price));
                    //     }
                    //     let c = document.querySelector("#cart-slideout-discount");
                    //     c && r.total_discount > 0
                    //         ? (c.textContent = "-" + Shopify.formatMoney(r.total_discount))
                    //         : c && (c.textContent = "");
                    // }

                    //to fix item quantity issue on navbar cart icon
                    document.querySelectorAll(".cart-icon span, [data-cartcount]").forEach(function (countEl) {
                            countEl.textContent = r.item_count || 0;
                        });
                    // adding this code to fix minus qty issue on cart slideout


                                let l = document.querySelector("#cart-slideout-subtotal");

                            if (l) {
                                l.textContent = Shopify.formatMoney(r.total_price || 0);

                                let d = document.querySelector("#cart-slideout-original");

                                if (d) {
                                    if (r.total_price < r.original_total_price) {
                                        d.textContent = Shopify.formatMoney(r.original_total_price);
                                    } else {
                                        d.textContent = "";
                                    }
                                }

                                let c = document.querySelector("#cart-slideout-discount");

                                if (c) {
                                    if (r.total_discount > 0) {
                                        c.textContent = "-" + Shopify.formatMoney(r.total_discount);
                                    } else {
                                        c.textContent = "";
                                    }
                                }
                            }
                    r.items &&
                        r.items.forEach((c, d) => {
                            let u = i.querySelector('[data-id="' + c.id + '"]');
                            if (u) {
                                let f = u.querySelector("[data-subtotal]");
                                f && (f.textContent = Shopify.formatMoney(c.line_price));
                            }
                        }),
                        n(r),
                        t !== !1 && t();
                })
                .catch((r) => console.error(r));
        }),
        (window._canUpdateCart = async function (e) {
            let t = await _ajaxGetMetafields(e.get("handle")),
                i = await _getCart(),
                s = !1,
                o = !1,
                a = !1,
                r = !1,
                l = e.get("quantity");
            i.items.forEach((u) => {
                u.id == e.get("id") &&
                    ((r = !0),
                    (!e.get("direction") || e.get("direction") == "increment") &&
                        parseInt(l) + parseInt(u.quantity) > t.max_buy &&
                        d(),
                    (!e.get("direction") || e.get("direction") == "decrement") &&
                        parseInt(l) + parseInt(u.quantity) < t.min_buy &&
                        c());
            }),
                r ||
                    ((!e.get("direction") || e.get("direction") == "increment") && parseInt(l) > t.max_buy && d(),
                    (!e.get("direction") || e.get("direction") == "decrement") && parseInt(l) < t.min_buy && c());
            function c() {
                (a = t.min_buy),
                    (o = !0),
                    _toastAlert(`
				<p>This product has a minimum purchase quantity of ${t.min_buy}.</p>
				<p>Your cart has been updated.</p>
			`);
            }
            function d() {
                (a = t.max_buy),
                    (s = !0),
                    _toastAlert(`
				<p>This product has a maximum quantity limit of ${t.max_buy}.</p>
				<p>Your cart has been updated.
			`);
            }
            return { maxLimit: s, minLimit: o, amended: a, max: t.max_buy, min: t.min_buy };
        }),
        (window._updateCartTotals = async function (e, t = !0) {
            let i = await _getCart();
            document.querySelectorAll(".cart-icon span, [data-cartcount]").forEach(function (o, a) {
                o.textContent = i.item_count;
            }),
                window.enable_slide_cart && _populateSlideOutCart(i, !0),
                t && e && _trackKlaviyoAddToCart(i, e);
        }),
        (window._ajaxAddToCart = function (e, t) {
            let i = new URLSearchParams(e).toString(),
                s = window.Shopify.routes.root + "cart/add.js?" + i;
            e.get("updating") &&
                ((i = "updates[" + e.get("id") + "]=" + e.get("quantity")),
                (s = window.Shopify.routes.root + "cart/update.js?" + i)),
                fetch(s, { method: "POST" })
                    .then((o) => (o.ok ? o.json() : Promise.reject("Error: Network response was not ok.")))
                    .then((o) => {
                        t(o);
                    })
                    .catch((o) => {
                        console.log("Error: " + o), t(!1);
                    });
        }),
        (window._getCart = async function () {
            let e = window.Shopify.routes.root + "cart.js?";
            try {
                const i = await (await fetch(e)).text();
                return JSON.parse(i);
            } catch (t) {
                throw (console.error("Error fetching page:", t), t);
            }
        }),
        (window._checkCartPageQuantities = async function (e, t) {
            let i = await _getCart();
            i.items &&
                (i.items.forEach((o) => {
                    e[o.id] && o.quantity < e[o.id] && s(o.id, e[o.id], o.title);
                }),
                i.items.forEach((o) => {
                    t[o.id] && o.quantity > t[o.id] && s(o.id, t[o.id], o.title);
                }));
            function s(o, a, r) {
                let l = document.querySelector('.section-cart [data-id="' + o + '"] [name="updates[]"]'),
                    c = l.closest("form").querySelector('[name="update"]');
                l && (l.value = a),
                    sessionStorage.setItem(
                        "toastOnLoad",
                        "<p>Updated quantity of product:<br/> <span>" +
                            r +
                            "</span> <br/>as it exceeded the allowed limit per customer.</p>"
                    ),
                    c.click();
            }
        }),
        (window._trackKlaviyoAddToCart = function (e, t) {
            if (!t || (!t.id && !t.ProductID)) return;
            let i = {},
                s = {};
            t.ProductID
                ? (s = t)
                : (s = {
                      Brand: t.vendor,
                      Categories: t.type,
                      ImageURL: t.image,
                      Name: t.product_title,
                      Price: Shopify.formatMoney(t.price),
                      CompareAtPrice: Shopify.formatMoney(t.compare_at_price),
                      ProductID: t.id,
                      URL: window.location.origin + "/products/" + t.handle + "/",
                  }),
                e &&
                    (i = {
                        total_price: e.total_price / 100,
                        $value: e.total_price / 100,
                        total_discount: e.total_discount,
                        original_total_price: e.original_total_price / 100,
                        items: e.items,
                    }),
                (i = Object.assign(i, s)),
                _learnq.push(["track", "Added to Cart", i]);
        }),
        (window._ajaxGetMetafields = async function (e) {
            let t = window.Shopify.routes.root + "products/" + e + "/?view=metafields";
            try {
                return (await (await fetch(t)).json()).metafields;
            } catch (i) {
                throw (console.error("Error fetching page:", i), i);
            }
        }),
        (window._ajaxGetVariantStock = async function (e) {
            let t = window.Shopify.routes.root + "products/" + e + "/?view=metafields";
            try {
                return await (await fetch(t)).json();
            } catch (i) {
                throw (console.error("Error fetching page:", i), i);
            }
        }),
        (window._createFormDataFromObject = function (e) {
            const t = new FormData();
            for (const i in e) e.hasOwnProperty(i) && t.append(i, e[i]);
            return t;
        });
    function n(e) {
        let t = document.querySelectorAll(".free-shipping");
        t.length &&
            t.forEach((i) => {
                let s = i.dataset.threshold,
                    o = i.querySelector("[data-amount-left]"),
                    a = i.querySelector(".free-shipping__progress span");
                (a.style.width = (e.total_price / s) * 100 + "%"),
                    e.total_price >= s
                        ? i.classList.remove("remaining")
                        : ((o.textContent = Shopify.formatMoney(s - e.total_price)), i.classList.add("remaining"));
            });
    }
}


function zo() {
    document.querySelectorAll("[data-cartslide]").forEach((s) => {
        s.addEventListener("click", function (o) {
            o.preventDefault(), document.body.classList.toggle("cart-open");
        });
    }),
        typeof customCart < "u" && _populateSlideOutCart(customCart, !1),
        e();
    function e() {
        let s = document.querySelector(".cart-slideout");
        s &&
            s.addEventListener("click", function (o) {
                if (o.target.classList.contains("remove-item")) {
                    o.preventDefault();
                    let a = o.target.closest(".cart-item"),
                        r = a.querySelector('[type="number"]');
                    (r.value = 0),
                        _ajaxUpdateCart(s.querySelector("form"), function (l) {
                            _updateCartTotals(l, !1);
                        }),
                        a.remove();
                }
            });
    }
    t();
    function t() {
        let s = document.querySelector(".cart-slideout");
        s &&
            s.addEventListener("click", function (o) {
                if (o.target.dataset.upsell) {
                    o.preventDefault(), o.target.closest(".cart-upsell");
                    let a = { id: o.target.dataset.upsell, quantity: 1 },
                        r = _createFormDataFromObject(a);
                    (o.target.textContent = "Adding..."),
                        _ajaxAddToCart(r, function (l) {
                            l.id
                                ? (_updateCartTotals(l), i(o.target.dataset.upsell))
                                : (o.target.textContent = "Unable To Add");
                        });
                }
            });
    }
    function i(s) {
        let o = document.querySelectorAll('.cart-upsell__product[data-id="' + s + '"]');
        if (
            (o.forEach(function (a, r) {
                a.parentNode.remove();
            }),
            !o.length)
        ) {
            document.querySelectorAll(".upsell-slider").forEach(function (r, l) {
                r.remove();
            });
            return;
        }
        document.querySelectorAll('[id*="upsell-slider"]');
        for (const a in window.sliders) window.sliders.hasOwnProperty(a) && window.sliders[a].update();
    }
}
function Do() {
    let n = document.querySelectorAll('form[action="/cart/add"]:not(.disable-ajax)'),
        e = !1;
    document.querySelector(".atc-popup"),
        n.length &&
            (window.enable_ajax_cart
                ? n.forEach((t) => {
                      t.addEventListener("submit", async function (i) {
                          let s = i.target;
                          if (s.getAttribute("action") == "/cart/add" && !s.classList.contains(".disable-ajax"))
                              i.preventDefault();
                          else return !0;
                          if (e) return !1;
                          let o = s.querySelector('[type="submit"]');
                          o && (o.textContent = "Adding..."), (e = !0);
                          let a = new FormData(s);
                          if (window.enable_minmax_buys) {
                              let r = await _canUpdateCart(a);
                              r.amended && (a.set("quantity", r.amended), a.set("updating", !0)),
                                  r.maxLimit && (o.textContent = "Limit Reached");
                          }
                          _ajaxAddToCart(a, function (r) {
                              r.id || r.item_count
                                  ? ((o.textContent = "Added To Cart"),
                                    (e = !1),
                                    _updateCartTotals(r),
                                    document.querySelector("#quickViewModal.is-open") &&
                                        MicroModal.close("quickViewModal"),
                                    window.enable_slide_cart ||
                                        _toastAlert(`
							<p>Item Added To Cart</p>
							<a class="btn" href="/cart">
								View Cart
							</a>
						`))
                                  : o && (o.textContent = "Error Adding, Please Check Your Cart");
                          });
                      });
                  })
                : n.forEach(function (t, i) {
                      t.addEventListener("submit", function (s) {
                          s.preventDefault(),
                              t.closest("#quickViewModal")
                                  ? _trackKlaviyoAddToCart(!1, window.qvItem)
                                  : typeof item < "u" && _trackKlaviyoAddToCart(!1, item),
                              setTimeout(function () {
                                  t.submit();
                              }, 100);
                      });
                  }));
}
function Ro() {
    let n = document.querySelector(".section-producthero"),
        e = document.querySelector(".sticky-add-to-cart"),
        t = document.querySelector(".site-footer");
    if (!n || !e) return;
    function i() {
        window.scrollY >= n.offsetHeight / 2 && window.scrollY < t.offsetTop - window.innerHeight
            ? e.classList.add("in")
            : e.classList.remove("in");
    }
    window.addEventListener("scroll", i);
}
function vi() {
    let n = document.querySelectorAll("[data-quickview]"),
        e = document.querySelector("#quickViewModal"),
        t = e.querySelectorAll("[data-qv]");
    if (!e) return;
    const i = {
        openClass: "is-open",
        onShow: () => {
            document.body.classList.add("modal-open");
        },
        onClose: () => {
            document.body.classList.remove("modal-open");
        },
    };
    n.forEach((a) => {
        a.addEventListener("click", function (r) {
            r.preventDefault(), o(), MicroModal.show("quickViewModal", i);
            let l = a.dataset.quickview,
                c = a.dataset.metainfo,
                d;
            fetch(l)
                .then((u) => u.json())
                .then((u) => {
                    fetch(c)
                        .then((f) => f.json())
                        .then((f) => {
                            (d = Object.assign(u, f)), (window.currentQVItem = d), s(d);
                        })
                        .catch((f) => {
                            console.error("Error fetching page meta:", f);
                        });
                })
                .catch((u) => {
                    console.error("Error fetching page content:", u);
                });
        });
    });
    function s(a) {
        let r = "";
        (window.qvItem = {
            Brand: a.vendor,
            Categories: a.type,
            ImageURL: a.featured_image,
            Name: a.title,
            Price: Shopify.formatMoney(a.price),
            CompareAtPrice: Shopify.formatMoney(a.compare_at_price),
            ProductID: a.id,
            URL: window.location.origin + a.url,
        }),
            t.forEach(function (l) {
                r = "";
                let c = a.variantStock[a.variants[0].id];
                switch (l.dataset.qv) {
                    case "title":
                        l.innerHTML = a.title;
                        break;
                    case "description":
                        l.innerHTML = a.description;
                        break;
                    case "price":
                        l.innerHTML = Shopify.formatMoney(a.price, window.money_format);
                        break;
                    case "handle":
                        l.innerHTML = '<input type="hidden" name="handle" value="' + a.handle + '"/>';
                        break;
                    case "compare":
                        a.compare_at_price > a.price &&
                            (l.innerHTML = Shopify.formatMoney(a.compare_at_price, window.money_format));
                        break;
                    case "subscriptions":
                        a.selling_plan_groups &&
                            a.selling_plan_groups.length > 0 &&
                            (a.selling_plan_groups.forEach((h, g) => {
                                (r += '<div class="subscriptions__group">'),
                                    (r += '<p class="h4">' + h.name + "</p>"),
                                    h.selling_plans.forEach((p, m) => {
                                        (r += '<label for="plan-qv-' + g + "-" + m + '">'),
                                            (r +=
                                                '<input type="radio" id="plan-qv-' +
                                                g +
                                                "-" +
                                                m +
                                                '" name="selling_plan" value="' +
                                                p.id +
                                                '" ' +
                                                (g == 1 ? "checked" : "") +
                                                "/>"),
                                            (r += p.name),
                                            (r += "</label>");
                                    }),
                                    (r += "</div>");
                            }),
                            (l.innerHTML = r));
                        break;
                    case "variants":
                        if (a.available && a.variants.length > 1) {
                            r += '<select id="product-selectors-qv" name="id">';
                            for (let h = 0; h < a.variants.length; h++)
                                a.variants[h].available
                                    ? ((r += '<option  value="' + a.variants[h].id + '">'),
                                      (r += a.variants[h].title),
                                      (r += "</option>"))
                                    : (r +=
                                          "<option disabled>" +
                                          a.variants[h].title +
                                          " - " +
                                          inventory_text.sold_out +
                                          "</option>");
                            r += "</select>";
                        } else r += '<input name="id" value="' + a.variants[0].id + '" type="hidden" />';
                        l.innerHTML = r;
                        for (let h = 0; h < a.options.length; h++) a.options[h] = a.options[h].name;
                        break;
                    case "quantity":
                        if (a.available) {
                            let h = 1,
                                g = 999999;
                            a.metafields != !1 && ((h = a.metafields.min_buy), (g = a.metafields.max_buy)),
                                (r += '<div class="product-quantity">'),
                                (r += `<label for="Quantity-qv" class="sr-only">Qty</label>
										<div class="d-flex qty-container">
											<span class="qty-btn decrease js-qty-update quickview-qty">-</span>
											<input type="number" id="Quantity-qv" name="quantity" data-qtt-id value="1" min="${h}" max="${g}" >
											<span class="qty-btn increase js-qty-update quickview-qty">+</span>
										</div>`);
                            let p = "",
                                m = "";
                            c.inventory >= 5
                                ? ((p = inventory_text.in_stock_long), (m = "instock"))
                                : c.inventory > 0
                                  ? ((p = inventory_text.low_stock_long), (m = "lowstock"))
                                  : c.inventory_management != "null"
                                    ? ((p = inventory_text.sold_out_long), (m = "outofstock"))
                                    : c.inventory_management == "null" && ((p = ""), (m = "")),
                                p != "" &&
                                    m != "" &&
                                    (r += `<span class="stock-indicator ${m}">
											${p}		
										</span>`),
                                (r += "</div>");
                        }
                        l.innerHTML = r;
                        break;
                    case "availability":
                        if (a.available) {
                            let h = "";
                            (c.inventory_policy == "continue" || c.inventory_management == "null") && (h = "invalid"),
                                (r += `<p class="js-availability-notice quickview-availability disabled ${h} ">Only <strong class="js-availablilty">${c.inventory}</strong> ${a.title} `),
                                a.variants.length > 1 && (r += '(<span class="js-varient"></span>)'),
                                (r += " available.</p>");
                        }
                        l.innerHTML = r;
                        break;
                    case "action":
                        a.available
                            ? ((r += '<button class="btn btn-primary" type="submit" name="add" id="qv-add-to-cart">'),
                              (r += inventory_text.add_to_cart),
                              (r += "</button>"))
                            : (r +=
                                  '<button class="btn btn-primary" disabled name="add" type="submit">' +
                                  inventory_text.sold_out +
                                  "</button>"),
                            (l.innerHTML = r);
                        break;
                    case "images":
                        a.images &&
                            ((r +=
                                '<div class="swiper-container swiper initializing" data-slidestoshow="1" id="product-slider-qv">'),
                            (r += '<div class="swiper-wrapper">'),
                            a.images.forEach((h, g) => {
                                let p = "";
                                a.variants.forEach((m, v) => {
                                    m.featured_image && m.featured_image.src == h && (p = m.id);
                                }),
                                    (r += '<div class="swiper-slide" data-variant-id="' + p + '">'),
                                    (r += '<img src="' + h + '"/>'),
                                    (r += "</div>");
                            }),
                            (r += "</div>"),
                            (r += "</div>"),
                            (r +=
                                '<div class="swiper-container swiper control initializing"  id="product-slider-nav-qv">'),
                            (r += '<div class="swiper-wrapper">'),
                            a.images.forEach((h, g) => {
                                (r += '<div class="swiper-slide">'), (r += '<img src="' + h + '"/>'), (r += "</div>");
                            }),
                            (r += "</div>"),
                            (r += "</div>"),
                            (r += '<div class="swiper-nav initializing">'),
                            (r += '<div class="swiper-button-prev swiper-prev"></div>'),
                            (r += '<div class="swiper-button-next swiper-next"></div>'),
                            (r += "</div>")),
                            (l.innerHTML = r);
                        let d = e.querySelector("#product-slider-qv"),
                            u = e.querySelector("#product-slider-nav-qv"),
                            f = e.querySelector(".swiper-nav");
                        d &&
                            (window.initSlider(d, 0, ".modal"),
                            setTimeout(function () {
                                d.classList.remove("initializing"),
                                    f.classList.remove("initializing"),
                                    u.classList.remove("initializing");
                            }, 400));
                        break;
                }
            }),
            a.variants.length > 1 && initProductScript(a, "product-selectors-qv", e),
            e.classList.remove("loading");
    }
    function o() {
        t.forEach(function (a) {
            a.innerHTML = "";
        }),
            e.classList.add("loading");
    }
}
function qo() {
    let n = document.querySelectorAll(".filters__title"),
        e = document.querySelector("form.filters");
    if (!n.length || !e) return;
    n.forEach((i, s) => {
        i.addEventListener("click", function () {
            i.parentNode.classList.toggle("open");
        });
    }),
        document.querySelectorAll(".filters input").forEach(function (i, s) {
            i.addEventListener("change", function () {
                e.submit();
            });
        });
}
function Fo() {
    let n = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ],
        e = new Date(),
        t = n[e.getMonth()],
        i = e.getFullYear(),
        s = document.querySelectorAll(".dyn-month"),
        o = document.querySelectorAll(".dyn-year");
    s.forEach(function (a, r) {
        a.textContent = t;
    }),
        o.forEach(function (a, r) {
            a.textContent = i;
        });
}
function No() {
    class n extends HTMLElement {
        constructor() {
            super(),
                (this.input = this.querySelector('input[type="search"]')),
                (this.predictiveSearchResults = this.querySelector("#predictive-search")),
                this.input.addEventListener("focus", this.onFocus.bind(this)),
                this.input.form.addEventListener("focusout", this.onFocusOut.bind(this)),
                this.input.addEventListener(
                    "input",
                    this.debounce((a) => {
                        this.onChange(a);
                    }, 200).bind(this)
                );
        }
        onChange() {
            const a = this.input.value.trim();
            if (a.length == 0) {
                this.resetResults();
                return;
            }
            if (!a.length) {
                this.onFocusOut();
                return;
            }
            this.getSearchResults(a);
        }
        getSearchResults(a) {
            this.loadingState(!0),
                fetch(
                    `/search/suggest?q=${a}&section_id=predictive-search&resources[type]=product,page,article,collection,query`
                )
                    .then((r) => {
                        if (!r.ok) {
                            var l = new Error(r.status);
                            throw (this.onFocusOut(), l);
                        }
                        return r.text();
                    })
                    .then((r) => {
                        const l = new DOMParser()
                            .parseFromString(r, "text/html")
                            .querySelector("#shopify-section-predictive-search").innerHTML;
                        this.predictiveSearchResults.innerHTML = l;
                    })
                    .catch((r) => {
                        throw (this.onFocusOut(), r);
                    });
        }
        onFocus() {
            document.body.classList.add("search-focus"), this.onChange();
        }
        onFocusOut(a) {
            a && (this.input.form.contains(a.relatedTarget) || document.body.classList.remove("search-focus"));
        }
        resetResults() {
            this.predictiveSearchResults.innerHTML = "";
        }
        loadingState(a = !0) {
            a
                ? (this.predictiveSearchResults.innerHTML = `
					<div class="loading-ring"><div></div><div></div><div></div><div></div></div>
				`)
                : (this.predictiveSearchResults.innerHTML = "");
        }
        debounce(a, r) {
            let l;
            return (...c) => {
                clearTimeout(l), (l = setTimeout(() => a.apply(this, c), r));
            };
        }
    }
    customElements.define("main-search", n);
    function e(o, a) {
        o.classList.toggle(a);
    }
    let t = document.querySelectorAll("body"),
        i = document.querySelectorAll(".search-toggle"),
        s = document.querySelector(".search-form input#Search");
    i.forEach(function (o) {
        o.addEventListener("click", function () {
            t.forEach(function (a) {
                e(a, "search-focus"), s.focus();
            });
        });
    });
}
function jo() {
    let n = !1;
    (window._toastAlert = function (e) {
        let t = document.querySelector(".toast-alert");
        t &&
            (t.classList.remove("active"),
            (t.innerHTML = e),
            t.classList.add("active"),
            clearTimeout(n),
            (n = setTimeout(function () {
                t.classList.remove("active");
            }, 6e3)));
    }),
        (window._toastOnLoad = function () {
            sessionStorage.getItem("toastOnLoad") &&
                (_toastAlert(sessionStorage.getItem("toastOnLoad")), sessionStorage.removeItem("toastOnLoad"));
        }),
        _toastOnLoad();
}
function Bo() {
    if (typeof _upsellProducts < "u" && _upsellProducts.length > 0) {
        let i = document.querySelectorAll(".cart-upsell"),
            s = document.querySelector("#cart-upsell-tmpl").innerHTML,
            o = document.querySelector("#cart-upsell-slide-tmpl").innerHTML,
            a = document.querySelector("#cart-subs-tmpl").innerHTML;
        i.forEach(function (r) {
            let l = s.replace("#HEADING#", _upsellHeading),
                c = "";
            _upsellProducts.forEach((u) => {
                let f = o
                        .replaceAll("#ID#", u.id)
                        .replaceAll("#URL#", u.url)
                        .replaceAll("#IMAGE#", u.variants[0].display_image)
                        .replaceAll("#TITLE#", u.title)
                        .replaceAll("#HERO#", u.hero)
                        .replaceAll("#GUARANTEE#", u.guarantee)
                        .replaceAll("#HANDLE#", u.url.split("/").pop()),
                    h = "",
                    g = "",
                    p = u.price;
                const m = u.selling_plan_groups && u.selling_plan_groups.length > 0;
                let v = u.variants.filter(
                    (b) =>
                        b.available.trim() === "true" &&
                        (!m || (b.selling_plan_allocations && b.selling_plan_allocations.length > 0))
                );
                if (v.length > 1)
                    (h = '<label class="sr-only">Variants</label><select id="variant-selectors" class="sr-only">'),
                        v.forEach((b) => {
                            h += `<option value="${b.id}" data-variantprice="${b.price}" data-image="${b.featured_image || ""}">${b.title} - ${Shopify.formatMoney(b.price)}</option>`;
                        }),
                        (h += "</select>");
                else if (v.length === 1) {
                    const b = v[0];
                    (h = `<input type="hidden" name="id" value="${b.id}">`), (p = b.price);
                } else h = "<span>No options available</span>";
                u.options &&
                    u.options.length > 0 &&
                    u.options.forEach((b) => {
                        const S = b.values.filter((y) =>
                            u.variants.some(
                                (x) =>
                                    x[`option${u.options.indexOf(b) + 1}`] === y &&
                                    x.available.trim() === "true" &&
                                    (!m || (m && x.selling_plan_allocations.length > 0))
                            )
                        );
                        S.length > 1
                            ? ((h += `<label class="sr-only">${b.name}</label><select class="variant-option-selector" data-option="${b.name}"><option selected value="">Choose ${b.name}</option>`),
                              S.forEach((y) => {
                                  var C;
                                  const x = u.variants.find(
                                      (E) =>
                                          E[`option${u.options.indexOf(b) + 1}`] === y &&
                                          E.available.trim() === "true" &&
                                          (!m || (m && E.selling_plan_allocations.length > 0))
                                  );
                                  x &&
                                      (h += `<option value="${x.id}" data-value="${y}" data-variantprice="${x.price}" data-image="${((C = x.featured_image) == null ? void 0 : C.src) || ""}">${y}</option>`);
                              }),
                              (h += "</select>"))
                            : S.length === 1 &&
                              (h += `<label class="sr-only">${b.name}</label><span class="single-option sr-only">${S[0]}</span>`);
                    }),
                    m &&
                        u.selling_plan_groups.forEach((b) => {
                            b.selling_plans.forEach((S) => {
                                var E, P;
                                let y = a
                                    .replaceAll("#SELLING_PLAN_NAME#", S.name)
                                    .replaceAll("#PLAN_NAME#", S.name)
                                    .replaceAll("#SELLING_PLAN_ID#", S.id)
                                    .replaceAll("#COMPARE_AT_PRICE#", Shopify.formatMoney(p))
                                    .replaceAll("#PRICE#", Shopify.formatMoney(S.price))
                                    .replaceAll("#DESCRIPTION#", S.description)
                                    .replaceAll("#BENEFIT1#", ((E = b.options[0]) == null ? void 0 : E.name) || "")
                                    .replaceAll("#BENEFIT2#", S.description || "");
                                const x = new Set([S.description, (P = b.options[0]) == null ? void 0 : P.name]),
                                    C = Array.from(x)
                                        .filter(Boolean)
                                        .map((_) => `<li>${_}</li>`)
                                        .join("");
                                (y = y.replace('<ul class="mb-0">#BENEFITS#</ul>', `<ul class="mb-0">${C}</ul>`)),
                                    (g += y);
                            });
                        }),
                    (f = f.replace("#VARIANT_OPTIONS#", h)),
                    (f = f.replace("#VARIANT_SUBSCRIPTIONS#", g)),
                    m &&
                        u.selling_plan_groups[0].selling_plans.length > 0 &&
                        (p = u.selling_plan_groups[0].selling_plans[0].price),
                    (f = f.replace("#PRICE#", Shopify.formatMoney(p))),
                    (c += f);
            }),
                (l = l.replace("#SLIDES#", c)),
                (r.innerHTML = l),
                r.querySelectorAll(".cart-upsell__product__wrap").forEach((u) => {
                    const f = u.querySelector("#variant-selectors");
                    if (!f) return;
                    const h = u.querySelectorAll(".variant-option-selector"),
                        g = u.querySelector(".btn"),
                        p = u.querySelector(".cart-upsell__info__price"),
                        m = u.querySelector(".cart-upsell__image img"),
                        v = u.querySelector('input[name="id"]');
                    h.forEach((b) => {
                        b.addEventListener("change", () => {
                            n(f, h, v), e(g, f, p), t(m, f);
                        });
                    }),
                        f.addEventListener("change", () => {
                            e(g, f, p), t(m, f);
                        });
                });
        });
    } else console.log("No upsell products available.");
    function n(i, s, o) {
        const a = Array.from(s).map((l) => l.options[l.selectedIndex].dataset.value),
            r = Array.from(i.options).find((l) => a.every((c) => l.text.includes(c)));
        r &&
            ((i.value = r.value),
            (i.dataset.variantprice = r.dataset.variantprice),
            (i.dataset.image = r.dataset.image),
            (o.value = r.value));
    }
    function e(i, s, o) {
        const a = s.value,
            r = s.dataset.variantprice;
        (i.dataset.upsell = a), (o.textContent = Shopify.formatMoney(r));
    }
    function t(i, s) {
        const o = s.dataset.image;
        if (o) {
            const a = o.split("?")[0];
            (i.src = a), (i.srcset = `${a}?width=352 352w, ${a}?width=832 832w, ${a}?width=1000 1000w`);
        }
    }
}
function Ho() {
    document.querySelectorAll("select.variant-option-selector").forEach(function (n) {
        const e = n.children.length;
        n.classList.add("select-hidden");
        const t = document.createElement("div");
        t.classList.add("select"), n.parentNode.insertBefore(t, n), t.appendChild(n);
        const i = document.createElement("div");
        i.classList.add("select-styled"), (i.textContent = n.options[0].textContent), t.appendChild(i);
        const s = document.createElement("ul");
        s.classList.add("select-options"), t.appendChild(s);
        for (let a = 0; a < e; a++) {
            const r = document.createElement("li");
            (r.textContent = n.options[a].textContent),
                r.setAttribute("rel", n.options[a].value),
                n.options[a].selected && r.classList.add("is-selected"),
                s.appendChild(r);
        }
        const o = s.children;
        i.addEventListener("click", function (a) {
            a.stopPropagation(),
                document.querySelectorAll("div.select-styled.active").forEach(function (r) {
                    r !== i && (r.classList.remove("active"), (r.nextElementSibling.style.display = "none"));
                }),
                i.classList.toggle("active"),
                (s.style.display = i.classList.contains("active") ? "block" : "none");
        }),
            Array.from(o).forEach(function (a) {
                a.addEventListener("click", function (r) {
                    r.stopPropagation(),
                        (i.textContent = this.textContent),
                        i.classList.remove("active"),
                        (n.value = this.getAttribute("rel"));
                    const l = new Event("change", { bubbles: !0 });
                    n.dispatchEvent(l),
                        Array.from(o).forEach(function (c) {
                            c.classList.remove("is-selected");
                        }),
                        this.classList.add("is-selected"),
                        (s.style.display = "none");
                });
            }),
            document.addEventListener("click", function () {
                i.classList.remove("active"), (s.style.display = "none");
            });
    });
}
window.initProductScript = function (n, e, t) {
    const i = document.querySelectorAll(".tub-discounts"),
        s = new Event("qtyChanged", { bubbles: !0, cancelable: !0 });
    function o(y) {
        y.forEach(function (x, C) {
            x.classList.remove("disabled"), x.removeAttribute("disabled");
        });
    }
    function a(y) {
        y.forEach(function (x, C) {
            x.classList.add("disabled"),
                (x.textContent = window.inventory_text.sold_out),
                x.setAttribute("disabled", "disabled");
        });
    }
    function r(y, x) {
        y.forEach(function (C, E) {
            let P = C.closest("form");
            if (P.dataset.upsell) return;
            let _ = P.querySelector('[name="id"]');
            P && (_ = P.querySelector('[name="id"]')), _ && (_.value = x.id);
        });
    }
    function l(y, x) {
        y &&
            (y.classList.remove("instock"),
            y.classList.remove("lowstock"),
            y.classList.remove("outofstock"),
            x == "lowstock"
                ? (y.classList.add("lowstock"), (y.textContent = inventory_text.low_stock_long))
                : x == "instock"
                  ? (y.classList.add("instock"), (y.textContent = inventory_text.in_stock_long))
                  : x == "outofstock"
                    ? (y.classList.add("outofstock"), (y.textContent = inventory_text.sold_out_long))
                    : (y.textContent = ""));
    }
    var c = function (y, x) {
        var C = t.querySelector('button[name="add"]:not([data-upsell="true"])'),
            E = t.querySelectorAll(
                'button[name="add"]:not(#product-add-to-cart):not([data-upsell="true"], a.product-tile'
            );
        (productPrices = t.querySelectorAll("[data-price]")),
            (comparePrices = t.querySelectorAll("[data-compare] s")),
            (sellingPlanInput = t.querySelector('[name="selling_plan"]')),
            (stockIndicator = t.querySelector(".stock-indicator")),
            (quantityInput = t.querySelector('input[name="quantity"]')),
            (productAvailabilityNotice = t.querySelector(".js-availability-notice "));
        var P, _;
        if (
            (productAvailabilityNotice &&
                ((P = productAvailabilityNotice.querySelector(".js-availablilty")),
                (_ = productAvailabilityNotice.querySelector(".js-varient"))),
            !!C)
        )
            if (
                ((quantityInput.value = 1),
                productAvailabilityNotice == null || productAvailabilityNotice.classList.add("disabled"),
                y)
            ) {
                if ((r(E, y), typeof sliders < "u" && sliders["product-slider"])) {
                    var T = t.querySelector('[data-variant-id="' + y.id + '"]');
                    if (T && T.dataset.slideIndex) {
                        var w = parseInt(T.dataset.slideIndex) + 1;
                        sliders["product-slider"].slideTo(w);
                    }
                }
                var k;
                if (
                    (t != document && t.classList.contains("modal") ? (k = currentQVItem) : (k = n),
                    k.variantStock[y.id])
                )
                    var A = k.variantStock[y.id].inventory;
                P && (P.textContent = A),
                    _ && (_.textContent = y.title),
                    y.available
                        ? (A >= 5
                              ? (l(stockIndicator, "instock"),
                                productAvailabilityNotice == null ||
                                    productAvailabilityNotice.classList.remove("invalid"))
                              : A > 0
                                ? (l(stockIndicator, "lowstock"),
                                  productAvailabilityNotice == null ||
                                      productAvailabilityNotice.classList.remove("invalid"))
                                : y.inventory_management != null
                                  ? (l(stockIndicator, "outofstock"),
                                    productAvailabilityNotice == null ||
                                        productAvailabilityNotice.classList.add("invalid"))
                                  : y.inventory_management == null &&
                                    (l(stockIndicator, !1),
                                    productAvailabilityNotice == null ||
                                        productAvailabilityNotice.classList.add("invalid")),
                          o([C]),
                          o(E),
                          A > 0 || y.inventory_management == null
                              ? (C.textContent = window.inventory_text.add_to_cart)
                              : (C.textContent = window.inventory_text.pre_order))
                        : ((C.textContent = window.inventory_text.sold_out),
                          a([C]),
                          a(E),
                          l(stockIndicator, "outofstock"),
                          productAvailabilityNotice == null || productAvailabilityNotice.classList.add("invalid")),
                    productPrices.forEach(function (O) {
                        O.hasAttribute("toggle-price")
                            ? (O.innerHTML = "<s>" + Shopify.formatMoney(y.price, window.money_format) + "</s>")
                            : (O.innerHTML = Shopify.formatMoney(y.price, window.money_format));
                    }),
                    y.compare_at_price > y.price
                        ? comparePrices.forEach(function (O) {
                              (O.innerHTML = Shopify.formatMoney(y.compare_at_price, window.money_format)),
                                  (O.style.display = "block");
                          })
                        : comparePrices.forEach(function (O) {
                              O.style.display = "none";
                          });
            } else
                (C.textContent = window.inventory_text.sold_out),
                    a([C]),
                    a(E),
                    l(stockIndicator, "outofstock"),
                    productAvailabilityNotice == null || productAvailabilityNotice.classList.add("invalid");
    };
    if (document.querySelector("#" + e)) {
        new Shopify.OptionSelectors(e, { product: n, onVariantSelected: c, enableHistoryState: !1 }),
            t.querySelectorAll(".selector-wrapper").forEach((E, P) => {
                let _ = E.querySelector("label"),
                    T = "",
                    w = !!(_ != null && _.closest(".quickview"));
                if (
                    (_
                        ? (T = u(_.textContent))
                        : ((T = document.querySelector("#product-selectors").dataset.label),
                          (_ = document.createElement("label")),
                          (_.textContent = T),
                          (T = u(T))),
                    _)
                ) {
                    let k = E.querySelector("select"),
                        A = Array.from(k.querySelectorAll("option"));
                    A.length <= 1 && E.classList.add("sr-only");
                    let O = `<div class="radio-selector"><label for="${T}" class="labels">${T}:</label>`;
                    A.forEach(($, j) => {
                        let G = "";
                        variant_colours &&
                            variant_colours.forEach((Qe) => {
                                let _t = Qe.split(":"),
                                    Xi = _t[0];
                                $.textContent === Xi && (G = `color:${_t[1]};`);
                            });
                        let F = $.selected ? "checked" : "",
                            q = n.variants.find((Qe) => Qe.title === $.textContent),
                            ce =
                                q && q.featured_image && q.featured_image.src
                                    ? q.featured_image.src
                                    : n.featured_image && n.featured_image.src
                                      ? n.featured_image.src
                                      : "";
                        q ? q.title : n.title;
                        let te = q ? Shopify.formatMoney(q.price, window.money_format) : "",
                            Se =
                                q && q.compare_at_price > 0
                                    ? Shopify.formatMoney(q.compare_at_price, window.money_format)
                                    : "";
                        const It = window.Shopify.currency.active,
                            Gi = q && q.compare_at_price > 0 ? 100 - (q.price / q.compare_at_price) * 100 : "",
                            Wi = q && q.compare_at_price > 0 ? Gi + "%" : "";
                        (O += '<div class="radio-selector__option">'),
                            (O += `<input id="${T}-${j}${w ? "-qv" : ""}" name="${T}-radio" ${F} type="radio" value="${$.value}" price="${te}" compare="${Se}">`),
                            (O += `<label style="${G}" for="${T}-${j}${w ? "-qv" : ""}" class="${u($.textContent)}">`),
                            (O += '<div class="wrap">'),
                            ce && (O += `<img class="variant-image" src="${ce}" alt="${$.textContent}" >`),
                            (O += `<span>${$.textContent}`),
                            Se && (O += `<br><span savings>You Save: ${Wi}  </span>`),
                            (O += "</span>"),
                            (O += "</div>"),
                            (O += `<span class="variant-price">${te} ${It}`),
                            Se && (O += `<s>${Se} ${It}</s>`),
                            (O += "</span>"),
                            (O += "</label>"),
                            (O += "</div>");
                    }),
                        (O += "</div>"),
                        E.insertAdjacentHTML("afterbegin", O);
                }
                E.classList.add("type-" + T);
            });
        let x = document.querySelectorAll(".subscriptions input"),
            C = document.querySelectorAll(".sub-sticky");
        x.forEach((E) => {
            E.checked &&
                C.forEach((P) => {
                    P.value = E.value;
                }),
                E.addEventListener("change", () => {
                    E.checked &&
                        C.forEach((P) => {
                            P.value = E.value;
                        });
                });
        }),
            d();
    }
    function d() {
        t.querySelectorAll(".radio-selector").forEach((x) => {
            x.querySelectorAll('input[type="radio"]').forEach((E) => {
                E.addEventListener("change", function () {
                    let P = this.value,
                        _ = this.closest(".selector-wrapper").querySelector("select");
                    _ &&
                        ((_.value = P),
                        _.dispatchEvent(new Event("change")),
                        document
                            .querySelector("#product-selectors")
                            .dispatchEvent(new Event("change", { bubbles: !0 })));
                });
            });
        });
    }
    function u(y) {
        return y.toLowerCase().replace(/\s+/g, "-").trim();
    }
    function f() {
        i.length > 0 &&
            i.forEach((y) => {
                const x = y.querySelectorAll(".tubs-container-discounts");
                x.forEach((C) => {
                    C.addEventListener("click", (E) => {
                        const P = t.querySelector('input[name="quantity"]');
                        h(x), C.classList.add("active"), (P.value = parseInt(C.dataset.tub)), document.dispatchEvent(s);
                    });
                });
            });
    }
    function h(y) {
        const x = t.querySelector('input[name="quantity"]');
        y.forEach((C) => {
            C.classList.remove("active");
        }),
            (x.value = 1),
            document.dispatchEvent(s);
    }
    function g(y, x = !1) {
        const C = document.querySelector("form#add-to-cart");
        let E = 0;
        const P = document.querySelector(".template-productbundles") !== null;
        if (x && !P)
            switch (!0) {
                case y >= 4:
                    E = 20;
                    break;
                case y >= 3:
                    E = 15;
                    break;
                case y >= 2:
                    E = 10;
                    break;
            }
        return P && (E = 25), m(E), parseFloat(C.dataset.currentPrice ?? n.price) * y * (E !== 0 ? (100 - E) / 100 : 1);
    }
    function p(y = !1, x = !1) {
        document.addEventListener("qtyChanged", (C) => {
            b();
        }),
            document.addEventListener("sealsubs:selling_plan_changed", (C) => {
                b();
            });
    }
    function m(y) {
        if (document.querySelector(".template-productbundles")) return;
        const x = document.querySelectorAll('.update-discount, [data-qv="price"]'),
            C = document.getElementById("savings");
        C &&
            (y > 0
                ? C.classList.remove("no-savings")
                : y === 0 && !C.classList.contains("no-savings") && C.classList.add("no-savings"),
            x.length > 0 &&
                x.forEach((E) => {
                    E.innerHTML = `${y}%`;
                }));
    }
    function v() {
        const y = document.querySelector("form#add-to-cart"),
            x = document.querySelector('.tubs-container-discounts[data-tub="2"] .text-price'),
            C = document.querySelector('.tubs-container-discounts[data-tub="3"] .text-price'),
            E = document.querySelector('.tubs-container-discounts[data-tub="4"] .text-price');
        x && (x.innerHTML = "$" + ((y.dataset.currentPrice * 2 * (90 / 100)) / 100).toFixed(2).toString()),
            C && (C.innerHTML = "$" + ((y.dataset.currentPrice * 3 * (85 / 100)) / 100).toFixed(2).toString()),
            E && (E.innerHTML = "$" + ((y.dataset.currentPrice * 4 * (80 / 100)) / 100).toFixed(2).toString());
    }
    function b() {
        setTimeout(() => {
            const y = t.querySelectorAll("[data-price], .sls-one-time-price .sls-price .money"),
                x = t.querySelector("[data-price-afterpay]"),
                C = t.querySelectorAll(".sls-selling-plan-group-price .sls-price .money"),
                E = document.querySelectorAll("[data-compare], [data-compare-qv]"),
                P = t.querySelector('input[name="quantity"]'),
                _ = g(P.value, !0);
            y.forEach(function (T) {
                T.innerHTML = Shopify.formatMoney(_, window.money_format);
            }),
                E.forEach((T) => {
                    T.innerHTML = `<s>${Shopify.formatMoney(parseFloat(n.price) * parseFloat(P.value), window.money_format)}</s>`;
                }),
                x && (x.innerHTML = Shopify.formatMoney(_ / 4, window.money_format)),
                v(),
                C.forEach((T) => {
                    T.innerHTML = Shopify.formatMoney(_ * 0.9, window.money_format);
                });
        }, 200);
    }
    document.querySelector(".buy-save") ? (f(), p(!0, !0)) : p(!1, !1);
    const S = document.querySelectorAll(".klaviyo-bis-trigger");
    if (S) {
        const y = new MutationObserver((C) => {
                C.forEach((E) => {
                    if (E.type === "attributes") {
                        const P = E.target,
                            _ = window.getComputedStyle(P).display;
                        console.log("Display style:", _), console.log(_ === "none" ? "K hide" : "K Visible");
                    }
                });
            }),
            x = { attributes: !0, attributeFilter: ["style", "class"] };
        S.forEach((C) => {
            y.observe(C, x);
        });
    }
    Bo(), Ho();
};
function Vo() {
    const n = document.querySelectorAll(".tabs__nav__item button"),
        e = document.querySelectorAll(".compare-table");
    function t() {
        e.forEach((s) => {
            s.style.display = "none";
        }),
            n.forEach((s) => {
                s.setAttribute("aria-selected", "false");
            });
    }
    function i(s) {
        const o = s.getAttribute("href").substring(1),
            a = document.getElementById(o);
        a && ((a.style.display = ""), s.setAttribute("aria-selected", "true"));
    }
    n.forEach((s) => {
        s.addEventListener("click", (o) => {
            o.preventDefault(), t(), i(o.target);
        });
    }),
        t(),
        n.length > 0 && i(n[0]);
}
function Go() {
    (window._playVideo = function (e) {
        let t = e.dataset.videoId,
            i = "";
        t
            ? (e.classList.contains("vimeo")
                  ? (i =
                        '<iframe src="https://player.vimeo.com/video/' +
                        t +
                        '?title=0&byline=0&portrait=0?&autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>')
                  : e.classList.contains("wistia")
                    ? ((i =
                          '<iframe src="https://fast.wistia.net/embed/iframe/' +
                          t +
                          '?controlsVisibleOnLoad=true&autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>'),
                      _wq.push({
                          id: t,
                          onReady: function (s) {
                              s.play();
                          },
                      }))
                    : (i =
                          '<iframe src="https://www.youtube.com/embed/' +
                          t +
                          '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'),
              e.parentNode.querySelector("iframe").remove(),
              e.parentNode.insertAdjacentHTML("afterbegin", i),
              e.parentNode.classList.add("playing"))
            : console.log("No Video ID Provided");
    }),
        document.querySelectorAll(".inline-video-trigger").forEach(function (e, t) {
            e.addEventListener("click", function () {
                _playVideo(e);
            });
        });
}
function Wo() {
    document.querySelectorAll(".swiper .testimonial-quote").forEach((e) => {
        let t = e.textContent.split(" "),
            i = 70;
        if (t.length > i) {
            let s = t.slice(0, i).join(" ") + " ",
                o = t.slice(i).join(" "),
                a = document.createElement("a"),
                r = document.createElement("a"),
                l = document.createElement("span");
            (a.textContent = "Read More"),
                r.classList.add("read-mo"),
                (r.textContent = "Read Less"),
                (l.textContent = ". "),
                (a.href = "#!"),
                (a.className = "read-mo"),
                (a.style.display = "inline-block"),
                (r.href = "#!"),
                (r.style.display = "none"),
                (e.innerHTML = s),
                e.appendChild(l),
                e.appendChild(a);
            let c = document.createElement("span");
            (c.innerHTML = o),
                (c.style.display = "none"),
                e.appendChild(c),
                e.appendChild(r),
                a.addEventListener("click", function (d) {
                    d.preventDefault(),
                        (c.style.display = "inline"),
                        (r.style.display = "inline-block"),
                        (a.style.display = "none"),
                        (l.textContent = " ");
                }),
                r.addEventListener("click", function (d) {
                    d.preventDefault(),
                        (c.style.display = "none"),
                        (r.style.display = "none"),
                        (a.style.display = "inline-block"),
                        (l.textContent = ". ");
                });
        }
    });
}
$o();
bi(window, function (n) {
    document.body.classList.add("ready"),
        Yi(),
        Ui(),
        Ji(),
        Qi(),
        co(),
        uo(),
        Mi(),
        ho(),
        fo(),
        mo(),
        po(),
        ko(),
        Oo(),
        Io(),
        zo(),
        Do(),
        No(),
        _o(),
        vi(),
        (window.globalQuickView = vi),
        Fo(),
        Ro(),
        qo(),
        jo(),
        Vo(),
        Go(),
        Wo();
});
window.contentLoaded = bi;
window.addEventListener("resize", function () {
    setTimeout(function () {
        Mi();
    }, 500);
});

fetch('/cart/change.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    line: lineNumber,
    quantity: 0
  })
});
